import { z } from 'zod';

var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var apiErrorResponseSchema = z.object({
  statusCode: z.number(),
  message: z.union([z.string(), z.array(z.string())]),
  error: z.string().optional()
});
var validationErrorResponseSchema = z.object({
  statusCode: z.number(),
  message: z.array(z.string()),
  error: z.string().optional()
});
var structuredErrorResponseSchema = z.object({
  success: z.literal(false),
  error: z.object({
    message: z.string(),
    code: z.string(),
    details: z.array(
      z.object({
        field: z.string(),
        message: z.string()
      })
    ).optional(),
    timestamp: z.string()
  })
});
function apiSuccess(data) {
  return z.object({
    success: z.boolean(),
    data,
    message: z.string().optional()
  });
}
var messageResponseSchema = z.object({
  success: z.boolean(),
  message: z.string()
});
function paginated(item) {
  return z.object({
    data: z.array(item),
    total: z.number().catch(0),
    page: z.number().catch(1),
    pageSize: z.number().catch(0),
    totalPages: z.number().catch(0).optional()
  });
}
var paginationMetaSchema = z.object({
  total: z.number().catch(0),
  page: z.number().catch(1),
  limit: z.number().catch(0),
  totalPages: z.number().catch(0).optional(),
  hasNext: z.boolean().catch(false),
  hasPrev: z.boolean().catch(false),
  timestamp: z.string().optional()
});
function dataResponse(item) {
  return z.object({
    success: z.boolean(),
    data: item,
    message: z.string().optional()
  });
}
function listResponse(item) {
  return z.object({
    success: z.boolean(),
    data: z.array(item),
    message: z.string().optional(),
    meta: paginationMetaSchema.optional()
  });
}
var successResponseSchema = z.object({
  success: z.boolean(),
  data: z.unknown().optional(),
  message: z.string().optional(),
  meta: paginationMetaSchema.optional()
});
function reportResponse(data) {
  return z.union([
    data,
    z.object({
      success: z.boolean().optional(),
      data
    })
  ]);
}
var nullableString = z.union([z.string(), z.null()]).optional().transform((val) => val === "" || val === void 0 ? null : val);
var booleanLike = z.union([z.boolean(), z.literal("true"), z.literal("false")]).transform((val) => val === true || val === "true");
var formaPagamentoEnum = z.enum(["Boleto", "Pix", "Cartao"]);
var companyTypeEnum = z.enum([
  "MEI",
  "LIMITED",
  "INDIVIDUAL",
  "ASSOCIATION"
]);
var personTypeEnum = z.enum(["FISICA", "JURIDICA"]);
var valueLabelSchema = z.object({
  value: z.string(),
  label: z.string()
});
var idLabelSchema = z.object({
  id: z.number(),
  label: z.string()
});
var userMiniSchema = z.object({
  id: z.number(),
  nome: z.string().nullable(),
  sobrenome: z.string().nullable(),
  email: z.string().nullable().optional()
});
var cidadeRefSchema = z.object({
  id: z.number(),
  nome: z.string(),
  slug: z.string(),
  uf: z.string().optional()
});
var enderecoSchema = z.object({
  cep: nullableString,
  rua: nullableString,
  numero: nullableString,
  bairro: nullableString,
  cidade: nullableString,
  uf: nullableString,
  complemento: nullableString
});
var presignedUploadDataSchema = z.object({
  presignedUrl: z.string().optional(),
  uploadUrl: z.string().optional(),
  fileUrl: z.string().optional(),
  filePath: z.string().optional(),
  fileKey: z.string().optional(),
  expiresIn: z.number().optional(),
  fileName: z.string().optional(),
  fileType: z.string().optional(),
  folder: z.string().optional(),
  dashboardId: z.number().optional(),
  tipoConteudo: z.string().optional(),
  conteudoId: z.number().optional(),
  isPublico: z.boolean().optional()
});
var tipoConteudoUploadEnum = z.enum([
  "imovel",
  "empreendimento",
  "incorporadora",
  "artigo",
  "usuario",
  "site",
  "assets",
  "ai-agent"
]);
var uploadFolderEnum = z.enum([
  "fotos",
  "anexos",
  "videos",
  "tours",
  "avatar",
  "logo",
  "favicon",
  "imagens",
  "arquivos",
  "audios"
]);
var presignedUrlRequestSchema = z.object({
  dashboardId: z.coerce.number().int().min(1),
  tipoConteudo: tipoConteudoUploadEnum,
  conteudoId: z.coerce.number().int().min(1).optional(),
  folder: uploadFolderEnum,
  fileName: z.string().min(1).max(255),
  fileType: z.string().min(1),
  size: z.coerce.number().min(1).optional(),
  isPublico: booleanLike.optional()
});
var presignedUrlResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  data: presignedUploadDataSchema
});
var uploadUrlDataSchema = z.object({
  uploadUrl: z.string(),
  fileKey: z.string()
});
var accessUrlDataSchema = z.object({
  accessUrl: z.string(),
  expiresIn: z.number()
});
var idParamSchema = z.object({
  id: z.coerce.number().int().min(1)
});
var dashboardIdParamSchema = z.object({
  dashboardId: z.coerce.number().int().min(1)
});
var propostaParamsSchema = dashboardIdParamSchema.extend({
  id: z.coerce.number().int().min(1)
});
var siteParamsSchema = dashboardIdParamSchema.extend({
  siteId: z.coerce.number().int().min(1)
});
var comodidadeTipoParamSchema = z.object({
  tipo: z.enum(["imovel", "empreendimento"])
});
var createAnexoMetadataSchema = z.object({
  titulo: z.string().min(1).max(255),
  fileKey: z.string().min(1),
  size: z.coerce.number().min(0),
  mimeType: z.string().min(1)
});
var updateAnexoMetadataSchema = z.object({
  titulo: z.string().max(255).optional()
});
var generateAnexoUploadUrlSchema = z.object({
  fileName: z.string().min(1).max(255),
  mimeType: z.string().min(1),
  size: z.coerce.number().int().min(1)
});
var mediaItemSchema = z.object({
  id: z.number(),
  titulo: z.string(),
  url: z.string(),
  order: z.number(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var anexoItemSchema = z.object({
  id: z.number(),
  titulo: z.string(),
  size: z.coerce.number(),
  mimeType: z.string(),
  url: z.string().optional(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var dataCatalogItemSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string(),
  padrao: z.boolean().optional(),
  dashboardId: z.number().nullable().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional()
});
var editorJsContentSchema = z.object({
  time: z.number().optional(),
  blocks: z.array(z.record(z.string(), z.unknown())),
  version: z.string().optional()
});

// src/whatsapp-instances/index.ts
var whatsapp_instances_exports = {};
__export(whatsapp_instances_exports, {
  completeMetaEmbeddedSignupRequestSchema: () => completeMetaEmbeddedSignupRequestSchema,
  connectInstanceRequestSchema: () => connectInstanceRequestSchema,
  createMetaMessageTemplateRequestSchema: () => createMetaMessageTemplateRequestSchema,
  createMetaMessageTemplateResponseSchema: () => createMetaMessageTemplateResponseSchema,
  createWhatsAppInstanceRequestSchema: () => createWhatsAppInstanceRequestSchema,
  createWhatsAppLabelMappingRequestSchema: () => createWhatsAppLabelMappingRequestSchema,
  deleteMetaMessageTemplateResponseSchema: () => deleteMetaMessageTemplateResponseSchema,
  deleteWhatsappInstanceResponseSchema: () => deleteWhatsappInstanceResponseSchema,
  fakeCallRequestSchema: () => fakeCallRequestSchema,
  metaBlockContactByPhoneRequestSchema: () => metaBlockContactByPhoneRequestSchema,
  metaBlockUserResponseSchema: () => metaBlockUserResponseSchema,
  metaBlockUserResultSchema: () => metaBlockUserResultSchema,
  metaBusinessVerticalEnum: () => metaBusinessVerticalEnum,
  metaEmbeddedSignupSessionSchema: () => metaEmbeddedSignupSessionSchema,
  metaMessageTemplateListDataSchema: () => metaMessageTemplateListDataSchema,
  metaMessageTemplateResponseSchema: () => metaMessageTemplateResponseSchema,
  metaMessageTemplateSchema: () => metaMessageTemplateSchema,
  metaMessageTemplatesListResponseSchema: () => metaMessageTemplatesListResponseSchema,
  metaTemplateCarouselCardSchema: () => metaTemplateCarouselCardSchema,
  metaTemplateCategoryEnum: () => metaTemplateCategoryEnum,
  metaTemplateComponentSchema: () => metaTemplateComponentSchema,
  metaTemplateComponentTypeEnum: () => metaTemplateComponentTypeEnum,
  metaTemplateHeaderFormatEnum: () => metaTemplateHeaderFormatEnum,
  metaWhatsappBusinessProfileResponseSchema: () => metaWhatsappBusinessProfileResponseSchema,
  metaWhatsappBusinessProfileSchema: () => metaWhatsappBusinessProfileSchema,
  metaWhatsappQualityResponseSchema: () => metaWhatsappQualityResponseSchema,
  metaWhatsappQualitySnapshotSchema: () => metaWhatsappQualitySnapshotSchema,
  updateMetaBusinessProfileRequestSchema: () => updateMetaBusinessProfileRequestSchema,
  updateMetaMessageTemplateRequestSchema: () => updateMetaMessageTemplateRequestSchema,
  updateWhatsAppInstanceRequestSchema: () => updateWhatsAppInstanceRequestSchema,
  updateWhatsAppLabelMappingRequestSchema: () => updateWhatsAppLabelMappingRequestSchema,
  whatsAppConnectionStateEnum: () => whatsAppConnectionStateEnum,
  whatsAppInstanceSchema: () => whatsAppInstanceSchema,
  whatsAppIntegrationTypeEnum: () => whatsAppIntegrationTypeEnum,
  whatsAppLabelMappingItemResponseSchema: () => whatsAppLabelMappingItemResponseSchema,
  whatsAppLabelMappingSchema: () => whatsAppLabelMappingSchema,
  whatsAppLabelMappingsResponseSchema: () => whatsAppLabelMappingsResponseSchema,
  whatsAppProviderEnum: () => whatsAppProviderEnum,
  whatsappInstanceConnectResponseSchema: () => whatsappInstanceConnectResponseSchema,
  whatsappInstanceParamsSchema: () => whatsappInstanceParamsSchema,
  whatsappInstanceQrcodeResponseSchema: () => whatsappInstanceQrcodeResponseSchema,
  whatsappInstanceResponseSchema: () => whatsappInstanceResponseSchema,
  whatsappInstanceStatusResponseSchema: () => whatsappInstanceStatusResponseSchema,
  whatsappInstanceSyncContactsResponseSchema: () => whatsappInstanceSyncContactsResponseSchema,
  whatsappInstanceSyncResponseSchema: () => whatsappInstanceSyncResponseSchema,
  whatsappInstancesResponseSchema: () => whatsappInstancesResponseSchema
});
var whatsAppProviderEnum = z.enum(["EVOLUTION_GO", "META_CLOUD"]);
var whatsAppConnectionStateEnum = z.enum([
  "Desconectado",
  "Conectando",
  "Conectado",
  "Desconectando",
  "Timeout",
  "Close"
]);
var whatsAppIntegrationTypeEnum = z.enum([
  "WHATSAPP_BAILEYS",
  "WHATSAPP_BUSINESS",
  "EVOLUTION"
]);
var jsonRecord = z.record(z.string(), z.any());
var whatsappInstanceParamsSchema = z.object({
  dashboardId: z.coerce.number().int().min(1),
  id: z.coerce.number().int().min(1)
});
var createWhatsAppInstanceRequestSchema = z.object({
  instanceName: z.string().max(255).regex(
    /^[a-z0-9-_]+$/,
    "instanceName deve conter apenas letras min\xFAsculas, n\xFAmeros, h\xEDfens e underscores"
  ).optional(),
  provider: whatsAppProviderEnum.optional(),
  integration: whatsAppIntegrationTypeEnum.optional(),
  number: z.string().optional(),
  apikey: z.string().optional(),
  token: z.string().optional(),
  nome: z.string().max(255).optional(),
  isDefault: z.boolean().optional(),
  settings: jsonRecord.optional(),
  webhook: jsonRecord.optional(),
  config: jsonRecord.optional(),
  rejectCalls: z.boolean().optional(),
  msgCall: z.string().optional(),
  ignoreGroups: z.boolean().optional(),
  alwaysOnline: z.boolean().optional(),
  readMessages: z.boolean().optional(),
  syncFullHistory: z.boolean().optional(),
  syncContacts: z.boolean().optional(),
  readStatus: z.boolean().optional()
});
var updateWhatsAppInstanceRequestSchema = z.object({
  nome: z.string().max(255).optional(),
  isDefault: z.boolean().optional(),
  apikey: z.string().optional(),
  token: z.string().optional(),
  settings: jsonRecord.optional(),
  webhook: jsonRecord.optional(),
  config: jsonRecord.optional(),
  rejectCalls: z.boolean().optional(),
  msgCall: z.string().optional(),
  ignoreGroups: z.boolean().optional(),
  alwaysOnline: z.boolean().optional(),
  readMessages: z.boolean().optional(),
  syncFullHistory: z.boolean().optional(),
  syncContacts: z.boolean().optional(),
  readStatus: z.boolean().optional()
});
var connectInstanceRequestSchema = z.object({
  number: z.string().optional()
});
var fakeCallRequestSchema = z.object({
  number: z.string().min(1),
  isVideo: z.boolean().optional(),
  callDuration: z.number().min(1).optional()
});
var metaEmbeddedSignupSessionSchema = z.object({
  appId: z.string(),
  configId: z.string(),
  apiVersion: z.string()
});
var completeMetaEmbeddedSignupRequestSchema = z.object({
  code: z.string().min(1),
  wabaId: z.string().min(1),
  phoneNumberId: z.string().min(1),
  businessId: z.string().optional()
});
var metaWhatsappQualitySnapshotSchema = z.object({
  qualityRating: z.string().nullable(),
  messagingLimitTier: z.string().nullable(),
  qualityCheckedAt: z.string()
});
var metaWhatsappQualityResponseSchema = dataResponse(
  metaWhatsappQualitySnapshotSchema
);
var whatsAppInstanceSchema = z.object({
  id: z.number(),
  uuid: z.string(),
  dashboardId: z.number(),
  provider: whatsAppProviderEnum,
  instanceName: z.string(),
  instanceId: z.string().nullable().optional(),
  connectionState: whatsAppConnectionStateEnum,
  integration: whatsAppIntegrationTypeEnum.nullable().optional(),
  number: z.string().nullable().optional(),
  metaWabaId: z.string().nullable().optional(),
  metaPhoneNumberId: z.string().nullable().optional(),
  metaBusinessId: z.string().nullable().optional(),
  qualityRating: z.string().nullable().optional(),
  messagingLimitTier: z.string().nullable().optional(),
  qualityCheckedAt: z.string().nullable().optional(),
  nome: z.string().nullable().optional(),
  isDefault: z.boolean(),
  settings: jsonRecord.nullable().optional(),
  webhook: jsonRecord.nullable().optional(),
  config: jsonRecord.nullable().optional(),
  connectedAt: z.string().nullable().optional(),
  lastSyncAt: z.string().nullable().optional(),
  contactsSyncedAt: z.string().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
  channelInstance: z.object({
    id: z.number(),
    uuid: z.string(),
    channel: z.string(),
    createdAt: z.string(),
    updatedAt: z.string()
  }).nullable().optional()
});
var whatsappInstancesResponseSchema = listResponse(whatsAppInstanceSchema);
var whatsappInstanceResponseSchema = dataResponse(whatsAppInstanceSchema);
var whatsappInstanceQrcodeResponseSchema = dataResponse(
  z.object({
    qrcode: z.string(),
    expiresAt: z.string().optional(),
    base64: z.string().optional(),
    pairingCode: z.string().optional()
  })
);
var whatsappInstanceConnectResponseSchema = whatsappInstanceQrcodeResponseSchema;
var whatsappInstanceStatusResponseSchema = dataResponse(
  z.object({
    connectionState: whatsAppConnectionStateEnum,
    number: z.string().nullable().optional(),
    instanceId: z.string().nullable().optional()
  })
);
var whatsappInstanceSyncResponseSchema = whatsappInstanceResponseSchema;
var whatsappInstanceSyncContactsResponseSchema = dataResponse(
  z.object({
    imported: z.number(),
    skipped: z.number(),
    errors: z.number(),
    contactsSyncedAt: z.string()
  })
);
var deleteWhatsappInstanceResponseSchema = messageResponseSchema;
var metaTemplateCategoryEnum = z.enum([
  "MARKETING",
  "UTILITY",
  "AUTHENTICATION"
]);
var metaTemplateComponentTypeEnum = z.enum([
  "HEADER",
  "BODY",
  "FOOTER",
  "BUTTONS",
  "CAROUSEL"
]);
var metaTemplateHeaderFormatEnum = z.enum([
  "TEXT",
  "IMAGE",
  "VIDEO",
  "DOCUMENT"
]);
var metaTemplateCarouselCardSchema = z.object({
  components: z.array(
    z.object({
      type: z.enum(["HEADER", "BODY", "BUTTONS"]),
      format: metaTemplateHeaderFormatEnum.optional(),
      text: z.string().optional(),
      example: z.record(z.string(), z.any()).optional(),
      buttons: z.array(z.record(z.string(), z.any())).optional()
    })
  )
});
var metaTemplateComponentSchema = z.object({
  type: metaTemplateComponentTypeEnum,
  format: metaTemplateHeaderFormatEnum.optional(),
  text: z.string().optional(),
  example: z.record(z.string(), z.any()).optional(),
  buttons: z.array(z.record(z.string(), z.any())).optional(),
  cards: z.array(metaTemplateCarouselCardSchema).optional()
});
var createMetaMessageTemplateRequestSchema = z.object({
  name: z.string().min(1).max(512).regex(/^[a-z0-9_]+$/, "name deve conter apenas letras min\xFAsculas, n\xFAmeros e underscores"),
  language: z.string().min(2).max(10),
  category: metaTemplateCategoryEnum,
  components: z.array(metaTemplateComponentSchema).min(1),
  allow_category_change: z.boolean().optional()
});
var updateMetaMessageTemplateRequestSchema = z.object({
  components: z.array(metaTemplateComponentSchema).min(1)
});
var metaMessageTemplateSchema = z.object({
  id: z.string(),
  name: z.string(),
  status: z.string(),
  category: z.string(),
  language: z.string(),
  components: z.array(metaTemplateComponentSchema).optional(),
  rejected_reason: z.string().nullable().optional()
});
var metaMessageTemplateListDataSchema = z.object({
  templates: z.array(metaMessageTemplateSchema),
  paging: z.object({
    before: z.string().optional(),
    after: z.string().optional()
  }).optional()
});
var metaMessageTemplatesListResponseSchema = dataResponse(
  metaMessageTemplateListDataSchema
);
var metaMessageTemplateResponseSchema = dataResponse(
  metaMessageTemplateSchema
);
var createMetaMessageTemplateResponseSchema = metaMessageTemplateResponseSchema;
var deleteMetaMessageTemplateResponseSchema = dataResponse(
  z.object({ success: z.boolean() })
);
var metaBusinessVerticalEnum = z.enum([
  "UNDEFINED",
  "OTHER",
  "AUTO",
  "BEAUTY",
  "APPAREL",
  "EDU",
  "ENTERTAIN",
  "EVENT_PLAN",
  "FINANCE",
  "GROCERY",
  "GOVT",
  "HOTEL",
  "HEALTH",
  "NONPROFIT",
  "PROF_SERVICES",
  "RETAIL",
  "TRAVEL",
  "RESTAURANT",
  "NOT_A_BIZ",
  "ALCOHOL",
  "ONLINE_GAMBLING",
  "PHYSICAL_GAMBLING",
  "OTC_DRUGS",
  "MATRIMONY_SERVICE"
]);
var metaWhatsappBusinessProfileSchema = z.object({
  about: z.string().nullable(),
  address: z.string().nullable(),
  description: z.string().nullable(),
  email: z.string().nullable(),
  websites: z.array(z.string()),
  vertical: z.string().nullable(),
  profilePictureUrl: z.string().nullable()
});
var updateMetaBusinessProfileRequestSchema = z.object({
  about: z.string().max(139).optional(),
  address: z.string().max(256).optional(),
  description: z.string().max(512).optional(),
  email: z.string().email().max(128).optional(),
  websites: z.array(z.string().url().max(256)).max(2).optional(),
  vertical: metaBusinessVerticalEnum.optional(),
  profile_picture_handle: z.string().min(1).optional()
});
var metaWhatsappBusinessProfileResponseSchema = dataResponse(
  metaWhatsappBusinessProfileSchema
);
var metaBlockContactByPhoneRequestSchema = z.object({
  phone: z.string().min(8).max(32)
});
var metaBlockUserResultSchema = z.object({
  success: z.boolean(),
  waId: z.string().nullable(),
  input: z.string()
});
var metaBlockUserResponseSchema = dataResponse(metaBlockUserResultSchema);
var whatsAppLabelMappingSchema = z.object({
  id: z.number(),
  uuid: z.string(),
  dashboardId: z.number(),
  whatsappInstanceId: z.number(),
  conversationLabelId: z.number(),
  waLabelId: z.string(),
  waLabelName: z.string(),
  waLabelColor: z.number().nullable().optional(),
  syncEnabled: z.boolean(),
  conversationLabel: z.object({
    id: z.number(),
    nome: z.string(),
    cor: z.string().nullable().optional()
  }).optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional()
});
var whatsAppLabelMappingsResponseSchema = listResponse(
  whatsAppLabelMappingSchema
);
var whatsAppLabelMappingItemResponseSchema = dataResponse(
  whatsAppLabelMappingSchema
);
var createWhatsAppLabelMappingRequestSchema = z.object({
  conversationLabelId: z.number().int().positive(),
  waLabelId: z.string().min(1),
  waLabelName: z.string().min(1),
  waLabelColor: z.number().int().min(0).max(19).optional(),
  syncEnabled: z.boolean().optional()
});
var updateWhatsAppLabelMappingRequestSchema = z.object({
  waLabelName: z.string().min(1).optional(),
  waLabelColor: z.number().int().min(0).max(19).optional(),
  syncEnabled: z.boolean().optional()
});

// src/auth/index.ts
var auth_exports = {};
__export(auth_exports, {
  AUTH_ERROR_CODE: () => AUTH_ERROR_CODE,
  AUTH_PHONE_VERIFICATION_REQUIRED_MESSAGE: () => AUTH_PHONE_VERIFICATION_REQUIRED_MESSAGE,
  AUTH_SESSION_SUPERSEDED_MESSAGE: () => AUTH_SESSION_SUPERSEDED_MESSAGE,
  abrirContaResponseSchema: () => abrirContaResponseSchema,
  authSessionRowSchema: () => authSessionRowSchema,
  checkMagicLinkRequestSchema: () => checkMagicLinkRequestSchema,
  checkoutSuccessResponseSchema: () => checkoutSuccessResponseSchema,
  checkoutTargetTokenGenerateResponseSchema: () => checkoutTargetTokenGenerateResponseSchema,
  checkoutTargetTokenRequestSchema: () => checkoutTargetTokenRequestSchema,
  checkoutTargetTokenResolveResponseSchema: () => checkoutTargetTokenResolveResponseSchema,
  checkoutTargetTokenResolveSchema: () => checkoutTargetTokenResolveSchema,
  confirmPasswordResetRequestSchema: () => confirmPasswordResetRequestSchema,
  contratarCheckoutResponseSchema: () => contratarCheckoutResponseSchema,
  contratarCicloEnum: () => contratarCicloEnum,
  contratarPreviewCouponSchema: () => contratarPreviewCouponSchema,
  contratarPreviewResponseSchema: () => contratarPreviewResponseSchema,
  contratarPreviewSchema: () => contratarPreviewSchema,
  contratarRequestSchema: () => contratarRequestSchema,
  contratarSchema: () => contratarSchema,
  currentUserRequestSchema: () => currentUserRequestSchema,
  currentUserResponseSchema: () => currentUserResponseSchema,
  loginAutoRequestSchema: () => loginAutoRequestSchema,
  loginHistoryResponseSchema: () => loginHistoryResponseSchema,
  loginHistoryRowSchema: () => loginHistoryRowSchema,
  loginMagicLinkRequestSchema: () => loginMagicLinkRequestSchema,
  loginRequestSchema: () => loginRequestSchema,
  loginSuccessResponseSchema: () => loginSuccessResponseSchema,
  logoutRequestSchema: () => logoutRequestSchema,
  logoutResponseSchema: () => logoutResponseSchema,
  magicLinkResponseSchema: () => magicLinkResponseSchema,
  newPasswordRequestSchema: () => newPasswordRequestSchema,
  parseAuthErrorCode: () => parseAuthErrorCode,
  recuperarSenhaResponseSchema: () => recuperarSenhaResponseSchema,
  refreshTokenRequestSchema: () => refreshTokenRequestSchema,
  refreshTokenResponseSchema: () => refreshTokenResponseSchema,
  registerRequestSchema: () => registerRequestSchema,
  registerTrialRequestSchema: () => registerTrialRequestSchema,
  revokeOtherSessionsResponseSchema: () => revokeOtherSessionsResponseSchema,
  revokeSessionResponseSchema: () => revokeSessionResponseSchema,
  sessionsListResponseSchema: () => sessionsListResponseSchema,
  validateOtpRequestSchema: () => validateOtpRequestSchema
});
var loginRequestSchema = z.object({
  email: z.string().email("Digite um email v\xE1lido"),
  password: z.string().min(1, "O campo de senha \xE9 obrigat\xF3rio")
});
var loginAutoRequestSchema = z.object({
  email: z.string().email("Digite um email v\xE1lido"),
  tokenFull: z.string().min(1, "O campo token \xE9 obrigat\xF3rio")
});
var loginMagicLinkRequestSchema = z.object({
  email: z.string().email("Digite um email v\xE1lido")
});
var checkMagicLinkRequestSchema = z.object({
  token: z.string().min(1, "Token \xE9 obrigat\xF3rio"),
  email: z.string().email("Digite um e-mail v\xE1lido").optional()
});
var refreshTokenRequestSchema = z.object({
  refreshToken: z.string().optional()
});
var currentUserRequestSchema = z.object({
  email: z.string().email("Digite um email v\xE1lido")
});
var currentUserResponseSchema = z.object({
  id: z.number()
});
var newPasswordRequestSchema = z.object({
  email: z.string().email("Digite um email v\xE1lido")
});
var confirmPasswordResetRequestSchema = z.object({
  token: z.string().min(1, "Token \xE9 obrigat\xF3rio"),
  password: z.string().min(6, "A senha deve ter no m\xEDnimo 6 caracteres").max(18, "A senha deve ter no m\xE1ximo 18 caracteres").regex(/^(?=.*[a-zA-Z])(?=.*\d)/, "A senha deve conter pelo menos 1 letra e 1 n\xFAmero"),
  passwordConfirmation: z.string().min(6).max(18)
});
var registerRequestSchema = z.object({
  nome: z.string().min(2, "Nome deve ter no m\xEDnimo 2 caracteres").max(100, "Nome deve ter no m\xE1ximo 100 caracteres").regex(/^[a-zA-ZÀ-ÿ\s]+$/, "Nome deve conter apenas letras"),
  sobrenome: z.string().optional(),
  cpf: z.string().optional(),
  email: z.string().email("Email inv\xE1lido"),
  celular: z.string().min(1, "Celular \xE9 obrigat\xF3rio").refine(
    (val) => {
      const cleaned = val.replace(/\D/g, "");
      return cleaned.length >= 10 && cleaned.length <= 15;
    },
    { message: "N\xFAmero de telefone inv\xE1lido" }
  )
});
var registerTrialRequestSchema = registerRequestSchema.extend({
  planoId: z.coerce.number(),
  trialDays: z.coerce.number().optional(),
  nomeImobiliaria: z.string().min(1),
  sobrenome: z.string().optional(),
  cpf: z.string().optional()
});
var logoutRequestSchema = z.object({
  scope: z.enum(["all", "current"]).optional()
});
var contratarCicloEnum = z.enum(["mensal", "anual"]);
var contratarRequestSchema = z.object({
  ciclo: contratarCicloEnum,
  email: z.string().optional(),
  nome: z.string().optional(),
  sobrenome: z.string().optional(),
  celular: z.string().optional(),
  cpf: z.string().optional(),
  nomeImobiliaria: z.string().optional(),
  otpCode: z.string().optional(),
  userId: z.coerce.number().optional(),
  trial: z.coerce.number().min(0).optional(),
  card: z.boolean().optional(),
  cupom: z.string().optional(),
  orderBumpPriceIds: z.array(z.string()).max(10).optional(),
  successUrl: z.string().optional(),
  cancelUrl: z.string().optional(),
  gaClientId: z.string().optional(),
  gaSessionId: z.string().optional(),
  utmSource: z.string().optional(),
  utmMedium: z.string().optional(),
  utmCampaign: z.string().optional(),
  utmContent: z.string().optional(),
  utmTerm: z.string().optional(),
  gclid: z.string().optional(),
  fbclid: z.string().optional(),
  pageLocation: z.string().optional(),
  pageReferrer: z.string().optional(),
  userAgent: z.string().optional()
});
var contratarPreviewSchema = z.object({
  ciclo: contratarCicloEnum,
  cupom: z.string().optional(),
  orderBumpPriceIds: z.array(z.string()).max(10).optional()
});
var checkoutTargetTokenRequestSchema = z.object({
  dashboardId: z.coerce.number()
});
var checkoutTargetTokenResolveSchema = z.object({
  token: z.string().min(1)
});
var contratarCheckoutResponseSchema = z.object({
  success: z.boolean(),
  url: z.string().optional(),
  sessionId: z.string().optional(),
  usuario: z.object({
    id: z.number(),
    email: z.string()
  }).optional(),
  otpSent: z.boolean().optional(),
  requiresOTP: z.boolean().optional(),
  email: z.string().optional(),
  message: z.string().optional()
});
var contratarPreviewCouponSchema = z.object({
  code: z.string(),
  valid: z.boolean(),
  reason: z.string().optional(),
  percentOff: z.number().optional(),
  amountOff: z.number().optional(),
  currency: z.string().optional()
});
var contratarPreviewResponseSchema = z.object({
  success: z.boolean(),
  data: z.object({
    currency: z.string(),
    subtotal: z.number(),
    discount: z.number(),
    total: z.number(),
    coupon: contratarPreviewCouponSchema.optional()
  })
});
var checkoutSuccessResponseSchema = z.object({
  processando: z.boolean(),
  message: z.string().optional(),
  token: z.string().optional(),
  redirectUrl: z.string().optional()
});
var checkoutTargetTokenGenerateResponseSchema = apiSuccess(
  z.object({
    token: z.string(),
    dashboardId: z.number(),
    expiresInSeconds: z.number()
  })
);
var checkoutTargetTokenResolveResponseSchema = apiSuccess(
  z.union([
    z.object({
      valid: z.literal(true),
      dashboardId: z.number()
    }),
    z.object({
      valid: z.literal(false),
      reason: z.string().optional()
    })
  ])
);
var contratarSchema = contratarRequestSchema;
var validateOtpRequestSchema = z.object({
  email: z.string().email("Email inv\xE1lido"),
  code: z.string().length(6, "C\xF3digo deve ter exatamente 6 d\xEDgitos").regex(/^\d{6}$/, "C\xF3digo deve conter apenas n\xFAmeros")
});
var loginSuccessResponseSchema = z.object({
  accessToken: z.string(),
  refreshToken: z.string(),
  // user.image is nullable in the DB; fall back to '' to keep type `string`.
  avatar: z.string().catch(""),
  email: z.string(),
  name: z.string(),
  id: z.number(),
  /** true quando o usuário ainda não tem celular cadastrado e confirmado. */
  requiresPhoneVerification: z.boolean().default(false)
});
var refreshTokenResponseSchema = z.object({
  accessToken: z.string()
});
var recuperarSenhaResponseSchema = messageResponseSchema;
var abrirContaResponseSchema = messageResponseSchema;
var magicLinkResponseSchema = messageResponseSchema;
var logoutResponseSchema = messageResponseSchema;
var authSessionRowSchema = z.object({
  id: z.number(),
  sessionUuid: z.string(),
  browser: z.string().nullable(),
  operatingSystem: z.string().nullable(),
  ip: z.string().nullable(),
  createdAt: z.string(),
  lastSeenAt: z.string(),
  current: z.boolean()
});
var loginHistoryRowSchema = z.object({
  id: z.number(),
  success: z.boolean(),
  reason: z.string().nullable(),
  emailAttempted: z.string().nullable(),
  ip: z.string().nullable(),
  userAgent: z.string().nullable(),
  createdAt: z.string()
});
function authPaginatedListResponse(item) {
  return z.object({
    success: z.boolean(),
    data: z.array(item).default([]),
    page: z.number().catch(1),
    pageSize: z.number().catch(0),
    total: z.number().catch(0)
  });
}
var sessionsListResponseSchema = authPaginatedListResponse(authSessionRowSchema);
var loginHistoryResponseSchema = authPaginatedListResponse(loginHistoryRowSchema);
var revokeSessionResponseSchema = messageResponseSchema;
var revokeOtherSessionsResponseSchema = revokeSessionResponseSchema;
var AUTH_ERROR_CODE = {
  SESSION_SUPERSEDED: "SESSION_SUPERSEDED",
  PHONE_VERIFICATION_REQUIRED: "PHONE_VERIFICATION_REQUIRED"
};
var AUTH_PHONE_VERIFICATION_REQUIRED_MESSAGE = "Cadastre e confirme seu celular para continuar usando o ImobDesk.";
var AUTH_SESSION_SUPERSEDED_MESSAGE = "Sua sess\xE3o foi encerrada porque houve login nesta conta em outro dispositivo ou navegador.";
function parseAuthErrorCode(payload) {
  if (!payload || typeof payload !== "object") return void 0;
  const code = payload.code;
  return typeof code === "string" && code.length > 0 ? code : void 0;
}

// src/workspace/index.ts
var workspace_exports = {};
__export(workspace_exports, {
  acceptInviteDataSchema: () => acceptInviteDataSchema,
  acceptInviteResponseSchema: () => acceptInviteResponseSchema,
  acceptInviteSchema: () => acceptInviteSchema,
  changeEmailConfirmSchema: () => changeEmailConfirmSchema,
  changeEmailFinalizeResponseSchema: () => changeEmailFinalizeResponseSchema,
  changeEmailRequestResponseSchema: () => changeEmailRequestResponseSchema,
  changeEmailRequestSchema: () => changeEmailRequestSchema,
  changePasswordResponseSchema: () => changePasswordResponseSchema,
  changePhoneConfirmResponseSchema: () => changePhoneConfirmResponseSchema,
  changePhoneConfirmSchema: () => changePhoneConfirmSchema,
  changePhoneFinalizeResponseSchema: () => changePhoneFinalizeResponseSchema,
  changePhoneRequestResponseSchema: () => changePhoneRequestResponseSchema,
  changePhoneRequestSchema: () => changePhoneRequestSchema,
  dashboardInviteSchema: () => dashboardInviteSchema,
  inviteErrorSchema: () => inviteErrorSchema,
  invitesResponseSchema: () => invitesResponseSchema,
  isValidCpf: () => isValidCpf,
  phoneChangeFlowSchema: () => phoneChangeFlowSchema,
  profileResponseSchema: () => profileResponseSchema,
  registerPhoneConfirmSchema: () => registerPhoneConfirmSchema,
  registerPhoneFinalizeResponseSchema: () => registerPhoneFinalizeResponseSchema,
  registerPhoneRequestResponseSchema: () => registerPhoneRequestResponseSchema,
  registerPhoneRequestSchema: () => registerPhoneRequestSchema,
  setPrincipalSchema: () => setPrincipalSchema,
  updateAvatarRequestSchema: () => updateAvatarRequestSchema,
  updateAvatarResponseSchema: () => updateAvatarResponseSchema,
  updatePasswordRequestSchema: () => updatePasswordRequestSchema,
  updateProfileRequestSchema: () => updateProfileRequestSchema,
  updateProfileResponseSchema: () => updateProfileResponseSchema,
  updateUserPreferencesSchema: () => updateUserPreferencesSchema,
  uploadAvatarDataSchema: () => uploadAvatarDataSchema,
  uploadAvatarRequestSchema: () => uploadAvatarRequestSchema,
  uploadAvatarResponseSchema: () => uploadAvatarResponseSchema,
  userPreferencesDataSchema: () => userPreferencesDataSchema,
  userPreferencesResponseSchema: () => userPreferencesResponseSchema,
  userProfileSchema: () => userProfileSchema,
  validatePhoneSchema: () => validatePhoneSchema,
  validatePinSchema: () => validatePinSchema
});
function isValidCpf(raw) {
  const cleaned = raw.replace(/\D/g, "");
  if (cleaned.length !== 11) return false;
  if (/^(\d)\1{10}$/.test(cleaned)) return false;
  let sum = 0;
  for (let i = 0; i < 9; i++) sum += parseInt(cleaned.charAt(i), 10) * (10 - i);
  let digit = 11 - sum % 11;
  if (digit >= 10) digit = 0;
  if (digit !== parseInt(cleaned.charAt(9), 10)) return false;
  sum = 0;
  for (let i = 0; i < 10; i++) sum += parseInt(cleaned.charAt(i), 10) * (11 - i);
  digit = 11 - sum % 11;
  if (digit >= 10) digit = 0;
  return digit === parseInt(cleaned.charAt(10), 10);
}
var pin = z.string().length(6, "PIN deve ter 6 d\xEDgitos").regex(/^\d{6}$/, "PIN deve conter apenas n\xFAmeros");
var updateProfileRequestSchema = z.object({
  nome: z.string().min(1, "Nome \xE9 um campo obrigat\xF3rio"),
  sobrenome: z.string().min(1, "Sobrenome \xE9 um campo obrigat\xF3rio"),
  cpf: z.string().regex(/^\d{11}$/, "CPF deve conter 11 d\xEDgitos").refine(isValidCpf, "CPF inv\xE1lido"),
  // backend: @IsOptional @IsNumberString
  dashboardPrincipal: z.string().regex(/^\d+$/).optional()
});
var updatePasswordRequestSchema = z.object({
  currentPassword: z.string().min(1, "Senha atual \xE9 obrigat\xF3ria"),
  password: z.string().min(6, "A senha deve ter no m\xEDnimo 6 caracteres").max(18, "A senha deve ter no m\xE1ximo 18 caracteres").regex(/^(?=.*[A-Za-z])(?=.*\d).{6,}$/, "A senha deve conter pelo menos 1 letra e 1 n\xFAmero"),
  passwordConfirmation: z.string().min(1, "Confirma\xE7\xE3o de senha \xE9 obrigat\xF3ria")
}).refine((data) => data.password === data.passwordConfirmation, {
  message: "As senhas devem ser iguais",
  path: ["passwordConfirmation"]
});
var changeEmailRequestSchema = z.object({
  newEmail: z.string().email("Informe um e-mail v\xE1lido")
});
var changeEmailConfirmSchema = z.object({ pin });
var changePhoneRequestSchema = z.object({
  // backend PhoneValidator; frontend enforces E.164.
  newPhone: z.string().min(1, "Celular \xE9 obrigat\xF3rio").regex(/^\+[1-9]\d{1,14}$/, "Celular deve estar no formato E.164 (+5543996548938)")
});
var changePhoneConfirmSchema = z.object({ pin });
var uploadAvatarRequestSchema = z.object({
  fileType: z.string().min(1, "fileType \xE9 obrigat\xF3rio").regex(/^image\/(jpeg|jpg|png|webp)$/, "Tipo de arquivo deve ser uma imagem (jpeg, jpg, png ou webp)")
});
var updateAvatarRequestSchema = z.object({
  imageKey: z.string().min(1, "imageKey \xE9 obrigat\xF3rio")
});
var userProfileSchema = z.object({
  id: z.number(),
  nome: z.string(),
  sobrenome: z.string().nullable().optional().transform((value) => value ?? ""),
  email: z.string().email(),
  celular: z.string().nullable().optional().transform((value) => value ?? ""),
  celularConfirmado: z.boolean().optional().default(false),
  cpf: z.string().nullable().optional().transform((value) => value ?? ""),
  image: z.string().nullable(),
  status: z.boolean(),
  pin: z.number().nullable(),
  tipo: z.string(),
  dashboardPrincipalId: z.number().nullable(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var profileResponseSchema = z.object({
  success: z.boolean(),
  data: userProfileSchema
});
var changePasswordResponseSchema = z.object({
  success: z.boolean(),
  data: z.object({
    id: z.number(),
    email: z.string(),
    updatedAt: z.string()
  }),
  message: z.string()
});
var updateProfileResponseSchema = z.object({
  success: z.boolean(),
  data: userProfileSchema,
  message: z.string()
});
var changeEmailRequestResponseSchema = messageResponseSchema;
var changeEmailFinalizeResponseSchema = z.object({
  success: z.boolean(),
  data: z.object({
    id: z.number(),
    email: z.string(),
    updatedAt: z.string()
  }),
  message: z.string()
});
var phoneChangeFlowSchema = z.enum(["change", "register"]);
var changePhoneRequestResponseSchema = messageResponseSchema.extend({
  /** `register` = usuário sem celular (PIN direto no novo número, 1 etapa). */
  flow: phoneChangeFlowSchema.default("change")
});
var changePhoneFinalizeResponseSchema = z.object({
  success: z.boolean(),
  data: z.object({
    id: z.number(),
    celular: z.string(),
    updatedAt: z.string()
  }),
  message: z.string()
});
var changePhoneConfirmResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  flow: phoneChangeFlowSchema.optional(),
  data: changePhoneFinalizeResponseSchema.shape.data.optional()
});
var registerPhoneRequestSchema = changePhoneRequestSchema;
var registerPhoneConfirmSchema = changePhoneConfirmSchema;
var registerPhoneRequestResponseSchema = changePhoneRequestResponseSchema;
var registerPhoneFinalizeResponseSchema = changePhoneFinalizeResponseSchema;
var uploadAvatarDataSchema = z.object({
  uploadUrl: z.string(),
  fileUrl: z.string(),
  fileKey: z.string(),
  expiresIn: z.number(),
  fileName: z.string(),
  fileType: z.string(),
  userId: z.number()
});
var uploadAvatarResponseSchema = apiSuccess(uploadAvatarDataSchema);
var updateAvatarResponseSchema = z.object({
  success: z.boolean(),
  data: z.object({
    id: z.number(),
    image: z.string(),
    updatedAt: z.string(),
    oldImageKey: z.string().nullable()
  }),
  message: z.string()
});
var updateUserPreferencesSchema = z.object({
  dashboardId: z.coerce.number().int().min(1),
  preferences: z.record(z.string(), z.any())
});
var validatePhoneSchema = z.object({
  celular: z.string().min(1, "Celular \xE9 obrigat\xF3rio").regex(/^\+[1-9]\d{1,14}$/, "Celular deve estar no formato E.164")
});
var validatePinSchema = z.object({
  pin: z.string().regex(/^\d{6}$/, "PIN deve ter 6 d\xEDgitos")
});
var acceptInviteSchema = z.object({
  dashboardId: z.string().regex(/^\d+$/)
});
var setPrincipalSchema = z.object({
  dashboardPrincipal: z.union([z.string().regex(/^\d+$/), z.null()]).optional()
});
var userPreferencesDataSchema = z.object({
  dashboardId: z.number(),
  preferences: z.record(z.string(), z.any()),
  updatedAt: z.string().optional()
});
var userPreferencesResponseSchema = z.object({
  success: z.boolean(),
  data: userPreferencesDataSchema,
  message: z.string().optional()
});
var dashboardInviteSchema = z.object({
  id: z.number(),
  logo: z.string().nullable(),
  titulo: z.string()
});
var invitesResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(dashboardInviteSchema),
  message: z.string()
});
var acceptInviteDataSchema = z.object({
  dashboardId: z.number(),
  usuarioId: z.number(),
  status: z.string(),
  acceptedAt: z.string()
});
var acceptInviteResponseSchema = z.object({
  success: z.boolean(),
  data: acceptInviteDataSchema,
  message: z.string()
});
var inviteErrorSchema = z.object({
  success: z.literal(false),
  error: z.object({
    message: z.string(),
    code: z.string(),
    timestamp: z.string()
  })
});

// src/leads/index.ts
var leads_exports = {};
__export(leads_exports, {
  addLeadAnnotationRequestSchema: () => addLeadAnnotationRequestSchema,
  addLeadItemRequestSchema: () => addLeadItemRequestSchema,
  addLeadItemResponseSchema: () => addLeadItemResponseSchema,
  anotacaoSchema: () => anotacaoSchema,
  anotacoesResponseSchema: () => anotacoesResponseSchema,
  convertLeadRequestSchema: () => convertLeadRequestSchema,
  convertLeadResponseSchema: () => convertLeadResponseSchema,
  createAnotacaoResponseSchema: () => createAnotacaoResponseSchema,
  createLeadRequestSchema: () => createLeadRequestSchema,
  createLeadResponseSchema: () => createLeadResponseSchema,
  deleteLeadAnotacaoResponseSchema: () => deleteLeadAnotacaoResponseSchema,
  deleteLeadResponseSchema: () => deleteLeadResponseSchema,
  leadFinalidadeEnum: () => leadFinalidadeEnum,
  leadInteressesResponseSchema: () => leadInteressesResponseSchema,
  leadItemModuloEnum: () => leadItemModuloEnum,
  leadListQuerySchema: () => leadListQuerySchema,
  leadResponseSchema: () => leadResponseSchema,
  leadSchema: () => leadSchema,
  leadStatusEnum: () => leadStatusEnum,
  leadsContagemPorStatusDataSchema: () => leadsContagemPorStatusDataSchema,
  leadsContagemPorStatusResponseSchema: () => leadsContagemPorStatusResponseSchema,
  leadsListEnvelopeSchema: () => leadsListEnvelopeSchema,
  leadsResponseSchema: () => leadsResponseSchema,
  novosLeadsCountResponseSchema: () => novosLeadsCountResponseSchema,
  removeLeadItemRequestSchema: () => removeLeadItemRequestSchema,
  removeLeadItemResponseSchema: () => removeLeadItemResponseSchema,
  updateAnotacaoResponseSchema: () => updateAnotacaoResponseSchema,
  updateLeadAnnotationRequestSchema: () => updateLeadAnnotationRequestSchema,
  updateLeadRequestSchema: () => updateLeadRequestSchema,
  updateLeadResponseSchema: () => updateLeadResponseSchema
});
var leadStatusEnum = z.enum([
  "Novo",
  "Pendente",
  "Perdido",
  "Qualificado"
]);
var leadFinalidadeEnum = z.enum([
  "Comprar",
  "Alugar",
  "Temporada",
  "AnunciarLocacao",
  "AnunciarVenda"
]);
var camposCustomizadosInput = z.record(
  z.string(),
  z.union([z.string(), z.number(), z.boolean(), z.null()])
);
var createLeadRequestSchema = z.object({
  contatoId: z.number().optional(),
  nome: z.string().max(255).optional(),
  email: z.string().email("Email deve ter um formato v\xE1lido").max(255).optional(),
  finalidade: leadFinalidadeEnum.optional(),
  celular: z.string().max(20).optional(),
  cpf: z.string().max(14).optional(),
  origem: z.string().max(50).optional(),
  responsavelId: z.number().optional(),
  status: leadStatusEnum.optional(),
  atendido: booleanLike.optional(),
  motivoPerdaId: z.number().optional(),
  comentarioPerda: z.string().max(500).optional(),
  duplicado: booleanLike.optional(),
  imoveis: z.array(z.number()).optional(),
  empreendimentos: z.array(z.number()).optional(),
  segmentos: z.array(z.string()).optional(),
  anotacoes: z.string().max(1e3).optional(),
  utmSource: z.string().max(255).optional(),
  utmMedium: z.string().max(255).optional(),
  utmCampaign: z.string().max(255).optional(),
  utmTerm: z.string().max(255).optional(),
  utmContent: z.string().max(255).optional(),
  facebookPageId: z.string().max(36).optional(),
  formId: z.string().max(100).optional(),
  leadgenId: z.string().max(100).optional(),
  formName: z.string().max(500).optional(),
  facebookCampaignId: z.string().max(100).optional(),
  facebookCampaignName: z.string().max(500).optional(),
  fingerprintId: z.string().max(255).optional(),
  camposCustomizados: camposCustomizadosInput.optional(),
  camposCustomizadosContato: camposCustomizadosInput.optional()
}).refine((data) => Boolean(data.contatoId) || Boolean(data.nome?.trim()), {
  message: "Nome \xE9 obrigat\xF3rio quando contatoId n\xE3o \xE9 fornecido",
  path: ["nome"]
});
var updateLeadRequestSchema = z.object({
  nome: z.string().max(255).optional(),
  email: z.string().email("Email deve ter um formato v\xE1lido").max(255).optional(),
  finalidade: leadFinalidadeEnum.optional(),
  celular: z.string().max(20).optional(),
  cpf: z.string().max(14).optional(),
  origem: z.string().max(50).optional(),
  responsavelId: z.number().optional(),
  status: leadStatusEnum.optional(),
  atendido: booleanLike.optional(),
  motivoPerdaId: z.number().optional(),
  comentarioPerda: z.string().max(500).optional(),
  duplicado: booleanLike.optional(),
  imoveis: z.array(z.number()).optional(),
  empreendimentos: z.array(z.number()).optional(),
  camposCustomizados: camposCustomizadosInput.optional(),
  camposCustomizadosContato: camposCustomizadosInput.optional()
});
var convertLeadRequestSchema = z.object({
  responsavel: z.number(),
  assunto: z.string().max(255).optional()
});
var leadItemModuloEnum = z.enum(["imoveis", "empreendimentos"]);
var addLeadItemRequestSchema = z.object({
  modulo: leadItemModuloEnum,
  itemId: z.string().min(1, "ID do item \xE9 obrigat\xF3rio")
});
var removeLeadItemRequestSchema = addLeadItemRequestSchema;
var addLeadAnnotationRequestSchema = z.object({
  conteudo: z.string().min(1, "Conte\xFAdo da anota\xE7\xE3o \xE9 obrigat\xF3rio").max(2e3)
});
var updateLeadAnnotationRequestSchema = addLeadAnnotationRequestSchema;
var leadListQuerySchema = z.object({
  page: z.coerce.number().min(1).optional(),
  take: z.coerce.number().min(1).max(100).optional(),
  status: leadStatusEnum.optional(),
  finalidade: leadFinalidadeEnum.optional(),
  contatoId: z.coerce.number().optional(),
  responsavelId: z.coerce.number().optional(),
  origem: z.string().optional(),
  duplicado: booleanLike.optional(),
  atendido: booleanLike.optional(),
  motivoPerdaId: z.coerce.number().optional(),
  search: z.string().optional(),
  dataInicio: z.string().optional(),
  dataFim: z.string().optional(),
  orderBy: z.string().optional(),
  order: z.enum(["asc", "desc"]).optional()
});
var contatoLeadSchema = z.object({
  id: z.number(),
  nome: z.string(),
  sobrenome: z.string().nullable(),
  email: z.string().nullable(),
  telefone: z.string().nullable(),
  numeroCpf: z.string().nullable().optional()
});
var motivoPerdaSchema = z.object({ id: z.number(), label: z.string() }).nullable();
var leadSchema = z.object({
  id: z.string(),
  finalidade: leadFinalidadeEnum.nullable(),
  oportunidadeId: z.string().nullable(),
  contatoId: z.number(),
  dashboardId: z.number(),
  origemValue: z.string().nullable(),
  responsavelId: z.number().nullable(),
  adicionadoPorId: z.number().nullable(),
  status: leadStatusEnum,
  duplicado: z.boolean(),
  notificacoesMarketing: z.boolean(),
  atendido: z.string().nullable(),
  ultimaRedistribuicao: z.string().nullable(),
  tentativasRedistribuicao: z.number(),
  proximaRedistribuicao: z.string().nullable(),
  historicoRedistribuicao: z.any().nullable(),
  motivoRedistribuicao: z.string().nullable(),
  escaladoParaSupervisor: z.boolean(),
  utmSource: z.string().nullable(),
  utmMedium: z.string().nullable(),
  utmCampaign: z.string().nullable(),
  utmTerm: z.string().nullable(),
  utmContent: z.string().nullable(),
  facebookPageId: z.string().nullable(),
  formId: z.string().nullable(),
  formName: z.string().nullable(),
  facebookCampaignId: z.string().nullable(),
  facebookCampaignName: z.string().nullable(),
  leadgenId: z.string().nullable(),
  motivoPerdaId: z.number().nullable(),
  comentarioPerda: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  finalizadoEm: z.string().nullable(),
  contato: contatoLeadSchema,
  responsavel: userMiniSchema.nullable(),
  origem: valueLabelSchema.nullable(),
  adicionadoPor: userMiniSchema.nullable(),
  motivoPerda: motivoPerdaSchema.optional(),
  camposCustomizados: z.record(z.string(), z.any()),
  _count: z.object({
    anotacoes: z.number(),
    imoveis: z.number(),
    empreendimentos: z.number()
  }).optional()
});
var leadsResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(leadSchema),
  meta: z.object({
    total: z.number(),
    page: z.number(),
    limit: z.number(),
    hasNext: z.boolean(),
    hasPrev: z.boolean(),
    timestamp: z.string()
  }),
  message: z.string().optional()
});
var leadResponseSchema = z.object({
  success: z.boolean(),
  data: leadSchema,
  message: z.string().optional()
});
var createLeadResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  data: leadSchema,
  distribuicao: z.object({ message: z.string() }).nullable().optional()
});
var updateLeadResponseSchema = leadResponseSchema;
var deleteLeadResponseSchema = messageResponseSchema;
var leadsContagemPorStatusDataSchema = z.object({
  Novo: z.number(),
  Pendente: z.number(),
  Qualificado: z.number(),
  Perdido: z.number()
});
var leadsContagemPorStatusResponseSchema = z.object({
  success: z.boolean(),
  data: leadsContagemPorStatusDataSchema
});
var novosLeadsCountResponseSchema = dataResponse(
  z.object({ count: z.number() })
);
var addLeadItemResponseSchema = messageResponseSchema;
var removeLeadItemResponseSchema = messageResponseSchema;
var anotacaoSchema = z.object({
  id: z.number(),
  leadId: z.string(),
  conteudo: z.string().nullable(),
  autorId: z.number().nullable(),
  autor: z.object({
    id: z.number(),
    nome: z.string().nullable(),
    sobrenome: z.string().nullable(),
    email: z.string()
  }).nullable(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var createAnotacaoResponseSchema = dataResponse(anotacaoSchema).extend({
  message: z.string()
});
var updateAnotacaoResponseSchema = createAnotacaoResponseSchema;
var deleteLeadAnotacaoResponseSchema = messageResponseSchema;
var anotacoesResponseSchema = z.object({
  success: z.boolean(),
  annotations: z.array(anotacaoSchema)
});
var leadInteressesResponseSchema = z.object({
  success: z.boolean(),
  data: z.object({
    imoveis: z.array(z.any()),
    empreendimentos: z.array(z.any())
  }),
  message: z.string().optional()
});
var convertLeadResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  data: z.object({ oportunidadeId: z.string().optional() }).optional()
});
var leadsListEnvelopeSchema = listResponse(leadSchema);

// src/propostas/index.ts
var propostas_exports = {};
__export(propostas_exports, {
  createPropostaRequestSchema: () => createPropostaRequestSchema,
  createPropostaResponseSchema: () => createPropostaResponseSchema,
  deletePropostaResponseSchema: () => deletePropostaResponseSchema,
  propostaDetailSchema: () => propostaDetailSchema,
  propostaFinalidadeEnum: () => propostaFinalidadeEnum,
  propostaListQuerySchema: () => propostaListQuerySchema,
  propostaParamsSchema: () => propostaParamsSchema2,
  propostaResponseSchema: () => propostaResponseSchema,
  propostaSchema: () => propostaSchema,
  propostaStatusEnum: () => propostaStatusEnum,
  propostasResponseSchema: () => propostasResponseSchema,
  updatePropostaRequestSchema: () => updatePropostaRequestSchema,
  updatePropostaResponseSchema: () => updatePropostaResponseSchema
});
var propostaFinalidadeEnum = z.enum(["Venda", "Locacao"]);
var propostaStatusEnum = z.enum([
  "Aceita",
  "Pendente",
  "Recusada",
  "Expirada",
  "Cancelada"
]);
var camposCustomizadosInput2 = z.record(
  z.string(),
  z.union([z.string(), z.number(), z.boolean(), z.null()])
);
var propostaListQuerySchema = z.object({
  page: z.coerce.number().min(1).optional(),
  take: z.coerce.number().min(1).max(100).optional(),
  status: propostaStatusEnum.optional(),
  finalidade: propostaFinalidadeEnum.optional(),
  imovelId: z.coerce.number().optional(),
  clienteId: z.coerce.number().optional(),
  oportunidadeId: z.string().optional(),
  responsavel: z.coerce.number().optional(),
  periodoInicio: z.string().optional(),
  periodoFim: z.string().optional(),
  order: z.string().optional(),
  orderBy: z.string().optional(),
  search: z.string().optional()
});
var propostaParamsSchema2 = z.object({
  dashboardId: z.coerce.number().int().min(1),
  id: z.coerce.number().int().min(1)
});
var createPropostaRequestSchema = z.object({
  imovel: z.number(),
  responsavel: z.number(),
  oportunidade: z.string().optional(),
  cliente: z.number(),
  valor: z.string(),
  finalidade: propostaFinalidadeEnum,
  anotacoes: z.string().optional(),
  status: propostaStatusEnum.optional(),
  expiraEm: z.string(),
  camposCustomizados: camposCustomizadosInput2.optional()
});
var updatePropostaRequestSchema = z.object({
  imovel: z.number().optional(),
  responsavel: z.number().optional(),
  oportunidade: z.string().optional(),
  cliente: z.number().optional(),
  valor: z.string().optional(),
  finalidade: propostaFinalidadeEnum.optional(),
  anotacoes: z.string().optional(),
  status: propostaStatusEnum.optional(),
  expiraEm: z.string().optional(),
  camposCustomizados: camposCustomizadosInput2.optional()
});
var funilPropostaSchema = z.object({
  id: z.number(),
  dashboardId: z.number(),
  value: z.string(),
  label: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  order: z.number()
}).nullable().optional();
var imovelValoresPropostaSchema = z.union([
  z.array(z.object({ valor: z.number().nullable() })),
  z.object({ valor: z.number().nullable() })
]).nullable();
var propostaSchema = z.object({
  id: z.number(),
  valor: z.number(),
  finalidade: propostaFinalidadeEnum,
  anotacoes: z.string().nullable(),
  status: propostaStatusEnum,
  expiraEm: z.string(),
  dashboardId: z.number(),
  imovelId: z.number(),
  /** Prisma permite proposta sem responsável (`responsavelId Int?`). */
  responsavelId: z.number().nullable(),
  clienteId: z.number(),
  oportunidadeId: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  responsavel: z.object({
    id: z.number(),
    nome: z.string().nullable(),
    sobrenome: z.string().nullable(),
    image: z.string().nullable()
  }).nullable().optional(),
  imovel: z.object({
    id: z.number(),
    titulo: z.string(),
    codigo: z.string(),
    valoresLocacao: imovelValoresPropostaSchema,
    valoresVenda: imovelValoresPropostaSchema
  }).optional(),
  oportunidade: z.object({
    id: z.string(),
    titulo: z.string(),
    funil: funilPropostaSchema
  }).nullable().optional(),
  cliente: z.object({
    id: z.number(),
    nome: z.string().nullable(),
    sobrenome: z.string().nullable()
  }).optional()
});
var imovelPropostaDetailSchema = z.object({
  id: z.number(),
  titulo: z.string(),
  codigo: z.string(),
  proprietarios: z.array(
    z.object({
      proprietario: z.object({
        id: z.number(),
        nome: z.string().nullable(),
        sobrenome: z.string().nullable()
      })
    })
  ).optional()
});
var oportunidadePropostaDetailSchema = z.object({
  id: z.string(),
  titulo: z.string(),
  funil: funilPropostaSchema,
  contato: z.object({
    id: z.number(),
    nome: z.string().nullable(),
    sobrenome: z.string().nullable(),
    email: z.string().nullable(),
    telefone: z.string().nullable()
  }).optional()
});
var propostaDetailSchema = propostaSchema.extend({
  imovel: imovelPropostaDetailSchema,
  oportunidade: oportunidadePropostaDetailSchema.nullable(),
  cliente: z.object({
    id: z.number(),
    nome: z.string().nullable(),
    sobrenome: z.string().nullable(),
    email: z.string().nullable(),
    telefone: z.string().nullable()
  }).optional(),
  camposCustomizados: z.record(z.string(), z.any()).optional().nullable()
});
var propostasResponseSchema = listResponse(propostaSchema);
var propostaResponseSchema = propostaDetailSchema;
var createPropostaResponseSchema = propostaSchema;
var updatePropostaResponseSchema = propostaSchema;
var deletePropostaResponseSchema = messageResponseSchema;

// src/registro-chaves/index.ts
var registro_chaves_exports = {};
__export(registro_chaves_exports, {
  createRegistroChaveRequestSchema: () => createRegistroChaveRequestSchema,
  createRegistroChaveResponseSchema: () => createRegistroChaveResponseSchema,
  deleteRegistroChaveResponseSchema: () => deleteRegistroChaveResponseSchema,
  motivoRetiradaEnum: () => motivoRetiradaEnum,
  registroChaveListQuerySchema: () => registroChaveListQuerySchema,
  registroChaveListResponseSchema: () => registroChaveListResponseSchema,
  registroChaveParamsSchema: () => registroChaveParamsSchema,
  registroChaveResponseSchema: () => registroChaveResponseSchema,
  registroChaveSchema: () => registroChaveSchema,
  statusRetiradaEnum: () => statusRetiradaEnum,
  tipoRetiradaEnum: () => tipoRetiradaEnum,
  updateRegistroChaveRequestSchema: () => updateRegistroChaveRequestSchema,
  updateRegistroChaveResponseSchema: () => updateRegistroChaveResponseSchema
});
var tipoRetiradaEnum = z.enum(["Temporaria", "Permanente"]);
var motivoRetiradaEnum = z.enum(["Visita", "Manutencao", "Vistoria"]);
var statusRetiradaEnum = z.enum([
  "Aguardando",
  "Atrasado",
  "Devolvido"
]);
var registroChaveParamsSchema = z.object({
  dashboard: z.coerce.number().int().min(1),
  id: z.coerce.number().int().min(1)
});
var registroChaveListQuerySchema = z.object({
  search: z.string().optional(),
  page: z.coerce.number().min(1).optional(),
  take: z.coerce.number().min(1).max(100).optional(),
  status: statusRetiradaEnum.optional(),
  tipoRetirada: tipoRetiradaEnum.optional(),
  motivoRetirada: motivoRetiradaEnum.optional(),
  responsavelId: z.coerce.number().optional(),
  responsavelUsuarioId: z.coerce.number().optional(),
  imovelId: z.coerce.number().optional(),
  imovel: z.string().optional(),
  responsavel: z.string().optional(),
  periodoInicio: z.string().optional(),
  periodoFim: z.string().optional(),
  entregueEmInicio: z.string().optional(),
  entregueEmFim: z.string().optional(),
  order: z.string().optional(),
  orderBy: z.string().optional()
});
var createRegistroChaveRequestSchema = z.object({
  tipoRetirada: tipoRetiradaEnum,
  motivoRetirada: motivoRetiradaEnum,
  responsavelId: z.number().optional(),
  responsavelUsuarioId: z.number().optional(),
  dataRetirada: z.string(),
  previsaoEntrega: z.string(),
  entregueEm: z.string().optional(),
  status: statusRetiradaEnum.optional(),
  chaves: z.array(z.string()).min(1).max(50),
  observacoes: z.string().optional()
}).refine(
  (data) => Boolean(data.responsavelId) || Boolean(data.responsavelUsuarioId),
  {
    message: "responsavelId \xE9 obrigat\xF3rio quando responsavelUsuarioId n\xE3o \xE9 informado",
    path: ["responsavelId"]
  }
);
var updateRegistroChaveRequestSchema = z.object({
  tipoRetirada: tipoRetiradaEnum.optional(),
  motivoRetirada: motivoRetiradaEnum.optional(),
  responsavelId: z.number().optional(),
  responsavelUsuarioId: z.number().optional(),
  dataRetirada: z.string().optional(),
  previsaoEntrega: z.string().optional(),
  entregueEm: z.string().optional(),
  status: statusRetiradaEnum.optional(),
  chaves: z.array(z.string()).min(1).max(50).optional(),
  observacoes: z.string().optional()
});
var usuarioMiniSchema = z.object({
  id: z.number(),
  nome: z.string().nullable(),
  sobrenome: z.string().nullable(),
  email: z.string()
});
var registroChaveSchema = z.object({
  id: z.number(),
  tipoRetirada: tipoRetiradaEnum,
  motivoRetirada: motivoRetiradaEnum,
  responsavelId: z.number().nullable(),
  responsavelUsuarioId: z.number().nullable(),
  dataRetirada: z.string(),
  previsaoEntrega: z.string(),
  entregueEm: z.string().nullable(),
  status: statusRetiradaEnum,
  observacoes: z.string().nullable(),
  dashboardId: z.number(),
  createdAt: z.string(),
  updatedAt: z.string(),
  criadoPorId: z.number().nullable(),
  responsavel: z.object({
    id: z.number(),
    nome: z.string().nullable(),
    sobrenome: z.string().nullable()
  }).nullable().optional(),
  responsavelUsuario: usuarioMiniSchema.nullable().optional(),
  criadoPor: usuarioMiniSchema.nullable().optional(),
  chaves: z.array(
    z.union([
      z.object({
        chaveId: z.string(),
        registroChaveId: z.number(),
        chave: z.object({
          id: z.string(),
          codigo: z.string(),
          quantidade: z.number(),
          imovel: z.object({ id: z.number(), titulo: z.string() })
        })
      }),
      z.object({
        id: z.string(),
        codigo: z.string(),
        quantidade: z.number(),
        imovel: z.object({ id: z.number(), titulo: z.string() })
      })
    ])
  )
});
var registroChaveMetaSchema = paginationMetaSchema.extend({
  totalPages: z.number().catch(0).optional()
});
var registroChaveListResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(registroChaveSchema),
  meta: registroChaveMetaSchema,
  message: z.string().optional()
});
var registroChaveResponseSchema = dataResponse(registroChaveSchema);
var createRegistroChaveResponseSchema = dataResponse(registroChaveSchema);
var updateRegistroChaveResponseSchema = dataResponse(registroChaveSchema);
var deleteRegistroChaveResponseSchema = messageResponseSchema;

// src/oportunidades/index.ts
var oportunidades_exports = {};
__export(oportunidades_exports, {
  concluirTarefaOportunidadeResponseSchema: () => concluirTarefaOportunidadeResponseSchema,
  contatoKanbanSchema: () => contatoKanbanSchema,
  createEtapaRequestSchema: () => createEtapaRequestSchema,
  createEtapaResponseSchema: () => createEtapaResponseSchema,
  createFunilRequestSchema: () => createFunilRequestSchema,
  createFunilResponseSchema: () => createFunilResponseSchema,
  createHistoricoRequestSchema: () => createHistoricoRequestSchema,
  createInteresseRequestSchema: () => createInteresseRequestSchema,
  createOportunidadeAnotacaoRequestSchema: () => createOportunidadeAnotacaoRequestSchema,
  createOportunidadeRequestSchema: () => createOportunidadeRequestSchema,
  createOportunidadeResponseSchema: () => createOportunidadeResponseSchema,
  createTarefaOportunidadeRequestSchema: () => createTarefaOportunidadeRequestSchema,
  deleteEtapaResponseSchema: () => deleteEtapaResponseSchema,
  deleteFunilResponseSchema: () => deleteFunilResponseSchema,
  deleteInteresseResponseSchema: () => deleteInteresseResponseSchema,
  deleteOportunidadeAnotacaoResponseSchema: () => deleteOportunidadeAnotacaoResponseSchema,
  deleteOportunidadeResponseSchema: () => deleteOportunidadeResponseSchema,
  etapaDetailResponseSchema: () => etapaDetailResponseSchema,
  etapaKanbanRefSchema: () => etapaKanbanRefSchema,
  etapaKanbanSchema: () => etapaKanbanSchema,
  etapaOportunidadeSchema: () => etapaOportunidadeSchema,
  etapaSchema: () => etapaSchema,
  etapasResponseSchema: () => etapasResponseSchema,
  funilDetailResponseSchema: () => funilDetailResponseSchema,
  funilKanbanResponseSchema: () => funilKanbanResponseSchema,
  funilKanbanSchema: () => funilKanbanSchema,
  funilSchema: () => funilSchema,
  funisResponseSchema: () => funisResponseSchema,
  historicoOportunidadeItemSchema: () => historicoOportunidadeItemSchema,
  historicoOportunidadeResponseSchema: () => historicoOportunidadeResponseSchema,
  interesseResponseSchema: () => interesseResponseSchema,
  interesseSchema: () => interesseSchema,
  interessesResponseSchema: () => interessesResponseSchema,
  marcarComoGanhaOportunidadeSchema: () => marcarComoGanhaOportunidadeSchema,
  marcarComoGanhaRequestSchema: () => marcarComoGanhaRequestSchema,
  marcarComoGanhaResponseSchema: () => marcarComoGanhaResponseSchema,
  oportunidadeAnotacaoResponseSchema: () => oportunidadeAnotacaoResponseSchema,
  oportunidadeAnotacaoSchema: () => oportunidadeAnotacaoSchema,
  oportunidadeAnotacoesResponseSchema: () => oportunidadeAnotacoesResponseSchema,
  oportunidadeDetalhesResponseSchema: () => oportunidadeDetalhesResponseSchema,
  oportunidadeDetalhesSchema: () => oportunidadeDetalhesSchema,
  oportunidadeEmpreendimentosListResponseSchema: () => oportunidadeEmpreendimentosListResponseSchema,
  oportunidadeGroupSchema: () => oportunidadeGroupSchema,
  oportunidadeImoveisListResponseSchema: () => oportunidadeImoveisListResponseSchema,
  oportunidadeKanbanSchema: () => oportunidadeKanbanSchema,
  oportunidadeListPaginationSchema: () => oportunidadeListPaginationSchema,
  oportunidadeQuerySchema: () => oportunidadeQuerySchema,
  oportunidadeSchema: () => oportunidadeSchema,
  oportunidadeStatusEnum: () => oportunidadeStatusEnum,
  oportunidadesGroupResponseSchema: () => oportunidadesGroupResponseSchema,
  oportunidadesResponseSchema: () => oportunidadesResponseSchema,
  origemKanbanSchema: () => origemKanbanSchema,
  responsavelKanbanSchema: () => responsavelKanbanSchema,
  tarefaKanbanSchema: () => tarefaKanbanSchema,
  tarefaOportunidadeResponseSchema: () => tarefaOportunidadeResponseSchema,
  tarefaOportunidadeSchema: () => tarefaOportunidadeSchema,
  tarefasOportunidadeResponseSchema: () => tarefasOportunidadeResponseSchema,
  updateEtapaRequestSchema: () => updateEtapaRequestSchema,
  updateEtapaResponseSchema: () => updateEtapaResponseSchema,
  updateFunilRequestSchema: () => updateFunilRequestSchema,
  updateFunilResponseSchema: () => updateFunilResponseSchema,
  updateInteresseRequestSchema: () => updateInteresseRequestSchema,
  updateOportunidadeAnotacaoRequestSchema: () => updateOportunidadeAnotacaoRequestSchema,
  updateOportunidadeRequestSchema: () => updateOportunidadeRequestSchema,
  updateOportunidadeResponseSchema: () => updateOportunidadeResponseSchema,
  updateTarefaOportunidadeRequestSchema: () => updateTarefaOportunidadeRequestSchema
});

// src/empreendimentos/index.ts
var empreendimentos_exports = {};
__export(empreendimentos_exports, {
  createEmpreendimentoRequestSchema: () => createEmpreendimentoRequestSchema,
  createEmpreendimentoResponseSchema: () => createEmpreendimentoResponseSchema,
  createEmpreendimentoSiteRequestSchema: () => createEmpreendimentoSiteRequestSchema,
  deleteEmpreendimentoResponseSchema: () => deleteEmpreendimentoResponseSchema,
  empAnexoAccessUrlResponseSchema: () => empAnexoAccessUrlResponseSchema,
  empAnexoResponseSchema: () => empAnexoResponseSchema,
  empAnexoSchema: () => empAnexoSchema,
  empAnexoUploadUrlResponseSchema: () => empAnexoUploadUrlResponseSchema,
  empAnexosResponseSchema: () => empAnexosResponseSchema,
  empCaracteristicasResponseSchema: () => empCaracteristicasResponseSchema,
  empCaracteristicasSchema: () => empCaracteristicasSchema,
  empComodidadeInputItemSchema: () => empComodidadeInputItemSchema,
  empComodidadeResponseItemSchema: () => empComodidadeResponseItemSchema,
  empComodidadeResponseSchema: () => empComodidadeResponseSchema,
  empComodidadesResponseSchema: () => empComodidadesResponseSchema,
  empCreateAnexoSchema: () => empCreateAnexoSchema,
  empCreateComodidadeSchema: () => empCreateComodidadeSchema,
  empCreateFotoSchema: () => empCreateFotoSchema,
  empCreateManyComodidadesSchema: () => empCreateManyComodidadesSchema,
  empCreateManyFotosSchema: () => empCreateManyFotosSchema,
  empCreateSiteSchema: () => empCreateSiteSchema,
  empCreateTagSchema: () => empCreateTagSchema,
  empCreateTourVirtualSchema: () => empCreateTourVirtualSchema,
  empCreateVideoSchema: () => empCreateVideoSchema,
  empDeleteManyComodidadesSchema: () => empDeleteManyComodidadesSchema,
  empFotoItemSchema: () => empFotoItemSchema,
  empFotoResponseSchema: () => empFotoResponseSchema,
  empFotoSchema: () => empFotoSchema,
  empFotosResponseSchema: () => empFotosResponseSchema,
  empGenerateAnexoUploadUrlSchema: () => empGenerateAnexoUploadUrlSchema,
  empLocalizacaoResponseSchema: () => empLocalizacaoResponseSchema,
  empLocalizacaoSchema: () => empLocalizacaoSchema,
  empManyComodidadesResponseSchema: () => empManyComodidadesResponseSchema,
  empPadraoLocalizacaoSchema: () => padraoLocalizacaoSchema,
  empPadroesLocalizacaoResponseSchema: () => padroesLocalizacaoResponseSchema,
  empSiteResponseSchema: () => empSiteResponseSchema,
  empSiteSchema: () => empSiteSchema,
  empSitesResponseSchema: () => empSitesResponseSchema,
  empTagResponseSchema: () => empTagResponseSchema,
  empTagSchema: () => empTagSchema,
  empTagsResponseSchema: () => empTagsResponseSchema,
  empTourResponseSchema: () => empTourResponseSchema,
  empTourSchema: () => empTourSchema,
  empToursResponseSchema: () => empToursResponseSchema,
  empUpdateAnexoSchema: () => empUpdateAnexoSchema,
  empUpdateCaracteristicasSchema: () => empUpdateCaracteristicasSchema,
  empUpdateComodidadeSchema: () => empUpdateComodidadeSchema,
  empUpdateFotoItemSchema: () => empUpdateFotoItemSchema,
  empUpdateFotoSchema: () => empUpdateFotoSchema,
  empUpdateLocalizacaoSchema: () => empUpdateLocalizacaoSchema,
  empUpdateManyComodidadesSchema: () => empUpdateManyComodidadesSchema,
  empUpdateManyFotosSchema: () => empUpdateManyFotosSchema,
  empUpdateSiteSchema: () => empUpdateSiteSchema,
  empUpdateTagSchema: () => empUpdateTagSchema,
  empUpdateTourVirtualSchema: () => empUpdateTourVirtualSchema,
  empUpdateVideoSchema: () => empUpdateVideoSchema,
  empVideoResponseSchema: () => empVideoResponseSchema,
  empVideoSchema: () => empVideoSchema,
  empVideosResponseSchema: () => empVideosResponseSchema,
  empreendimentoDetailResponseSchema: () => empreendimentoDetailResponseSchema,
  empreendimentoRelacaoSchema: () => empreendimentoRelacaoSchema,
  empreendimentoSchema: () => empreendimentoSchema,
  empreendimentoSiteResponseSchema: () => empreendimentoSiteResponseSchema,
  empreendimentoSiteSchema: () => empreendimentoSiteSchema,
  empreendimentoSitesResponseSchema: () => empreendimentoSitesResponseSchema,
  empreendimentosListResponseSchema: () => empreendimentosListResponseSchema,
  empreendimentosSearchDataPayloadSchema: () => empreendimentosSearchDataPayloadSchema,
  empreendimentosSearchDataResponseSchema: () => empreendimentosSearchDataResponseSchema,
  queryEmpreendimentoSchema: () => queryEmpreendimentoSchema,
  searchDataQuerySchema: () => searchDataQuerySchema,
  updateEmpreendimentoRequestSchema: () => updateEmpreendimentoRequestSchema,
  updateEmpreendimentoResponseSchema: () => updateEmpreendimentoResponseSchema,
  updateEmpreendimentoSiteRequestSchema: () => updateEmpreendimentoSiteRequestSchema
});

// src/imoveis/index.ts
var imoveis_exports = {};
__export(imoveis_exports, {
  chaveResponsavelTipoEnum: () => chaveResponsavelTipoEnum,
  comodidadeItemSchema: () => comodidadeItemSchema,
  cotacaoTemporadaDataSchema: () => cotacaoTemporadaDataSchema,
  cotacaoTemporadaResponseSchema: () => cotacaoTemporadaResponseSchema,
  cotacaoTemporadaSchema: () => cotacaoTemporadaSchema,
  createChaveSchema: () => createChaveSchema,
  createComodidadeSchema: () => createComodidadeSchema,
  createFotoPrivadaSchema: () => createFotoPrivadaSchema,
  createFotoSchema: () => createFotoSchema,
  createImovelAnexoSchema: () => createImovelAnexoSchema,
  createImovelPortalSchema: () => createImovelPortalSchema,
  createImovelRequestSchema: () => createImovelRequestSchema,
  createImovelResponseSchema: () => createImovelResponseSchema,
  createImovelSiteSchema: () => createImovelSiteSchema,
  createManyComodidadesSchema: () => createManyComodidadesSchema,
  createManyFotosSchema: () => createManyFotosSchema,
  createManyProprietariosSchema: () => createManyProprietariosSchema,
  createPortalConfigRequestSchema: () => createPortalConfigRequestSchema,
  createProprietarioSchema: () => createProprietarioSchema,
  createResponsavelSchema: () => createResponsavelSchema,
  createTemporadaRegraSchema: () => createTemporadaRegraSchema,
  createTourVirtualSchema: () => createTourVirtualSchema,
  createVideoSchema: () => createVideoSchema,
  deleteImovelResponseSchema: () => deleteImovelResponseSchema,
  deleteManyComodidadesSchema: () => deleteManyComodidadesSchema,
  fotoItemSchema: () => fotoItemSchema,
  generateImovelAnexoUploadUrlSchema: () => generateImovelAnexoUploadUrlSchema,
  imoveisListResponseSchema: () => imoveisListResponseSchema,
  imoveisSearchDataPayloadSchema: () => imoveisSearchDataPayloadSchema,
  imoveisSearchDataSchema: () => imoveisSearchDataSchema,
  imovelAnexoAccessUrlDataSchema: () => imovelAnexoAccessUrlDataSchema,
  imovelAnexoAccessUrlResponseSchema: () => imovelAnexoAccessUrlResponseSchema,
  imovelAnexoResponseSchema: () => imovelAnexoResponseSchema,
  imovelAnexoSchema: () => imovelAnexoSchema,
  imovelAnexoUploadUrlResponseSchema: () => imovelAnexoUploadUrlResponseSchema,
  imovelAnexosResponseSchema: () => imovelAnexosResponseSchema,
  imovelAreaConstrucaoSchema: () => imovelAreaConstrucaoSchema,
  imovelAreaRuralSchema: () => imovelAreaRuralSchema,
  imovelAreaTerrenoSchema: () => imovelAreaTerrenoSchema,
  imovelAreasConstrucaoResponseSchema: () => imovelAreasConstrucaoResponseSchema,
  imovelAreasResponseSchema: () => imovelAreasResponseSchema,
  imovelAreasRuralResponseSchema: () => imovelAreasRuralResponseSchema,
  imovelAreasSchema: () => imovelAreasSchema,
  imovelAreasTerrenoResponseSchema: () => imovelAreasTerrenoResponseSchema,
  imovelCampanhaVinculoSchema: () => imovelCampanhaVinculoSchema,
  imovelCampanhasVinculoResponseSchema: () => imovelCampanhasVinculoResponseSchema,
  imovelCaracteristicasResponseSchema: () => imovelCaracteristicasResponseSchema,
  imovelCaracteristicasSchema: () => imovelCaracteristicasSchema,
  imovelChaveResponseSchema: () => imovelChaveResponseSchema,
  imovelChaveSchema: () => imovelChaveSchema,
  imovelChavesResponseSchema: () => imovelChavesResponseSchema,
  imovelComodidadeItemSchema: () => imovelComodidadeItemSchema,
  imovelComodidadeResponseSchema: () => imovelComodidadeResponseSchema,
  imovelComodidadesResponseSchema: () => imovelComodidadesResponseSchema,
  imovelDetailResponseSchema: () => imovelDetailResponseSchema,
  imovelDetailSchema: () => imovelDetailSchema,
  imovelDocumentosCadastraisResponseSchema: () => imovelDocumentosCadastraisResponseSchema,
  imovelDocumentosCadastraisSchema: () => imovelDocumentosCadastraisSchema,
  imovelFinalidadeItemSchema: () => imovelFinalidadeItemSchema,
  imovelFinalidadeResponseSchema: () => imovelFinalidadeResponseSchema,
  imovelFinalidadesResponseSchema: () => imovelFinalidadesResponseSchema,
  imovelFotoPrivadaResponseSchema: () => imovelFotoPrivadaResponseSchema,
  imovelFotoPrivadaSchema: () => imovelFotoPrivadaSchema,
  imovelFotoResponseSchema: () => imovelFotoResponseSchema,
  imovelFotoSchema: () => imovelFotoSchema,
  imovelFotosPrivadasResponseSchema: () => imovelFotosPrivadasResponseSchema,
  imovelFotosResponseSchema: () => imovelFotosResponseSchema,
  imovelListItemSchema: () => imovelListItemSchema,
  imovelLocalizacaoResponseSchema: () => imovelLocalizacaoResponseSchema,
  imovelLocalizacaoSchema: () => imovelLocalizacaoSchema,
  imovelManyComodidadesResponseSchema: () => imovelManyComodidadesResponseSchema,
  imovelMotivosFinalidadeResponseSchema: () => imovelMotivosFinalidadeResponseSchema,
  imovelPortaisResponseSchema: () => imovelPortaisResponseSchema,
  imovelPortalResponseSchema: () => imovelPortalResponseSchema,
  imovelPortalSchema: () => imovelPortalSchema,
  imovelPresignedUrlRequestSchema: () => presignedUrlRequestSchema,
  imovelPresignedUrlResponseSchema: () => presignedUrlResponseSchema,
  imovelProprietarioResponseSchema: () => imovelProprietarioResponseSchema,
  imovelProprietarioSchema: () => imovelProprietarioSchema,
  imovelProprietariosResponseSchema: () => imovelProprietariosResponseSchema,
  imovelResponsaveisResponseSchema: () => imovelResponsaveisResponseSchema,
  imovelResponsavelResponseSchema: () => imovelResponsavelResponseSchema,
  imovelResponsavelSchema: () => imovelResponsavelSchema,
  imovelSiteResponseSchema: () => imovelSiteResponseSchema,
  imovelSiteSchema: () => imovelSiteSchema,
  imovelSitesResponseSchema: () => imovelSitesResponseSchema,
  imovelTaxasResponseSchema: () => imovelTaxasResponseSchema,
  imovelTaxasSchema: () => imovelTaxasSchema,
  imovelTemporadaModoPacoteEnum: () => imovelTemporadaModoPacoteEnum,
  imovelTemporadaRegraResponseSchema: () => imovelTemporadaRegraResponseSchema,
  imovelTemporadaRegraSchema: () => imovelTemporadaRegraSchema,
  imovelTemporadaTipoCobrancaEnum: () => imovelTemporadaTipoCobrancaEnum,
  imovelTourResponseSchema: () => imovelTourResponseSchema,
  imovelTourSchema: () => imovelTourSchema,
  imovelToursResponseSchema: () => imovelToursResponseSchema,
  imovelValoresLocacaoResponseSchema: () => imovelValoresLocacaoResponseSchema,
  imovelValoresLocacaoSchema: () => imovelValoresLocacaoSchema,
  imovelValoresTemporadaResponseSchema: () => imovelValoresTemporadaResponseSchema,
  imovelValoresTemporadaSchema: () => imovelValoresTemporadaSchema,
  imovelValoresVendaResponseSchema: () => imovelValoresVendaResponseSchema,
  imovelValoresVendaSchema: () => imovelValoresVendaSchema,
  imovelVideoResponseSchema: () => imovelVideoResponseSchema,
  imovelVideoSchema: () => imovelVideoSchema,
  imovelVideosResponseSchema: () => imovelVideosResponseSchema,
  iptuPeriodoEnum: () => iptuPeriodoEnum,
  padraoLocalizacaoSchema: () => padraoLocalizacaoSchema,
  padroesLocalizacaoResponseSchema: () => padroesLocalizacaoResponseSchema,
  portaisComConfigResponseSchema: () => portaisComConfigResponseSchema,
  portaisDisponiveisResponseSchema: () => portaisDisponiveisResponseSchema,
  portaisStatsResponseSchema: () => portaisStatsResponseSchema,
  portaisStatsSchema: () => portaisStatsSchema,
  portalComConfigSchema: () => portalComConfigSchema,
  portalConfigResponseSchema: () => portalConfigResponseSchema,
  portalConfigSchema: () => portalConfigSchema,
  portalDisponivelSchema: () => portalDisponivelSchema,
  proprietarioItemSchema: () => proprietarioItemSchema,
  queryImovelSchema: () => queryImovelSchema,
  seguroIncendioPeriodoEnum: () => seguroIncendioPeriodoEnum,
  tagIdsRequestSchema: () => tagIdsRequestSchema,
  tipoAnuncioPortalEnum: () => tipoAnuncioPortalEnum,
  updateAreasConstrucaoSchema: () => updateAreasConstrucaoSchema,
  updateAreasRuralSchema: () => updateAreasRuralSchema,
  updateAreasTerrenoSchema: () => updateAreasTerrenoSchema,
  updateCaracteristicasSchema: () => updateCaracteristicasSchema,
  updateChaveSchema: () => updateChaveSchema,
  updateComodidadeSchema: () => updateComodidadeSchema,
  updateFinalidadeSchema: () => updateFinalidadeSchema,
  updateFotoItemSchema: () => updateFotoItemSchema,
  updateFotoPrivadaSchema: () => updateFotoPrivadaSchema,
  updateFotoSchema: () => updateFotoSchema,
  updateImovelAnexoSchema: () => updateImovelAnexoSchema,
  updateImovelDocumentosSchema: () => updateImovelDocumentosSchema,
  updateImovelPortalSchema: () => updateImovelPortalSchema,
  updateImovelRequestSchema: () => updateImovelRequestSchema,
  updateImovelResponseSchema: () => updateImovelResponseSchema,
  updateImovelSiteSchema: () => updateImovelSiteSchema,
  updateLocalizacaoSchema: () => updateLocalizacaoSchema,
  updateManyComodidadesSchema: () => updateManyComodidadesSchema,
  updateManyFotosSchema: () => updateManyFotosSchema,
  updatePortalConfigRequestSchema: () => updatePortalConfigRequestSchema,
  updateProprietarioSchema: () => updateProprietarioSchema,
  updateResponsavelSchema: () => updateResponsavelSchema,
  updateTaxasImpostosSchema: () => updateTaxasImpostosSchema,
  updateTemporadaRegraSchema: () => updateTemporadaRegraSchema,
  updateTourVirtualSchema: () => updateTourVirtualSchema,
  updateValoresLocacaoSchema: () => updateValoresLocacaoSchema,
  updateValoresTemporadaSchema: () => updateValoresTemporadaSchema,
  updateValoresVendaSchema: () => updateValoresVendaSchema,
  updateVideoSchema: () => updateVideoSchema
});
var tipoAnuncioPortalEnum = z.enum([
  "Normal",
  "Destaque",
  "SuperDestaque"
]);
var jsonDescricao = z.preprocess((v) => {
  if (typeof v === "string") {
    try {
      return JSON.parse(v);
    } catch {
      return v;
    }
  }
  return v;
}, z.any());
var camposCustomizadosInput3 = z.record(
  z.string(),
  z.union([z.string(), z.number(), z.boolean()])
);
var numberListCsv = z.preprocess((v) => {
  if (typeof v === "string") return v.split(",").map((s) => Number(s.trim()));
  return v;
}, z.array(z.coerce.number()));
var stringListCsv = z.preprocess((v) => {
  if (typeof v === "string") return v.split(",").map((s) => s.trim());
  return v;
}, z.array(z.string()));
var numberOrFalse = z.union([z.literal("false"), z.coerce.number()]);
var createImovelRequestSchema = z.object({
  titulo: z.string().min(1, "T\xEDtulo \xE9 obrigat\xF3rio").max(255),
  codigo: z.string().max(50).optional(),
  status: z.string().max(50).optional(),
  uso: z.string().max(50).optional(),
  tipo: z.string().max(50).optional(),
  subTipo: z.string().max(50).optional(),
  empreendimentoId: z.coerce.number().min(1).optional(),
  incorporadoraId: z.coerce.number().min(1).optional(),
  descricao: jsonDescricao.optional(),
  destacado: booleanLike.optional(),
  tagIds: z.array(z.coerce.number()).optional(),
  camposCustomizados: camposCustomizadosInput3.optional()
});
var nullableRelationId = (min = 1) => z.union([z.coerce.number().min(min), z.null()]).optional();
var updateImovelRequestSchema = z.object({
  titulo: z.string().max(255).optional(),
  codigo: z.string().max(50).optional(),
  status: z.string().max(50).optional(),
  uso: z.string().max(50).optional(),
  tipo: z.string().max(50).optional(),
  subTipo: z.string().max(50).optional(),
  empreendimentoId: nullableRelationId(),
  incorporadoraId: nullableRelationId(),
  descricao: jsonDescricao.optional(),
  destacado: booleanLike.optional(),
  tagIds: numberListCsv.optional(),
  camposCustomizados: camposCustomizadosInput3.optional()
});
var num = z.coerce.number().optional();
var queryImovelSchema = z.object({
  search: z.string().optional(),
  forPerfil: booleanLike.optional(),
  titulo: z.string().optional(),
  codigo: z.string().optional(),
  status: z.string().optional(),
  uso: z.string().optional(),
  tipo: z.string().optional(),
  subTipo: z.string().optional(),
  empreendimentoId: numberOrFalse.optional(),
  incorporadoraId: numberOrFalse.optional(),
  uf: z.string().optional(),
  cidade: z.string().optional(),
  bairro: z.string().optional(),
  rua: z.string().optional(),
  distanciaPraia: z.string().optional(),
  condicao: z.string().optional(),
  mobiliado: z.string().optional(),
  localizacao: z.string().optional(),
  exclusividade: booleanLike.optional(),
  financiavel: booleanLike.optional(),
  exclusividadeVencida: booleanLike.optional(),
  comVideos: booleanLike.optional(),
  comTours: booleanLike.optional(),
  chaves: booleanLike.optional(),
  proprietarioId: numberOrFalse.optional(),
  responsavelId: numberOrFalse.optional(),
  siteId: z.string().optional(),
  finalidade: z.string().optional(),
  finalidadeDisponivel: z.string().optional(),
  finalidadeMotivoId: num,
  totalDormitorios: num,
  totalDormitoriosMin: num,
  totalDormitoriosMax: num,
  dormitorios: num,
  dormitoriosMin: num,
  dormitoriosMax: num,
  salas: num,
  salasMin: num,
  salasMax: num,
  vagasGaragem: num,
  vagasGaragemMin: num,
  vagasGaragemMax: num,
  valorVenda: num,
  valorVendaMin: num,
  valorVendaMax: num,
  valorLocacao: num,
  valorLocacaoMin: num,
  valorLocacaoMax: num,
  suites: num,
  suitesMin: num,
  suitesMax: num,
  banheiros: num,
  banheirosMin: num,
  banheirosMax: num,
  page: z.coerce.number().min(1).optional().default(1),
  itemsPerPage: z.coerce.number().min(1).max(100).optional().default(20),
  areaConstrucaoTotal: num,
  areaConstrucaoTotalMin: num,
  areaConstrucaoTotalMax: num,
  areaTerrenoTotal: num,
  areaTerrenoTotalMin: num,
  areaTerrenoTotalMax: num,
  areaRuralTotal: num,
  areaRuralTotalMin: num,
  areaRuralTotalMax: num,
  areaRuralAravel: num,
  areaRuralAravelMin: num,
  areaRuralAravelMax: num,
  demiSuites: num,
  demiSuitesMin: num,
  demiSuitesMax: num,
  pessoas: num,
  pessoasMin: num,
  pessoasMax: num,
  andar: num,
  andarMin: num,
  andarMax: num,
  anoConstrucao: num,
  anoConstrucaoMin: num,
  anoConstrucaoMax: num,
  esquina: booleanLike.optional(),
  aceitaPet: booleanLike.optional(),
  precisaReforma: booleanLike.optional(),
  vagasRotativas: num,
  vagasRotativasMin: num,
  vagasRotativasMax: num,
  entregaObra: z.string().optional(),
  orientacaoSolar: stringListCsv.optional(),
  posicao: stringListCsv.optional(),
  topografia: stringListCsv.optional(),
  atividadesRurais: stringListCsv.optional(),
  padraoClasse: z.string().optional(),
  zoneamento: z.string().optional(),
  areaUtil: num,
  areaUtilMin: num,
  areaUtilMax: num,
  areaPrivativa: num,
  areaPrivativaMin: num,
  areaPrivativaMax: num,
  alturaPeDireito: num,
  alturaPeDireitoMin: num,
  alturaPeDireitoMax: num,
  frente: num,
  frenteMin: num,
  frenteMax: num,
  fundo: num,
  fundoMin: num,
  fundoMax: num,
  lateralEsquerda: num,
  lateralEsquerdaMin: num,
  lateralEsquerdaMax: num,
  lateralDireita: num,
  lateralDireitaMin: num,
  lateralDireitaMax: num,
  sedes: num,
  sedesMin: num,
  sedesMax: num,
  temCondominio: booleanLike.optional(),
  condominioValor: num,
  condominioValorMin: num,
  condominioValorMax: num,
  iptuIsento: booleanLike.optional(),
  iptuValor: num,
  iptuValorMin: num,
  iptuValorMax: num,
  iptuPeriodo: z.string().optional(),
  temSeguroIncendio: booleanLike.optional(),
  seguroIncendioValor: num,
  seguroIncendioValorMin: num,
  seguroIncendioValorMax: num,
  seguroIncendioPeriodo: z.string().optional(),
  valorVendaAvaliacao: num,
  valorVendaAvaliacaoMin: num,
  valorVendaAvaliacaoMax: num,
  valorLocacaoBase: num,
  valorLocacaoBaseMin: num,
  valorLocacaoBaseMax: num,
  valorLocacaoAvaliacao: num,
  valorLocacaoAvaliacaoMin: num,
  valorLocacaoAvaliacaoMax: num,
  indiceReajusteId: num,
  comFotos: booleanLike.optional(),
  comAudios: booleanLike.optional(),
  comAnexos: booleanLike.optional(),
  comodidades: numberListCsv.optional(),
  campanhaIds: numberListCsv.optional(),
  portalIds: numberListCsv.optional(),
  tipoAnuncioPortal: z.preprocess((v) => {
    if (typeof v === "string") return v.split(",").map((s) => s.trim());
    return v;
  }, z.array(tipoAnuncioPortalEnum)).optional(),
  createdAtMin: z.string().optional(),
  createdAtMax: z.string().optional(),
  updatedAtMin: z.string().optional(),
  updatedAtMax: z.string().optional(),
  orderBy: z.string().optional(),
  orderDirection: z.enum(["asc", "desc"]).optional()
});
var tagIdsRequestSchema = z.object({
  tagIds: z.array(z.coerce.number())
});
var formOptInt = (min = 0) => z.preprocess(
  (v) => {
    if (v === "" || v === null || v === void 0) return void 0;
    const n = typeof v === "number" ? v : parseInt(String(v), 10);
    return Number.isNaN(n) ? void 0 : n;
  },
  z.number().int().min(min).optional()
);
var formNullableInt = (min = 0) => z.preprocess(
  (v) => {
    if (v === null) return null;
    if (v === "" || v === void 0) return void 0;
    const n = typeof v === "number" ? v : parseInt(String(v), 10);
    return Number.isNaN(n) ? void 0 : n;
  },
  z.number().int().min(min).nullish()
);
var formOptFloat = z.preprocess((v) => {
  if (v === "" || v === null || v === void 0) return void 0;
  const n = typeof v === "number" ? v : parseFloat(String(v));
  return Number.isNaN(n) ? void 0 : n;
}, z.number().optional());
var idNumberArray = z.preprocess(
  (v) => Array.isArray(v) ? v.map((x) => Number(x)) : [],
  z.array(z.number())
);
var mediaTitulo = z.string().trim().min(1, "T\xEDtulo \xE9 obrigat\xF3rio").max(255);
var mediaUrl = z.string().trim().min(1, "URL \xE9 obrigat\xF3ria").max(500);
var mediaOrderCreate = z.coerce.number().int().min(1).default(1);
var mediaOrderUpdate = formOptInt(1);
var createFotoSchema = z.object({
  titulo: mediaTitulo,
  url: mediaUrl,
  order: mediaOrderCreate
});
var updateFotoSchema = z.object({
  titulo: z.string().trim().min(1).max(255).optional(),
  order: mediaOrderUpdate
});
var fotoItemSchema = createFotoSchema;
var createManyFotosSchema = z.object({
  fotos: z.array(fotoItemSchema)
});
var updateFotoItemSchema = z.object({
  id: z.coerce.number().int().min(1),
  titulo: z.string().trim().min(1).max(255).optional(),
  order: mediaOrderUpdate
});
var updateManyFotosSchema = z.object({
  fotos: z.array(updateFotoItemSchema)
});
var createVideoSchema = z.object({
  titulo: mediaTitulo,
  url: mediaUrl,
  order: mediaOrderCreate
});
var updateVideoSchema = z.object({
  titulo: z.string().trim().min(1).max(255).optional(),
  url: z.string().trim().min(1).max(500).optional(),
  order: mediaOrderUpdate
});
var createTourVirtualSchema = z.object({
  titulo: mediaTitulo,
  url: mediaUrl,
  order: mediaOrderCreate
});
var updateTourVirtualSchema = z.object({
  titulo: z.string().trim().min(1).max(255).optional(),
  url: z.string().trim().min(1).max(500).optional(),
  order: mediaOrderUpdate
});
var createFotoPrivadaSchema = z.object({
  titulo: mediaTitulo,
  url: mediaUrl,
  order: mediaOrderCreate
});
var updateFotoPrivadaSchema = z.object({
  titulo: z.string().trim().min(1).max(255).optional(),
  order: mediaOrderUpdate
});
var createComodidadeSchema = z.object({
  comodidadeValue: z.number(),
  quantidade: z.number().int().min(1).optional()
});
var updateComodidadeSchema = z.object({
  quantidade: z.number().int().min(1).optional()
});
var comodidadeItemSchema = z.object({
  value: z.number(),
  quantidade: z.number().int().min(1).optional()
});
var createManyComodidadesSchema = z.object({
  comodidades: z.array(comodidadeItemSchema)
});
var updateManyComodidadesSchema = z.object({
  ids: z.array(z.number()),
  quantidade: z.number().int().min(1).optional()
});
var deleteManyComodidadesSchema = z.object({
  ids: z.array(z.number())
});
var chaveResponsavelTipoEnum = z.enum([
  "Imobiliaria",
  "Proprietario",
  "Outros"
]);
var createChaveSchema = z.object({
  codigo: z.string(),
  quantidade: z.number(),
  disponivel: z.boolean().optional(),
  observacoes: z.string().optional(),
  responsavelTipo: chaveResponsavelTipoEnum,
  responsavelId: z.number().optional()
});
var updateChaveSchema = z.object({
  codigo: z.string().optional(),
  quantidade: z.number().optional(),
  disponivel: z.boolean().optional(),
  observacoes: z.string().optional(),
  responsavelTipo: chaveResponsavelTipoEnum.optional(),
  responsavelId: z.number().optional()
});
var trimMax = (max) => z.preprocess(
  (v) => typeof v === "string" ? v.trim() : v,
  z.string().max(max).optional()
);
var updateLocalizacaoSchema = z.object({
  cep: trimMax(10),
  uf: trimMax(2),
  cidade: trimMax(100),
  cidadeSlug: z.string().optional(),
  rua: trimMax(200),
  numero: trimMax(20),
  bairro: trimMax(100),
  complemento: trimMax(200),
  pontoReferencia: trimMax(200),
  longitude: formOptFloat,
  latitude: formOptFloat,
  googleEarth: trimMax(500),
  distanciaPraia: formOptInt(0),
  padraoLocalizacaoValue: trimMax(50)
});
var updateCaracteristicasSchema = z.object({
  salas: formNullableInt(0),
  dormitorios: formNullableInt(0),
  suites: formNullableInt(0),
  demiSuites: formNullableInt(0),
  banheiros: formNullableInt(0),
  lavabos: formNullableInt(0),
  closets: formNullableInt(0),
  pessoas: formNullableInt(0),
  entregaObra: trimMax(50),
  orientacaoSolar: idNumberArray.optional(),
  posicao: idNumberArray.optional(),
  topografia: idNumberArray.optional(),
  atividadesRurais: idNumberArray.optional(),
  condicao: trimMax(50),
  mobiliado: trimMax(50),
  anoConstrucao: formNullableInt(1800),
  precisaReforma: booleanLike.optional(),
  anoReforma: formNullableInt(1800),
  zoneamento: trimMax(100),
  andar: formNullableInt(0),
  qtdAndar: formNullableInt(0),
  qtdUnidadePorAndar: formNullableInt(0),
  esquina: booleanLike.optional(),
  vagasRotativas: formNullableInt(0),
  vagasGaragem: formNullableInt(0),
  padraoClasse: trimMax(50),
  aceitaPet: booleanLike.optional()
});
var updateValoresVendaSchema = z.object({
  valorAvaliacao: z.number().optional(),
  valorComDesconto: z.number().optional(),
  dataAvaliacao: z.string().optional(),
  valor: z.number().optional(),
  ocultarValor: z.boolean().optional(),
  financiavel: z.boolean().optional(),
  tiposFinanciamentos: z.array(z.number()).optional(),
  usoFGTS: z.boolean().optional(),
  informacoesAdicionais: z.string().optional()
});
var updateValoresLocacaoSchema = z.object({
  valorAvaliacao: z.number().optional(),
  dataAvaliacao: z.string().optional(),
  valor: z.number().optional(),
  indiceReajuste: z.number().optional(),
  valorBase: z.number().optional(),
  valorComDesconto: z.number().optional(),
  informacoesAdicionais: z.string().optional(),
  ocultarValor: z.boolean().optional()
});
var updateValoresTemporadaSchema = z.object({
  valorAvaliacao: z.number().optional(),
  dataAvaliacao: z.string().optional(),
  valor: z.number().optional(),
  valorBase: z.number().optional(),
  valorComDesconto: z.number().optional(),
  informacoesAdicionais: z.string().optional(),
  ocultarValor: z.boolean().optional(),
  minNoitesPadrao: z.number().int().optional(),
  taxaLimpezaPadrao: z.number().optional()
});
var imovelTemporadaTipoCobrancaEnum = z.enum(["Diaria", "Pacote"]);
var imovelTemporadaModoPacoteEnum = z.enum([
  "Proporcional",
  "Fechado"
]);
var createTemporadaRegraSchema = z.object({
  nome: z.string().optional(),
  dataInicio: z.string(),
  dataFim: z.string(),
  tipoCobranca: imovelTemporadaTipoCobrancaEnum,
  modoPacote: imovelTemporadaModoPacoteEnum.optional(),
  precoPorNoite: z.number().optional(),
  valorPacote: z.number().optional(),
  minNoites: z.number().min(1).optional(),
  taxaLimpeza: z.number().optional(),
  ativo: z.boolean().optional()
});
var updateTemporadaRegraSchema = z.object({
  nome: z.string().optional(),
  dataInicio: z.string().optional(),
  dataFim: z.string().optional(),
  tipoCobranca: imovelTemporadaTipoCobrancaEnum.optional(),
  modoPacote: imovelTemporadaModoPacoteEnum.nullish(),
  precoPorNoite: z.number().nullish(),
  valorPacote: z.number().nullish(),
  minNoites: z.number().min(1).nullish(),
  taxaLimpeza: z.number().nullish(),
  ativo: z.boolean().optional()
});
var cotacaoTemporadaSchema = z.object({
  checkIn: z.string(),
  checkOut: z.string()
});
var iptuPeriodoEnum = z.enum(["Mensal", "Anual"]);
var seguroIncendioPeriodoEnum = z.enum(["Mensal", "Anual"]);
var updateTaxasImpostosSchema = z.object({
  condominio: z.boolean().optional(),
  condominioValor: z.number().optional(),
  inclusoCondominio: z.array(z.number()).optional(),
  condominioOcultarValor: z.boolean().optional(),
  iptuIsento: z.boolean().optional(),
  /**
   * Enums espelham as colunas Prisma `IptuPeriodo`/`SeguroIncendioPeriodo`
   * (Mensal|Anual) — antes eram `z.string()` livre, aceitando no request
   * valores que o response (`imovelTaxasSchema`) e o banco rejeitariam.
   */
  iptuPeriodo: iptuPeriodoEnum.optional(),
  iptuValor: z.number().optional(),
  iptuOcultarValor: z.boolean().optional(),
  seguroIncendio: z.boolean().optional(),
  seguroIncendioPeriodo: seguroIncendioPeriodoEnum.optional(),
  seguroIncendioValor: z.number().optional(),
  seguroIncendioOcultarValor: z.boolean().optional(),
  informacoesAdicionais: z.string().optional()
});
var updateFinalidadeSchema = z.object({
  ativo: z.boolean().optional(),
  disponivel: z.boolean().optional(),
  motivo: z.number().optional()
});
var updateImovelDocumentosSchema = z.object({
  matricula: z.string().optional(),
  iptu: z.string().optional(),
  cadastroImobiliario: z.string().optional(),
  numeroMedidorEnergia: z.string().optional(),
  numeroMedidorAgua: z.string().optional(),
  numeroMedidorGas: z.string().optional(),
  averbado: z.boolean().optional(),
  locado: z.boolean().optional(),
  ocupado: z.boolean().optional(),
  escriturado: z.boolean().optional(),
  projetoAprovado: z.boolean().optional(),
  placa: z.boolean().optional(),
  autorizacao: z.boolean().optional(),
  exclusividade: z.boolean().optional(),
  vencimentoExclusividade: z.string().optional(),
  dataAgenciamento: z.string().optional()
});
var updateAreasRuralSchema = z.object({
  areaTotal: z.number().optional(),
  areaAravel: z.number().optional(),
  sedes: z.number().optional()
});
var updateAreasTerrenoSchema = z.object({
  areaTotal: z.number().optional(),
  frente: z.number().optional(),
  fundo: z.number().optional(),
  lateralDireita: z.number().optional(),
  lateralEsquerda: z.number().optional()
});
var updateAreasConstrucaoSchema = z.object({
  areaTotal: z.number().optional(),
  areaPrivativa: z.number().optional(),
  areaUtil: z.number().optional(),
  alturaPeDireito: z.number().optional()
});
var createProprietarioSchema = z.object({
  cota: z.number().optional(),
  notificacoes: z.boolean().optional()
});
var proprietarioItemSchema = z.object({
  proprietarioId: z.number(),
  cota: z.number().optional(),
  notificacoes: z.boolean().optional()
});
var createManyProprietariosSchema = z.object({
  proprietarios: z.array(proprietarioItemSchema)
});
var updateProprietarioSchema = z.object({
  cota: z.coerce.number().optional(),
  notificacoes: z.boolean().optional()
});
var createResponsavelSchema = z.object({
  honorarioLocacao: z.number().optional(),
  honorarioLocacaoTipo: z.string().optional(),
  honorarioTemporada: z.number().optional(),
  honorarioTemporadaTipo: z.string().optional(),
  honorarioVenda: z.number().optional(),
  honorarioVendaTipo: z.string().optional(),
  funcao: z.number()
});
var updateResponsavelSchema = z.object({
  honorarioLocacao: z.number().optional(),
  honorarioLocacaoTipo: z.string().optional(),
  honorarioTemporada: z.number().optional(),
  honorarioTemporadaTipo: z.string().optional(),
  honorarioVenda: z.number().optional(),
  honorarioVendaTipo: z.string().optional(),
  funcao: z.number().optional()
});
var createImovelPortalSchema = z.object({
  descricao: z.string().optional(),
  tipoAnuncio: tipoAnuncioPortalEnum.optional(),
  esconderEnderecoImovel: z.boolean().optional()
});
var updateImovelPortalSchema = createImovelPortalSchema;
var createImovelSiteSchema = z.object({
  siteId: z.coerce.number().int().min(1).optional(),
  metaTitle: z.string().trim().min(1).max(255).optional(),
  metaDescription: z.string().trim().min(1).max(500).optional(),
  slug: z.preprocess(
    (v) => typeof v === "string" ? v.trim() : v,
    z.string().max(255).optional()
  ),
  keyword: z.string().trim().min(1).max(255).optional()
});
var updateImovelSiteSchema = z.object({
  metaTitle: z.string().trim().min(1).max(255).optional(),
  metaDescription: z.string().trim().min(1).max(500).optional(),
  slug: z.preprocess(
    (v) => typeof v === "string" ? v.trim() : v,
    z.string().max(255).optional()
  ),
  keyword: z.string().trim().min(1).max(255).optional()
});
var createImovelAnexoSchema = z.object({
  titulo: z.string().min(1).max(255),
  fileKey: z.string().min(1),
  size: z.number().min(0),
  mimeType: z.string().min(1)
});
var updateImovelAnexoSchema = z.object({
  titulo: z.string().max(255).optional()
});
var imovelValorSchema = z.object({
  valor: z.number().nullable(),
  valorComDesconto: z.number().nullable().optional()
});
var imovelListItemSchema = z.object({
  id: z.number(),
  titulo: z.string(),
  codigo: z.string(),
  status: z.string(),
  /**
   * `ImovelService.findAll`/`findOne` sempre devolvem a relação Prisma
   * completa (`{ value, label }`, e no detalhe também `id`) — nunca a
   * string crua. `valueLabelSchema` reflete o shape real; campos extras
   * (como `id` no detalhe) são ignorados pelo Zod por padrão.
   */
  uso: valueLabelSchema.nullable().optional(),
  tipo: valueLabelSchema.nullable().optional(),
  subTipo: valueLabelSchema.nullable().optional(),
  empreendimentoId: z.number().nullable().optional(),
  incorporadoraId: z.number().nullable().optional(),
  destacado: z.boolean().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
  valoresVenda: z.array(imovelValorSchema).catch([]),
  valoresLocacao: z.array(imovelValorSchema).catch([]),
  localizacao: z.object({
    cidade: z.string().nullable().optional(),
    bairro: z.string().nullable().optional(),
    uf: z.string().nullable().optional()
  }).nullable().optional(),
  fotoDestaque: z.string().nullable().optional()
});
var imovelDetailSchema = imovelListItemSchema.extend({
  descricao: z.any().nullable().optional(),
  tagIds: z.array(z.number()).optional(),
  camposCustomizados: z.record(z.string(), z.any()).optional()
});
var imoveisListResponseSchema = listResponse(imovelListItemSchema);
var imovelDetailResponseSchema = dataResponse(imovelDetailSchema);
var createImovelResponseSchema = dataResponse(imovelDetailSchema);
var updateImovelResponseSchema = dataResponse(imovelDetailSchema);
var deleteImovelResponseSchema = messageResponseSchema;
var imovelSubId = z.object({ imovelId: z.number() });
var imovelFotoSchema = mediaItemSchema.extend(imovelSubId.shape);
var imovelFotosResponseSchema = listResponse(imovelFotoSchema);
var imovelFotoResponseSchema = dataResponse(imovelFotoSchema);
var imovelVideoSchema = mediaItemSchema.extend(imovelSubId.shape);
var imovelVideosResponseSchema = listResponse(imovelVideoSchema);
var imovelVideoResponseSchema = dataResponse(imovelVideoSchema);
var imovelTourSchema = mediaItemSchema.extend(imovelSubId.shape);
var imovelToursResponseSchema = listResponse(imovelTourSchema);
var imovelTourResponseSchema = dataResponse(imovelTourSchema);
var imovelAnexoSchema = anexoItemSchema.extend(imovelSubId.shape);
var imovelAnexosResponseSchema = listResponse(imovelAnexoSchema);
var imovelAnexoResponseSchema = dataResponse(imovelAnexoSchema);
var imovelAnexoUploadUrlResponseSchema = dataResponse(uploadUrlDataSchema);
var generateImovelAnexoUploadUrlSchema = z.object({
  fileName: z.string().min(1).max(255),
  mimeType: z.string().min(1),
  size: z.number().min(1)
});
var imovelLocalizacaoSchema = z.object({
  id: z.number(),
  imovelId: z.number(),
  cep: z.union([z.number(), z.string()]).nullable().optional(),
  uf: z.string().nullable().optional(),
  cidade: z.string().nullable().optional(),
  cidadeSlug: z.string().nullable().optional(),
  rua: z.string().nullable().optional(),
  numero: z.string().nullable().optional(),
  bairro: z.string().nullable().optional(),
  complemento: z.string().nullable().optional(),
  pontoReferencia: z.string().nullable().optional(),
  longitude: z.string().nullable().optional(),
  latitude: z.string().nullable().optional(),
  googleEarth: z.string().nullable().optional(),
  distanciaPraia: z.number().nullable().optional(),
  padraoLocalizacaoValue: z.string().nullable().optional(),
  cidadeRef: cidadeRefSchema.nullable().optional(),
  padraoLocalizacao: idLabelSchema.extend({ value: z.string() }).nullable().optional()
});
var imovelLocalizacaoResponseSchema = dataResponse(imovelLocalizacaoSchema);
var padraoLocalizacaoSchema = idLabelSchema.extend({ value: z.string() });
var padroesLocalizacaoResponseSchema = listResponse(padraoLocalizacaoSchema);
var caracteristicaRefSchema = z.object({
  id: z.number(),
  value: z.string().optional(),
  label: z.string().optional()
});
var imovelCaracteristicasSchema = z.object({
  id: z.number().optional(),
  salas: z.number().nullable().optional(),
  dormitorios: z.number().nullable().optional(),
  suites: z.number().nullable().optional(),
  demiSuites: z.number().nullable().optional(),
  banheiros: z.number().nullable().optional(),
  pessoas: z.number().nullable().optional(),
  anoConstrucao: z.number().nullable().optional(),
  /** Prisma persiste como TEXT; a API pode devolver string numérica. */
  anoReforma: formNullableInt(1800),
  andar: z.number().nullable().optional(),
  vagasRotativas: z.number().nullable().optional(),
  vagasGaragem: z.number().nullable().optional(),
  entregaObra: z.string().nullable().optional(),
  zoneamento: z.string().nullable().optional(),
  precisaReforma: z.boolean().nullable().optional(),
  esquina: z.boolean().nullable().optional(),
  aceitaPet: z.boolean().nullable().optional(),
  orientacaoSolar: z.array(caracteristicaRefSchema).optional(),
  posicao: z.array(caracteristicaRefSchema).optional(),
  topografia: z.array(caracteristicaRefSchema).optional(),
  atividadesRurais: z.array(caracteristicaRefSchema).optional(),
  condicao: valueLabelSchema.nullable().optional(),
  mobiliado: valueLabelSchema.nullable().optional(),
  padraoClasse: valueLabelSchema.nullable().optional()
});
var imovelCaracteristicasResponseSchema = dataResponse(imovelCaracteristicasSchema);
var imovelComodidadeItemSchema = z.object({
  id: z.number(),
  comodidadeValue: z.string(),
  quantidade: z.number().nullable().optional(),
  comodidade: valueLabelSchema.extend({ id: z.number() }).optional()
});
var imovelComodidadesResponseSchema = listResponse(imovelComodidadeItemSchema);
var imovelComodidadeResponseSchema = dataResponse(imovelComodidadeItemSchema);
var imovelManyComodidadesResponseSchema = dataResponse(
  z.object({ count: z.number() })
);
var tipoFinanciamentoRefSchema = z.object({
  id: z.number(),
  label: z.string().optional()
});
var indiceReajusteRefSchema = z.object({
  indice: z.string(),
  valor: z.number()
});
var imovelValoresVendaSchema = z.object({
  id: z.number().optional(),
  imovelId: z.number().optional(),
  valorAvaliacao: z.number().nullable().optional(),
  dataAvaliacao: z.string().nullable().optional(),
  valor: z.number().nullable().optional(),
  valorComDesconto: z.number().nullable().optional(),
  ocultarValor: z.boolean().optional(),
  financiavel: z.boolean().optional(),
  usoFGTS: z.boolean().optional(),
  informacoesAdicionais: z.string().nullable().optional(),
  tiposFinanciamentos: z.array(tipoFinanciamentoRefSchema).optional()
});
var imovelValoresLocacaoSchema = z.object({
  id: z.number().optional(),
  imovelId: z.number().optional(),
  valorAvaliacao: z.number().nullable().optional(),
  dataAvaliacao: z.string().nullable().optional(),
  valor: z.number().nullable().optional(),
  valorBase: z.number().nullable().optional(),
  valorComDesconto: z.number().nullable().optional(),
  indiceReajuste: indiceReajusteRefSchema.nullable().optional(),
  indiceReajusteId: z.number().nullable().optional(),
  ocultarValor: z.boolean().optional(),
  informacoesAdicionais: z.string().nullable().optional()
});
var imovelValoresVendaResponseSchema = dataResponse(imovelValoresVendaSchema);
var imovelValoresLocacaoResponseSchema = dataResponse(imovelValoresLocacaoSchema);
var imovelChaveSchema = z.object({
  id: z.string(),
  imovelId: z.number(),
  codigo: z.string(),
  quantidade: z.number(),
  disponivel: z.boolean(),
  observacoes: z.string().nullable().optional(),
  responsavelTipo: z.enum(["Imobiliaria", "Proprietario", "Outros"]),
  responsavelId: z.number().nullable().optional(),
  responsavel: userMiniSchema.extend({
    telefone: z.string().nullable().optional(),
    telefoneSecundario: z.string().nullable().optional()
  }).nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var imovelChavesResponseSchema = listResponse(imovelChaveSchema);
var imovelChaveResponseSchema = dataResponse(imovelChaveSchema);
var imovelPortalNestedSchema = z.object({
  value: z.string(),
  nome: z.string(),
  label: z.string().optional(),
  id: z.number().optional()
}).transform((portal) => ({
  value: portal.value,
  label: portal.label ?? portal.nome,
  nome: portal.nome,
  ...portal.id !== void 0 ? { id: portal.id } : {}
}));
var imovelPortalSchema = z.object({
  id: z.number(),
  portalValue: z.string(),
  descricao: z.string().nullable().optional(),
  tipoAnuncio: tipoAnuncioPortalEnum.nullable().optional(),
  esconderEnderecoImovel: z.boolean().optional(),
  portal: imovelPortalNestedSchema.optional()
});
var imovelPortaisResponseSchema = listResponse(imovelPortalSchema);
var imovelPortalResponseSchema = dataResponse(imovelPortalSchema);
var imovelSiteSchema = z.object({
  id: z.number(),
  siteId: z.number(),
  metaTitle: z.string(),
  metaDescription: z.string(),
  slug: z.string(),
  keyword: z.string().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var imovelSitesResponseSchema = listResponse(imovelSiteSchema);
var imovelSiteResponseSchema = dataResponse(imovelSiteSchema);
var imovelCampanhaVinculoSchema = z.object({
  id: z.number(),
  campanhaId: z.number(),
  campanha: z.object({ id: z.number(), nome: z.string(), slug: z.string() }).optional()
});
var imovelCampanhasVinculoResponseSchema = listResponse(imovelCampanhaVinculoSchema);
var taxaRefSchema = z.object({
  id: z.number(),
  label: z.string().optional()
});
var periodoTaxaEnum = z.enum(["Mensal", "Anual"]);
var imovelTaxasSchema = z.object({
  id: z.number().optional(),
  condominio: z.boolean().optional(),
  condominioValor: z.number().nullable().optional(),
  condominioOcultarValor: z.boolean().optional(),
  inclusoCondominio: z.array(taxaRefSchema).optional(),
  iptuIsento: z.boolean().optional(),
  iptuPeriodo: periodoTaxaEnum.nullable().optional(),
  iptuValor: z.number().nullable().optional(),
  iptuOcultarValor: z.boolean().optional(),
  seguroIncendio: z.boolean().optional(),
  seguroIncendioPeriodo: periodoTaxaEnum.nullable().optional(),
  seguroIncendioValor: z.number().nullable().optional(),
  seguroIncendioOcultarValor: z.boolean().optional(),
  informacoesAdicionais: z.string().nullable().optional()
});
var imovelTaxasResponseSchema = dataResponse(imovelTaxasSchema);
var docCertificadoSchema = z.object({
  id: z.number(),
  label: z.string()
});
var imovelDocumentosCadastraisSchema = z.object({
  id: z.number().optional(),
  matricula: z.string().nullable().optional(),
  iptu: z.string().nullable().optional(),
  cadastroImobiliario: z.string().nullable().optional(),
  numeroMedidorEnergia: z.string().nullable().optional(),
  numeroMedidorAgua: z.string().nullable().optional(),
  numeroMedidorGas: z.string().nullable().optional(),
  averbado: z.boolean().nullable().optional(),
  locado: z.boolean().nullable().optional(),
  ocupado: z.boolean().nullable().optional(),
  escriturado: z.boolean().nullable().optional(),
  projetoAprovado: z.boolean().nullable().optional(),
  placa: z.boolean().nullable().optional(),
  autorizacao: z.boolean().nullable().optional(),
  exclusividade: z.boolean().nullable().optional(),
  vencimentoExclusividade: z.string().nullable().optional(),
  dataAgenciamento: z.string().nullable().optional(),
  documentosCertificados: z.array(docCertificadoSchema).optional()
});
var imovelDocumentosCadastraisResponseSchema = dataResponse(
  imovelDocumentosCadastraisSchema
);
var imovelAreaEntitySchema = z.object({
  id: z.number(),
  imovelId: z.number()
});
var imovelAreaConstrucaoSchema = imovelAreaEntitySchema.extend({
  areaTotal: z.number().nullable().optional(),
  areaPrivativa: z.number().nullable().optional(),
  areaUtil: z.number().nullable().optional(),
  alturaPeDireito: z.number().nullable().optional()
});
var imovelAreaTerrenoSchema = imovelAreaEntitySchema.extend({
  areaTotal: z.number().nullable().optional(),
  frente: z.number().nullable().optional(),
  fundo: z.number().nullable().optional(),
  lateralEsquerda: z.number().nullable().optional(),
  lateralDireita: z.number().nullable().optional()
});
var imovelAreaRuralSchema = imovelAreaEntitySchema.extend({
  areaTotal: z.number().nullable().optional(),
  areaAravel: z.number().nullable().optional(),
  sedes: z.number().nullable().optional()
});
var imovelAreasSchema = z.union([
  imovelAreaConstrucaoSchema,
  imovelAreaTerrenoSchema,
  imovelAreaRuralSchema
]);
var imovelAreasConstrucaoResponseSchema = dataResponse(
  imovelAreaConstrucaoSchema
);
var imovelAreasTerrenoResponseSchema = dataResponse(imovelAreaTerrenoSchema);
var imovelAreasRuralResponseSchema = dataResponse(imovelAreaRuralSchema);
var imovelAreasResponseSchema = dataResponse(imovelAreasSchema);
var contatoProprietarioRefSchema = z.object({
  id: z.number(),
  nome: z.string(),
  sobrenome: z.string().nullable().optional(),
  email: z.string().nullable().optional(),
  telefone: z.string().nullable().optional()
});
var imovelProprietarioSchema = z.object({
  id: z.number(),
  proprietarioId: z.number(),
  cota: z.number().nullable().optional(),
  notificacoes: z.boolean().optional(),
  proprietario: contatoProprietarioRefSchema.optional()
});
var imovelProprietariosResponseSchema = listResponse(imovelProprietarioSchema);
var imovelProprietarioResponseSchema = dataResponse(imovelProprietarioSchema);
var imovelResponsavelFuncaoRefSchema = z.object({
  id: z.number(),
  value: z.string().optional(),
  label: z.string().optional()
});
var imovelResponsavelSchema = z.object({
  id: z.number(),
  responsavelId: z.number(),
  funcaoId: z.number(),
  funcao: z.union([z.number(), imovelResponsavelFuncaoRefSchema]),
  honorarioVenda: z.number().nullable().optional(),
  honorarioVendaTipo: z.string().nullable().optional(),
  honorarioLocacao: z.number().nullable().optional(),
  honorarioLocacaoTipo: z.string().nullable().optional(),
  honorarioTemporada: z.number().nullable().optional(),
  honorarioTemporadaTipo: z.string().nullable().optional(),
  responsavel: z.object({
    id: z.number(),
    nome: z.string(),
    sobrenome: z.string().nullable().optional(),
    email: z.string().nullable().optional()
  }).optional()
});
var imovelResponsaveisResponseSchema = listResponse(imovelResponsavelSchema);
var imovelResponsavelResponseSchema = dataResponse(imovelResponsavelSchema);
var imovelFotoPrivadaSchema = mediaItemSchema.extend(imovelSubId.shape);
var imovelFotosPrivadasResponseSchema = listResponse(imovelFotoPrivadaSchema);
var imovelFotoPrivadaResponseSchema = dataResponse(imovelFotoPrivadaSchema);
var imovelTemporadaRegraSchema = z.object({
  id: z.number(),
  imovelValorTemporadaId: z.number(),
  nome: z.string().nullable().optional(),
  dataInicio: z.string(),
  dataFim: z.string(),
  tipoCobranca: imovelTemporadaTipoCobrancaEnum,
  modoPacote: imovelTemporadaModoPacoteEnum.nullable().optional(),
  precoPorNoite: z.number().nullable().optional(),
  valorPacote: z.number().nullable().optional(),
  minNoites: z.number().nullable().optional(),
  taxaLimpeza: z.number().nullable().optional(),
  ativo: z.boolean()
});
var imovelValoresTemporadaSchema = z.object({
  id: z.number(),
  imovelId: z.number(),
  valorAvaliacao: z.number().nullable().optional(),
  dataAvaliacao: z.string().nullable().optional(),
  valor: z.number().nullable().optional(),
  valorBase: z.number().nullable().optional(),
  valorComDesconto: z.number().nullable().optional(),
  informacoesAdicionais: z.string().nullable().optional(),
  ocultarValor: z.boolean().optional(),
  minNoitesPadrao: z.number().nullable().optional(),
  taxaLimpezaPadrao: z.number().nullable().optional(),
  regras: z.array(imovelTemporadaRegraSchema).catch([])
});
var imovelValoresTemporadaResponseSchema = dataResponse(
  imovelValoresTemporadaSchema
);
var imovelTemporadaRegraResponseSchema = dataResponse(imovelTemporadaRegraSchema);
var cotacaoLinhaSchema = z.object({
  data: z.string(),
  rotulo: z.string(),
  regraId: z.number().nullable(),
  valorNoite: z.number(),
  detalhe: z.string().optional()
});
var cotacaoTemporadaDataSchema = z.discriminatedUnion("disponivel", [
  z.object({
    disponivel: z.literal(true),
    noites: z.number(),
    minNoitesExigido: z.number(),
    minNoitesOk: z.boolean(),
    linhas: z.array(cotacaoLinhaSchema),
    subtotalHospedagem: z.number(),
    taxaLimpeza: z.number(),
    total: z.number()
  }),
  z.object({
    disponivel: z.literal(false),
    motivo: z.string(),
    noites: z.number(),
    sugestaoPacote: z.object({
      regraId: z.number(),
      nome: z.string().nullable(),
      checkInSugerido: z.string(),
      checkOutSugerido: z.string(),
      valorPacote: z.number(),
      taxaLimpeza: z.number().nullable()
    }).optional()
  })
]);
var cotacaoTemporadaResponseSchema = dataResponse(cotacaoTemporadaDataSchema);
var imovelFinalidadeItemSchema = z.object({
  imovelId: z.number(),
  finalidadeValue: z.string(),
  ativo: z.boolean(),
  disponivel: z.boolean(),
  motivoId: z.number().nullable().optional(),
  motivo: z.object({
    id: z.number(),
    value: z.string(),
    label: z.string(),
    padrao: z.boolean().optional()
  }).nullable().optional()
});
var imovelFinalidadesResponseSchema = listResponse(imovelFinalidadeItemSchema);
var imovelFinalidadeResponseSchema = dataResponse(imovelFinalidadeItemSchema);
var imovelMotivosFinalidadeResponseSchema = listResponse(
  z.object({
    id: z.number(),
    value: z.string(),
    label: z.string(),
    padrao: z.boolean().optional()
  })
);
var portalDisponivelSchema = z.object({
  id: z.number(),
  value: z.string(),
  nome: z.string(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var portaisDisponiveisResponseSchema = listResponse(portalDisponivelSchema);
var portalConfigSchema = z.object({
  id: z.union([z.string(), z.number()]).transform(String),
  portal: z.object({
    id: z.number(),
    value: z.string(),
    nome: z.string(),
    logo: z.string().nullable().optional(),
    tiposAnuncioDisponiveis: z.array(tipoAnuncioPortalEnum)
  }).optional(),
  token: z.string(),
  ativo: z.boolean(),
  anuncioNormal: z.number(),
  anuncioDestaque: z.number(),
  anuncioSuperDestaque: z.number(),
  custo: z.number(),
  url: z.string().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var portalConfigResponseSchema = dataResponse(portalConfigSchema);
var portalComConfigSchema = z.object({
  id: z.number(),
  value: z.string(),
  nome: z.string(),
  logo: z.string().nullable().optional(),
  tiposAnuncioDisponiveis: z.array(tipoAnuncioPortalEnum),
  ativo: z.boolean(),
  config: portalConfigSchema.omit({ portal: true }).extend({ id: z.union([z.string(), z.number()]).transform(String) }).nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var portaisComConfigResponseSchema = listResponse(portalComConfigSchema);
var portaisStatsSchema = z.object({
  totalPortais: z.number(),
  portaisComImoveis: z.array(
    z.object({
      id: z.number(),
      nome: z.string(),
      value: z.string(),
      totalImoveis: z.number(),
      porTipoAnuncio: z.object({
        Normal: z.number().optional(),
        Destaque: z.number().optional(),
        SuperDestaque: z.number().optional()
      })
    })
  )
});
var portaisStatsResponseSchema = dataResponse(portaisStatsSchema);
var createPortalConfigRequestSchema = z.object({
  portalValue: z.string(),
  anuncioNormal: z.number().min(0).optional(),
  anuncioDestaque: z.number().min(0).optional(),
  anuncioSuperDestaque: z.number().min(0).optional(),
  custo: z.number().min(0).optional()
});
var updatePortalConfigRequestSchema = z.object({
  anuncioNormal: z.number().min(0).optional(),
  anuncioDestaque: z.number().min(0).optional(),
  anuncioSuperDestaque: z.number().min(0).optional(),
  custo: z.number().min(0).optional()
});
var imovelAnexoAccessUrlDataSchema = accessUrlDataSchema.extend({
  fileUrl: z.string().optional()
});
var imovelAnexoAccessUrlResponseSchema = dataResponse(
  imovelAnexoAccessUrlDataSchema
);
var imovelSearchDataRangeSchema = z.object({
  min: z.number(),
  max: z.number()
}).nullable();
var imovelSearchDataLabelValueNumberSchema = z.object({
  id: z.number().optional(),
  value: z.union([z.number(), z.string()]).transform(
    (val) => typeof val === "number" ? val.toString() : val
  ),
  label: z.string()
});
var imovelSearchDataLabelValueStringSchema = z.object({
  value: z.string().nullable(),
  label: z.string()
});
var imovelSearchDataIdValueSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string()
});
var imovelSearchDataEnderecoSchema = z.object({
  filter: z.string(),
  label: z.string()
});
var imovelSearchDataIdNomeSchema = z.object({
  id: z.number(),
  nome: z.string()
});
var imovelSearchDataSiteSchema = z.object({
  id: z.number(),
  nome: z.string(),
  dominioDev: z.string().nullable(),
  dominioProprio: z.string().nullable()
});
var imoveisSearchDataPayloadSchema = z.object({
  ufs: z.array(z.string()),
  cidades: z.array(imovelSearchDataLabelValueStringSchema),
  bairros: z.array(imovelSearchDataLabelValueStringSchema),
  ruas: z.array(imovelSearchDataLabelValueStringSchema),
  enderecos: z.array(imovelSearchDataEnderecoSchema),
  tipos: z.array(imovelSearchDataLabelValueNumberSchema),
  subTipos: z.array(imovelSearchDataLabelValueNumberSchema),
  usos: z.array(imovelSearchDataLabelValueNumberSchema),
  status: z.array(z.string()),
  condicoes: z.array(imovelSearchDataLabelValueStringSchema),
  mobiliado: z.array(imovelSearchDataLabelValueStringSchema),
  orientacaoSolar: z.array(imovelSearchDataIdValueSchema),
  posicao: z.array(imovelSearchDataIdValueSchema),
  topografia: z.array(imovelSearchDataIdValueSchema),
  atividadesRurais: z.array(imovelSearchDataIdValueSchema),
  padraoClasse: z.array(imovelSearchDataIdValueSchema),
  padraoLocalizacao: z.array(imovelSearchDataIdValueSchema),
  empreendimentos: z.array(imovelSearchDataIdNomeSchema).optional(),
  incorporadoras: z.array(imovelSearchDataIdNomeSchema).optional(),
  proprietarios: z.array(imovelSearchDataIdNomeSchema).optional(),
  responsaveis: z.array(imovelSearchDataIdNomeSchema).optional(),
  usuarios: z.array(imovelSearchDataIdNomeSchema).optional(),
  sites: z.array(imovelSearchDataSiteSchema).optional(),
  finalidades: z.array(imovelSearchDataIdValueSchema).optional(),
  finalidadeMotivos: z.array(imovelSearchDataIdValueSchema).optional(),
  comodidades: z.array(imovelSearchDataIdValueSchema).optional(),
  campanhas: z.array(imovelSearchDataIdNomeSchema).optional(),
  portais: z.array(imovelSearchDataIdNomeSchema).optional(),
  ranges: z.object({
    caracteristicas: z.object({
      totalDormitorios: imovelSearchDataRangeSchema,
      dormitorios: imovelSearchDataRangeSchema,
      suites: imovelSearchDataRangeSchema,
      demiSuites: imovelSearchDataRangeSchema,
      banheiros: imovelSearchDataRangeSchema,
      salas: imovelSearchDataRangeSchema,
      pessoas: imovelSearchDataRangeSchema,
      vagasGaragem: imovelSearchDataRangeSchema,
      vagasRotativas: imovelSearchDataRangeSchema,
      andar: imovelSearchDataRangeSchema,
      anoConstrucao: imovelSearchDataRangeSchema
    }),
    areasConstrucao: z.object({
      areaTotal: imovelSearchDataRangeSchema,
      areaUtil: imovelSearchDataRangeSchema,
      areaPrivativa: imovelSearchDataRangeSchema,
      alturaPeDireito: imovelSearchDataRangeSchema
    }),
    areasTerreno: z.object({
      areaTotal: imovelSearchDataRangeSchema,
      frente: imovelSearchDataRangeSchema,
      fundo: imovelSearchDataRangeSchema,
      lateralEsquerda: imovelSearchDataRangeSchema,
      lateralDireita: imovelSearchDataRangeSchema
    }),
    areasRural: z.object({
      areaTotal: imovelSearchDataRangeSchema,
      areaAravel: imovelSearchDataRangeSchema,
      sedes: imovelSearchDataRangeSchema
    }),
    valoresVenda: z.object({
      valor: imovelSearchDataRangeSchema,
      valorComDesconto: imovelSearchDataRangeSchema,
      valorAvaliacao: imovelSearchDataRangeSchema
    }),
    valoresLocacao: z.object({
      valor: imovelSearchDataRangeSchema,
      valorComDesconto: imovelSearchDataRangeSchema,
      valorBase: imovelSearchDataRangeSchema,
      valorAvaliacao: imovelSearchDataRangeSchema
    }),
    taxasImpostos: z.object({
      condominioValor: imovelSearchDataRangeSchema,
      iptuValor: imovelSearchDataRangeSchema,
      seguroIncendioValor: imovelSearchDataRangeSchema
    })
  })
});
var imoveisSearchDataSchema = dataResponse(
  imoveisSearchDataPayloadSchema
).extend({
  message: z.string()
});

// src/empreendimentos/index.ts
var jsonDescricao2 = z.preprocess((v) => {
  if (typeof v === "string") {
    try {
      return JSON.parse(v);
    } catch {
      return v;
    }
  }
  return v;
}, z.any());
var clearableString = z.preprocess(
  (v) => v === "" || v === null || v === "null" ? null : v,
  z.string().max(500).nullable()
).optional();
var camposCustomizadosInput4 = z.record(
  z.string(),
  z.union([z.string(), z.number(), z.boolean()])
);
var createEmpreendimentoRequestSchema = z.object({
  nome: z.string().min(1, "Nome \xE9 obrigat\xF3rio").max(255),
  tipo: z.coerce.number(),
  fase: z.coerce.number(),
  descricao: jsonDescricao2.optional(),
  logo: z.string().max(500).optional(),
  imagemDestaque: z.string().max(500).optional(),
  sistemaVenda: z.coerce.number().optional(),
  padraoClasse: z.coerce.number().optional(),
  plantaoLocal: booleanLike.optional(),
  status: z.string().optional(),
  incorporadora: z.coerce.number().optional(),
  camposCustomizados: camposCustomizadosInput4.optional()
});
var updateEmpreendimentoRequestSchema = z.object({
  nome: z.string().max(255).optional(),
  tipo: z.coerce.number().optional(),
  fase: z.coerce.number().optional(),
  descricao: jsonDescricao2.optional(),
  logo: clearableString,
  imagemDestaque: clearableString,
  sistemaVenda: z.coerce.number().optional(),
  padraoClasse: z.coerce.number().optional(),
  plantaoLocal: booleanLike.optional(),
  status: z.string().optional(),
  /**
   * `null` explícito desvincula a incorporadora (backend faz `disconnect`);
   * ausência preserva o vínculo. Não usar `z.coerce.number()` puro aqui:
   * `Number(null) === 0`, o que transformava "desvincular" em
   * `incorporadora: 0` (ignorado pelo backend — o vínculo nunca era desfeito).
   * A ordem da union importa: coerce primeiro (com `min(1)`, que rejeita o 0
   * vindo de null) e `z.null()` como fallback.
   */
  incorporadora: z.union([z.coerce.number().min(1), z.null()]).optional(),
  camposCustomizados: camposCustomizadosInput4.optional()
});
var queryEmpreendimentoSchema = z.object({
  page: z.coerce.number().optional().default(1),
  itemsPerPage: z.coerce.number().optional().default(25),
  nome: z.string().optional(),
  search: z.string().optional(),
  tipo: z.string().optional(),
  fase: z.string().optional(),
  sistemaVenda: z.string().optional(),
  status: z.string().optional(),
  incorporadoraId: z.coerce.number().optional(),
  uf: z.string().optional(),
  cidade: z.string().optional(),
  bairro: z.string().optional(),
  rua: z.string().optional(),
  distanciaPraia: z.string().optional(),
  comVideos: z.string().optional(),
  comTours: z.string().optional(),
  siteId: z.string().optional(),
  tag: z.string().optional(),
  comodidade: z.union([z.string(), z.array(z.string())]).optional(),
  order: z.string().optional(),
  orderBy: z.string().optional()
});
var searchDataQuerySchema = z.object({
  nome: z.string().optional(),
  tipo: z.string().optional(),
  fase: z.string().optional(),
  sistemaVenda: z.string().optional(),
  status: z.string().optional(),
  incorporadoraId: z.coerce.number().optional(),
  uf: z.string().optional(),
  cidade: z.string().optional(),
  bairro: z.string().optional(),
  rua: z.string().optional(),
  distanciaPraia: z.string().optional(),
  comVideos: z.string().optional(),
  comTours: z.string().optional(),
  siteId: z.string().optional(),
  tag: z.string().optional(),
  comodidade: z.union([z.string(), z.array(z.string())]).optional()
});
var empFormOptInt = (min) => z.preprocess(
  (v) => {
    if (v === "" || v === null || v === void 0) return void 0;
    const n = typeof v === "number" ? v : parseInt(String(v), 10);
    return Number.isNaN(n) ? void 0 : n;
  },
  min != null ? z.number().int().min(min).optional() : z.number().int().optional()
);
var empFormOptFloat = z.preprocess((v) => {
  if (v === "" || v === null || v === void 0) return void 0;
  const n = typeof v === "number" ? v : parseFloat(String(v));
  return Number.isNaN(n) ? void 0 : n;
}, z.number().optional());
var empTrimMax = (max) => z.preprocess(
  (v) => typeof v === "string" ? v.trim() : v,
  z.string().max(max).optional()
);
var empMediaTitulo = z.string().trim().min(1, "T\xEDtulo \xE9 obrigat\xF3rio").max(255);
var empMediaUrl = z.string().trim().min(1, "URL \xE9 obrigat\xF3ria").max(500);
var empCreateFotoSchema = z.object({
  titulo: empMediaTitulo,
  url: empMediaUrl,
  order: z.coerce.number().int().min(1).default(1)
});
var empUpdateFotoSchema = z.object({
  titulo: z.string().trim().min(1).max(255).optional(),
  order: empFormOptInt(1)
});
var empFotoItemSchema = empCreateFotoSchema;
var empCreateManyFotosSchema = z.object({
  fotos: z.array(empFotoItemSchema)
});
var empUpdateFotoItemSchema = z.object({
  id: z.coerce.number().int().min(1),
  titulo: z.string().trim().min(1).max(255).optional(),
  order: empFormOptInt(1)
});
var empUpdateManyFotosSchema = z.object({
  fotos: z.array(empUpdateFotoItemSchema)
});
var empCreateVideoSchema = z.object({
  titulo: empMediaTitulo,
  url: z.string().url("URL deve ser v\xE1lida"),
  order: empFormOptInt(1).optional()
});
var empUpdateVideoSchema = z.object({
  titulo: z.string().trim().min(1).max(255).optional(),
  url: z.string().url("URL deve ser v\xE1lida").optional(),
  order: empFormOptInt(1)
});
var empCreateTourVirtualSchema = z.object({
  titulo: empMediaTitulo,
  url: z.string().url("URL deve ser v\xE1lida"),
  order: empFormOptInt(1).optional()
});
var empUpdateTourVirtualSchema = z.object({
  titulo: z.string().trim().min(1).max(255).optional(),
  url: z.string().url("URL deve ser v\xE1lida").optional(),
  order: empFormOptInt(1)
});
var empCreateTagSchema = z.object({
  value: z.string().trim().min(1, "Valor \xE9 obrigat\xF3rio").max(100),
  label: z.string().trim().min(1, "Label \xE9 obrigat\xF3rio").max(100)
});
var empUpdateTagSchema = empCreateTagSchema;
var empCreateComodidadeSchema = z.object({
  comodidadeValue: z.number(),
  quantidade: z.number().int().min(1).optional()
});
var empUpdateComodidadeSchema = z.object({
  quantidade: z.number().int().min(1).optional()
});
var empComodidadeInputItemSchema = z.object({
  value: z.number(),
  quantidade: z.number().int().min(1).optional()
});
var empCreateManyComodidadesSchema = z.object({
  comodidades: z.array(empComodidadeInputItemSchema)
});
var empUpdateManyComodidadesSchema = z.object({
  ids: z.array(z.number()),
  quantidade: z.number().int().min(1).optional()
});
var empDeleteManyComodidadesSchema = z.object({
  ids: z.array(z.number())
});
var empUpdateLocalizacaoSchema = z.object({
  cep: empTrimMax(10),
  uf: empTrimMax(2),
  cidade: empTrimMax(100),
  rua: empTrimMax(200),
  numero: empTrimMax(20),
  bairro: empTrimMax(100),
  complemento: empTrimMax(200),
  pontoReferencia: empTrimMax(200),
  longitude: empFormOptFloat,
  latitude: empFormOptFloat,
  googleEarth: empTrimMax(500),
  distanciaPraia: empFormOptInt(0),
  padraoLocalizacaoValue: empTrimMax(50)
});
var empUpdateCaracteristicasSchema = z.object({
  valorDe: empFormOptInt(),
  valorAte: empFormOptInt(),
  dormitoriosDe: empFormOptInt(),
  dormitoriosAte: empFormOptInt(),
  suitesDe: empFormOptInt(),
  suitesAte: empFormOptInt(),
  demiSuitesDe: empFormOptInt(),
  demiSuitesAte: empFormOptInt(),
  areaDe: empFormOptInt(),
  areaAte: empFormOptInt(),
  vagasGaragemDe: empFormOptInt(),
  vagasGaragemAte: empFormOptInt(),
  salasDe: empFormOptInt(),
  salasAte: empFormOptInt(),
  banheirosDe: empFormOptInt(),
  banheirosAte: empFormOptInt(),
  lavabosDe: empFormOptInt(),
  lavabosAte: empFormOptInt(),
  anoConstrucao: empFormOptInt(),
  dataEntrega: z.string().optional()
});
var empCreateSiteSchema = z.object({
  siteId: z.coerce.number().int().min(1).optional(),
  metaTitle: z.string().trim().min(1).max(255).optional(),
  metaDescription: z.string().trim().min(1).max(500).optional(),
  slug: z.preprocess(
    (v) => typeof v === "string" ? v.trim().toLowerCase().replace(/^-+|-+$/g, "") : v,
    z.string().max(255).optional()
  ),
  keyword: z.string().trim().min(1).max(255).optional()
});
var empUpdateSiteSchema = z.object({
  metaTitle: z.string().trim().min(1).max(255).optional(),
  metaDescription: z.string().trim().min(1).max(500).optional(),
  slug: z.preprocess(
    (v) => typeof v === "string" ? v.trim().toLowerCase().replace(/^-+|-+$/g, "") : v,
    z.string().max(255).optional()
  ),
  keyword: z.string().trim().min(1).max(255).optional()
});
var empCreateAnexoSchema = z.object({
  titulo: z.string().min(1).max(255),
  fileKey: z.string().min(1),
  size: z.number().min(0),
  mimeType: z.string().min(1)
});
var empUpdateAnexoSchema = z.object({
  titulo: z.string().max(255).optional()
});
var empGenerateAnexoUploadUrlSchema = z.object({
  fileName: z.string().min(1).max(255),
  mimeType: z.string().min(1),
  size: z.number().min(1)
});
var empreendimentoRelacaoSchema = z.object({
  id: z.number(),
  value: z.string().optional(),
  label: z.string().optional()
});
var empreendimentoRelacaoOuId = z.union([z.number(), empreendimentoRelacaoSchema]).nullable().optional();
var empreendimentoSchema = z.object({
  id: z.number(),
  dashboardId: z.number(),
  nome: z.string(),
  status: nullableString,
  tipo: empreendimentoRelacaoOuId,
  fase: empreendimentoRelacaoOuId,
  tipoId: z.number().nullable().optional(),
  faseId: z.number().nullable().optional(),
  descricao: z.any().nullable().optional(),
  logo: z.string().nullable().optional(),
  imagemDestaque: z.string().nullable().optional(),
  incorporadoraId: z.number().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var empreendimentosListResponseSchema = listResponse(empreendimentoSchema);
var empreendimentoDetailResponseSchema = dataResponse(empreendimentoSchema);
var createEmpreendimentoResponseSchema = dataResponse(empreendimentoSchema);
var updateEmpreendimentoResponseSchema = dataResponse(empreendimentoSchema);
var deleteEmpreendimentoResponseSchema = messageResponseSchema;
var empSubId = z.object({ empreendimentoId: z.number() });
var empFotoSchema = mediaItemSchema.extend(empSubId.shape);
var empFotosResponseSchema = listResponse(empFotoSchema);
var empFotoResponseSchema = dataResponse(empFotoSchema);
var empVideoSchema = mediaItemSchema.extend(empSubId.shape);
var empVideosResponseSchema = listResponse(empVideoSchema);
var empVideoResponseSchema = dataResponse(empVideoSchema);
var empTourSchema = mediaItemSchema.extend(empSubId.shape);
var empToursResponseSchema = listResponse(empTourSchema);
var empTourResponseSchema = dataResponse(empTourSchema);
var empAnexoSchema = anexoItemSchema.extend(empSubId.shape);
var empAnexosResponseSchema = listResponse(empAnexoSchema);
var empAnexoResponseSchema = dataResponse(empAnexoSchema);
var empAnexoUploadUrlResponseSchema = dataResponse(uploadUrlDataSchema);
var empAnexoAccessUrlResponseSchema = dataResponse(accessUrlDataSchema);
var empLocalizacaoSchema = z.object({
  id: z.number(),
  empreendimentoId: z.number(),
  cep: z.union([z.number(), z.string()]).nullable().optional(),
  uf: nullableString,
  cidade: nullableString,
  rua: nullableString,
  numero: nullableString,
  bairro: nullableString,
  complemento: nullableString,
  pontoReferencia: nullableString,
  longitude: nullableString,
  latitude: nullableString,
  googleEarth: nullableString,
  distanciaPraia: z.number().nullable().optional(),
  padraoLocalizacaoValue: nullableString,
  cidadeRef: cidadeRefSchema.nullable().optional(),
  padraoLocalizacao: idLabelSchema.extend({ value: z.string() }).nullable().optional()
});
var empLocalizacaoResponseSchema = dataResponse(empLocalizacaoSchema);
var empCaracteristicasSchema = z.object({
  id: z.number(),
  empreendimentoId: z.number(),
  totalDormitorios: z.number().nullable().optional(),
  valorDe: z.number().nullable().optional(),
  valorAte: z.number().nullable().optional(),
  dormitoriosDe: z.number().nullable().optional(),
  dormitoriosAte: z.number().nullable().optional(),
  suitesDe: z.number().nullable().optional(),
  suitesAte: z.number().nullable().optional(),
  demiSuitesDe: z.number().nullable().optional(),
  demiSuitesAte: z.number().nullable().optional(),
  areaDe: z.number().nullable().optional(),
  areaAte: z.number().nullable().optional(),
  vagasGaragemDe: z.number().nullable().optional(),
  vagasGaragemAte: z.number().nullable().optional(),
  salasDe: z.number().nullable().optional(),
  salasAte: z.number().nullable().optional(),
  banheirosDe: z.number().nullable().optional(),
  banheirosAte: z.number().nullable().optional(),
  lavabosDe: z.number().nullable().optional(),
  lavabosAte: z.number().nullable().optional(),
  anoConstrucao: z.string().nullable().optional(),
  dataEntrega: z.string().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var empCaracteristicasResponseSchema = dataResponse(empCaracteristicasSchema);
var empComodidadeResponseItemSchema = z.object({
  id: z.number(),
  comodidadeValue: z.string(),
  quantidade: z.number().nullable().optional(),
  comodidade: valueLabelSchema.extend({ id: z.number() }).optional()
});
var empComodidadesResponseSchema = listResponse(empComodidadeResponseItemSchema);
var empComodidadeResponseSchema = dataResponse(empComodidadeResponseItemSchema);
var empManyComodidadesResponseSchema = dataResponse(
  z.object({ count: z.number() })
);
var empSiteSchema = z.object({
  id: z.number(),
  siteId: z.number(),
  metaTitle: z.string(),
  metaDescription: z.string(),
  slug: z.string(),
  keyword: z.string().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var empSitesResponseSchema = listResponse(empSiteSchema);
var empSiteResponseSchema = dataResponse(empSiteSchema);
var empreendimentoSiteSchema = empSiteSchema;
var empreendimentoSitesResponseSchema = empSitesResponseSchema;
var empreendimentoSiteResponseSchema = empSiteResponseSchema;
var createEmpreendimentoSiteRequestSchema = empCreateSiteSchema;
var updateEmpreendimentoSiteRequestSchema = empUpdateSiteSchema;
var empTagSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string()
});
var empTagsResponseSchema = listResponse(empTagSchema);
var empTagResponseSchema = dataResponse(empTagSchema);
var empSearchDataIdValueLabelSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string()
});
var empSearchDataLabelValueSchema = z.object({
  value: z.string(),
  label: z.string()
});
var empSearchDataRangeSchema = z.object({
  min: z.number(),
  max: z.number()
});
var empreendimentosSearchDataPayloadSchema = z.object({
  tipos: z.array(empSearchDataIdValueLabelSchema),
  fases: z.array(empSearchDataIdValueLabelSchema),
  sistemaVenda: z.array(empSearchDataIdValueLabelSchema),
  status: z.array(z.string()),
  enderecos: z.array(z.object({ filter: z.string(), label: z.string() })).optional(),
  localizacoes: z.object({
    ufs: z.array(z.string()),
    cidades: z.array(empSearchDataLabelValueSchema),
    bairros: z.array(empSearchDataLabelValueSchema),
    ruas: z.array(empSearchDataLabelValueSchema),
    distanciasPraia: z.array(z.number())
  }),
  comodidades: z.array(empSearchDataIdValueLabelSchema),
  tags: z.array(empSearchDataIdValueLabelSchema),
  padraoClasse: z.array(empSearchDataIdValueLabelSchema).optional(),
  padraoLocalizacao: z.array(empSearchDataIdValueLabelSchema).optional(),
  incorporadoras: z.array(z.object({ id: z.number(), nome: z.string() })).optional(),
  sites: z.array(z.object({ id: z.number(), nome: z.string() })).optional(),
  caracteristicas: z.object({
    valor: empSearchDataRangeSchema,
    totalDormitorios: empSearchDataRangeSchema.nullable().optional(),
    dormitorios: empSearchDataRangeSchema,
    suites: empSearchDataRangeSchema,
    demiSuites: empSearchDataRangeSchema,
    area: empSearchDataRangeSchema,
    vagasGaragem: empSearchDataRangeSchema,
    salas: empSearchDataRangeSchema,
    banheiros: empSearchDataRangeSchema,
    lavabos: empSearchDataRangeSchema
  })
});
var empreendimentosSearchDataResponseSchema = dataResponse(
  empreendimentosSearchDataPayloadSchema
);

// src/tarefas/index.ts
var tarefas_exports = {};
__export(tarefas_exports, {
  createTarefaRequestSchema: () => createTarefaRequestSchema,
  createTarefaResponseSchema: () => createTarefaResponseSchema,
  deleteTarefaResponseSchema: () => deleteTarefaResponseSchema,
  tarefaResponseSchema: () => tarefaResponseSchema,
  tarefaSchema: () => tarefaSchema,
  tarefasResponseSchema: () => tarefasResponseSchema,
  todasTarefasQuerySchema: () => todasTarefasQuerySchema,
  updateTarefaRequestSchema: () => updateTarefaRequestSchema,
  updateTarefaResponseSchema: () => updateTarefaResponseSchema
});
var camposCustomizadosInput5 = z.record(
  z.string(),
  z.union([z.string(), z.number(), z.boolean()])
);
var createTarefaRequestSchema = z.object({
  acaoId: z.number(),
  assunto: z.string().min(1, "Assunto \xE9 obrigat\xF3rio").max(255),
  agendadoPara: z.string().min(1, "Data e hora agendada \xE9 obrigat\xF3ria"),
  agendadoFim: z.string().optional(),
  responsaveis: z.array(z.number()),
  descricao: z.any().optional(),
  statusValue: z.string().min(1, "Status \xE9 obrigat\xF3rio").max(50),
  finalizadoEm: z.string().optional(),
  finalizadoPor: z.number().optional(),
  camposCustomizados: camposCustomizadosInput5.optional()
});
var updateTarefaRequestSchema = createTarefaRequestSchema.partial().extend({
  agendadoFim: z.string().nullable().optional()
});
var todasTarefasQuerySchema = z.object({
  responsavel: z.coerce.number().optional(),
  responsaveis: z.array(z.coerce.number()).optional(),
  status: z.string().optional(),
  statusValue: z.string().optional(),
  acao: z.string().optional(),
  periodoInicio: z.string().optional(),
  periodoFim: z.string().optional(),
  finalizadoEmInicio: z.string().optional(),
  finalizadoEmFim: z.string().optional(),
  finalizadoPor: z.coerce.number().optional(),
  cliente: z.coerce.number().optional(),
  funil: z.coerce.number().optional(),
  etapa: z.coerce.number().optional(),
  pesquisa: z.string().optional(),
  orderBy: z.string().optional(),
  order: z.enum(["asc", "desc"]).optional(),
  page: z.coerce.number().optional(),
  take: z.coerce.number().optional()
});
var tarefaSchema = z.object({
  id: z.number(),
  oportunidadeId: z.string().nullable(),
  acaoId: z.number(),
  assunto: z.string(),
  agendadoPara: z.string().nullable(),
  agendadoFim: z.string().nullable(),
  statusValue: z.string(),
  status: z.object({
    label: z.string(),
    value: z.string()
  }).optional(),
  descricao: z.union([z.string(), z.object({ text: z.string().optional() })]).nullable(),
  autorId: z.number().nullable(),
  finalizadoEm: z.string().nullable(),
  finalizadoPor: z.number().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  oportunidade: z.object({
    id: z.string(),
    titulo: z.string().nullable(),
    status: z.string(),
    contato: z.object({
      id: z.number(),
      nome: z.string(),
      sobrenome: z.string().nullable(),
      email: z.string().nullable()
    })
  }).nullable().optional(),
  responsaveis: z.array(
    z.object({
      id: z.number(),
      nome: z.string(),
      sobrenome: z.string().nullable(),
      email: z.string().nullable().optional()
    })
  ),
  autor: z.object({
    id: z.number(),
    nome: z.string(),
    sobrenome: z.string().nullable(),
    email: z.string().nullable().optional()
  }).nullable(),
  camposCustomizados: z.record(z.string(), z.any()).optional()
});
var tarefasResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(tarefaSchema),
  pagination: z.object({
    page: z.number(),
    limit: z.number(),
    total: z.number(),
    totalPages: z.number()
  }),
  message: z.string().optional()
});
var tarefaResponseSchema = dataResponse(tarefaSchema);
var createTarefaResponseSchema = dataResponse(tarefaSchema);
var updateTarefaResponseSchema = dataResponse(tarefaSchema);
var deleteTarefaResponseSchema = messageResponseSchema;

// src/oportunidades/index.ts
var oportunidadeStatusEnum = z.enum([
  "Novo",
  "Pausado",
  "EmAndamento",
  "Ganho",
  "Perdido",
  "Arquivado"
]);
var camposCustomizadosInput6 = z.record(
  z.string(),
  z.union([z.string(), z.number(), z.boolean()])
);
var createOportunidadeRequestSchema = z.object({
  titulo: z.string().min(1, "T\xEDtulo \xE9 obrigat\xF3rio").max(255),
  contatoId: z.number().optional(),
  responsaveis: z.array(z.number()).optional(),
  status: oportunidadeStatusEnum.optional(),
  previsaoFechamento: z.string().optional(),
  funilId: z.number().optional(),
  etapaId: z.number().optional(),
  origemValue: z.string().max(100).optional(),
  qualificacao: z.number().optional(),
  camposCustomizados: camposCustomizadosInput6.optional(),
  /** UI may send loss fields on create when status is Perdido. */
  motivoPerdaId: z.number().optional(),
  comentarioPerda: z.string().max(500).optional()
});
var updateOportunidadeRequestSchema = createOportunidadeRequestSchema.partial().extend({
  motivoPerdaId: z.number().optional(),
  comentarioPerda: z.string().max(500).optional(),
  previsaoFechamento: z.string().nullable().optional()
}).refine(
  (data) => data.status !== "Perdido" || typeof data.motivoPerdaId === "number" && Boolean(data.comentarioPerda?.trim()),
  {
    message: 'Motivo e coment\xE1rio da perda s\xE3o obrigat\xF3rios quando o status \xE9 "Perdido"',
    path: ["comentarioPerda"]
  }
);
var marcarComoGanhaRequestSchema = z.object({
  propostaId: z.number()
});
var oportunidadeImoveisListResponseSchema = imoveisListResponseSchema;
var oportunidadeEmpreendimentosListResponseSchema = empreendimentosListResponseSchema;
var oportunidadeQuerySchema = z.object({
  contatoId: z.string().optional(),
  responsavel: z.string().optional(),
  status: z.string().optional(),
  periodoInicio: z.string().optional(),
  periodoFim: z.string().optional(),
  origem: z.string().optional(),
  motivoPerdaId: z.string().optional(),
  imovelId: z.string().optional(),
  empreendimentoId: z.string().optional(),
  search: z.string().optional(),
  incluirFinalizadas: booleanLike.optional(),
  incluirGanhasEPerdidas: booleanLike.optional(),
  clienteNome: z.string().optional(),
  orderBy: z.string().optional(),
  order: z.string().optional(),
  page: z.coerce.number().optional(),
  limit: z.coerce.number().optional()
});
var createInteresseRequestSchema = z.object({
  imovelId: z.number().optional(),
  empreendimentoId: z.number().optional(),
  status: z.boolean().optional(),
  motivo: z.string().max(500).optional(),
  negociacaoFechada: z.boolean().optional(),
  inseridoPor: z.enum(["Cliente", "Corretor"])
});
var updateInteresseRequestSchema = createInteresseRequestSchema.partial();
var interesseLocalizacaoSchema = z.object({
  cidade: z.string(),
  bairro: z.string().nullable().optional()
});
var interesseSchema = z.object({
  id: z.number(),
  oportunidadeId: z.string(),
  imovelId: z.number().nullable(),
  empreendimentoId: z.number().nullable(),
  status: z.boolean().nullable(),
  motivo: z.string().nullable(),
  negociacaoFechada: z.boolean(),
  inseridoPor: z.enum(["Cliente", "Corretor"]),
  createdAt: z.string(),
  updatedAt: z.string(),
  imovel: z.object({
    id: z.number(),
    titulo: z.string(),
    codigo: z.string(),
    localizacao: interesseLocalizacaoSchema
  }).nullable().optional(),
  empreendimento: z.object({
    id: z.number(),
    nome: z.string(),
    localizacao: interesseLocalizacaoSchema
  }).nullable().optional()
});
var interesseResponseSchema = dataResponse(interesseSchema);
var interessesResponseSchema = listResponse(interesseSchema);
var deleteInteresseResponseSchema = messageResponseSchema;
var createOportunidadeAnotacaoRequestSchema = z.object({
  conteudo: z.any().refine((v) => v !== void 0 && v !== null, {
    message: "Conte\xFAdo \xE9 obrigat\xF3rio"
  })
});
var updateOportunidadeAnotacaoRequestSchema = z.object({
  conteudo: z.any().optional()
});
var createHistoricoRequestSchema = z.object({
  descricao: z.string().min(1, "Descri\xE7\xE3o \xE9 obrigat\xF3ria").max(1e3),
  eventoValue: z.string().min(1, "Evento \xE9 obrigat\xF3rio").max(50)
});
var createEtapaRequestSchema = z.object({
  label: z.string().min(1, "Label \xE9 obrigat\xF3rio").max(100),
  value: z.string().min(1, "Value \xE9 obrigat\xF3rio").max(50),
  order: z.number(),
  probabilidade: z.number().optional(),
  estagnado: z.number().optional(),
  color: z.string().min(1, "Color \xE9 obrigat\xF3rio").max(7)
});
var updateEtapaRequestSchema = createEtapaRequestSchema.partial();
var createFunilRequestSchema = z.object({
  label: z.string().min(1, "Label \xE9 obrigat\xF3rio").max(100),
  value: z.string().min(1, "Value \xE9 obrigat\xF3rio").max(50),
  order: z.number().optional(),
  etapas: z.array(createEtapaRequestSchema).optional()
});
var updateFunilRequestSchema = createFunilRequestSchema.partial();
var oportunidadeContatoSchema = z.object({
  id: z.number(),
  nome: z.string(),
  sobrenome: z.string().nullable().optional(),
  email: z.string().nullable().optional(),
  telefone: z.string().nullable().optional()
});
var oportunidadeResponsavelSchema = z.object({
  id: z.number(),
  nome: z.string(),
  sobrenome: z.string().nullable()
});
var etapaOportunidadeSchema = z.object({
  id: z.number(),
  label: z.string(),
  order: z.number(),
  /** `EtapaFunil.probabilidade` é `Int?` no Prisma — pode ser `null`. */
  probabilidade: z.number().nullable(),
  color: z.string().optional()
});
var oportunidadeOrigemRefSchema = z.object({
  value: z.string(),
  label: z.string()
});
var marcarComoGanhaOportunidadeSchema = z.object({
  id: z.string(),
  status: z.literal("Ganho"),
  finalizadoEm: z.string(),
  titulo: z.string().nullable().optional(),
  qualificacao: z.number().optional(),
  previsaoFechamento: z.string().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
  dashboardId: z.number().optional(),
  contatoId: z.number().optional(),
  origemValue: z.string().optional(),
  funilId: z.number().optional(),
  etapaId: z.number().optional(),
  motivoPerdaId: z.number().nullable().optional(),
  comentarioPerda: z.string().nullable().optional(),
  contato: oportunidadeContatoSchema.extend({ numeroCpf: z.string().nullable().optional() }).optional(),
  responsaveis: z.array(oportunidadeResponsavelSchema.extend({ email: z.string().optional() })).optional(),
  funil: z.object({
    id: z.number(),
    label: z.string(),
    value: z.string().optional(),
    order: z.number().optional()
  }).optional(),
  etapa: etapaOportunidadeSchema.extend({
    value: z.string().optional(),
    color: z.string().optional(),
    estagnado: z.number().nullable().optional()
  }).optional(),
  origem: oportunidadeOrigemRefSchema.nullable().optional(),
  camposCustomizados: z.record(z.string(), z.any()).optional()
});
var marcarComoGanhaResponseSchema = dataResponse(
  marcarComoGanhaOportunidadeSchema
);
var oportunidadeSchema = z.object({
  id: z.string(),
  titulo: z.string().nullable().optional(),
  contato: oportunidadeContatoSchema,
  responsaveis: z.array(oportunidadeResponsavelSchema).optional(),
  etapa: etapaOportunidadeSchema,
  qualificacao: z.number().optional(),
  previsaoFechamento: z.string().nullable().optional(),
  status: oportunidadeStatusEnum,
  _count: z.object({
    tarefas: z.number().optional(),
    anotacoes: z.number().optional(),
    historico: z.number().optional()
  }).optional(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var oportunidadeListPaginationSchema = z.object({
  page: z.number(),
  limit: z.number(),
  total: z.number(),
  totalPages: z.number()
});
var oportunidadesResponseSchema = listResponse(
  oportunidadeSchema
).extend({
  pagination: oportunidadeListPaginationSchema.optional()
});
var oportunidadeDetalhesSchema = z.object({
  id: z.string(),
  titulo: z.string().nullable(),
  status: oportunidadeStatusEnum,
  qualificacao: z.number(),
  previsaoFechamento: z.string().nullable(),
  finalizadoEm: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  contato: oportunidadeContatoSchema.extend({
    numeroCpf: z.string().nullable().optional()
  }),
  responsaveis: z.array(
    oportunidadeResponsavelSchema.extend({ email: z.string().optional() })
  ),
  funil: z.object({ id: z.number(), label: z.string() }),
  etapa: etapaOportunidadeSchema.extend({
    probabilidade: z.number().nullable()
  }),
  comentarioPerda: z.string().nullable(),
  motivoPerdaId: z.number().nullable().optional(),
  camposCustomizados: z.record(z.string(), z.any()).optional(),
  origemValue: z.string().nullable().optional(),
  origem: oportunidadeOrigemRefSchema.nullable().optional()
});
var oportunidadeDetalhesResponseSchema = dataResponse(
  oportunidadeDetalhesSchema
);
var updateOportunidadeResponseSchema = dataResponse(
  oportunidadeSchema.partial().extend({ id: z.string().optional() })
);
var oportunidadeGroupSchema = z.object({
  id: z.string(),
  dashboardId: z.number(),
  contatoId: z.number(),
  titulo: z.string().nullable(),
  origemValue: z.string(),
  funilId: z.number(),
  etapaId: z.number(),
  qualificacao: z.number(),
  previsaoFechamento: z.string().nullable(),
  status: oportunidadeStatusEnum,
  motivoPerdaId: z.number().nullable(),
  comentarioPerda: z.string().nullable(),
  finalizadoEm: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  contato: oportunidadeContatoSchema.extend({
    email: z.string().nullable().optional(),
    telefone: z.string().nullable().optional()
  }).optional(),
  responsaveis: z.array(oportunidadeResponsavelSchema).optional(),
  funil: z.object({ id: z.number(), label: z.string() }),
  etapa: z.object({
    id: z.number(),
    label: z.string(),
    order: z.number(),
    color: z.string(),
    estagnado: z.number().nullable(),
    oportunidades: z.array(z.any()).optional()
  }),
  _count: z.object({
    tarefas: z.number(),
    anotacoes: z.number(),
    historico: z.number()
  })
});
var oportunidadesGroupResponseSchema = z.object({
  success: z.boolean(),
  data: z.object({
    success: z.boolean(),
    data: z.array(oportunidadeGroupSchema)
  }),
  message: z.string().optional()
});
var createOportunidadeResponseSchema = dataResponse(oportunidadeDetalhesSchema);
var deleteOportunidadeResponseSchema = messageResponseSchema;
var autorMiniSchema = z.object({
  id: z.number(),
  nome: z.string(),
  sobrenome: z.string().nullable(),
  email: z.string()
});
var oportunidadeAnotacaoSchema = z.object({
  id: z.number(),
  oportunidadeId: z.string(),
  conteudo: z.any(),
  autorId: z.number().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  autor: autorMiniSchema.nullable(),
  origem: z.enum(["lead", "oportunidade"]).optional()
});
var oportunidadeAnotacaoResponseSchema = dataResponse(oportunidadeAnotacaoSchema);
var oportunidadeAnotacoesResponseSchema = listResponse(oportunidadeAnotacaoSchema);
var deleteOportunidadeAnotacaoResponseSchema = messageResponseSchema;
var historicoOportunidadeItemSchema = z.object({
  id: z.number(),
  oportunidadeId: z.string(),
  descricao: z.string(),
  eventoValue: z.string(),
  autorId: z.number(),
  createdAt: z.string(),
  autor: autorMiniSchema
});
var historicoOportunidadeResponseSchema = listResponse(historicoOportunidadeItemSchema);
var responsavelTarefaSchema = z.object({
  id: z.number(),
  nome: z.string(),
  sobrenome: z.string().nullable()
});
var tarefaOportunidadeSchema = z.object({
  id: z.number(),
  oportunidadeId: z.string(),
  acaoId: z.number(),
  assunto: z.string(),
  agendadoPara: z.string().nullable(),
  agendadoFim: z.string().nullable(),
  descricao: z.any(),
  statusValue: z.string(),
  finalizadoEm: z.string().nullable(),
  finalizadoPor: z.number().nullable(),
  autorId: z.number().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  responsaveis: z.array(responsavelTarefaSchema),
  autor: responsavelTarefaSchema.extend({ email: z.string().nullable().optional() }).nullable(),
  camposCustomizados: z.record(z.string(), z.any()).optional()
});
var tarefaOportunidadeResponseSchema = dataResponse(tarefaOportunidadeSchema);
var tarefasOportunidadeResponseSchema = listResponse(tarefaOportunidadeSchema);
var concluirTarefaOportunidadeResponseSchema = dataResponse(
  tarefaOportunidadeSchema.partial()
);
var createTarefaOportunidadeRequestSchema = createTarefaRequestSchema;
var updateTarefaOportunidadeRequestSchema = updateTarefaRequestSchema;
var tarefaKanbanSchema = z.object({
  id: z.number(),
  assunto: z.string(),
  agendadoPara: z.string().nullable(),
  agendadoFim: z.string().nullish(),
  statusValue: z.string(),
  camposCustomizados: z.record(z.string(), z.any()).optional()
});
var origemKanbanSchema = oportunidadeOrigemRefSchema;
var etapaKanbanRefSchema = z.object({
  value: z.string(),
  label: z.string()
});
var contatoKanbanSchema = z.object({
  id: z.number(),
  nome: z.string().nullable(),
  sobrenome: z.string().nullable(),
  email: z.string().nullable(),
  telefone: z.string().nullable()
});
var responsavelKanbanSchema = z.object({
  id: z.number(),
  nome: z.string().nullable(),
  sobrenome: z.string().nullable(),
  image: z.string().nullable()
});
var oportunidadeKanbanSchema = z.object({
  id: z.string(),
  titulo: z.string().nullable(),
  status: oportunidadeStatusEnum,
  origem: origemKanbanSchema,
  etapa: etapaKanbanRefSchema,
  qualificacao: z.number(),
  previsaoFechamento: z.string().nullable(),
  finalizadoEm: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  contato: contatoKanbanSchema,
  responsaveis: z.array(responsavelKanbanSchema),
  tarefas: z.array(tarefaKanbanSchema),
  _count: z.object({
    tarefas: z.number()
  }),
  totalTarefas: z.number()
});
var etapaKanbanSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string(),
  order: z.number(),
  color: z.string(),
  probabilidade: z.number().nullable(),
  estagnado: z.number().nullable(),
  oportunidades: z.array(oportunidadeKanbanSchema)
});
var funilKanbanSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string(),
  order: z.number(),
  etapas: z.array(etapaKanbanSchema)
});
var funilKanbanResponseSchema = dataResponse(funilKanbanSchema);
var etapaSchema = z.object({
  id: z.number(),
  label: z.string(),
  value: z.string(),
  order: z.number(),
  probabilidade: z.number(),
  estagnado: z.number(),
  color: z.string(),
  funilId: z.number(),
  createdAt: z.string(),
  updatedAt: z.string(),
  _count: z.object({
    oportunidades: z.number()
  }).optional()
});
var etapasResponseSchema = listResponse(etapaSchema);
var etapaDetailResponseSchema = dataResponse(
  etapaSchema.extend({
    oportunidades: z.array(z.any()).optional()
  })
);
var createEtapaResponseSchema = dataResponse(etapaSchema).extend({
  message: z.string()
});
var updateEtapaResponseSchema = dataResponse(etapaSchema).extend({
  message: z.string()
});
var deleteEtapaResponseSchema = messageResponseSchema;
var funilSchema = z.object({
  id: z.number(),
  label: z.string(),
  value: z.string(),
  order: z.number(),
  dashboardId: z.number().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  etapas: z.array(etapaSchema).optional(),
  _count: z.object({
    oportunidades: z.number()
  }).optional()
});
var funisResponseSchema = listResponse(funilSchema);
var funilDetailResponseSchema = dataResponse(
  funilSchema.extend({
    oportunidades: z.array(z.any()).optional()
  })
);
var createFunilResponseSchema = dataResponse(funilSchema).extend({
  message: z.string()
});
var updateFunilResponseSchema = dataResponse(funilSchema).extend({
  message: z.string()
});
var deleteFunilResponseSchema = messageResponseSchema;

// src/contatos/index.ts
var contatos_exports = {};
__export(contatos_exports, {
  anexoAccessUrlContatoResponseSchema: () => anexoAccessUrlContatoResponseSchema,
  anexoContatoParamsSchema: () => anexoContatoParamsSchema,
  anexoContatoResponseSchema: () => anexoContatoResponseSchema,
  anexoContatoSchema: () => anexoContatoSchema,
  anexosContatoResponseSchema: () => anexosContatoResponseSchema,
  associarSegmentoContatoRequestSchema: () => associarSegmentoContatoRequestSchema,
  associarSegmentoContatoResponseSchema: () => associarSegmentoContatoResponseSchema,
  contaBancariaContatoResponseSchema: () => contaBancariaContatoResponseSchema,
  contaBancariaContatoSchema: () => contaBancariaContatoSchema,
  contasBancariasContatoResponseSchema: () => contasBancariasContatoResponseSchema,
  contatoAnexoParamsSchema: () => contatoAnexoParamsSchema,
  contatoListItemSchema: () => contatoListItemSchema,
  contatoListQuerySchema: () => contatoListQuerySchema,
  contatoRelacionadoInfoSchema: () => contatoRelacionadoInfoSchema,
  contatoRelacionadoParamsSchema: () => contatoRelacionadoParamsSchema,
  contatoResponseSchema: () => contatoResponseSchema,
  contatoSchema: () => contatoSchema,
  contatosResponseSchema: () => contatosResponseSchema,
  createAnexoContatoRequestSchema: () => createAnexoContatoRequestSchema,
  createAnexoContatoResponseSchema: () => createAnexoContatoResponseSchema,
  createContaBancariaRequestSchema: () => createContaBancariaRequestSchema,
  createContatoRequestSchema: () => createContatoRequestSchema,
  createContatoResponseSchema: () => createContatoResponseSchema,
  createRelacionadoRequestSchema: () => createRelacionadoRequestSchema,
  createRelacionadoResponseSchema: () => createRelacionadoResponseSchema,
  createSegmentoContatoRequestSchema: () => createSegmentoContatoRequestSchema,
  createSegmentoContatoResponseSchema: () => createSegmentoContatoResponseSchema,
  deleteAnexoContatoResponseSchema: () => deleteAnexoContatoResponseSchema,
  deleteContaBancariaContatoResponseSchema: () => deleteContaBancariaContatoResponseSchema,
  deleteContatoResponseSchema: () => deleteContatoResponseSchema,
  deleteRelacionadoResponseSchema: () => deleteRelacionadoResponseSchema,
  generateContatoFotoUploadUrlRequestSchema: () => generateContatoFotoUploadUrlRequestSchema,
  generateUploadUrlContatoRequestSchema: () => generateUploadUrlContatoRequestSchema,
  naturezaJuridicaEnum: () => naturezaJuridicaEnum,
  pesquisarContatoSchema: () => pesquisarContatoSchema,
  pesquisarContatosResponseSchema: () => pesquisarContatosResponseSchema,
  relacionadoDetailResponseSchema: () => relacionadoDetailResponseSchema,
  relacionadoSchema: () => relacionadoSchema,
  relacionadosResponseSchema: () => relacionadosResponseSchema,
  removerSegmentoContatoResponseSchema: () => removerSegmentoContatoResponseSchema,
  segmentoContatoAssociationSchema: () => segmentoContatoAssociationSchema,
  segmentoContatoRefSchema: () => segmentoContatoRefSchema,
  segmentoDisponivelContatoSchema: () => segmentoDisponivelContatoSchema,
  segmentosContatoResponseSchema: () => segmentosContatoResponseSchema,
  segmentosDisponiveisContatoResponseSchema: () => segmentosDisponiveisContatoResponseSchema,
  tipoCadastroEnum: () => tipoCadastroEnum,
  tipoChavePixEnum: () => tipoChavePixEnum,
  tipoContaBancariaEnum: () => tipoContaBancariaEnum,
  updateAnexoContatoRequestSchema: () => updateAnexoContatoRequestSchema,
  updateAnexoContatoResponseSchema: () => updateAnexoContatoResponseSchema,
  updateContaBancariaRequestSchema: () => updateContaBancariaRequestSchema,
  updateContatoRequestSchema: () => updateContatoRequestSchema,
  updateContatoResponseSchema: () => updateContatoResponseSchema,
  updateRelacionadoRequestSchema: () => updateRelacionadoRequestSchema,
  updateRelacionadoResponseSchema: () => updateRelacionadoResponseSchema,
  uploadUrlContatoFotoResponseSchema: () => uploadUrlContatoFotoResponseSchema,
  uploadUrlContatoResponseSchema: () => uploadUrlContatoResponseSchema
});
var naturezaJuridicaEnum = z.enum(["PF", "PJ"]);
var cpfRegex = /^\d{3}\.\d{3}\.\d{3}-\d{2}$|^\d{11}$/;
var cnpjRegex = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$|^\d{14}$/;
var camposCustomizadosInput7 = z.record(
  z.string(),
  z.union([z.string(), z.number(), z.boolean(), z.null()])
);
var contatoBaseShape = {
  sobrenome: z.string().max(255).optional(),
  numeroCpf: z.string().regex(cpfRegex, "CPF deve ter formato v\xE1lido").optional(),
  numeroRg: z.string().max(50).optional(),
  emissaoRg: z.string().max(50).optional(),
  numeroCnh: z.string().max(50).optional(),
  emissaoCnh: z.string().max(50).optional(),
  profissao: z.string().max(255).optional(),
  tituloEleitor: z.string().max(50).optional(),
  dataNascimento: z.string().max(50).optional(),
  cidadeNascimento: z.string().max(255).optional(),
  nomeMae: z.string().max(255).optional(),
  nomePai: z.string().max(255).optional(),
  estadoCivil: z.string().max(50).optional(),
  inscricaoEstadual: z.string().max(50).optional(),
  renda: z.number().optional(),
  cnpj: z.string().regex(cnpjRegex, "CNPJ deve ter formato v\xE1lido").optional(),
  nomeFantasia: z.string().max(255).optional(),
  razaoSocial: z.string().max(255).optional(),
  email: z.string().email().optional(),
  emailSecundario: z.string().email().optional(),
  telefone: z.string().optional(),
  telefoneSecundario: z.string().optional(),
  cep: z.string().optional(),
  rua: z.string().max(255).optional(),
  numero: z.string().max(20).optional(),
  bairro: z.string().max(255).optional(),
  cidade: z.string().max(255).optional(),
  uf: z.string().max(2).optional(),
  complemento: z.string().max(255).optional(),
  informacoesAdicionais: z.string().optional(),
  foto: nullableString,
  tipos: z.array(z.number()).optional(),
  camposCustomizados: camposCustomizadosInput7.optional(),
  /** Aceita campanhas de marketing (email/WhatsApp). Default true no banco. */
  aceitaMarketing: z.boolean().optional(),
  /**
   * Bloqueio de segurança no CRM (sem envios 1:1 / campanhas / automações).
   * Distinto de aceitaMarketing (opt-out só de marketing).
   */
  bloqueado: z.boolean().optional(),
  /** Motivo opcional ao bloquear (ignorado ao desbloquear). */
  bloqueadoMotivo: z.string().max(500).optional().nullable()
};
var createContatoRequestSchema = z.object({
  naturezaJuridica: naturezaJuridicaEnum,
  nome: z.string().min(1).max(255),
  ...contatoBaseShape
});
var updateContatoRequestSchema = z.object({
  naturezaJuridica: naturezaJuridicaEnum.optional(),
  nome: z.string().max(255).optional(),
  ...contatoBaseShape
});
var contatoListQuerySchema = z.object({
  page: z.coerce.number().min(1).optional(),
  take: z.coerce.number().min(1).max(100).optional(),
  hasImoveis: booleanLike.optional(),
  hasPropostas: booleanLike.optional(),
  hasRegistroChaves: booleanLike.optional(),
  hasLead: booleanLike.optional(),
  hasOportunidades: booleanLike.optional(),
  search: z.string().optional(),
  segmentos: z.array(z.string()).optional()
});
var pesquisarContatoSchema = z.object({
  termo: z.string().optional(),
  naturezaJuridica: naturezaJuridicaEnum.optional(),
  cidade: z.string().optional(),
  uf: z.string().optional()
});
var createRelacionadoRequestSchema = z.object({
  relacionado: z.number(),
  relacao: z.string().min(1).max(255)
});
var updateRelacionadoRequestSchema = z.object({
  relacionado: z.number().optional(),
  relacao: z.string().max(255).optional()
});
var tipoCadastroEnum = z.enum(["PIX", "CONTA"]);
var tipoContaBancariaEnum = z.enum([
  "CONTA_CORRENTE",
  "CONTA_POUPANCA"
]);
var tipoChavePixEnum = z.enum([
  "CPF",
  "CNPJ",
  "EMAIL",
  "PHONE",
  "EVP"
]);
var createContaBancariaRequestSchema = z.object({
  tipoCadastro: tipoCadastroEnum,
  chavePix: z.string().optional(),
  tipoChavePix: tipoChavePixEnum.optional(),
  tipoConta: tipoContaBancariaEnum.optional(),
  banco: z.number().min(1).optional(),
  bancoNome: z.string().optional(),
  agencia: z.string().optional(),
  conta: z.string().optional(),
  digitoConta: z.string().optional()
}).refine(
  (d) => d.tipoCadastro === "PIX" ? Boolean(d.chavePix) && Boolean(d.tipoChavePix) : Boolean(d.tipoConta) && Boolean(d.agencia) && Boolean(d.conta),
  {
    message: "Campos obrigat\xF3rios n\xE3o preenchidos conforme o tipo de cadastro selecionado"
  }
);
var updateContaBancariaRequestSchema = z.object({
  tipoCadastro: tipoCadastroEnum.optional(),
  chavePix: z.string().optional(),
  tipoChavePix: tipoChavePixEnum.optional(),
  tipoConta: tipoContaBancariaEnum.optional(),
  banco: z.number().min(1).max(999).optional(),
  bancoNome: z.string().optional(),
  agencia: z.string().optional(),
  conta: z.string().optional(),
  digitoConta: z.string().optional()
});
var contatoMetadataSchema = z.object({
  isLead: z.boolean(),
  isPropriedades: z.boolean(),
  isPropostas: z.boolean(),
  registroChaves: z.boolean(),
  isOportunidades: z.boolean()
});
var contatoListItemSchema = z.object({
  id: z.number(),
  foto: nullableString,
  naturezaJuridica: naturezaJuridicaEnum,
  nome: z.string(),
  sobrenome: nullableString,
  email: nullableString,
  telefone: nullableString,
  numeroCpf: nullableString,
  cnpj: nullableString,
  createdAt: z.string(),
  updatedAt: z.string(),
  metadata: contatoMetadataSchema
});
var contatoSchema = z.object({
  id: z.number(),
  dashboardId: z.number(),
  naturezaJuridica: naturezaJuridicaEnum,
  foto: nullableString,
  nome: z.string(),
  sobrenome: nullableString,
  numeroCpf: nullableString,
  numeroRg: nullableString,
  emissaoRg: nullableString,
  numeroCnh: nullableString,
  emissaoCnh: nullableString,
  profissao: nullableString,
  tituloEleitor: nullableString,
  dataNascimento: nullableString,
  cidadeNascimento: nullableString,
  nomeMae: nullableString,
  nomePai: nullableString,
  estadoCivil: nullableString,
  inscricaoEstadual: nullableString,
  cnpj: nullableString,
  nomeFantasia: nullableString,
  razaoSocial: nullableString,
  estrangeiro: z.boolean(),
  renda: z.union([z.string(), z.number(), z.null()]).optional().transform((val) => {
    if (val === "" || val === void 0) return null;
    if (typeof val === "number") return val.toString();
    return val;
  }),
  informacoesAdicionais: nullableString,
  email: nullableString,
  telefone: nullableString,
  emailSecundario: nullableString,
  telefoneSecundario: nullableString,
  aceitaMarketing: z.boolean().default(true),
  marketingOptOutEm: z.string().nullable().optional(),
  marketingOptOutCanal: z.string().nullable().optional(),
  bloqueado: z.boolean().default(false),
  bloqueadoEm: z.string().nullable().optional(),
  bloqueadoPorId: z.number().nullable().optional(),
  bloqueadoMotivo: z.string().nullable().optional(),
  rua: nullableString,
  numero: nullableString,
  bairro: nullableString,
  cidade: nullableString,
  uf: nullableString,
  complemento: nullableString,
  cep: nullableString,
  createdAt: z.string(),
  updatedAt: z.string(),
  adicionadoPor: z.object({
    id: z.number(),
    nome: z.string(),
    sobrenome: z.string().nullable(),
    email: z.string().nullable()
  }).nullable().optional(),
  camposCustomizados: z.any().nullable(),
  tipos: z.array(z.any()),
  propriedades: z.array(z.any()),
  relacionados: z.array(z.any()),
  metadata: contatoMetadataSchema
});
var contatosResponseSchema = listResponse(contatoListItemSchema);
var contatoResponseSchema = dataResponse(contatoSchema);
var createContatoResponseSchema = dataResponse(contatoSchema);
var updateContatoResponseSchema = contatoResponseSchema;
var deleteContatoResponseSchema = messageResponseSchema;
var pesquisarContatosResponseSchema = dataResponse(
  z.array(contatoSchema)
);
var contatoRelacionadoInfoSchema = z.object({
  id: z.number(),
  nome: z.string(),
  sobrenome: nullableString,
  email: nullableString,
  telefone: nullableString
});
var relacionadoSchema = z.object({
  id: z.number(),
  contatoId: z.number(),
  relacionadoId: z.number(),
  relacao: z.string(),
  relacaoInversa: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
  relacionado: contatoRelacionadoInfoSchema.optional()
});
var relacionadosResponseSchema = listResponse(relacionadoSchema);
var createRelacionadoResponseSchema = dataResponse(relacionadoSchema);
var updateRelacionadoResponseSchema = createRelacionadoResponseSchema;
var relacionadoDetailResponseSchema = createRelacionadoResponseSchema;
var deleteRelacionadoResponseSchema = messageResponseSchema;
var contaBancariaContatoSchema = z.object({
  id: z.string(),
  contatoId: z.number(),
  tipoCadastro: tipoCadastroEnum,
  tipoConta: tipoContaBancariaEnum.nullable().optional(),
  banco: z.number().nullable().optional(),
  bancoNome: nullableString,
  agencia: nullableString,
  conta: nullableString,
  digitoConta: nullableString,
  chavePix: nullableString,
  tipoChavePix: tipoChavePixEnum.nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
  contato: z.object({
    id: z.number(),
    nome: z.string(),
    sobrenome: z.string().nullable()
  }).optional()
});
var contasBancariasContatoResponseSchema = listResponse(
  contaBancariaContatoSchema
);
var contaBancariaContatoResponseSchema = dataResponse(
  contaBancariaContatoSchema
);
var deleteContaBancariaContatoResponseSchema = messageResponseSchema;
var anexoContatoSchema = z.object({
  id: z.number(),
  titulo: z.string(),
  size: z.number(),
  mimeType: z.string(),
  contatoId: z.number(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var anexosContatoResponseSchema = listResponse(anexoContatoSchema);
var anexoContatoResponseSchema = dataResponse(anexoContatoSchema);
var createAnexoContatoResponseSchema = dataResponse(anexoContatoSchema);
var updateAnexoContatoResponseSchema = dataResponse(anexoContatoSchema);
var deleteAnexoContatoResponseSchema = messageResponseSchema;
var uploadUrlContatoResponseSchema = dataResponse(
  z.object({
    uploadUrl: z.string(),
    fileKey: z.string()
  })
);
var generateContatoFotoUploadUrlRequestSchema = z.object({
  fileType: z.string().min(1, "fileType \xE9 obrigat\xF3rio").regex(
    /^image\/(jpeg|jpg|png|webp)$/,
    "Tipo de arquivo deve ser uma imagem (jpeg, jpg, png ou webp)"
  )
});
var uploadUrlContatoFotoResponseSchema = dataResponse(
  z.object({
    uploadUrl: z.string(),
    fileKey: z.string(),
    fileType: z.string()
  })
);
var generateUploadUrlContatoRequestSchema = generateAnexoUploadUrlSchema;
var createAnexoContatoRequestSchema = createAnexoMetadataSchema;
var updateAnexoContatoRequestSchema = updateAnexoMetadataSchema;
var anexoAccessUrlContatoResponseSchema = dataResponse(accessUrlDataSchema);
var contatoAnexoParamsSchema = z.object({
  contatoId: z.coerce.number().int().min(1)
});
var contatoRelacionadoParamsSchema = z.object({
  contatoId: z.coerce.number().int().min(1)
});
var anexoContatoParamsSchema = contatoAnexoParamsSchema.extend({
  id: z.coerce.number().int().min(1)
});
var segmentoContatoRefSchema = z.object({
  id: z.number(),
  label: z.string(),
  value: z.string(),
  description: z.string().nullable()
});
var segmentoContatoAssociationSchema = z.object({
  contatoId: z.number(),
  segmentoId: z.number(),
  createdAt: z.string(),
  updatedAt: z.string(),
  segmento: segmentoContatoRefSchema
});
var segmentosContatoResponseSchema = listResponse(
  segmentoContatoAssociationSchema
);
var associarSegmentoContatoRequestSchema = z.object({
  value: z.string().min(1)
});
var associarSegmentoContatoResponseSchema = dataResponse(
  segmentoContatoAssociationSchema
);
var segmentoDisponivelContatoSchema = segmentoContatoRefSchema.extend({
  contatosCount: z.number().optional()
});
var segmentosDisponiveisContatoResponseSchema = listResponse(
  segmentoDisponivelContatoSchema
);
var createSegmentoContatoRequestSchema = z.object({
  label: z.string().min(1),
  value: z.string().optional(),
  description: z.string().nullable().optional()
});
var createSegmentoContatoResponseSchema = dataResponse(
  segmentoDisponivelContatoSchema.extend({
    dashboardId: z.number(),
    createdAt: z.string(),
    updatedAt: z.string()
  })
);
var removerSegmentoContatoResponseSchema = messageResponseSchema;

// src/distribuicao-leads/index.ts
var distribuicao_leads_exports = {};
__export(distribuicao_leads_exports, {
  atualizarPrioridadeDataSchema: () => atualizarPrioridadeDataSchema,
  atualizarPrioridadeRequestSchema: () => atualizarPrioridadeRequestSchema,
  atualizarPrioridadeResponseSchema: () => atualizarPrioridadeResponseSchema,
  auditoriaDataSchema: () => auditoriaDataSchema,
  auditoriaItemSchema: () => auditoriaItemSchema,
  auditoriaResponseSchema: () => auditoriaResponseSchema,
  checkinResponseSchema: () => checkinResponseSchema,
  checkinStatusResponseSchema: () => checkinStatusResponseSchema,
  configuracaoDistribuicaoLeadsRequestSchema: () => configuracaoDistribuicaoLeadsRequestSchema,
  configuracaoDistribuicaoResponseSchema: () => configuracaoDistribuicaoResponseSchema,
  configuracaoDistribuicaoSchema: () => configuracaoDistribuicaoSchema,
  corretorFilaSchema: () => corretorFilaSchema,
  createGrupoResponsaveisRequestSchema: () => createGrupoResponsavelRequestSchema,
  createGrupoResponsaveisResponseSchema: () => createGrupoResponsavelResponseSchema,
  criterioPontuacaoSchema: () => criterioPontuacaoSchema,
  deleteGrupoResponsaveisResponseSchema: () => deleteGrupoResponsaveisResponseSchema,
  distribuicaoPaginacaoSchema: () => distribuicaoPaginacaoSchema,
  empreendimentoGrupoSchema: () => empreendimentoGrupoSchema,
  filaDistribuicaoDataSchema: () => filaDistribuicaoDataSchema,
  filaDistribuicaoResponseSchema: () => filaDistribuicaoResponseSchema,
  filaItemSchema: () => filaItemSchema,
  grupoAnalisadoSchema: () => grupoAnalisadoSchema,
  grupoResponsaveisDetailResponseSchema: () => grupoResponsaveisDetailResponseSchema,
  grupoResponsaveisSchema: () => grupoResponsaveisSchema,
  grupoResponsavelSchema: () => grupoResponsavelSchema,
  gruposResponsaveisResponseSchema: () => gruposResponsaveisResponseSchema,
  historicoDistribuicaoDataSchema: () => historicoDistribuicaoDataSchema,
  historicoDistribuicaoItemSchema: () => historicoDistribuicaoItemSchema,
  historicoDistribuicaoResponseSchema: () => historicoDistribuicaoResponseSchema,
  horarioComercialSchema: () => horarioComercialSchema,
  imovelGrupoSchema: () => imovelGrupoSchema,
  membroFilaSchema: () => membroFilaSchema,
  metricasCorretorDataSchema: () => metricasCorretorDataSchema,
  metricasCorretorResponseSchema: () => metricasCorretorResponseSchema,
  modoDistribuicaoSchema: () => modoDistribuicaoSchema,
  opcoesDadosDataSchema: () => opcoesDadosDataSchema,
  opcoesDadosResponseSchema: () => opcoesDadosResponseSchema,
  opcoesImovelOptionSchema: () => opcoesImovelOptionSchema,
  relatorioDistribuicaoDataSchema: () => relatorioDistribuicaoDataSchema,
  relatorioDistribuicaoResponseSchema: () => relatorioDistribuicaoResponseSchema,
  reordenarFilaDataSchema: () => reordenarFilaDataSchema,
  reordenarFilaRequestSchema: () => reordenarFilaRequestSchema,
  reordenarFilaResponseSchema: () => reordenarFilaResponseSchema,
  responsavelGrupoResumoSchema: () => responsavelGrupoSchema,
  responsavelResumoSchema: () => responsavelResumoSchema,
  resumoLeadPassagemSchema: () => resumoLeadPassagemSchema,
  simulacaoDistribuicaoDataSchema: () => simulacaoDistribuicaoDataSchema,
  simulacaoDistribuicaoRequestSchema: () => simulacaoDistribuicaoRequestSchema,
  simulacaoDistribuicaoResponseSchema: () => simulacaoDistribuicaoResponseSchema,
  updateConfiguracaoDistribuicaoResponseSchema: () => updateConfiguracaoDistribuicaoResponseSchema,
  updateGrupoResponsaveisRequestSchema: () => updateGrupoResponsavelRequestSchema,
  updateGrupoResponsaveisResponseSchema: () => updateGrupoResponsavelResponseSchema,
  valueLabelOptionSchema: () => valueLabelOptionSchema
});

// src/responsaveis/index.ts
var responsaveis_exports = {};
__export(responsaveis_exports, {
  createGrupoResponsavelRequestSchema: () => createGrupoResponsavelRequestSchema,
  createGrupoResponsavelResponseSchema: () => createGrupoResponsavelResponseSchema,
  deleteGrupoResponsavelResponseSchema: () => deleteGrupoResponsavelResponseSchema,
  empreendimentoGrupoSchema: () => empreendimentoGrupoSchema,
  grupoResponsavelResponseSchema: () => grupoResponsavelResponseSchema,
  grupoResponsavelSchema: () => grupoResponsavelSchema,
  gruposResponsavelResponseSchema: () => gruposResponsavelResponseSchema,
  imovelGrupoSchema: () => imovelGrupoSchema,
  opcoesDadosDataSchema: () => opcoesDadosDataSchema,
  opcoesDadosResponseSchema: () => opcoesDadosResponseSchema,
  opcoesImovelOptionSchema: () => opcoesImovelOptionSchema,
  responsavelGrupoSchema: () => responsavelGrupoSchema,
  updateGrupoResponsavelRequestSchema: () => updateGrupoResponsavelRequestSchema,
  updateGrupoResponsavelResponseSchema: () => updateGrupoResponsavelResponseSchema,
  valueLabelOptionSchema: () => valueLabelOptionSchema
});
var createGrupoResponsavelRequestSchema = z.object({
  nome: z.string().min(1, "Nome \xE9 obrigat\xF3rio").max(255),
  finalidades: z.array(z.string()),
  responsaveis: z.array(z.coerce.number()),
  origens: z.array(z.string()).optional(),
  cidades: z.array(z.string()).optional(),
  bairros: z.array(z.string()).optional(),
  imoveis: z.array(z.coerce.number()).optional(),
  empreendimentos: z.array(z.coerce.number()).optional(),
  status: booleanLike.optional(),
  responsavelFallbackId: z.coerce.number().optional(),
  exigeCheckin: booleanLike.optional(),
  horarioAtivacao: z.any().optional(),
  prioridade: z.coerce.number().min(0).optional(),
  valorMinimo: z.coerce.number().optional(),
  valorMaximo: z.coerce.number().optional()
});
var updateGrupoResponsavelRequestSchema = createGrupoResponsavelRequestSchema.partial();
var responsavelGrupoSchema = z.object({
  id: z.number(),
  nome: z.string().nullable().optional(),
  sobrenome: z.string().nullable().optional()
});
var imovelGrupoSchema = z.object({
  id: z.number(),
  titulo: z.string().nullable().optional(),
  codigo: z.string().nullable().optional()
});
var empreendimentoGrupoSchema = z.object({
  id: z.number(),
  nome: z.string().nullable().optional()
});
var grupoResponsavelSchema = z.object({
  id: z.number(),
  nome: z.string(),
  finalidades: z.array(z.string()),
  responsaveis: z.array(responsavelGrupoSchema).optional().default([]),
  origens: z.array(z.string()).nullable().optional(),
  cidades: z.array(z.string()).nullable().optional(),
  bairros: z.array(z.string()).nullable().optional(),
  imoveis: z.array(imovelGrupoSchema).nullable().optional(),
  empreendimentos: z.array(empreendimentoGrupoSchema).nullable().optional(),
  status: z.boolean(),
  exigeCheckin: z.boolean().optional().default(false),
  horarioAtivacao: z.any().nullable().optional(),
  prioridade: z.number().optional().default(0),
  valorMinimo: z.number().nullable().optional(),
  valorMaximo: z.number().nullable().optional(),
  responsavelFallbackId: z.number().nullable().optional(),
  dashboardId: z.number(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional()
});
var gruposResponsavelResponseSchema = dataResponse(
  z.array(grupoResponsavelSchema)
);
var grupoResponsavelResponseSchema = dataResponse(grupoResponsavelSchema);
var createGrupoResponsavelResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  data: grupoResponsavelSchema
});
var updateGrupoResponsavelResponseSchema = createGrupoResponsavelResponseSchema;
var deleteGrupoResponsavelResponseSchema = messageResponseSchema;
var valueLabelOptionSchema = z.object({
  value: z.string(),
  label: z.string()
});
var opcoesImovelOptionSchema = valueLabelOptionSchema.extend({
  codigo: z.string().optional()
});
var opcoesDadosDataSchema = z.object({
  finalidades: z.array(valueLabelOptionSchema),
  origens: z.array(valueLabelOptionSchema),
  cidades: z.array(valueLabelOptionSchema),
  bairros: z.array(valueLabelOptionSchema),
  imoveis: z.array(opcoesImovelOptionSchema).optional(),
  empreendimentos: z.array(valueLabelOptionSchema).optional(),
  responsaveis: z.array(responsavelGrupoSchema)
});
var opcoesDadosResponseSchema = dataResponse(opcoesDadosDataSchema);

// src/distribuicao-leads/index.ts
var horarioComercialSchema = z.object({
  diasSemana: z.array(z.number().int()).optional(),
  horaInicio: z.string().optional(),
  horaFim: z.string().optional(),
  fusoHorario: z.string().optional()
});
var modoDistribuicaoSchema = z.enum(["pontuacao", "cascata"]);
var configuracaoDistribuicaoLeadsRequestSchema = z.object({
  atribuirLeadResponsavel: z.boolean().optional(),
  sempreDefinirResponsavel: z.boolean().optional(),
  responsavelPadraoId: z.number().int().min(1).nullable().optional(),
  distribuirApenasHorarioComercial: z.boolean().optional(),
  horariosComerciais: horarioComercialSchema.nullable().optional(),
  delayInicioHorarioComercial: z.number().int().min(0).optional(),
  notificarApenasHorarioComercial: z.boolean().optional(),
  redistribuirAutomaticamente: z.boolean().optional(),
  tempoLimiteRedistribuicao: z.number().int().min(0).optional(),
  tipoTempoRedistribuicao: z.enum(["Minutos", "Horas", "Dias"]).optional(),
  maxTentativasRedistribuicao: z.number().int().min(1).max(10).optional(),
  escalarParaSupervisor: z.boolean().optional(),
  grupoEscalacaoId: z.number().int().min(1).nullable().optional(),
  modoDistribuicao: modoDistribuicaoSchema.optional(),
  maxLeadsPendentes: z.number().int().min(1).nullable().optional(),
  habilitarPlantao: z.boolean().optional(),
  intervaloRevalidacaoCheckin: z.number().int().min(5).nullable().optional(),
  tempoMaximoPausaCheckin: z.number().int().min(5).nullable().optional(),
  permitirPausaCheckin: z.boolean().optional(),
  notificarGestorSemPlantao: z.boolean().optional(),
  permitirRenovacaoViaLink: z.boolean().optional()
});
var atualizarPrioridadeRequestSchema = z.object({
  prioridade: z.number().int().min(0).max(10)
});
var reordenarFilaRequestSchema = z.object({
  ordem: z.array(z.number().int().min(1))
});
var simulacaoDistribuicaoRequestSchema = z.object({
  finalidade: z.string(),
  origem: z.string().optional(),
  cidade: z.string().optional(),
  bairro: z.string().optional(),
  imoveis: z.array(z.number()).optional(),
  empreendimentos: z.array(z.number()).optional(),
  valorImovel: z.number().optional()
});
var configuracaoDistribuicaoSchema = z.object({
  id: z.number(),
  atribuirLeadResponsavel: z.boolean(),
  sempreDefinirResponsavel: z.boolean(),
  responsavelPadraoId: z.number().nullable(),
  distribuirApenasHorarioComercial: z.boolean(),
  horariosComerciais: horarioComercialSchema.nullable(),
  delayInicioHorarioComercial: z.number().int().min(0),
  notificarApenasHorarioComercial: z.boolean(),
  redistribuirAutomaticamente: z.boolean(),
  tempoLimiteRedistribuicao: z.number().int().min(0),
  tipoTempoRedistribuicao: z.enum(["Minutos", "Horas", "Dias"]),
  maxTentativasRedistribuicao: z.number().int().min(1).max(10),
  escalarParaSupervisor: z.boolean(),
  grupoEscalacaoId: z.number().nullable(),
  modoDistribuicao: z.string(),
  maxLeadsPendentes: z.number().nullable().optional(),
  habilitarPlantao: z.boolean().optional(),
  intervaloRevalidacaoCheckin: z.number().nullable().optional(),
  tempoMaximoPausaCheckin: z.number().nullable().optional(),
  permitirPausaCheckin: z.boolean().optional(),
  notificarGestorSemPlantao: z.boolean().optional(),
  permitirRenovacaoViaLink: z.boolean().optional(),
  updatedAt: z.string().optional()
});
var configuracaoDistribuicaoResponseSchema = dataResponse(
  configuracaoDistribuicaoSchema
);
var updateConfiguracaoDistribuicaoResponseSchema = dataResponse(
  configuracaoDistribuicaoSchema
);
var grupoResponsaveisSchema = z.object({
  id: z.number(),
  nome: z.string(),
  descricao: z.string().nullable().optional(),
  finalidades: z.array(z.string()).optional(),
  responsaveis: z.array(z.object({ id: z.number(), nome: z.string().nullable().optional(), sobrenome: z.string().nullable().optional() })).optional(),
  origens: z.array(z.string()).nullable().optional(),
  cidades: z.array(z.string()).nullable().optional(),
  bairros: z.array(z.string()).nullable().optional(),
  prioridade: z.number().optional(),
  status: z.boolean().optional(),
  exigeCheckin: z.boolean().optional(),
  dashboardId: z.number().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional()
});
var gruposResponsaveisResponseSchema = listResponse(grupoResponsaveisSchema);
var grupoResponsaveisDetailResponseSchema = dataResponse(grupoResponsaveisSchema);
var deleteGrupoResponsaveisResponseSchema = messageResponseSchema;
var filaItemSchema = z.object({
  id: z.number(),
  usuarioId: z.number(),
  ordem: z.number(),
  prioridade: z.number().optional(),
  usuario: z.object({ id: z.number(), nome: z.string().nullable().optional() }).optional()
});
var membroFilaSchema = z.object({
  id: z.number(),
  nome: z.string().nullable(),
  sobrenome: z.string().nullable(),
  prioridade: z.number(),
  disponibilidade: z.string().optional(),
  online: z.boolean(),
  leadsAtivos: z.number(),
  slotsNaFila: z.number(),
  posicaoCustomizada: z.number().nullable()
});
var filaDistribuicaoDataSchema = z.object({
  grupo: z.object({
    id: z.number(),
    nome: z.string(),
    contadorRoundRobin: z.number(),
    ultimoResponsavelId: z.number().nullable(),
    ordemDistribuicao: z.array(z.number())
  }),
  proximoResponsavel: z.object({
    id: z.number(),
    nome: z.string().nullable(),
    sobrenome: z.string().nullable(),
    prioridade: z.number()
  }).nullable(),
  fila: z.array(membroFilaSchema),
  filaExpandida: z.array(z.object({ id: z.number(), nome: z.string() })),
  totalSlots: z.number()
});
var filaDistribuicaoResponseSchema = dataResponse(filaDistribuicaoDataSchema);
var responsavelResumoSchema = z.object({
  id: z.number(),
  nome: z.string().nullable(),
  sobrenome: z.string().nullable()
});
var distribuicaoPaginacaoSchema = z.object({
  page: z.number(),
  limit: z.number(),
  total: z.number(),
  totalPages: z.number()
});
var historicoDistribuicaoItemSchema = z.object({
  id: z.number(),
  leadId: z.string(),
  dashboardId: z.number(),
  tipo: z.enum([
    "distribuicao_inicial",
    "redistribuicao",
    "escalacao",
    "manual",
    "fallback"
  ]),
  responsavelAnteriorId: z.number().nullable(),
  responsavelAnterior: responsavelResumoSchema.nullable(),
  novoResponsavelId: z.number().nullable(),
  novoResponsavel: responsavelResumoSchema.nullable(),
  grupoId: z.number().nullable(),
  grupoNome: z.string().nullable(),
  motivo: z.string().nullable(),
  tentativa: z.number(),
  sucesso: z.boolean(),
  metadados: z.any().nullable(),
  createdAt: z.string()
});
var resumoLeadPassagemSchema = z.object({
  leadId: z.string(),
  atendido: z.boolean(),
  atendidoEm: z.string().nullable(),
  totalPassagens: z.number(),
  totalCorretoresDistintos: z.number(),
  registrosConsiderados: z.number(),
  corretores: z.array(
    responsavelResumoSchema.extend({
      passagens: z.number(),
      primeiraPassagemEm: z.string(),
      ultimaPassagemEm: z.string()
    })
  )
});
var historicoDistribuicaoDataSchema = z.object({
  registros: z.array(historicoDistribuicaoItemSchema),
  resumoLead: resumoLeadPassagemSchema.nullable().optional(),
  paginacao: distribuicaoPaginacaoSchema
});
var historicoDistribuicaoResponseSchema = dataResponse(
  historicoDistribuicaoDataSchema
);
var atualizarPrioridadeDataSchema = z.object({
  usuarioId: z.number(),
  nome: z.string().nullable(),
  sobrenome: z.string().nullable(),
  prioridadeDistribuicao: z.number().nullable()
});
var atualizarPrioridadeResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  data: atualizarPrioridadeDataSchema
});
var reordenarFilaDataSchema = z.object({
  grupoId: z.number(),
  nome: z.string(),
  ordemDistribuicao: z.array(z.number()),
  filaResultante: z.array(
    z.object({
      posicao: z.number(),
      id: z.number(),
      nome: z.string(),
      prioridade: z.number()
    })
  ),
  totalSlots: z.number()
});
var reordenarFilaResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  data: reordenarFilaDataSchema
});
var checkinResponseSchema = dataResponse(
  z.object({
    usuarioId: z.number(),
    checkinAtivo: z.boolean(),
    checkinInicio: z.string().nullable(),
    checkinFim: z.string().nullable(),
    checkinPausado: z.boolean(),
    checkinUltimaRenovacao: z.string().nullable()
  })
);
var checkinStatusResponseSchema = dataResponse(
  z.object({
    usuarioId: z.number(),
    nome: z.string().nullable(),
    sobrenome: z.string().nullable(),
    checkinAtivo: z.boolean(),
    checkinInicio: z.string().nullable(),
    checkinFim: z.string().nullable(),
    checkinPausado: z.boolean(),
    disponibilidade: z.string(),
    habilitarPlantao: z.boolean().optional()
  })
);
var criterioPontuacaoSchema = z.object({
  match: z.boolean(),
  pontos: z.number()
});
var grupoAnalisadoSchema = z.object({
  id: z.number(),
  nome: z.string(),
  pontuacao: z.number(),
  selecionado: z.boolean(),
  descartado: z.boolean(),
  motivoDescarte: z.string().optional(),
  detalhes: z.object({
    finalidade: criterioPontuacaoSchema,
    origem: criterioPontuacaoSchema,
    cidade: criterioPontuacaoSchema,
    bairro: criterioPontuacaoSchema,
    imoveis: criterioPontuacaoSchema,
    empreendimentos: criterioPontuacaoSchema,
    faixaValor: criterioPontuacaoSchema,
    horarioAtivo: z.boolean()
  })
});
var corretorFilaSchema = z.object({
  posicao: z.number(),
  id: z.number(),
  nome: z.string(),
  prioridade: z.number(),
  online: z.boolean(),
  selecionado: z.boolean(),
  checkinAtivo: z.boolean().optional()
});
var simulacaoDistribuicaoDataSchema = z.object({
  leadSimulado: z.object({
    finalidade: z.string(),
    origem: z.string().optional(),
    cidade: z.string().optional(),
    bairro: z.string().optional(),
    imoveis: z.array(z.number()).optional(),
    empreendimentos: z.array(z.number()).optional()
  }),
  modoDistribuicao: z.string(),
  maxLeadsPendentes: z.number().nullable(),
  gruposAnalisados: z.array(grupoAnalisadoSchema),
  grupoSelecionado: z.object({
    id: z.number(),
    nome: z.string(),
    pontuacao: z.number()
  }).nullable(),
  filaDoGrupo: z.array(corretorFilaSchema),
  corretorSelecionado: z.object({
    id: z.number(),
    nome: z.string(),
    posicaoNaFila: z.number(),
    prioridade: z.number()
  }).nullable(),
  fallback: z.object({
    ativado: z.boolean(),
    motivo: z.string().optional(),
    responsavelPadraoId: z.number().optional(),
    responsavelPadraoNome: z.string().optional()
  }),
  horarioComercial: z.object({
    configurado: z.boolean(),
    dentroDoHorario: z.boolean(),
    proximoHorario: z.string().optional()
  }),
  notificacao: z.object({
    envioImediato: z.boolean(),
    agendadoPara: z.string().optional()
  }),
  resumo: z.string()
});
var simulacaoDistribuicaoResponseSchema = z.object({
  success: z.boolean(),
  data: simulacaoDistribuicaoDataSchema
});
var relatorioDistribuicaoDataSchema = z.object({
  periodo: z.object({
    inicio: z.string(),
    fim: z.string()
  }),
  resumo: z.object({
    totalDistribuicoes: z.number(),
    totalRedistribuicoes: z.number(),
    totalEscalacoes: z.number(),
    totalFallbacks: z.number(),
    taxaRedistribuicao: z.number(),
    taxaEscalacao: z.number()
  }),
  checkin: z.object({
    totalCheckins: z.number(),
    totalCheckouts: z.number(),
    totalExpiracoes: z.number(),
    totalPausas: z.number(),
    totalRenovacoes: z.number()
  }),
  porCorretor: z.array(
    z.object({
      usuarioId: z.number(),
      nome: z.string(),
      leadsRecebidos: z.number(),
      leadsAtendidos: z.number(),
      leadsNaoAtendidos: z.number(),
      taxaAtendimento: z.number(),
      leadsRedistribuidosRecebidos: z.number(),
      checkinsExpirados: z.number()
    })
  ),
  porGrupo: z.array(
    z.object({
      grupoId: z.number(),
      nome: z.string(),
      leadsDistribuidos: z.number()
    })
  ),
  loginAcessos: z.array(
    z.object({
      usuarioId: z.number(),
      nome: z.string(),
      email: z.string(),
      totalLoginsSucesso: z.number(),
      totalLoginsFalha: z.number(),
      ultimoLoginSucessoEm: z.string().nullable(),
      ultimoLoginFalhaEm: z.string().nullable(),
      ultimoLoginSucessoIp: z.string().nullable(),
      ultimoLoginSucessoUserAgent: z.string().nullable(),
      ultimaAtividadeEm: z.string().nullable()
    })
  )
});
var relatorioDistribuicaoResponseSchema = z.object({
  success: z.boolean(),
  data: relatorioDistribuicaoDataSchema
});
var metricasCorretorDataSchema = z.object({
  leadsHoje: z.number(),
  leadsSemana: z.number(),
  leadsMes: z.number(),
  leadsPendentes: z.number(),
  leadsRedistribuidosMes: z.number(),
  posicaoFila: z.array(
    z.object({
      grupoId: z.number(),
      grupoNome: z.string(),
      posicao: z.number().nullable(),
      totalNaFila: z.number(),
      leadsAteVez: z.number().nullable()
    })
  ).nullable(),
  ultimoLeadRecebido: z.object({
    leadId: z.string(),
    recebidoEm: z.string()
  }).nullable()
});
var metricasCorretorResponseSchema = dataResponse(
  metricasCorretorDataSchema
);
var auditoriaItemSchema = z.object({
  id: z.number(),
  acao: z.string(),
  observacoes: z.string().nullable(),
  criadoEm: z.string(),
  usuario: z.object({
    id: z.number(),
    nome: z.string()
  })
});
var auditoriaDataSchema = z.object({
  registros: z.array(auditoriaItemSchema),
  paginacao: distribuicaoPaginacaoSchema
});
var auditoriaResponseSchema = dataResponse(auditoriaDataSchema);

// src/notifications/index.ts
var notifications_exports = {};
__export(notifications_exports, {
  deleteNotificationResponseSchema: () => deleteNotificationResponseSchema,
  markAllReadResponseSchema: () => markAllReadResponseSchema,
  markNotificationReadResponseSchema: () => markNotificationReadResponseSchema,
  notificacaoSchema: () => notificacaoSchema,
  notificacaoTipoEnum: () => notificacaoTipoEnum,
  notificationQuerySchema: () => notificationQuerySchema,
  notificationsListResponseSchema: () => notificationsListResponseSchema,
  unreadCountResponseSchema: () => unreadCountResponseSchema
});
var notificacaoTipoEnum = z.enum([
  "LEAD",
  "MENSAGEM",
  "OPORTUNIDADE",
  "TAREFA",
  "SISTEMA",
  "INTEGRACAO",
  "CUSTOMIZADA"
]);
var notificationQuerySchema = z.object({
  status: z.enum(["lido", "nao-lido"]).optional(),
  tipo: notificacaoTipoEnum.optional(),
  limit: z.coerce.number().min(1).optional(),
  offset: z.coerce.number().min(0).optional()
});
var notificacaoSchema = z.object({
  id: z.string(),
  dashboardId: z.number(),
  usuarioId: z.number().nullable(),
  tipo: z.union([notificacaoTipoEnum, z.literal("GERAL")]),
  titulo: z.string(),
  corpo: z.string().nullish(),
  dados: z.record(z.string(), z.any()).nullish(),
  lida: z.boolean(),
  lidaEm: z.string().nullable().optional(),
  criadaEm: z.string().optional(),
  createdAt: z.string().optional(),
  canaisEnviados: z.preprocess(
    (value) => Array.isArray(value) ? value : [],
    z.array(z.string())
  )
});
var notificationsListResponseSchema = z.object({
  notifications: z.array(notificacaoSchema),
  total: z.number(),
  naoLidas: z.number()
});
var unreadCountResponseSchema = z.object({ count: z.number() });
var markAllReadResponseSchema = z.object({ count: z.number() });
var markNotificationReadResponseSchema = dataResponse(notificacaoSchema);
var deleteNotificationResponseSchema = messageResponseSchema;

// src/campos-customizados/index.ts
var campos_customizados_exports = {};
__export(campos_customizados_exports, {
  campoCustomizadoOptionSchema: () => campoCustomizadoOptionSchema,
  campoCustomizadoResponseSchema: () => campoCustomizadoResponseSchema,
  campoCustomizadoRuleConditionSchema: () => campoCustomizadoRuleConditionSchema,
  campoCustomizadoRulesSchema: () => campoCustomizadoRulesSchema,
  campoCustomizadoSchema: () => campoCustomizadoSchema,
  camposCustomizadosResponseSchema: () => camposCustomizadosResponseSchema,
  createCampoCustomizadoRequestSchema: () => createCampoCustomizadoRequestSchema,
  createCampoCustomizadoResponseSchema: () => createCampoCustomizadoResponseSchema,
  deleteCampoCustomizadoResponseSchema: () => deleteCampoCustomizadoResponseSchema,
  moduloCampoCustomizadoEnum: () => moduloCampoCustomizadoEnum,
  tipoCampoCustomizadoEnum: () => tipoCampoCustomizadoEnum,
  updateCampoCustomizadoRequestSchema: () => updateCampoCustomizadoRequestSchema,
  updateCampoCustomizadoResponseSchema: () => updateCampoCustomizadoResponseSchema
});
var moduloCampoCustomizadoEnum = z.enum([
  "CONTATO",
  "NEGOCIO",
  "PROPOSTA",
  "TAREFA",
  "IMOVEL",
  "EMPREENDIMENTO"
]);
var tipoCampoCustomizadoEnum = z.enum([
  "text",
  "number",
  "email",
  "tel",
  "date",
  "select",
  "textarea",
  "boolean"
]);
var campoCustomizadoOptionSchema = z.object({
  label: z.string(),
  value: z.string()
});
var campoOptionSchema = campoCustomizadoOptionSchema;
var campoCustomizadoRuleConditionSchema = z.object({
  source: z.enum(["funil", "etapa", "campo", "status"]),
  // optional (não usar .default) para alinhar z.input/z.output — UI trata undefined como 'eq'
  op: z.enum(["eq", "neq", "in", "not_in"]).optional(),
  /** Valor escalar ou lista (ops `in` / `not_in`). */
  value: z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.array(z.union([z.string(), z.number(), z.boolean()]))
  ]),
  /** Slug do campo customizado quando `source === 'campo'`. */
  campoValue: z.string().optional()
});
var campoCustomizadoRulesSchema = z.object({
  /** Todas as condições precisam bater (AND) para o campo aparecer. */
  showWhen: z.array(campoCustomizadoRuleConditionSchema).optional(),
  /** Torna o campo obrigatório quando as condições batem (AND). */
  requireWhen: z.array(campoCustomizadoRuleConditionSchema).optional()
}).nullable().optional();
var createCampoCustomizadoRequestSchema = z.object({
  modulo: moduloCampoCustomizadoEnum,
  label: z.string().min(1).max(255),
  value: z.string().max(255).optional(),
  placeholder: z.string().max(255).optional(),
  type: tipoCampoCustomizadoEnum,
  required: z.boolean().optional(),
  order: z.number().min(0).optional(),
  active: z.boolean().optional(),
  options: z.array(campoOptionSchema).optional(),
  /** Vazio = todos os funis (apenas relevante para módulo NEGOCIO). */
  funilIds: z.array(z.number().int().positive()).optional(),
  /** Vazio = todas as etapas. */
  etapaIds: z.array(z.number().int().positive()).optional(),
  rules: campoCustomizadoRulesSchema
});
var updateCampoCustomizadoRequestSchema = z.object({
  label: z.string().max(255).optional(),
  value: z.string().max(255).optional(),
  placeholder: z.string().max(255).optional(),
  type: tipoCampoCustomizadoEnum.optional(),
  required: z.boolean().optional(),
  order: z.number().min(0).optional(),
  active: z.boolean().optional(),
  options: z.array(campoOptionSchema).optional(),
  funilIds: z.array(z.number().int().positive()).optional(),
  etapaIds: z.array(z.number().int().positive()).optional(),
  rules: campoCustomizadoRulesSchema
});
var campoCustomizadoSchema = z.object({
  id: z.number(),
  dashboardId: z.number().nullable(),
  modulo: moduloCampoCustomizadoEnum,
  label: z.string(),
  value: z.string(),
  placeholder: z.string().nullable(),
  type: z.union([tipoCampoCustomizadoEnum, z.string()]),
  required: z.boolean(),
  order: z.number(),
  active: z.boolean(),
  options: z.array(campoOptionSchema).nullable(),
  funilIds: z.array(z.number()).default([]),
  etapaIds: z.array(z.number()).default([]),
  rules: campoCustomizadoRulesSchema.default(null),
  createdAt: z.string(),
  updatedAt: z.string()
});
var camposCustomizadosResponseSchema = listResponse(campoCustomizadoSchema);
var campoCustomizadoResponseSchema = dataResponse(campoCustomizadoSchema);
var createCampoCustomizadoResponseSchema = dataResponse(campoCustomizadoSchema);
var updateCampoCustomizadoResponseSchema = dataResponse(campoCustomizadoSchema);
var deleteCampoCustomizadoResponseSchema = messageResponseSchema;

// src/incorporadoras/index.ts
var incorporadoras_exports = {};
__export(incorporadoras_exports, {
  createIncorporadoraRequestSchema: () => createIncorporadoraRequestSchema,
  createIncorporadoraResponseSchema: () => createIncorporadoraResponseSchema,
  createIncorporadoraSiteSchema: () => createIncorporadoraSiteSchema,
  deleteIncorporadoraResponseSchema: () => deleteIncorporadoraResponseSchema,
  deleteIncorporadoraSiteResponseSchema: () => deleteIncorporadoraSiteResponseSchema,
  incorporadoraDetailSchema: () => incorporadoraDetailSchema,
  incorporadoraEmpreendimentoSchema: () => incorporadoraEmpreendimentoSchema,
  incorporadoraImovelSchema: () => incorporadoraImovelSchema,
  incorporadoraListQuerySchema: () => incorporadoraListQuerySchema,
  incorporadoraPresignedUrlRequestSchema: () => incorporadoraPresignedUrlRequestSchema,
  incorporadoraPresignedUrlResponseSchema: () => incorporadoraPresignedUrlResponseSchema,
  incorporadoraResponseSchema: () => incorporadoraResponseSchema,
  incorporadoraSchema: () => incorporadoraSchema,
  incorporadoraSiteListItemSchema: () => incorporadoraSiteListItemSchema,
  incorporadoraSiteResponseSchema: () => incorporadoraSiteResponseSchema,
  incorporadoraSiteSchema: () => incorporadoraSiteSchema,
  incorporadoraSitesResponseSchema: () => incorporadoraSitesResponseSchema,
  incorporadorasListResponseSchema: () => incorporadorasListResponseSchema,
  updateIncorporadoraRequestSchema: () => updateIncorporadoraRequestSchema,
  updateIncorporadoraResponseSchema: () => updateIncorporadoraResponseSchema,
  updateIncorporadoraSiteSchema: () => updateIncorporadoraSiteSchema
});
var createIncorporadoraRequestSchema = z.object({
  nome: z.string().min(1).max(255),
  logo: z.string().max(500).optional(),
  descricao: z.any().optional()
});
var updateIncorporadoraRequestSchema = z.object({
  nome: z.string().max(255).optional(),
  logo: z.string().max(500).optional(),
  /** `null` explícito limpa a descrição (`IncorporadoraService` → `Prisma.DbNull`). */
  descricao: z.any().nullable().optional()
});
var incorporadoraListQuerySchema = z.object({
  id: z.coerce.number().optional(),
  nome: z.string().optional(),
  search: z.string().optional(),
  siteId: z.coerce.number().optional(),
  page: z.coerce.number().optional(),
  take: z.coerce.number().optional(),
  order: z.string().optional(),
  orderBy: z.string().optional()
});
var incorporadoraSchema = z.object({
  id: z.number(),
  nome: z.string(),
  logo: z.string().nullable().optional(),
  descricao: z.any().nullable().optional(),
  dashboardId: z.number(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var incorporadoraRelacionadoSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string()
}).passthrough();
var incorporadoraImovelSchema = z.object({
  id: z.number(),
  codigo: z.string(),
  titulo: z.string(),
  /** Relações Prisma `{ value, label }` (id extra é ignorado pelo Zod). */
  tipo: valueLabelSchema,
  uso: valueLabelSchema,
  subTipo: valueLabelSchema.nullable(),
  empreendimentoId: z.number().nullable()
});
var incorporadoraEmpreendimentoSchema = z.object({
  id: z.number(),
  nome: z.string(),
  fase: incorporadoraRelacionadoSchema.nullable().optional(),
  tipo: incorporadoraRelacionadoSchema.nullable().optional()
});
var incorporadoraSiteListItemSchema = z.object({
  id: z.number(),
  siteId: z.number(),
  metaTitle: z.string(),
  metaDescription: z.string(),
  slug: z.string(),
  keyword: z.string().nullable().optional()
});
var incorporadoraDetailSchema = incorporadoraSchema.extend({
  imoveis: z.array(incorporadoraImovelSchema).optional(),
  empreendimentos: z.array(incorporadoraEmpreendimentoSchema).optional(),
  sites: z.array(incorporadoraSiteListItemSchema).optional()
});
var incorporadorasListResponseSchema = listResponse(incorporadoraSchema);
var incorporadoraResponseSchema = dataResponse(incorporadoraSchema);
var createIncorporadoraResponseSchema = dataResponse(incorporadoraSchema);
var updateIncorporadoraResponseSchema = dataResponse(incorporadoraSchema);
var deleteIncorporadoraResponseSchema = messageResponseSchema;
var incorporadoraSiteSchema = z.object({
  id: z.number(),
  incorporadoraId: z.number(),
  siteId: z.number(),
  metaTitle: z.string(),
  metaDescription: z.string(),
  slug: z.string(),
  keyword: z.string().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
  site: z.object({
    dominioProprio: z.string().nullable().optional(),
    dominioDev: z.string().optional()
  }).optional()
});
var incorporadoraSitesResponseSchema = listResponse(incorporadoraSiteSchema);
var incorporadoraSiteResponseSchema = dataResponse(incorporadoraSiteSchema);
var deleteIncorporadoraSiteResponseSchema = messageResponseSchema;
var createIncorporadoraSiteSchema = z.object({ siteId: z.number().optional() });
var updateIncorporadoraSiteSchema = z.object({
  metaTitle: z.string().max(255).optional(),
  metaDescription: z.string().max(500).optional(),
  slug: z.string().max(255).optional(),
  keyword: z.string().max(500).optional()
});
var incorporadoraPresignedUrlRequestSchema = presignedUrlRequestSchema.refine(
  (d) => d.tipoConteudo === "incorporadora" && d.folder === "logo",
  { message: "tipoConteudo deve ser incorporadora e folder logo" }
);
var incorporadoraPresignedUrlResponseSchema = presignedUrlResponseSchema;

// src/perfis-interesse/index.ts
var perfis_interesse_exports = {};
__export(perfis_interesse_exports, {
  bairroSchema: () => bairroSchema,
  createPerfilImovelRequestSchema: () => createPerfilImovelRequestSchema,
  deletePerfilInteresseResponseSchema: () => deletePerfilInteresseResponseSchema,
  enviarMatchWhatsappResponseSchema: () => enviarMatchWhatsappResponseSchema,
  filterImoveisComMatchesQuerySchema: () => filterImoveisComMatchesQuerySchema,
  filterPerfilImovelQuerySchema: () => filterPerfilImovelQuerySchema,
  imoveisComMatchesApiResponseSchema: () => imoveisComMatchesApiResponseSchema,
  imoveisComMatchesPaginationSchema: () => imoveisComMatchesPaginationSchema,
  imoveisComMatchesResponseSchema: () => imoveisComMatchesResponseSchema,
  imovelComMatchesSchema: () => imovelComMatchesSchema,
  matchContatoSchema: () => matchContatoSchema,
  matchDetailResponseSchema: () => matchDetailResponseSchema,
  matchImovelSchema: () => matchImovelSchema,
  matchItemSchema: () => matchItemSchema,
  matchPerfilSchema: () => matchPerfilSchema,
  matchResponseSchema: () => matchResponseSchema,
  matchesListResponseSchema: () => matchesListResponseSchema,
  perfilImovelOrigemSchema: () => perfilImovelOrigemSchema,
  perfilInteresseResponseSchema: () => perfilInteresseResponseSchema,
  perfilInteresseSchema: () => perfilInteresseSchema,
  perfisInteressePaginationSchema: () => perfisInteressePaginationSchema,
  perfisInteresseResponseSchema: () => perfisInteresseResponseSchema,
  updateInteresseRequestSchema: () => updateInteresseRequestSchema2,
  updatePerfilImovelRequestSchema: () => updatePerfilImovelRequestSchema
});
var bairroSchema = z.object({
  bairro: z.string(),
  cidade: z.string().optional()
});
var perfilImovelBaseSchema = z.object({
  cidades: z.array(z.string()).optional(),
  cidadesSlugs: z.array(z.string()).optional(),
  bairros: z.array(bairroSchema).optional(),
  tipos: z.array(z.coerce.number()).optional(),
  subtipos: z.array(z.coerce.number()).optional(),
  precoMinimo: z.coerce.number().min(0).optional(),
  precoMaximo: z.coerce.number().min(0).optional(),
  areaMinima: z.coerce.number().min(0).optional(),
  areaMaxima: z.coerce.number().min(0).optional(),
  quartosMinimo: z.coerce.number().min(0).optional(),
  quartosMaximo: z.coerce.number().min(0).optional(),
  vagasMinimo: z.coerce.number().min(0).optional(),
  banheirosMinimo: z.coerce.number().min(0).optional(),
  valorLocacaoMinimo: z.coerce.number().min(0).optional(),
  valorLocacaoMaximo: z.coerce.number().min(0).optional(),
  suitesMinimo: z.coerce.number().min(0).optional(),
  suitesMaximo: z.coerce.number().min(0).optional(),
  areaPrivativaMinima: z.coerce.number().min(0).optional(),
  areaPrivativaMaxima: z.coerce.number().min(0).optional(),
  usoId: z.coerce.number().optional(),
  condicaoValue: z.string().optional(),
  mobiliadoValue: z.string().optional(),
  padraoClasseValue: z.string().optional(),
  aceitaPet: z.boolean().optional(),
  financiavel: z.boolean().optional(),
  finalidades: z.array(z.string()).optional(),
  comodidades: z.array(z.string()).optional(),
  empreendimentos: z.array(z.coerce.number()).optional(),
  ativo: z.boolean().optional()
});
var createPerfilImovelRequestSchema = perfilImovelBaseSchema;
var updatePerfilImovelRequestSchema = perfilImovelBaseSchema;
var filterPerfilImovelQuerySchema = z.object({
  page: z.coerce.number().min(1).optional(),
  itemsPerPage: z.coerce.number().min(1).max(100).optional()
});
var updateInteresseRequestSchema2 = z.object({
  interessado: z.boolean().nullish()
});
var filterImoveisComMatchesQuerySchema = z.object({
  // backend accepted true/false/null (no transform); coerced loosely here
  interessado: z.union([z.boolean(), z.literal("true"), z.literal("false"), z.null()]).transform((v) => v === "true" ? true : v === "false" ? false : v).optional(),
  scoreMinimo: z.coerce.number().min(0).max(100).optional(),
  page: z.coerce.number().min(1).optional(),
  itemsPerPage: z.coerce.number().min(1).max(100).optional()
});
var perfilImovelOrigemSchema = z.enum(["MANUAL", "AUTOMATICO"]);
var perfilInteresseSchema = z.object({
  id: z.number(),
  dashboardId: z.number(),
  contatoId: z.number(),
  ativo: z.boolean(),
  origem: perfilImovelOrigemSchema.optional().default("MANUAL"),
  inferidoEm: z.string().nullable().optional(),
  resumoPreferencias: z.string().nullable().optional(),
  usoId: z.number().nullable().optional(),
  uso: valueLabelSchema.nullable().optional(),
  precoMinimo: z.number().nullable().optional(),
  precoMaximo: z.number().nullable().optional(),
  valorLocacaoMinimo: z.number().nullable().optional(),
  valorLocacaoMaximo: z.number().nullable().optional(),
  areaMinima: z.number().nullable().optional(),
  areaMaxima: z.number().nullable().optional(),
  areaPrivativaMinima: z.number().nullable().optional(),
  areaPrivativaMaxima: z.number().nullable().optional(),
  quartosMinimo: z.number().nullable().optional(),
  quartosMaximo: z.number().nullable().optional(),
  suitesMinimo: z.number().nullable().optional(),
  suitesMaximo: z.number().nullable().optional(),
  vagasMinimo: z.number().nullable().optional(),
  banheirosMinimo: z.number().nullable().optional(),
  condicaoValue: z.string().nullable().optional(),
  condicao: valueLabelSchema.nullable().optional(),
  mobiliadoValue: z.string().nullable().optional(),
  mobiliado: valueLabelSchema.nullable().optional(),
  padraoClasseValue: z.string().nullable().optional(),
  padrao: valueLabelSchema.nullable().optional(),
  aceitaPet: z.boolean().nullable().optional(),
  financiavel: z.boolean().nullable().optional(),
  cidades: z.array(z.object({ id: z.number().optional(), cidade: z.string() })).optional(),
  bairros: z.array(
    z.object({
      id: z.number().optional(),
      bairro: z.string(),
      cidade: z.string().nullable().optional()
    })
  ).optional(),
  tipos: z.array(
    z.object({
      id: z.number().optional(),
      tipoId: z.number(),
      tipo: valueLabelSchema.optional()
    })
  ).optional(),
  subtipos: z.array(
    z.object({
      id: z.number().optional(),
      subTipoId: z.number(),
      subTipo: valueLabelSchema.optional()
    })
  ).optional(),
  finalidades: z.array(
    z.object({
      id: z.number().optional(),
      finalidadeValue: z.string(),
      finalidade: valueLabelSchema.optional()
    })
  ).optional(),
  comodidades: z.array(
    z.object({
      id: z.number().optional(),
      comodidadeValue: z.string(),
      comodidade: z.object({
        value: z.string(),
        label: z.string(),
        categoria: z.string().nullable().optional()
      }).optional()
    })
  ).optional(),
  empreendimentos: z.array(
    z.object({
      id: z.number().optional(),
      empreendimentoId: z.number(),
      empreendimento: z.object({ id: z.number(), nome: z.string() }).optional()
    })
  ).optional(),
  _count: z.object({ matches: z.number() }).optional(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var perfisInteressePaginationSchema = z.object({
  page: z.number(),
  itemsPerPage: z.number(),
  total: z.number(),
  totalPages: z.number()
});
var perfisInteresseResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(perfilInteresseSchema),
  pagination: perfisInteressePaginationSchema,
  message: z.string().optional()
});
var perfilInteresseResponseSchema = dataResponse(perfilInteresseSchema);
var deletePerfilInteresseResponseSchema = messageResponseSchema;
var matchContatoSchema = z.object({
  id: z.number(),
  nome: z.string(),
  sobrenome: z.string().nullable().optional()
});
var matchPerfilSchema = z.object({ id: z.number() });
var matchItemSchema = z.object({
  matchId: z.number(),
  contato: matchContatoSchema,
  perfil: matchPerfilSchema,
  perfilOrigem: perfilImovelOrigemSchema.optional().default("MANUAL"),
  scoreRelevancia: z.number().nullable(),
  interessado: z.boolean().nullable(),
  visualizado: z.boolean(),
  visualizadoAt: z.string().nullable().optional(),
  createdAt: z.string()
});
var matchImovelSchema = z.object({
  id: z.number(),
  titulo: z.string().nullable().optional(),
  codigo: z.string().nullable().optional(),
  status: z.string().nullable().optional(),
  localizacao: z.object({
    cidade: z.string().nullable().optional(),
    bairro: z.string().nullable().optional(),
    uf: z.string().nullable().optional(),
    rua: z.string().nullable().optional(),
    numero: z.string().nullable().optional()
  }).nullable().optional(),
  tipo: valueLabelSchema.nullable().optional(),
  subTipo: valueLabelSchema.nullable().optional(),
  valoresVenda: z.object({ valor: z.number().nullable().optional() }).nullable().optional(),
  valoresLocacao: z.object({ valor: z.number().nullable().optional() }).nullable().optional(),
  areasConstrucao: z.object({
    areaTotal: z.number().nullable().optional(),
    areaPrivativa: z.number().nullable().optional()
  }).nullable().optional(),
  caracteristicas: z.object({
    dormitorios: z.number().nullable().optional(),
    suites: z.number().nullable().optional(),
    vagasGaragem: z.number().nullable().optional(),
    banheiros: z.number().nullable().optional()
  }).nullable().optional(),
  fotos: z.array(z.object({ url: z.string(), ordem: z.number().optional() })).optional()
});
var imovelComMatchesSchema = z.object({
  imovel: matchImovelSchema,
  matches: z.array(matchItemSchema),
  totalMatches: z.number(),
  matchesInteressados: z.number(),
  matchesNaoInteressados: z.number(),
  matchesPendentes: z.number()
});
var imoveisComMatchesPaginationSchema = perfisInteressePaginationSchema;
var imoveisComMatchesResponseSchema = z.object({
  data: z.array(imovelComMatchesSchema),
  pagination: imoveisComMatchesPaginationSchema
});
var imoveisComMatchesApiResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(imovelComMatchesSchema),
  pagination: imoveisComMatchesPaginationSchema,
  message: z.string().optional()
});
var matchResponseSchema = z.object({
  id: z.number(),
  perfilId: z.number(),
  imovelId: z.number(),
  scoreRelevancia: z.number().nullable(),
  interessado: z.boolean().nullable(),
  visualizado: z.boolean(),
  visualizadoAt: z.string().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var matchDetailResponseSchema = dataResponse(matchResponseSchema);
var matchesListResponseSchema = listResponse(matchItemSchema);
var enviarMatchWhatsappResponseSchema = z.object({
  success: z.boolean(),
  data: z.object({
    messageId: z.string(),
    conversationId: z.string()
  }),
  message: z.string().optional()
});

// src/campanhas/index.ts
var campanhas_exports = {};
__export(campanhas_exports, {
  campanhaCanalEnum: () => campanhaCanalEnum,
  campanhaContatoItemSchema: () => campanhaContatoItemSchema,
  campanhaContatoStatusEnum: () => campanhaContatoStatusEnum,
  campanhaDetailResponseSchema: () => campanhaDetailResponseSchema,
  campanhaHistoricoResponseSchema: () => campanhaHistoricoResponseSchema,
  campanhaModoEnum: () => campanhaModoEnum,
  campanhaRodadaSchema: () => campanhaRodadaSchema,
  campanhaRodadasResponseSchema: () => campanhaRodadasResponseSchema,
  campanhaSchema: () => campanhaSchema,
  campanhaStatusEnum: () => campanhaStatusEnum,
  campanhasResponseSchema: () => campanhasResponseSchema,
  createCampanhaRequestSchema: () => createCampanhaRequestSchema,
  createCampanhaResponseSchema: () => createCampanhaResponseSchema,
  deleteCampanhaResponseSchema: () => deleteCampanhaResponseSchema,
  listCampanhaContatosQuerySchema: () => listCampanhaContatosQuerySchema,
  listCampanhasQuerySchema: () => listCampanhasQuerySchema,
  recorrenciaSchema: () => recorrenciaSchema,
  recorrenciaTipoEnum: () => recorrenciaTipoEnum,
  reprocessarFalhasResponseSchema: () => reprocessarFalhasResponseSchema,
  updateCampanhaRequestSchema: () => updateCampanhaRequestSchema,
  updateCampanhaResponseSchema: () => updateCampanhaResponseSchema
});
var campanhaCanalEnum = z.enum(["EMAIL", "WHATSAPP", "AMBOS"]);
var campanhaModoEnum = z.enum([
  "PONTUAL",
  "GATILHO",
  "HIBRIDO",
  "RECORRENTE"
]);
var campanhaStatusEnum = z.enum([
  "RASCUNHO",
  "AGENDADA",
  "ATIVA",
  "PAUSADA",
  "CONCLUIDA",
  "CANCELADA"
]);
var campanhaContatoStatusEnum = z.enum([
  "FILA",
  "ENVIANDO",
  "ENVIADO",
  "FALHOU",
  "CANCELADO"
]);
var recorrenciaTipoEnum = z.enum(["DIARIO", "SEMANAL", "MENSAL"]);
var recorrenciaSchema = z.object({
  tipo: recorrenciaTipoEnum,
  hora: z.string().min(1),
  diasSemana: z.array(z.number()).optional(),
  diaMes: z.number().min(1).optional()
});
var createCampanhaRequestSchema = z.object({
  label: z.string().min(1),
  canal: campanhaCanalEnum,
  modo: campanhaModoEnum,
  segmentoId: z.number().int(),
  emailTemplateId: z.string().optional(),
  whatsappTemplateId: z.string().optional(),
  whatsappInstanceId: z.number().int().optional(),
  agendadoPara: z.string().optional(),
  dataFim: z.string().optional(),
  recorrencia: recorrenciaSchema.optional()
});
var updateCampanhaRequestSchema = z.object({
  label: z.string().min(1).optional(),
  canal: campanhaCanalEnum.optional(),
  status: campanhaStatusEnum.optional(),
  segmentoId: z.number().int().optional(),
  emailTemplateId: z.string().optional(),
  whatsappTemplateId: z.string().optional(),
  whatsappInstanceId: z.number().int().optional(),
  agendadoPara: z.string().optional(),
  dataFim: z.string().optional(),
  recorrencia: recorrenciaSchema.optional()
});
var listCampanhasQuerySchema = z.object({
  page: z.coerce.number().min(1).optional().default(1),
  limit: z.coerce.number().min(1).optional().default(20),
  status: campanhaStatusEnum.optional(),
  canal: campanhaCanalEnum.optional(),
  modo: campanhaModoEnum.optional(),
  search: z.string().optional()
});
var listCampanhaContatosQuerySchema = z.object({
  page: z.coerce.number().min(1).optional().default(1),
  limit: z.coerce.number().min(1).optional().default(50),
  status: campanhaContatoStatusEnum.optional(),
  canal: campanhaCanalEnum.optional(),
  rodadaId: z.string().optional(),
  search: z.string().optional()
});
var campanhaSchema = z.object({
  id: z.number(),
  label: z.string(),
  canal: campanhaCanalEnum,
  modo: campanhaModoEnum,
  status: campanhaStatusEnum,
  segmentoId: z.number(),
  segmento: z.object({ id: z.number(), label: z.string(), value: z.string() }).optional(),
  emailTemplateId: z.string().nullable().optional(),
  emailTemplate: z.object({ id: z.string(), nome: z.string() }).nullable().optional(),
  whatsappTemplateId: z.string().nullable().optional(),
  whatsappTemplate: z.object({ id: z.string(), nome: z.string() }).nullable().optional(),
  whatsappInstanceId: z.number().nullable().optional(),
  whatsappInstance: z.object({
    id: z.number(),
    nome: z.string().nullable(),
    number: z.string().nullable()
  }).nullable().optional(),
  agendadoPara: z.string().nullable(),
  dataFim: z.string().nullable(),
  recorrencia: recorrenciaSchema.nullable(),
  ultimoDisparo: z.string().nullable(),
  totalContatos: z.number(),
  contatosEnviados: z.number().catch(0),
  contatosFalhados: z.number().catch(0),
  contatosFila: z.number().catch(0),
  contatosCancelados: z.number().catch(0),
  contatosEnviando: z.number().catch(0),
  criadoPorId: z.number().nullable().optional(),
  dashboardId: z.number().optional(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var campanhasResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(campanhaSchema),
  message: z.string().optional(),
  meta: z.object({
    total: z.number(),
    page: z.number(),
    limit: z.number(),
    totalPages: z.number().optional(),
    hasNext: z.boolean().optional(),
    hasPrev: z.boolean().optional()
  })
});
var campanhaDetailResponseSchema = dataResponse(campanhaSchema);
var createCampanhaResponseSchema = dataResponse(campanhaSchema);
var updateCampanhaResponseSchema = dataResponse(campanhaSchema);
var deleteCampanhaResponseSchema = messageResponseSchema;
var campanhaContatoItemSchema = z.object({
  id: z.number(),
  canal: campanhaCanalEnum,
  status: campanhaContatoStatusEnum,
  rodadaId: z.string().nullable(),
  tentativas: z.number(),
  enviadoEm: z.string().nullable(),
  falhaMotivo: z.string().nullable(),
  adicionadoEm: z.string(),
  contato: z.object({
    id: z.number(),
    nome: z.string(),
    email: z.string().nullable(),
    telefone: z.string().nullable(),
    foto: z.string().nullable()
  })
});
var campanhaHistoricoResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(campanhaContatoItemSchema),
  message: z.string().optional(),
  meta: z.object({
    total: z.number(),
    page: z.number(),
    limit: z.number(),
    totalPages: z.number().optional(),
    hasNext: z.boolean().optional(),
    hasPrev: z.boolean().optional()
  }).optional()
});
var campanhaRodadaSchema = z.object({
  rodadaId: z.string(),
  total: z.number(),
  enviados: z.number(),
  falhados: z.number(),
  fila: z.number(),
  cancelados: z.number()
});
var campanhaRodadasResponseSchema = listResponse(campanhaRodadaSchema);
var reprocessarFalhasResponseSchema = dataResponse(
  z.object({ reprocessados: z.number() })
);

// src/imoveis-campanhas/index.ts
var imoveis_campanhas_exports = {};
__export(imoveis_campanhas_exports, {
  campanhaMetaSchema: () => campanhaMetaSchema,
  createCampanhaRequestSchema: () => createCampanhaRequestSchema2,
  createImovelCampanhaResponseSchema: () => createImovelCampanhaResponseSchema,
  deleteImovelCampanhaResponseSchema: () => deleteImovelCampanhaResponseSchema,
  imoveisCampanhasDataResponseSchema: () => imoveisCampanhasDataResponseSchema,
  imoveisCampanhasListResponseSchema: () => imoveisCampanhasListResponseSchema,
  imovelCampanhaRefSchema: () => imovelCampanhaRefSchema,
  imovelCampanhaResponseSchema: () => imovelCampanhaResponseSchema,
  imovelCampanhaSchema: () => imovelCampanhaSchema,
  queryCampanhaSchema: () => queryCampanhaSchema,
  updateCampanhaRequestSchema: () => updateCampanhaRequestSchema2,
  updateImovelCampanhaResponseSchema: () => updateImovelCampanhaResponseSchema
});
var slugSchema = z.preprocess(
  (v) => typeof v === "string" ? v.toLowerCase().trim() : v,
  z.string().min(1, "Slug \xE9 obrigat\xF3rio").max(100, "Slug deve ter no m\xE1ximo 100 caracteres").regex(
    /^[a-z0-9-]+$/,
    "Slug deve conter apenas letras min\xFAsculas, n\xFAmeros e h\xEDfens"
  )
);
var trimmedNome = z.preprocess(
  (v) => typeof v === "string" ? v.trim() : v,
  z.string().min(1, "Nome \xE9 obrigat\xF3rio").max(255)
);
var createCampanhaRequestSchema2 = z.object({
  slug: slugSchema,
  nome: trimmedNome,
  descricao: z.any().optional(),
  metaTitle: z.string().min(1, "Meta title \xE9 obrigat\xF3rio"),
  metaDescription: z.string().optional()
});
var updateCampanhaRequestSchema2 = z.object({
  slug: slugSchema.optional(),
  nome: trimmedNome.optional(),
  descricao: z.any().optional(),
  // legacy transform: trimmed value or null
  metaTitle: z.string().max(60, "Meta title deve ter no m\xE1ximo 60 caracteres").transform((v) => v?.trim() || null).optional(),
  metaDescription: z.string().max(160, "Meta description deve ter no m\xE1ximo 160 caracteres").transform((v) => v?.trim() || null).optional()
});
var queryCampanhaSchema = z.object({
  page: z.coerce.number().optional().default(1),
  itemsPerPage: z.coerce.number().optional().default(16),
  nome: z.string().optional(),
  slug: z.string().optional(),
  search: z.string().optional(),
  order: z.enum(["id", "nome", "slug", "createdAt", "updatedAt"]).optional(),
  orderBy: z.enum(["asc", "desc"]).optional()
});
var imovelCampanhaSchema = z.object({
  id: z.number(),
  dashboardId: z.number(),
  nome: z.string(),
  slug: z.string(),
  descricao: z.any().nullable().optional(),
  metaTitle: z.string(),
  metaDescription: z.string().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
  totalImoveis: z.number().optional()
});
var imovelCampanhaRefSchema = z.object({
  id: z.number(),
  nome: z.string(),
  slug: z.string()
});
var campanhaMetaSchema = z.object({
  total: z.number(),
  page: z.number(),
  limit: z.number(),
  hasNext: z.boolean(),
  hasPrev: z.boolean(),
  timestamp: z.string()
});
var imoveisCampanhasListResponseSchema = listResponse(
  imovelCampanhaSchema
).extend({ meta: campanhaMetaSchema });
var imovelCampanhaResponseSchema = dataResponse(imovelCampanhaSchema);
var createImovelCampanhaResponseSchema = dataResponse(imovelCampanhaSchema);
var updateImovelCampanhaResponseSchema = dataResponse(imovelCampanhaSchema);
var deleteImovelCampanhaResponseSchema = messageResponseSchema;
var imoveisCampanhasDataResponseSchema = dataResponse(
  z.array(imovelCampanhaRefSchema)
);

// src/relatorios/index.ts
var relatorios_exports = {};
__export(relatorios_exports, {
  bairroInteresseSchema: () => bairroInteresseSchema,
  bairroMaisProcuradoSchema: () => bairroMaisProcuradoSchema,
  cidadeInteresseSchema: () => cidadeInteresseSchema,
  cidadeMaisProcuradaSchema: () => cidadeMaisProcuradaSchema,
  empreendimentoMaisInteresseSchema: () => empreendimentoMaisInteresseSchema,
  filtroRelatorioImovelSchema: () => filtroRelatorioImovelSchema,
  filtroRelatorioLeadSchema: () => filtroRelatorioLeadSchema,
  filtroRelatorioOportunidadeSchema: () => filtroRelatorioOportunidadeSchema,
  imoveisComMidiaResponseSchema: () => imoveisComMidiaResponseSchema,
  imoveisComMidiaSchema: () => imoveisComMidiaSchema,
  imoveisPorBairroResponseSchema: () => imoveisPorBairroResponseSchema,
  imoveisPorCidadeResponseSchema: () => imoveisPorCidadeResponseSchema,
  imoveisPorEntidadeResponseSchema: () => imoveisPorEntidadeResponseSchema,
  imoveisPorFaixaValorLocacaoResponseSchema: () => imoveisPorFaixaValorLocacaoResponseSchema,
  imoveisPorFaixaValorResponseSchema: () => imoveisPorFaixaValorResponseSchema,
  imoveisPorFaixaValorVendaResponseSchema: () => imoveisPorFaixaValorVendaResponseSchema,
  imoveisPorFinalidadeResponseSchema: () => imoveisPorFinalidadeResponseSchema,
  imoveisPorLeadsInteressadosResponseSchema: () => imoveisPorLeadsInteressadosResponseSchema,
  imoveisPorPeriodoResponseSchema: () => imoveisPorPeriodoResponseSchema,
  imoveisPorPortalResponseSchema: () => imoveisPorPortalResponseSchema,
  imoveisPorPropostasResponseSchema: () => imoveisPorPropostasResponseSchema,
  imoveisPorResponsavelResponseSchema: () => imoveisPorResponsavelResponseSchema,
  imoveisPorSiteResponseSchema: () => imoveisPorSiteResponseSchema,
  imoveisPorStatusRelatorioResponseSchema: () => imoveisPorStatusRelatorioResponseSchema,
  imoveisPorTipoResponseSchema: () => imoveisPorTipoResponseSchema,
  imoveisPorUsoResponseSchema: () => imoveisPorUsoResponseSchema,
  imovelFinalidadeRelatorioEnum: () => imovelFinalidadeRelatorioEnum,
  imovelMaisInteresseSchema: () => imovelMaisInteresseSchema,
  imovelMaisProcuradoSchema: () => imovelMaisProcuradoSchema,
  imovelPorBairroSchema: () => imovelPorBairroSchema,
  imovelPorCidadeSchema: () => imovelPorCidadeSchema,
  imovelPorEntidadeSchema: () => imovelPorEntidadeSchema,
  imovelPorFaixaValorLocacaoSchema: () => imovelPorFaixaValorLocacaoSchema,
  imovelPorFaixaValorSchema: () => imovelPorFaixaValorSchema,
  imovelPorFaixaValorVendaSchema: () => imovelPorFaixaValorVendaSchema,
  imovelPorFinalidadeSchema: () => imovelPorFinalidadeSchema,
  imovelPorLeadsInteressadosSchema: () => imovelPorLeadsInteressadosSchema,
  imovelPorPeriodoSchema: () => imovelPorPeriodoSchema,
  imovelPorPortalSchema: () => imovelPorPortalSchema,
  imovelPorPropostasSchema: () => imovelPorPropostasSchema,
  imovelPorResponsavelSchema: () => imovelPorResponsavelSchema,
  imovelPorSiteSchema: () => imovelPorSiteSchema,
  imovelPorStatusItemSchema: () => imovelPorStatusItemSchema,
  imovelPorStatusRelatorioSchema: () => imovelPorStatusRelatorioSchema,
  imovelPorStatusSchema: () => imovelPorStatusSchema,
  imovelPorTipoSchema: () => imovelPorTipoSchema,
  imovelPorUsoSchema: () => imovelPorUsoSchema,
  imovelStatusEnum: () => imovelStatusEnum,
  leadDuplicadoGrupoLeadSchema: () => leadDuplicadoGrupoLeadSchema,
  leadDuplicadoGrupoSchema: () => leadDuplicadoGrupoSchema,
  leadDuplicadoSchema: () => leadDuplicadoSchema,
  leadPorFinalidadePeriodoSchema: () => leadPorFinalidadePeriodoSchema,
  leadPorFinalidadePorPeriodoSchema: () => leadPorFinalidadePorPeriodoSchema,
  leadPorFinalidadeSchema: () => leadPorFinalidadeSchema,
  leadPorMotivoPerdaSchema: () => leadPorMotivoPerdaSchema,
  leadPorOrigemSchema: () => leadPorOrigemSchema,
  leadPorPeriodoSchema: () => leadPorPeriodoSchema,
  leadPorResponsavelSchema: () => leadPorResponsavelSchema,
  leadPorStatusResponsavelSchema: () => leadPorStatusResponsavelSchema,
  leadPorStatusSchema: () => leadPorStatusSchema,
  leadPorUtmSchema: () => leadPorUtmSchema,
  leadsDuplicadosAgregadoSchema: () => leadsDuplicadosAgregadoSchema,
  oportunidadeEstagnadaSchema: () => oportunidadeEstagnadaSchema,
  oportunidadePorEtapaRelatorioSchema: () => oportunidadePorEtapaRelatorioSchema,
  oportunidadePorEtapaSchema: () => oportunidadePorEtapaSchema,
  oportunidadePorFunilSchema: () => oportunidadePorFunilSchema,
  oportunidadePorMotivoPerdaSchema: () => oportunidadePorMotivoPerdaSchema,
  oportunidadePorPeriodoSchema: () => oportunidadePorPeriodoSchema,
  oportunidadePorResponsavelRelatorioSchema: () => oportunidadePorResponsavelRelatorioSchema,
  oportunidadePorStatusRelatorioSchema: () => oportunidadePorStatusRelatorioSchema,
  oportunidadeStatusRelatorioEnum: () => oportunidadeStatusRelatorioEnum,
  oportunidadesEstagnadasResponseSchema: () => oportunidadesEstagnadasResponseSchema,
  oportunidadesPorFunilResponseSchema: () => oportunidadesPorFunilResponseSchema,
  oportunidadesPorMotivoPerdaResponseSchema: () => oportunidadesPorMotivoPerdaResponseSchema,
  oportunidadesPorPeriodoResponseSchema: () => oportunidadesPorPeriodoResponseSchema,
  origemEficazResponseSchema: () => origemEficazResponseSchema,
  origemEficazSchema: () => origemEficazSchema,
  propostasPorOportunidadeResponseSchema: () => propostasPorOportunidadeResponseSchema,
  propostasPorOportunidadeSchema: () => propostasPorOportunidadeSchema,
  relatorioChartItemSchema: () => relatorioChartItemSchema,
  relatorioChartResponseSchema: () => relatorioChartResponseSchema,
  relatorioImoveisPorStatusResponseSchema: () => relatorioImoveisPorStatusResponseSchema,
  relatorioLeadsBairrosMaisProcuradosResponseSchema: () => relatorioLeadsBairrosMaisProcuradosResponseSchema,
  relatorioLeadsCidadesMaisProcuradasResponseSchema: () => relatorioLeadsCidadesMaisProcuradasResponseSchema,
  relatorioLeadsDuplicadosResponseSchema: () => relatorioLeadsDuplicadosResponseSchema,
  relatorioLeadsImoveisMaisProcuradosResponseSchema: () => relatorioLeadsImoveisMaisProcuradosResponseSchema,
  relatorioLeadsPorFinalidadePeriodoResponseSchema: () => relatorioLeadsPorFinalidadePeriodoResponseSchema,
  relatorioLeadsPorFinalidadeResponseSchema: () => relatorioLeadsPorFinalidadeResponseSchema,
  relatorioLeadsPorMotivoPerdaResponseSchema: () => relatorioLeadsPorMotivoPerdaResponseSchema,
  relatorioLeadsPorOrigemResponseSchema: () => relatorioLeadsPorOrigemResponseSchema,
  relatorioLeadsPorPeriodoResponseSchema: () => relatorioLeadsPorPeriodoResponseSchema,
  relatorioLeadsPorResponsavelResponseSchema: () => relatorioLeadsPorResponsavelResponseSchema,
  relatorioLeadsPorStatusResponseSchema: () => relatorioLeadsPorStatusResponseSchema,
  relatorioLeadsPorUtmResponseSchema: () => relatorioLeadsPorUtmResponseSchema,
  relatorioLeadsResumoGeralResponseSchema: () => relatorioLeadsResumoGeralResponseSchema,
  relatorioLeadsResumoGeralSchema: () => relatorioLeadsResumoGeralSchema,
  relatorioLeadsTaxaConversaoDetalhadaResponseSchema: () => relatorioLeadsTaxaConversaoDetalhadaResponseSchema,
  relatorioLeadsTaxaConversaoResponseSchema: () => relatorioLeadsTaxaConversaoResponseSchema,
  relatorioLeadsTempoMedioAtendimentoAgregadoResponseSchema: () => relatorioLeadsTempoMedioAtendimentoAgregadoResponseSchema,
  relatorioLeadsTempoMedioAtendimentoResponseSchema: () => relatorioLeadsTempoMedioAtendimentoResponseSchema,
  relatorioOportunidadesPorEtapaResponseSchema: () => relatorioOportunidadesPorEtapaResponseSchema,
  relatorioSerieTemporalItemSchema: () => relatorioSerieTemporalItemSchema,
  relatorioSerieTemporalResponseSchema: () => relatorioSerieTemporalResponseSchema,
  resumoGeralImoveisResponseSchema: () => resumoGeralImoveisResponseSchema,
  resumoGeralImoveisSchema: () => resumoGeralImoveisSchema,
  taxaAvancoEtapasResponseSchema: () => taxaAvancoEtapasResponseSchema,
  taxaAvancoEtapasSchema: () => taxaAvancoEtapasSchema,
  taxaConversaoLeadsDetalhadaSchema: () => taxaConversaoLeadsDetalhadaSchema,
  taxaConversaoLeadsSchema: () => taxaConversaoLeadsSchema,
  taxaConversaoOportunidadeSchema: () => taxaConversaoOportunidadeSchema,
  tempoMedioAtendimentoAgregadoSchema: () => tempoMedioAtendimentoAgregadoSchema,
  tempoMedioAtendimentoPorResponsavelItemSchema: () => tempoMedioAtendimentoPorResponsavelItemSchema,
  tempoMedioAtendimentoSchema: () => tempoMedioAtendimentoSchema,
  tempoMedioEtapaResponseSchema: () => tempoMedioEtapaResponseSchema,
  tempoMedioEtapaSchema: () => tempoMedioEtapaSchema,
  tempoMedioFunilResponseSchema: () => tempoMedioFunilResponseSchema,
  tempoMedioFunilSchema: () => tempoMedioFunilSchema,
  tempoMedioPublicacaoResponseSchema: () => tempoMedioPublicacaoResponseSchema,
  tempoMedioPublicacaoSchema: () => tempoMedioPublicacaoSchema,
  tipoAgrupamentoEnum: () => tipoAgrupamentoEnum,
  tipoComparacaoEnum: () => tipoComparacaoEnum,
  valorPorPeriodoResponseSchema: () => valorPorPeriodoResponseSchema,
  valorPorPeriodoSchema: () => valorPorPeriodoSchema,
  valorTotalFunilResponseSchema: () => valorTotalFunilResponseSchema,
  valorTotalFunilSchema: () => valorTotalFunilSchema
});
var imovelFinalidadeRelatorioEnum = z.enum([
  "Venda",
  "Locacao",
  "Temporada"
]);
var resumoGeralImoveisSchema = z.object({
  totalImoveis: z.number(),
  imoveisPublicados: z.number(),
  imoveisRascunho: z.number(),
  imoveisPendentes: z.number().optional(),
  imoveisReprovados: z.number().optional(),
  imoveisIndisponiveis: z.number().optional(),
  imoveisNegociacao: z.number().optional(),
  imoveisNegociados: z.number().optional(),
  imoveisDesativados: z.number().optional(),
  taxaPublicacao: z.number().optional(),
  valorMedioVenda: z.number().optional(),
  valorMedioLocacao: z.number().optional(),
  imoveisComValorVenda: z.number().optional(),
  imoveisComValorLocacao: z.number().optional(),
  imoveisFinanciaveis: z.number().optional(),
  imoveisAceitaFGTS: z.number().optional(),
  imoveisAceitaPet: z.number().optional()
});
var resumoGeralImoveisResponseSchema = reportResponse(
  resumoGeralImoveisSchema
);
var imovelPorStatusItemSchema = z.object({
  status: z.string(),
  quantidade: z.number(),
  percentual: z.number()
});
var imovelPorStatusRelatorioSchema = z.object({
  status: z.string(),
  quantidade: z.number(),
  percentual: z.number()
});
var imoveisPorStatusRelatorioResponseSchema = reportResponse(
  z.array(imovelPorStatusRelatorioSchema)
);
var imovelPorUsoSchema = z.object({
  usoId: z.number(),
  usoLabel: z.string(),
  quantidade: z.number(),
  percentual: z.number()
});
var imoveisPorUsoResponseSchema = reportResponse(
  z.array(imovelPorUsoSchema)
);
var imovelPorTipoSchema = z.object({
  tipoId: z.number(),
  tipoLabel: z.string(),
  quantidade: z.number(),
  percentual: z.number()
});
var imoveisPorTipoResponseSchema = reportResponse(
  z.array(imovelPorTipoSchema)
);
var imovelPorFinalidadeSchema = z.object({
  finalidade: z.string(),
  quantidade: z.number(),
  quantidadeDisponivel: z.number().optional(),
  quantidadeAtiva: z.number().optional(),
  percentual: z.number()
});
var imoveisPorFinalidadeResponseSchema = reportResponse(
  z.array(imovelPorFinalidadeSchema)
);
var imovelPorResponsavelSchema = z.object({
  responsavelId: z.number(),
  responsavelNome: z.string(),
  quantidadeTotal: z.number(),
  porStatus: z.array(imovelPorStatusItemSchema),
  honorarioVendaMedio: z.number().optional(),
  honorarioLocacaoMedio: z.number().optional()
});
var imoveisPorResponsavelResponseSchema = reportResponse(
  z.array(imovelPorResponsavelSchema)
);
var imovelPorCidadeSchema = z.object({
  cidade: z.string(),
  uf: z.string(),
  quantidade: z.number(),
  percentual: z.number()
});
var imoveisPorCidadeResponseSchema = reportResponse(
  z.array(imovelPorCidadeSchema)
);
var imovelPorBairroSchema = z.object({
  bairro: z.string(),
  cidade: z.string(),
  uf: z.string(),
  quantidade: z.number(),
  percentual: z.number()
});
var imoveisPorBairroResponseSchema = reportResponse(
  z.array(imovelPorBairroSchema)
);
var imovelPorFaixaValorSchema = z.object({
  faixa: z.string().optional(),
  valorMinimo: z.number().optional(),
  valorMaximo: z.number().optional(),
  quantidade: z.number().optional(),
  valorMedio: z.number().optional(),
  valorMin: z.number().optional(),
  valorMax: z.number().optional(),
  percentual: z.number().optional()
}).passthrough();
var imovelPorFaixaValorVendaSchema = z.object({
  faixa: z.string(),
  valorMinimo: z.number(),
  valorMaximo: z.number(),
  quantidade: z.number(),
  valorMedio: z.number(),
  valorMin: z.number(),
  valorMax: z.number(),
  percentual: z.number()
});
var imovelPorFaixaValorLocacaoSchema = z.object({
  faixa: z.string(),
  valorMinimo: z.number(),
  valorMaximo: z.number(),
  quantidade: z.number(),
  valorMedio: z.number(),
  valorMin: z.number(),
  valorMax: z.number(),
  percentual: z.number()
});
var imoveisPorFaixaValorVendaResponseSchema = reportResponse(
  z.array(imovelPorFaixaValorVendaSchema)
);
var imoveisPorFaixaValorLocacaoResponseSchema = reportResponse(
  z.array(imovelPorFaixaValorLocacaoSchema)
);
var imoveisPorFaixaValorResponseSchema = z.union([
  z.array(imovelPorFaixaValorSchema),
  z.array(imovelPorFaixaValorVendaSchema),
  z.array(imovelPorFaixaValorLocacaoSchema),
  z.array(z.any()),
  z.object({
    success: z.boolean().optional(),
    data: z.union([
      z.array(imovelPorFaixaValorSchema),
      z.array(imovelPorFaixaValorVendaSchema),
      z.array(imovelPorFaixaValorLocacaoSchema),
      z.array(z.any())
    ])
  })
]);
var imovelPorEntidadeSchema = z.object({
  incorporadoraId: z.number().optional(),
  incorporadoraNome: z.string().optional(),
  empreendimentoId: z.number().optional(),
  empreendimentoNome: z.string().optional(),
  campanhaId: z.number().optional(),
  campanhaNome: z.string().optional(),
  siteId: z.number().optional(),
  siteNome: z.string().optional(),
  portalId: z.number().optional(),
  portalNome: z.string().optional(),
  id: z.number().optional(),
  nome: z.string().optional(),
  quantidade: z.number(),
  percentual: z.number()
});
var imoveisPorEntidadeResponseSchema = reportResponse(
  z.array(imovelPorEntidadeSchema)
);
var imovelPorPeriodoSchema = z.object({
  periodo: z.string(),
  dataInicio: z.string(),
  dataFim: z.string(),
  quantidade: z.number(),
  porStatus: z.array(imovelPorStatusItemSchema).optional(),
  quantidadePeriodoAnterior: z.number().optional(),
  variacaoPercentual: z.number().optional()
});
var imoveisPorPeriodoResponseSchema = reportResponse(
  z.array(imovelPorPeriodoSchema)
);
var tempoMedioPublicacaoSchema = z.object({
  tempoMedioDias: z.number(),
  quantidadePublicados: z.number(),
  porStatus: z.record(z.string(), z.any()).optional(),
  tempoMedioHoras: z.number().optional(),
  quantidadeImoveis: z.number().optional()
});
var tempoMedioPublicacaoResponseSchema = reportResponse(
  tempoMedioPublicacaoSchema
);
var imoveisComMidiaSchema = z.object({
  totalComFotos: z.number(),
  totalSemFotos: z.number(),
  totalComVideos: z.number(),
  totalComTourVirtual: z.number(),
  totalComPlantas: z.number().optional(),
  mediaFotosPorImovel: z.number().optional(),
  mediaVideosPorImovel: z.number().optional(),
  totalSemMidia: z.number().optional(),
  percentualComFotos: z.number().optional(),
  percentualSemFotos: z.number().optional(),
  percentualComVideos: z.number().optional(),
  percentualComTourVirtual: z.number().optional(),
  percentualComPlantas: z.number().optional(),
  percentualSemMidia: z.number().optional(),
  totalImoveis: z.number().optional(),
  imoveisComFotos: z.number().optional(),
  imoveisComVideos: z.number().optional(),
  imoveisComTours: z.number().optional(),
  imoveisComPlantas: z.number().optional(),
  imoveisSemMidia: z.number().optional(),
  percentualComTours: z.number().optional()
});
var imoveisComMidiaResponseSchema = reportResponse(imoveisComMidiaSchema);
var imovelPorSiteSchema = z.object({
  siteId: z.number(),
  siteNome: z.string(),
  quantidade: z.number(),
  percentual: z.number()
});
var imovelPorPortalSchema = z.object({
  portal: z.string(),
  tipoAnuncio: z.string(),
  quantidade: z.number(),
  percentual: z.number()
});
var imovelPorLeadsInteressadosSchema = z.object({
  imovelId: z.number(),
  imovelTitulo: z.string(),
  imovelCodigo: z.string(),
  quantidadeLeads: z.number(),
  percentual: z.number()
});
var imovelPorPropostasSchema = z.object({
  imovelId: z.number(),
  imovelTitulo: z.string(),
  imovelCodigo: z.string(),
  quantidadePropostas: z.number(),
  propostasAceitas: z.number(),
  propostasPendentes: z.number(),
  propostasRecusadas: z.number(),
  percentual: z.number()
});
var imoveisPorSiteResponseSchema = reportResponse(
  z.array(imovelPorSiteSchema)
);
var imoveisPorPortalResponseSchema = reportResponse(
  z.array(imovelPorPortalSchema)
);
var imoveisPorLeadsInteressadosResponseSchema = reportResponse(
  z.array(imovelPorLeadsInteressadosSchema)
);
var imoveisPorPropostasResponseSchema = reportResponse(
  z.array(imovelPorPropostasSchema)
);
var oportunidadeStatusRelatorioEnum = z.enum([
  "Novo",
  "Pausado",
  "EmAndamento",
  "Ganho",
  "Perdido",
  "Arquivado"
]);
var oportunidadePorStatusRelatorioSchema = z.object({
  status: z.string(),
  quantidade: z.number(),
  percentual: z.number()
});
var oportunidadePorEtapaRelatorioSchema = z.object({
  etapaId: z.number(),
  etapaLabel: z.string(),
  quantidade: z.number(),
  percentual: z.number(),
  valorMedioVenda: z.number().optional(),
  valorMedioLocacao: z.number().optional()
});
var taxaConversaoOportunidadeSchema = z.object({
  totalOportunidades: z.number(),
  oportunidadesGanhas: z.number(),
  oportunidadesPerdidas: z.number(),
  taxaConversao: z.number(),
  taxaPerda: z.number()
});
var imovelMaisInteresseSchema = z.object({
  imovelId: z.number(),
  imovelTitulo: z.string(),
  imovelCodigo: z.string(),
  quantidade: z.number(),
  percentual: z.number(),
  valorVenda: z.number().optional(),
  valorLocacao: z.number().optional()
});
var empreendimentoMaisInteresseSchema = z.object({
  empreendimentoId: z.number(),
  empreendimentoNome: z.string(),
  quantidade: z.number(),
  percentual: z.number()
});
var cidadeInteresseSchema = z.object({
  cidade: z.string(),
  uf: z.string(),
  quantidade: z.number(),
  percentual: z.number()
});
var bairroInteresseSchema = z.object({
  bairro: z.string(),
  cidade: z.string(),
  uf: z.string(),
  quantidade: z.number(),
  percentual: z.number()
});
var oportunidadePorResponsavelRelatorioSchema = z.object({
  responsavelId: z.number(),
  responsavelNome: z.string(),
  quantidadeTotal: z.number(),
  quantidadeGanhas: z.number(),
  quantidadePerdidas: z.number(),
  taxaConversao: z.number(),
  taxaPerda: z.number()
});
var oportunidadePorFunilSchema = z.object({
  funilId: z.number(),
  funilValue: z.string(),
  funilLabel: z.string(),
  quantidadeTotal: z.number(),
  porStatus: z.array(oportunidadePorStatusRelatorioSchema),
  porEtapa: z.array(oportunidadePorEtapaRelatorioSchema).optional(),
  taxaConversao: taxaConversaoOportunidadeSchema,
  valorMedioVenda: z.number().optional(),
  valorMedioLocacao: z.number().optional(),
  imoveisMaisInteresse: z.array(imovelMaisInteresseSchema).optional(),
  empreendimentosMaisInteresse: z.array(empreendimentoMaisInteresseSchema).optional(),
  cidadesInteresse: z.array(cidadeInteresseSchema).optional(),
  bairrosInteresse: z.array(bairroInteresseSchema).optional(),
  porResponsavel: z.array(oportunidadePorResponsavelRelatorioSchema).optional()
});
var oportunidadesPorFunilResponseSchema = reportResponse(
  z.array(oportunidadePorFunilSchema)
);
var oportunidadePorPeriodoSchema = z.object({
  periodo: z.string(),
  quantidade: z.number(),
  porStatus: z.array(oportunidadePorStatusRelatorioSchema),
  porFunil: z.record(z.string(), z.number()).optional(),
  quantidadeGanhas: z.number().optional(),
  quantidadePerdidas: z.number().optional(),
  taxaConversao: z.number().optional(),
  valorTotal: z.number().optional()
});
var oportunidadesPorPeriodoResponseSchema = reportResponse(
  z.array(oportunidadePorPeriodoSchema)
);
var oportunidadePorMotivoPerdaSchema = z.object({
  motivoPerdaId: z.number(),
  motivoPerdaLabel: z.string(),
  quantidade: z.number(),
  percentual: z.number()
});
var oportunidadesPorMotivoPerdaResponseSchema = reportResponse(
  z.array(oportunidadePorMotivoPerdaSchema)
);
var tempoMedioFunilSchema = z.object({
  funilId: z.number(),
  funilLabel: z.string(),
  tempoMedioDias: z.number(),
  tempoMedioGanhoDias: z.number().optional(),
  tempoMedioPerdaDias: z.number().optional(),
  quantidadeOportunidades: z.number()
});
var tempoMedioFunilResponseSchema = reportResponse(
  z.array(tempoMedioFunilSchema)
);
var tempoMedioEtapaSchema = z.object({
  etapaId: z.number(),
  etapaLabel: z.string(),
  funilId: z.number(),
  funilLabel: z.string(),
  tempoMedioDias: z.number(),
  quantidadeOportunidades: z.number()
});
var tempoMedioEtapaResponseSchema = reportResponse(
  z.array(tempoMedioEtapaSchema)
);
var taxaAvancoEtapasSchema = z.object({
  etapaOrigemId: z.number(),
  etapaOrigemLabel: z.string(),
  etapaDestinoId: z.number(),
  etapaDestinoLabel: z.string(),
  funilId: z.number(),
  quantidadeSaidas: z.number(),
  quantidadeChegadas: z.number(),
  taxaAvanco: z.number(),
  taxaAbandono: z.number()
});
var taxaAvancoEtapasResponseSchema = reportResponse(
  z.array(taxaAvancoEtapasSchema)
);
var oportunidadeEstagnadaSchema = z.object({
  oportunidadeId: z.string(),
  titulo: z.string(),
  funilId: z.number(),
  funilLabel: z.string(),
  etapaId: z.number(),
  etapaLabel: z.string(),
  diasEstagnada: z.number(),
  ultimaMovimentacao: z.string(),
  responsaveis: z.array(z.string())
});
var oportunidadesEstagnadasResponseSchema = reportResponse(
  z.array(oportunidadeEstagnadaSchema)
);
var propostasPorOportunidadeSchema = z.object({
  funilId: z.number(),
  funilLabel: z.string(),
  quantidadeMediaPropostas: z.number(),
  totalPropostas: z.number(),
  propostasAceitas: z.number(),
  propostasPendentes: z.number(),
  propostasRecusadas: z.number(),
  taxaAceitacao: z.number(),
  valorMedioPropostas: z.number(),
  valorTotalAceitas: z.number()
});
var propostasPorOportunidadeResponseSchema = reportResponse(
  z.array(propostasPorOportunidadeSchema)
);
var origemEficazSchema = z.object({
  origemValue: z.string(),
  origemLabel: z.string(),
  quantidadeTotal: z.number(),
  quantidadeGanhas: z.number(),
  quantidadePerdidas: z.number(),
  taxaConversao: z.number(),
  valorMedioGanhas: z.number().optional(),
  valorTotalGanhas: z.number().optional()
});
var origemEficazResponseSchema = reportResponse(
  z.array(origemEficazSchema)
);
var valorTotalFunilSchema = z.object({
  funilId: z.number(),
  funilLabel: z.string(),
  quantidadeGanhas: z.number(),
  valorTotalVenda: z.number(),
  valorTotalLocacao: z.number(),
  valorMedioVenda: z.number(),
  valorMedioLocacao: z.number()
});
var valorTotalFunilResponseSchema = reportResponse(
  z.array(valorTotalFunilSchema)
);
var valorPorPeriodoSchema = z.object({
  periodo: z.string(),
  quantidadeGanhas: z.number(),
  valorTotalVenda: z.number(),
  valorTotalLocacao: z.number(),
  valorMedioVenda: z.number(),
  valorMedioLocacao: z.number(),
  taxaConversao: z.number().optional()
});
var valorPorPeriodoResponseSchema = reportResponse(
  z.array(valorPorPeriodoSchema)
);
var relatorioLeadsResumoGeralSchema = z.object({
  totalLeads: z.number(),
  leadsNovos: z.number(),
  leadsPendentes: z.number(),
  leadsQualificados: z.number(),
  leadsPerdidos: z.number(),
  taxaConversao: z.number(),
  taxaPerda: z.number(),
  leadsAtendidos: z.number(),
  leadsNaoAtendidos: z.number(),
  tempoMedioAtendimentoHoras: z.number()
});
var relatorioLeadsResumoGeralResponseSchema = reportResponse(
  relatorioLeadsResumoGeralSchema
);
var leadPorStatusSchema = z.object({
  status: leadStatusEnum,
  quantidade: z.number(),
  percentual: z.number()
});
var relatorioLeadsPorStatusResponseSchema = reportResponse(
  z.array(leadPorStatusSchema)
);
var leadPorStatusResponsavelSchema = z.object({
  status: leadStatusEnum,
  quantidade: z.number(),
  percentual: z.number()
});
var leadPorResponsavelSchema = z.object({
  responsavelId: z.number(),
  responsavelNome: z.string(),
  quantidadeTotal: z.number(),
  porStatus: z.array(leadPorStatusResponsavelSchema),
  tempoMedioAtendimentoHoras: z.number().optional(),
  tempoMedioAtendimentoMinutos: z.number().optional(),
  quantidadeAtendidos: z.number().optional()
});
var relatorioLeadsPorResponsavelResponseSchema = reportResponse(
  z.array(leadPorResponsavelSchema)
);
var leadPorOrigemSchema = z.object({
  origemValue: z.string(),
  origemLabel: z.string(),
  quantidade: z.number(),
  percentual: z.number()
});
var relatorioLeadsPorOrigemResponseSchema = reportResponse(
  z.array(leadPorOrigemSchema)
);
var leadPorFinalidadePorPeriodoSchema = z.object({
  periodo: z.string(),
  dataInicio: z.string(),
  dataFim: z.string(),
  quantidade: z.number(),
  percentual: z.number()
});
var leadPorFinalidadeSchema = z.object({
  finalidade: leadFinalidadeEnum.nullable(),
  quantidade: z.number(),
  percentual: z.number(),
  porPeriodo: z.array(leadPorFinalidadePorPeriodoSchema).optional()
});
var relatorioLeadsPorFinalidadeResponseSchema = reportResponse(
  z.array(leadPorFinalidadeSchema)
);
var leadPorFinalidadePeriodoSchema = z.object({
  periodo: z.string(),
  dataInicio: z.string(),
  dataFim: z.string(),
  quantidade: z.number(),
  porFinalidade: z.array(
    z.object({
      finalidade: z.string(),
      quantidade: z.number(),
      percentual: z.number()
    })
  )
});
var relatorioLeadsPorFinalidadePeriodoResponseSchema = reportResponse(
  z.array(leadPorFinalidadePeriodoSchema)
);
var relatorioDateSchema = z.string();
var leadPorPeriodoSchema = z.object({
  periodo: z.string(),
  dataInicio: relatorioDateSchema,
  dataFim: relatorioDateSchema,
  quantidade: z.number(),
  porStatus: z.array(leadPorStatusSchema).optional(),
  porOrigem: z.array(leadPorOrigemSchema).optional(),
  porFinalidade: z.array(
    z.object({
      finalidade: leadFinalidadeEnum.nullable(),
      quantidade: z.number(),
      percentual: z.number()
    })
  ).optional(),
  quantidadePeriodoAnterior: z.number().optional(),
  variacaoPercentual: z.number().optional()
});
var relatorioLeadsPorPeriodoResponseSchema = reportResponse(
  z.array(leadPorPeriodoSchema)
);
var leadPorMotivoPerdaSchema = z.object({
  motivoPerdaId: z.number(),
  motivoPerdaLabel: z.string(),
  quantidade: z.number(),
  percentual: z.number()
});
var relatorioLeadsPorMotivoPerdaResponseSchema = reportResponse(
  z.array(leadPorMotivoPerdaSchema)
);
var leadPorUtmSchema = z.object({
  utmSource: z.string().nullable(),
  utmMedium: z.string().nullable(),
  utmCampaign: z.string().nullable(),
  quantidade: z.number(),
  percentual: z.number()
});
var relatorioLeadsPorUtmResponseSchema = reportResponse(
  z.array(leadPorUtmSchema)
);
var tempoMedioAtendimentoSchema = z.object({
  responsavelId: z.number().nullable(),
  responsavelNome: z.string().nullable(),
  tempoMedioHoras: z.number(),
  quantidadeLeads: z.number()
});
var relatorioLeadsTempoMedioAtendimentoResponseSchema = reportResponse(
  z.array(tempoMedioAtendimentoSchema)
);
var tempoMedioAtendimentoPorResponsavelItemSchema = z.object({
  responsavelId: z.number(),
  responsavelNome: z.string(),
  tempoMedioHoras: z.number(),
  quantidade: z.number()
});
var tempoMedioAtendimentoAgregadoSchema = z.object({
  tempoMedioHoras: z.number(),
  tempoMedioMinutos: z.number(),
  quantidadeAtendidos: z.number(),
  porResponsavel: z.record(z.string(), tempoMedioAtendimentoPorResponsavelItemSchema).optional()
});
var relatorioLeadsTempoMedioAtendimentoAgregadoResponseSchema = reportResponse(tempoMedioAtendimentoAgregadoSchema);
var taxaConversaoLeadsSchema = z.object({
  periodo: z.string().optional(),
  taxaConversao: z.number(),
  leadsQualificados: z.number().optional(),
  leadsPerdidos: z.number().optional(),
  total: z.number().optional()
});
var taxaConversaoLeadsDetalhadaSchema = z.object({
  totalLeads: z.number(),
  leadsQualificados: z.number(),
  leadsPerdidos: z.number(),
  taxaConversao: z.number(),
  taxaPerda: z.number(),
  porPeriodo: z.array(leadPorPeriodoSchema).optional()
});
var relatorioLeadsTaxaConversaoDetalhadaResponseSchema = reportResponse(
  taxaConversaoLeadsDetalhadaSchema
);
var taxaConversaoLeadsDataSchema = z.union([
  taxaConversaoLeadsSchema,
  taxaConversaoLeadsDetalhadaSchema,
  z.array(taxaConversaoLeadsSchema)
]);
var relatorioLeadsTaxaConversaoResponseSchema = reportResponse(
  taxaConversaoLeadsDataSchema
);
var imovelMaisProcuradoSchema = z.object({
  imovelId: z.number(),
  imovelTitulo: z.string(),
  imovelCodigo: z.string(),
  finalidade: z.string(),
  quantidade: z.number(),
  percentual: z.number(),
  bairro: z.string().nullable().optional(),
  cidade: z.string().nullable().optional(),
  uf: z.string().nullable().optional()
});
var relatorioLeadsImoveisMaisProcuradosResponseSchema = reportResponse(
  z.array(imovelMaisProcuradoSchema)
);
var bairroMaisProcuradoSchema = z.object({
  bairro: z.string(),
  cidade: z.string(),
  uf: z.string(),
  finalidade: z.string().optional(),
  quantidade: z.number(),
  percentual: z.number()
});
var relatorioLeadsBairrosMaisProcuradosResponseSchema = reportResponse(
  z.array(bairroMaisProcuradoSchema)
);
var cidadeMaisProcuradaSchema = z.object({
  cidade: z.string(),
  uf: z.string(),
  finalidade: z.string().optional(),
  quantidade: z.number(),
  percentual: z.number()
});
var relatorioLeadsCidadesMaisProcuradasResponseSchema = reportResponse(
  z.array(cidadeMaisProcuradaSchema)
);
var leadDuplicadoSchema = z.object({
  tipo: z.enum(["email", "telefone", "cpf"]),
  valor: z.string(),
  quantidade: z.number(),
  leadIds: z.array(z.string())
});
var leadDuplicadoGrupoLeadSchema = z.object({
  id: z.string(),
  nome: z.string(),
  email: z.string().optional(),
  telefone: z.string().optional(),
  createdAt: relatorioDateSchema
});
var leadDuplicadoGrupoSchema = z.object({
  identificador: z.string(),
  tipo: z.enum(["email", "telefone", "cpf"]),
  quantidade: z.number(),
  leads: z.array(leadDuplicadoGrupoLeadSchema)
});
var leadsDuplicadosAgregadoSchema = z.object({
  totalDuplicados: z.number(),
  totalUnicos: z.number(),
  percentualDuplicados: z.number(),
  gruposDuplicados: z.array(leadDuplicadoGrupoSchema)
});
var relatorioLeadsDuplicadosResponseSchema = reportResponse(
  z.union([z.array(leadDuplicadoSchema), leadsDuplicadosAgregadoSchema])
);

// src/relatorios/index.ts
var tipoAgrupamentoEnum = z.enum(["dia", "semana", "mes", "ano"]);
var tipoComparacaoEnum = z.enum([
  "periodo_anterior",
  "mes_anterior",
  "ano_anterior"
]);
var imovelStatusEnum = z.enum([
  "Publicado",
  "Rascunho",
  "Pendente",
  "Reprovado",
  "Indisponivel",
  "Negociacao",
  "Negociado",
  "Desativado"
]);
var filtroRelatorioImovelSchema = z.object({
  dashboardId: z.coerce.number().optional(),
  dataInicio: z.string().optional(),
  dataFim: z.string().optional(),
  responsavelId: z.coerce.number().optional(),
  responsaveisIds: z.array(z.coerce.number()).optional(),
  status: imovelStatusEnum.optional(),
  statusList: z.array(imovelStatusEnum).optional(),
  tipoId: z.coerce.number().optional(),
  usoId: z.coerce.number().optional(),
  incorporadoraId: z.coerce.number().optional(),
  empreendimentoId: z.coerce.number().optional(),
  cidade: z.string().optional(),
  uf: z.string().optional(),
  bairro: z.string().optional(),
  comValorVenda: booleanLike.optional(),
  comValorLocacao: booleanLike.optional(),
  financiavel: booleanLike.optional(),
  aceitaFGTS: booleanLike.optional(),
  aceitaPet: booleanLike.optional(),
  agrupamento: tipoAgrupamentoEnum.optional(),
  compararCom: tipoComparacaoEnum.optional()
});
var filtroRelatorioLeadSchema = z.object({
  dashboardId: z.coerce.number().optional(),
  dataInicio: z.string().optional(),
  dataFim: z.string().optional(),
  responsavelId: z.coerce.number().optional(),
  responsaveisIds: z.array(z.coerce.number()).optional(),
  origem: z.string().optional(),
  origens: z.array(z.string()).optional(),
  status: leadStatusEnum.optional(),
  statusList: z.array(leadStatusEnum).optional(),
  finalidade: leadFinalidadeEnum.optional(),
  finalidades: z.array(leadFinalidadeEnum).optional(),
  duplicado: booleanLike.optional(),
  atendido: booleanLike.optional(),
  agrupamento: tipoAgrupamentoEnum.optional(),
  compararCom: tipoComparacaoEnum.optional()
});
var filtroRelatorioOportunidadeSchema = z.object({
  dashboardId: z.coerce.number().optional(),
  dataInicio: z.string().optional(),
  dataFim: z.string().optional(),
  responsavelId: z.coerce.number().optional(),
  responsaveisIds: z.array(z.coerce.number()).optional(),
  origem: z.string().optional(),
  origens: z.array(z.string()).optional(),
  status: oportunidadeStatusEnum.optional(),
  statusList: z.array(oportunidadeStatusEnum).optional(),
  funilId: z.coerce.number().optional(),
  funisIds: z.array(z.coerce.number()).optional(),
  agrupamento: tipoAgrupamentoEnum.optional(),
  compararCom: tipoComparacaoEnum.optional()
});
var relatorioChartItemSchema = z.object({
  label: z.string(),
  value: z.number(),
  percentual: z.number().optional()
});
var relatorioChartResponseSchema = reportResponse(
  z.array(relatorioChartItemSchema)
);
var imovelPorStatusSchema = z.object({
  status: imovelStatusEnum,
  quantidade: z.number(),
  percentual: z.number()
});
var relatorioImoveisPorStatusResponseSchema = reportResponse(
  z.array(imovelPorStatusSchema)
);
var oportunidadePorEtapaSchema = z.object({
  etapaId: z.number(),
  etapaLabel: z.string(),
  quantidade: z.number(),
  valorTotal: z.number().optional()
});
var relatorioOportunidadesPorEtapaResponseSchema = reportResponse(
  z.array(oportunidadePorEtapaSchema)
);
var relatorioSerieTemporalItemSchema = z.object({
  periodo: z.string(),
  valor: z.number(),
  comparacao: z.number().optional()
});
var relatorioSerieTemporalResponseSchema = reportResponse(
  z.array(relatorioSerieTemporalItemSchema)
);

// src/audit-logs/index.ts
var audit_logs_exports = {};
__export(audit_logs_exports, {
  auditActionEnum: () => auditActionEnum,
  auditLogFiltersSchema: () => auditLogFiltersSchema,
  auditLogListQuerySchema: () => auditLogListQuerySchema,
  auditLogSchema: () => auditLogSchema,
  auditLogUsuarioSchema: () => auditLogUsuarioSchema,
  auditLogsResponseSchema: () => auditLogsResponseSchema
});
var auditActionEnum = z.enum(["CREATE", "UPDATE", "DELETE"]);
var auditLogListQuerySchema = z.object({
  page: z.coerce.number().min(1).optional().default(1),
  limit: z.coerce.number().min(1).max(100).optional().default(20),
  entidade: z.string().optional(),
  entidadeId: z.string().optional(),
  usuarioId: z.coerce.number().optional(),
  acao: auditActionEnum.optional(),
  dataInicio: z.string().optional(),
  dataFim: z.string().optional(),
  subEntidade: z.string().optional(),
  subEntidadeId: z.string().optional()
});
var auditLogUsuarioSchema = z.object({
  id: z.number(),
  nome: z.string().nullable(),
  sobrenome: z.string().nullable(),
  email: z.string(),
  image: z.string().nullable()
});
var auditLogSchema = z.object({
  id: z.number(),
  dashboardId: z.number(),
  usuarioId: z.number().nullable(),
  entidade: z.string().nullable(),
  entidadeId: z.string().nullable(),
  subEntidade: z.string().nullable(),
  subEntidadeId: z.string().nullable(),
  acao: auditActionEnum,
  observacoes: z.string().nullable(),
  createdAt: z.string(),
  usuario: auditLogUsuarioSchema.nullable()
});
var auditLogMetaSchema = z.object({
  total: z.number().catch(0),
  page: z.number().catch(1),
  limit: z.number().catch(0),
  totalPages: z.number().catch(0),
  hasNext: z.boolean().catch(false),
  hasPrev: z.boolean().catch(false),
  timestamp: z.string().optional()
});
var auditLogFiltersSchema = z.object({
  entidades: z.array(z.object({ value: z.string(), count: z.number() })),
  usuarios: z.array(
    z.object({
      id: z.number(),
      nome: z.string().nullable(),
      sobrenome: z.string().nullable(),
      email: z.string(),
      count: z.number()
    })
  ),
  acoes: z.array(z.object({ value: auditActionEnum, count: z.number() }))
});
var auditLogsResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(auditLogSchema),
  meta: auditLogMetaSchema,
  filters: auditLogFiltersSchema,
  message: z.string().optional()
});

// src/dashboard/index.ts
var dashboard_exports = {};
__export(dashboard_exports, {
  artigoResponseSchema: () => artigoResponseSchema,
  artigoSchema: () => artigoSchema,
  artigoStatusAprovacaoSchema: () => artigoStatusAprovacaoSchema,
  artigosDataSchema: () => artigosDataSchema,
  artigosResponseSchema: () => artigosResponseSchema,
  assetUploadUrlResponseSchema: () => assetUploadUrlResponseSchema,
  companyTypeSchema: () => companyTypeSchema,
  createArtigoRequestSchema: () => createArtigoRequestSchema,
  createArtigoResponseSchema: () => createArtigoResponseSchema,
  createPortalStripeRequestSchema: () => createPortalStripeRequestSchema,
  createTagRequestSchema: () => createTagRequestSchema,
  createTagResponseSchema: () => createTagResponseSchema,
  dashboardDetailResponseSchema: () => dashboardDetailResponseSchema,
  dashboardDetailSchema: () => dashboardDetailSchema,
  dashboardParamsSchema: () => dashboardParamsSchema,
  dashboardQuantidadesSchema: () => dashboardQuantidadesSchema,
  dashboardSchema: () => dashboardSchema,
  dashboardStatisticsResponseSchema: () => dashboardStatisticsResponseSchema,
  dashboardStatisticsSchema: () => dashboardStatisticsSchema,
  dashboardStatsResponseSchema: () => dashboardStatsResponseSchema,
  dashboardStatsSchema: () => dashboardStatsSchema,
  dashboardStatusSchema: () => dashboardStatusSchema,
  dashboardUsuarioSchema: () => dashboardUsuarioSchema,
  dashboardUsuariosResponseSchema: () => dashboardUsuariosResponseSchema,
  dashboardsResponseSchema: () => dashboardsResponseSchema,
  deleteTagResponseSchema: () => deleteTagResponseSchema,
  dnsConfigDataSchema: () => dnsConfigDataSchema,
  dnsConfigDnsSchema: () => dnsConfigDnsSchema,
  dnsConfigResponseSchema: () => dnsConfigResponseSchema,
  dnsConfigRootSchema: () => dnsConfigRootSchema,
  dnsConfigVerificationSchema: () => dnsConfigVerificationSchema,
  dnsConfigWwwSchema: () => dnsConfigWwwSchema,
  editorLinkResponseSchema: () => editorLinkResponseSchema,
  generateAssetUploadRequestSchema: () => generateAssetUploadRequestSchema,
  generateImageUploadRequestSchema: () => generateImageUploadRequestSchema,
  generatePortalUrlRequestSchema: () => generatePortalUrlRequestSchema,
  personTypeSchema: () => personTypeSchema,
  portalStripeDataSchema: () => portalStripeDataSchema,
  portalStripeResponseSchema: () => portalStripeResponseSchema,
  setDashboardPrincipalDataSchema: () => setDashboardPrincipalDataSchema,
  setDashboardPrincipalErrorSchema: () => setDashboardPrincipalErrorSchema,
  setDashboardPrincipalResponseSchema: () => setDashboardPrincipalResponseSchema,
  setDashboardPrincipalSchema: () => setDashboardPrincipalSchema,
  siteResponseSchema: () => siteResponseSchema,
  siteSchema: () => siteSchema,
  sitesResponseSchema: () => sitesResponseSchema,
  tagDetailResponseSchema: () => tagDetailResponseSchema,
  tagSchema: () => tagSchema,
  tagsResponseSchema: () => tagsResponseSchema,
  updateArtigoRequestSchema: () => updateArtigoRequestSchema,
  updateArtigoResponseSchema: () => updateArtigoResponseSchema,
  updateDashboardRequestSchema: () => updateDashboardRequestSchema,
  updateDashboardResponseSchema: () => updateDashboardResponseSchema,
  updateDashboardSchema: () => updateDashboardSchema,
  updateSiteSchema: () => updateSiteSchema,
  updateTagRequestSchema: () => updateTagRequestSchema,
  updateTagResponseSchema: () => updateTagResponseSchema,
  uploadUrlResponseSchema: () => uploadUrlResponseSchema
});
var dashboardStatusSchema = z.enum([
  "Trial",
  "Ativo",
  "Suspenso",
  "Pendente",
  "Cancelado"
]);
var dashboardSchema = z.object({
  id: z.number(),
  logo: z.string().nullable(),
  titulo: z.string(),
  status: dashboardStatusSchema,
  userStatus: z.string(),
  createdAt: z.string()
});
var dashboardsResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(dashboardSchema),
  message: z.string()
});
var setDashboardPrincipalSchema = z.object({
  dashboardPrincipal: z.string().nullable()
});
var setDashboardPrincipalDataSchema = z.object({
  userId: z.number(),
  dashboardPrincipalId: z.number().nullable(),
  updatedAt: z.string()
});
var setDashboardPrincipalResponseSchema = z.object({
  success: z.boolean(),
  data: setDashboardPrincipalDataSchema,
  message: z.string()
});
var setDashboardPrincipalErrorSchema = z.object({
  success: z.literal(false),
  error: z.object({
    message: z.string(),
    code: z.string(),
    timestamp: z.string()
  })
});
var personTypeSchema = personTypeEnum;
var companyTypeSchema = z.enum([
  "MEI",
  "LIMITED",
  "INDIVIDUAL",
  "ASSOCIATION",
  "PARTNERSHIP",
  "CORPORATION",
  "NON_PROFIT",
  "OTHER"
]);
var dashboardDetailSchema = z.object({
  id: z.number(),
  uuid: z.string(),
  logo: z.string().nullable(),
  titulo: z.string(),
  trial: z.boolean(),
  trialExpiration: z.string().nullable(),
  desbloqueioConfiancaAte: z.string().nullable(),
  status: dashboardStatusSchema,
  proprietarioId: z.number(),
  email: z.string().nullable(),
  telefone: z.string().nullable(),
  mobilePhone: z.string().nullable(),
  endereco: z.string().nullable(),
  numero: z.string().nullable(),
  complemento: z.string().nullable(),
  bairro: z.string().nullable(),
  cidade: z.string().nullable(),
  uf: z.string().nullable(),
  cep: z.string().nullable(),
  pais: z.string().nullable(),
  razaoSocial: z.string().nullable(),
  cpfCnpj: z.string().nullable(),
  personType: personTypeSchema.nullable(),
  companyType: companyTypeSchema.nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  atribuirLeadResponsavel: z.boolean(),
  sempreDefinirResponsavel: z.boolean(),
  ocultarDadosLeads: z.boolean(),
  tempoEsperaLead: z.number(),
  tempoEsperaLeadTipo: z.enum(["Minutos", "Horas", "Dias"]),
  tempoEsperaHorarioComercial: z.boolean(),
  horariosComerciais: z.any().nullable(),
  distribuirApenasHorarioComercial: z.boolean(),
  redistribuirAutomaticamente: z.boolean(),
  tempoLimiteRedistribuicao: z.number().int().min(0),
  tipoTempoRedistribuicao: z.enum(["Minutos", "Horas", "Dias"]),
  maxTentativasRedistribuicao: z.number().int().min(1).max(10),
  escalarParaSupervisor: z.boolean(),
  grupoEscalacaoId: z.number().nullable(),
  whatsappInstancia: z.string().nullable(),
  watermark: z.string().nullable(),
  watermarkEnabled: z.boolean(),
  watermarkVersion: z.number().int(),
  watermarkScalePercent: z.number().nullable(),
  opacity: z.number().nullable(),
  margin: z.number().nullable(),
  position: z.string().nullable()
});
var dashboardDetailResponseSchema = z.object({
  success: z.boolean(),
  data: dashboardDetailSchema,
  message: z.string()
});
var siteSchema = z.object({
  id: z.number(),
  nome: z.string(),
  dominioDev: z.string(),
  dominioProprio: z.string().nullable(),
  publicado: z.boolean(),
  creci: z.string().nullable(),
  dashboardId: z.number(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var sitesResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(siteSchema),
  message: z.string()
});
var editorLinkResponseSchema = z.object({
  success: z.boolean(),
  data: z.object({
    link: z.string()
  }),
  message: z.string()
});
var createPortalStripeRequestSchema = z.object({
  returnUrl: z.string().optional()
});
var portalStripeDataSchema = z.object({
  url: z.string()
});
var portalStripeResponseSchema = z.object({
  success: z.boolean(),
  data: portalStripeDataSchema,
  message: z.string()
});
var siteResponseSchema = z.object({
  success: z.boolean(),
  data: siteSchema,
  message: z.string()
});
var updateSiteSchema = z.object({
  nome: z.string().optional(),
  creci: z.string().nullable().optional(),
  publicado: z.boolean().optional(),
  dominioDev: z.string().optional(),
  dominioProprio: z.string().nullable().optional()
});
var dnsConfigRootSchema = z.object({
  type: z.literal("A"),
  values: z.array(z.string())
});
var dnsConfigWwwSchema = z.object({
  type: z.literal("CNAME"),
  value: z.string()
});
var dnsConfigVerificationSchema = z.object({
  type: z.string(),
  domain: z.string(),
  value: z.string(),
  reason: z.string().optional()
});
var dnsConfigDnsSchema = z.object({
  root: dnsConfigRootSchema,
  www: dnsConfigWwwSchema,
  verification: z.array(dnsConfigVerificationSchema).optional()
});
var dnsConfigDataSchema = z.object({
  configured: z.boolean(),
  domain: z.string(),
  dns: dnsConfigDnsSchema,
  rawResponse: z.any(),
  rawProjectDomainResponse: z.object({
    root: z.any().optional(),
    www: z.any().optional()
  }).optional()
});
var dnsConfigResponseSchema = z.object({
  success: z.boolean(),
  data: dnsConfigDataSchema,
  message: z.string()
});
var adicionadoPorSchema = z.object({
  id: z.number(),
  nome: z.string(),
  sobrenome: z.string().nullable(),
  email: z.string().nullable().optional()
}).nullable().optional();
var artigoStatusAprovacaoSchema = z.enum([
  "Pendente",
  "Aprovado",
  "Rejeitado"
]);
var artigoSchema = z.object({
  id: z.number(),
  titulo: z.string(),
  /**
   * `ArtigoService` sempre devolve esses campos no detalhe (Prisma retorna
   * `null` para colunas vazias), mas respostas parciais/legadas podem omitir
   * a chave — `.optional()` evita falha no parse do app.
   */
  metaTitle: z.string().nullable().optional(),
  metaDescription: z.string().nullable().optional(),
  slug: z.string(),
  keyword: z.string().nullable().optional(),
  conteudo: z.any().optional(),
  // JSON (TipTap/ProseMirror format)
  imagemDestaque: z.string().nullable().optional(),
  status: z.enum(["Publicado", "Rascunho", "Removido"]),
  siteId: z.number(),
  geradoPorIa: z.boolean().optional(),
  statusAprovacao: artigoStatusAprovacaoSchema.nullable().optional(),
  dataPublicacaoAgendada: z.string().nullable().optional(),
  publishedAt: z.string().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
  tags: z.array(z.string()),
  adicionadoPor: adicionadoPorSchema
});
var artigosDataSchema = z.object({
  items: z.array(artigoSchema),
  totalItems: z.number(),
  totalPages: z.number(),
  currentPage: z.number(),
  itemsPerPage: z.number()
});
var artigosResponseSchema = z.object({
  success: z.boolean(),
  data: artigosDataSchema,
  message: z.string()
});
var artigoResponseSchema = z.object({
  success: z.boolean(),
  data: artigoSchema,
  message: z.string()
});
var tagSchema = z.object({
  id: z.number(),
  label: z.string(),
  value: z.string(),
  siteId: z.number()
});
var tagsResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(tagSchema),
  message: z.string()
});
var tagDetailResponseSchema = z.object({
  success: z.boolean(),
  data: tagSchema,
  message: z.string()
});
var createTagRequestSchema = z.object({
  nome: z.string().min(2, "O nome da tag deve ter no m\xEDnimo 2 caracteres").max(50, "O nome da tag deve ter no m\xE1ximo 50 caracteres"),
  value: z.string().regex(
    /^[a-z0-9-]+$/,
    "O valor da tag deve conter apenas letras min\xFAsculas, n\xFAmeros e h\xEDfens"
  ).max(50, "O valor da tag deve ter no m\xE1ximo 50 caracteres").optional()
});
var createTagResponseSchema = z.object({
  success: z.boolean(),
  data: tagSchema,
  message: z.string()
});
var updateTagRequestSchema = z.object({
  nome: z.string().min(2, "O nome da tag deve ter no m\xEDnimo 2 caracteres").max(50, "O nome da tag deve ter no m\xE1ximo 50 caracteres").optional(),
  value: z.string().regex(
    /^[a-z0-9-]+$/,
    "O valor da tag deve conter apenas letras min\xFAsculas, n\xFAmeros e h\xEDfens"
  ).max(50, "O valor da tag deve ter no m\xE1ximo 50 caracteres").optional()
});
var updateTagResponseSchema = z.object({
  success: z.boolean(),
  data: tagSchema,
  message: z.string()
});
var deleteTagResponseSchema = z.object({
  success: z.boolean(),
  message: z.string()
});
var createArtigoRequestSchema = z.object({
  titulo: z.string().min(5, "O t\xEDtulo deve ter no m\xEDnimo 5 caracteres").max(200, "O t\xEDtulo deve ter no m\xE1ximo 200 caracteres"),
  conteudo: z.any(),
  // JSON (TipTap/ProseMirror format)
  resumo: z.string().max(500, "O resumo deve ter no m\xE1ximo 500 caracteres").optional(),
  slug: z.preprocess(
    (val) => val === "" || val === void 0 ? void 0 : val,
    z.string().max(200).regex(
      /^[a-z0-9-]+$/,
      "O slug deve conter apenas letras min\xFAsculas, n\xFAmeros e h\xEDfens"
    ).optional()
  ),
  metaTitle: z.string().max(200, "O meta t\xEDtulo deve ter no m\xE1ximo 200 caracteres").optional(),
  metaDescription: z.string().max(500, "A meta descri\xE7\xE3o deve ter no m\xE1ximo 500 caracteres").optional(),
  keyword: z.string().max(255, "A palavra-foco deve ter no m\xE1ximo 255 caracteres").optional().or(z.literal("")),
  imagemDestaque: z.union([z.string(), z.literal("")]).optional(),
  publicado: z.boolean().optional(),
  tags: z.array(z.string()).optional(),
  autores: z.array(z.string()).optional()
  // Array de IDs dos autores (strings)
});
var createArtigoResponseSchema = z.object({
  success: z.boolean(),
  data: artigoSchema,
  message: z.string()
});
var updateArtigoRequestSchema = createArtigoRequestSchema.partial();
var updateArtigoResponseSchema = createArtigoResponseSchema;
var generateImageUploadRequestSchema = z.object({
  fileName: z.string().max(255),
  contentType: z.enum([
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/gif",
    "image/webp",
    "image/svg+xml"
  ]),
  size: z.number().max(10485760),
  // 10MB
  folder: z.enum(["capas", "galeria", "perfil"]).optional()
});
var uploadUrlResponseSchema = dataResponse(
  z.object({
    uploadUrl: z.string().url(),
    fileKey: z.string()
  })
);
var dashboardUsuarioApiSchema = z.object({
  id: z.number(),
  usuarioId: z.number(),
  dashboardId: z.number(),
  role: z.string(),
  status: z.string(),
  disponibilidade: z.string().nullable().optional(),
  ultimaAtividade: z.string().nullable().optional(),
  ultimoStatus: z.string().nullable().optional(),
  observacoes: z.string().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
  usuario: z.object({
    nome: z.string(),
    sobrenome: z.string().nullable(),
    image: z.string().nullable().optional(),
    cpf: z.string().nullable().optional(),
    email: z.string().nullable().optional(),
    celular: z.string().nullable().optional()
  })
});
var dashboardUsuarioSchema = dashboardUsuarioApiSchema.transform(
  (data) => ({
    id: data.usuarioId,
    // Usa usuarioId como id para compatibilidade
    nome: data.usuario.nome,
    sobrenome: data.usuario.sobrenome,
    email: data.usuario.email
  })
);
var dashboardUsuariosResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(dashboardUsuarioSchema),
  message: z.string()
});
var updateDashboardSchema = z.object({
  titulo: z.string().optional(),
  email: z.union([z.string().email("Email inv\xE1lido"), z.literal("")]).optional(),
  telefone: z.string().optional(),
  mobilePhone: z.string().optional(),
  cep: z.string().optional(),
  uf: z.string().optional(),
  cidade: z.string().optional(),
  bairro: z.string().optional(),
  endereco: z.string().optional(),
  numero: z.string().optional(),
  complemento: z.string().optional(),
  pais: z.string().optional(),
  razaoSocial: z.string().optional(),
  cpfCnpj: z.string().optional(),
  personType: personTypeSchema.optional(),
  companyType: companyTypeSchema.optional(),
  logo: z.string().nullable().optional(),
  watermark: z.string().nullable().optional(),
  watermarkEnabled: z.boolean().optional(),
  watermarkScalePercent: z.number().int().min(0).max(100).optional(),
  opacity: z.number().min(0).max(1).optional(),
  margin: z.number().int().min(0).optional(),
  position: z.string().optional()
});
var generateAssetUploadRequestSchema = z.object({
  dashboardId: z.number(),
  tipoConteudo: z.literal("assets"),
  folder: z.enum(["logo", "imagens"]),
  fileName: z.string().max(255).regex(
    /^[a-zA-Z0-9._-]+$/,
    "O nome do arquivo pode conter apenas letras, n\xFAmeros, pontos, h\xEDfens e underscores"
  ),
  fileType: z.enum([
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/webp",
    "image/svg+xml"
  ]),
  isPublico: z.boolean().optional().default(false)
});
var assetUploadUrlResponseSchema = z.object({
  success: z.boolean(),
  data: z.object({
    presignedUrl: z.string().url(),
    fileUrl: z.string().url(),
    filePath: z.string(),
    expiresIn: z.number(),
    fileName: z.string(),
    fileType: z.string(),
    folder: z.string(),
    dashboardId: z.number(),
    tipoConteudo: z.string(),
    isPublico: z.boolean()
  }),
  message: z.string()
});

// src/dashboard/index.ts
var dashboardParamsSchema = z.object({
  dashboardId: z.coerce.number().int().min(1)
});
var updateDashboardRequestSchema = z.object({
  titulo: z.string().optional(),
  email: z.string().email().optional(),
  telefone: z.string().optional(),
  cep: z.string().optional(),
  uf: z.string().optional(),
  cidade: z.string().optional(),
  bairro: z.string().optional(),
  endereco: z.string().optional(),
  numero: z.string().optional(),
  complemento: z.string().optional(),
  mobilePhone: z.string().optional(),
  razaoSocial: z.string().optional(),
  cpfCnpj: z.string().optional(),
  personType: personTypeEnum.optional(),
  companyType: companyTypeEnum.optional(),
  pais: z.string().optional(),
  atribuirLeadResponsavel: z.boolean().optional(),
  tempoEsperaLead: z.number().int().min(0).optional(),
  tempoEsperaLeadTipo: z.string().optional(),
  sempreDefinirResponsavel: z.boolean().optional(),
  responsavelPadraoId: z.number().int().min(1).optional(),
  tempoEsperaHorarioComercial: z.boolean().optional(),
  delayInicioHorarioComercial: z.number().int().min(0).optional(),
  ocultarDadosLeads: z.boolean().optional(),
  logo: z.string().nullable().optional(),
  watermark: z.string().nullable().optional(),
  watermarkEnabled: z.boolean().optional(),
  watermarkScalePercent: z.number().int().min(0).max(100).optional(),
  opacity: z.number().min(0).max(1).optional(),
  margin: z.number().int().min(0).optional(),
  position: z.string().optional()
});
var generatePortalUrlRequestSchema = z.object({
  returnUrl: z.string().optional()
});
var dashboardStatsSchema = z.record(z.string(), z.any());
var dashboardStatsResponseSchema = apiSuccess(dashboardStatsSchema);
var dashboardQuantidadesSchema = z.object({
  imoveis: z.object({ uso: z.number(), limite: z.number(), adicional: z.number() }),
  empreendimentos: z.object({ uso: z.number(), limite: z.number(), adicional: z.number() }),
  incorporadoras: z.object({ uso: z.number(), limite: z.number(), adicional: z.number() }),
  leads: z.object({ uso: z.number(), limite: z.number(), adicional: z.number() }),
  contatos: z.object({ uso: z.number(), limite: z.number(), adicional: z.number() }),
  oportunidades: z.object({ uso: z.number(), limite: z.number(), adicional: z.number() }),
  usuarios: z.object({ uso: z.number(), limite: z.number(), adicional: z.number() }),
  funis: z.object({ uso: z.number(), limite: z.number(), adicional: z.number() }),
  propostas: z.object({ uso: z.number(), limite: z.number(), adicional: z.number() })
});
var dashboardStatisticsSchema = z.object({
  quantidades: dashboardQuantidadesSchema
});
var dashboardStatisticsResponseSchema = dataResponse(
  dashboardStatisticsSchema
);
var updateDashboardResponseSchema = dataResponse(
  z.object({ id: z.number(), titulo: z.string().optional(), updatedAt: z.string().optional() })
);

// src/financeiro/index.ts
var financeiro_exports = {};
__export(financeiro_exports, {
  categoriaResponseSchema: () => categoriaResponseSchema,
  categoriaSchema: () => categoriaSchema,
  categoriasResponseSchema: () => categoriasResponseSchema,
  centroCustoResponseSchema: () => centroCustoResponseSchema,
  centroCustoSchema: () => centroCustoSchema,
  centrosCustoResponseSchema: () => centrosCustoResponseSchema,
  conciliacaoBancariaSchema: () => conciliacaoBancariaSchema,
  conciliacaoItemDetalheSchema: () => conciliacaoItemDetalheSchema,
  conciliacaoItemResponseSchema: () => conciliacaoItemResponseSchema,
  conciliacaoItemTransacaoRefSchema: () => conciliacaoItemTransacaoRefSchema,
  conciliacaoResponseSchema: () => conciliacaoResponseSchema,
  conciliacaoStatusEnum: () => conciliacaoStatusEnum,
  conciliacoesResponseSchema: () => conciliacoesResponseSchema,
  conciliarItemRequestSchema: () => conciliarItemRequestSchema,
  conciliarTransferenciaRequestSchema: () => conciliarTransferenciaRequestSchema,
  conciliarTransferenciaResponseSchema: () => conciliarTransferenciaResponseSchema,
  contaBancariaResponseSchema: () => contaBancariaResponseSchema,
  contaBancariaSchema: () => contaBancariaSchema,
  contasBancariasResponseSchema: () => contasBancariasResponseSchema,
  createCategoriaRequestSchema: () => createCategoriaRequestSchema,
  createCentroCustoRequestSchema: () => createCentroCustoRequestSchema,
  createConciliacaoRequestSchema: () => createConciliacaoRequestSchema,
  createContaBancariaRequestSchema: () => createContaBancariaRequestSchema2,
  createTransacaoAnexoRequestSchema: () => createTransacaoAnexoRequestSchema,
  createTransacaoAnexoResponseSchema: () => createTransacaoAnexoResponseSchema,
  createTransacaoFlexRequestSchema: () => createTransacaoFlexRequestSchema,
  createTransacaoGrupoRequestSchema: () => createTransacaoGrupoRequestSchema,
  createTransacaoRequestSchema: () => createTransacaoRequestSchema,
  createTransacoesBatchRequestSchema: () => createTransacoesBatchRequestSchema,
  criarTransacaoDeConciliacaoResponseSchema: () => criarTransacaoDeConciliacaoResponseSchema,
  deleteCategoriaResponseSchema: () => deleteCategoriaResponseSchema,
  deleteCentroCustoResponseSchema: () => deleteCentroCustoResponseSchema,
  deleteConciliacaoResponseSchema: () => deleteConciliacaoResponseSchema,
  deleteContaBancariaResponseSchema: () => deleteContaBancariaResponseSchema,
  deleteTransacaoAnexoResponseSchema: () => deleteTransacaoAnexoResponseSchema,
  deleteTransacaoGrupoResponseSchema: () => deleteTransacaoGrupoResponseSchema,
  deleteTransacaoResponseSchema: () => deleteTransacaoResponseSchema,
  desativarTransacaoGrupoResponseSchema: () => desativarTransacaoGrupoResponseSchema,
  financeiroDreItemSchema: () => financeiroDreItemSchema,
  financeiroDreResponseSchema: () => financeiroDreResponseSchema,
  financeiroFluxoCaixaItemSchema: () => financeiroFluxoCaixaItemSchema,
  financeiroFluxoCaixaResponseSchema: () => financeiroFluxoCaixaResponseSchema,
  financeiroResumoItemSchema: () => financeiroResumoItemSchema,
  financeiroResumoResponseSchema: () => financeiroResumoResponseSchema,
  generateTransacaoAnexoUploadUrlSchema: () => generateTransacaoAnexoUploadUrlSchema,
  itemConciliacaoSchema: () => itemConciliacaoSchema,
  marcarTransacoesComoPagasResponseSchema: () => marcarTransacoesComoPagasResponseSchema,
  periodicidadeEnum: () => periodicidadeEnum,
  queryContasBancariasSchema: () => queryContasBancariasSchema,
  queryDreSchema: () => queryDreSchema,
  queryFluxoCaixaContaSchema: () => queryFluxoCaixaContaSchema,
  queryFluxoCaixaSchema: () => queryFluxoCaixaSchema,
  queryRelatorioAnualSchema: () => queryRelatorioAnualSchema,
  queryRelatorioPorCategoriaSchema: () => queryRelatorioPorCategoriaSchema,
  queryResumoSchema: () => queryResumoSchema,
  queryTransacoesSchema: () => queryTransacoesSchema,
  saldoTotalResponseSchema: () => saldoTotalResponseSchema,
  statusTransacaoEnum: () => statusTransacaoEnum,
  tipoCategoriaEnum: () => tipoCategoriaEnum,
  tipoGrupoEnum: () => tipoGrupoEnum,
  tipoTransacaoEnum: () => tipoTransacaoEnum,
  transacaoAnexoAccessUrlResponseSchema: () => transacaoAnexoAccessUrlResponseSchema,
  transacaoAnexoResponseSchema: () => transacaoAnexoResponseSchema,
  transacaoAnexoSchema: () => transacaoAnexoSchema,
  transacaoAnexoUploadUrlResponseSchema: () => transacaoAnexoUploadUrlResponseSchema,
  transacaoAnexosResponseSchema: () => transacaoAnexosResponseSchema,
  transacaoGrupoEmbeddedSchema: () => transacaoGrupoEmbeddedSchema,
  transacaoGrupoResponseSchema: () => transacaoGrupoResponseSchema,
  transacaoGrupoSchema: () => transacaoGrupoSchema,
  transacaoGruposResponseSchema: () => transacaoGruposResponseSchema,
  transacaoResponseSchema: () => transacaoResponseSchema,
  transacaoSchema: () => transacaoSchema,
  transacoesMetaSchema: () => transacoesMetaSchema,
  transacoesResponseSchema: () => transacoesResponseSchema,
  transacoesResumoSchema: () => transacoesResumoSchema,
  updateCategoriaRequestSchema: () => updateCategoriaRequestSchema,
  updateCentroCustoRequestSchema: () => updateCentroCustoRequestSchema,
  updateContaBancariaRequestSchema: () => updateContaBancariaRequestSchema2,
  updateTransacaoAnexoRequestSchema: () => updateTransacaoAnexoRequestSchema,
  updateTransacaoAnexoResponseSchema: () => updateTransacaoAnexoResponseSchema,
  updateTransacaoGrupoRequestSchema: () => updateTransacaoGrupoRequestSchema,
  updateTransacaoRequestSchema: () => updateTransacaoRequestSchema
});
var tipoCategoriaEnum = z.enum(["receita", "despesa"]);
var tipoTransacaoEnum = z.enum(["entrada", "saida", "transferencia"]);
var statusTransacaoEnum = z.enum(["pendente", "pago", "vencido"]);
var tipoGrupoEnum = z.enum(["recorrente", "parcelada"]);
var periodicidadeEnum = z.enum([
  "diaria",
  "semanal",
  "quinzenal",
  "mensal",
  "bimestral",
  "trimestral",
  "semestral",
  "anual"
]);
function csvOf(item) {
  return z.preprocess((v) => {
    if (v === void 0 || v === null || v === "") return void 0;
    if (Array.isArray(v)) return v;
    if (typeof v === "string" && v.includes(",")) {
      return v.split(",").map((s) => s.trim());
    }
    return v;
  }, z.union([item, z.array(item)]));
}
z.coerce.number().int().min(0);
var createContaBancariaRequestSchema2 = z.object({
  nome: z.string(),
  numeroConta: z.string().optional(),
  agencia: z.string().optional(),
  tipoChavePix: z.string().optional(),
  chavePix: z.string().optional()
});
var updateContaBancariaRequestSchema2 = createContaBancariaRequestSchema2.partial();
var createCategoriaRequestSchema = z.object({
  nome: z.string(),
  tipo: tipoCategoriaEnum,
  descricao: z.string().optional()
});
var updateCategoriaRequestSchema = z.object({
  nome: z.string().optional(),
  tipo: tipoCategoriaEnum.optional(),
  descricao: z.string().optional(),
  ativa: z.boolean().optional()
});
var createCentroCustoRequestSchema = z.object({
  nome: z.string(),
  descricao: z.string().optional()
});
var updateCentroCustoRequestSchema = createCentroCustoRequestSchema.extend({
  ativo: z.boolean().optional()
});
var createTransacaoRequestSchema = z.object({
  tipo: tipoTransacaoEnum,
  descricao: z.string(),
  valor: z.coerce.number().int(),
  dataVencimento: z.string(),
  dataPagamento: z.string().optional(),
  contaId: z.string().optional(),
  contaDestinoId: z.string().optional(),
  categoriaId: z.string().optional(),
  centroCustoId: z.string().optional(),
  clienteId: z.number().int().optional(),
  fornecedorId: z.number().int().optional(),
  observacoes: z.string().optional()
});
var updateTransacaoRequestSchema = createTransacaoRequestSchema.extend(
  {
    status: statusTransacaoEnum.optional()
  }
);
var createTransacoesBatchRequestSchema = z.object({
  transacoes: z.array(createTransacaoRequestSchema)
});
var createTransacaoFlexRequestSchema = z.object({
  tipoGrupo: tipoGrupoEnum.optional(),
  tipo: tipoTransacaoEnum.optional(),
  descricao: z.string(),
  valor: z.coerce.number().int(),
  dataVencimento: z.string(),
  dataPagamento: z.string().optional(),
  tipoTransacao: tipoTransacaoEnum.optional(),
  periodicidade: periodicidadeEnum.optional(),
  dataFim: z.string().optional(),
  totalParcelas: z.coerce.number().int().min(1).optional(),
  contaId: z.string().optional(),
  contaDestinoId: z.string().optional(),
  categoriaId: z.string().optional(),
  centroCustoId: z.string().optional(),
  clienteId: z.number().int().optional(),
  fornecedorId: z.number().int().optional(),
  observacoes: z.string().optional()
});
var createTransacaoGrupoRequestSchema = z.object({
  tipo: tipoGrupoEnum,
  descricao: z.string(),
  valor: z.coerce.number().int(),
  tipoTransacao: tipoTransacaoEnum,
  periodicidade: periodicidadeEnum,
  dataVencimento: z.string(),
  dataFim: z.string().optional(),
  totalParcelas: z.coerce.number().int().min(1).optional(),
  contaId: z.string().optional(),
  contaDestinoId: z.string().optional(),
  categoriaId: z.string().optional(),
  centroCustoId: z.string().optional(),
  clienteId: z.number().int().optional(),
  fornecedorId: z.number().int().optional(),
  observacoes: z.string().optional()
});
var updateTransacaoGrupoRequestSchema = createTransacaoGrupoRequestSchema.extend({
  ativa: z.boolean().optional()
});
var itemConciliacaoSchema = z.object({
  data: z.string(),
  descricao: z.string(),
  valor: z.coerce.number().int(),
  tipo: z.enum(["entrada", "saida"]),
  dadosOriginais: z.any().optional()
});
var createConciliacaoRequestSchema = z.object({
  contaId: z.string(),
  nomeArquivo: z.string(),
  tipoArquivo: z.enum(["OFX", "CSV", "XLS", "XLSX"]),
  arquivoUrl: z.string().url().optional(),
  itens: z.array(itemConciliacaoSchema),
  dadosArquivo: z.any().optional()
});
var conciliarItemRequestSchema = z.object({
  categoriaId: z.string().optional(),
  centroCustoId: z.string().optional(),
  clienteId: z.number().int().optional(),
  fornecedorId: z.number().int().optional(),
  observacoes: z.string().optional()
});
var conciliarTransferenciaRequestSchema = z.object({
  itemOrigemId: z.string().min(1),
  itemDestinoId: z.string().min(1),
  conciliacaoOrigemId: z.string().min(1),
  conciliacaoDestinoId: z.string().min(1),
  dadosAdicionais: conciliarItemRequestSchema.optional()
});
var queryContasBancariasSchema = z.object({
  dataSaldo: z.string().optional(),
  dataInicio: z.string().optional(),
  dataFim: z.string().optional()
});
var queryTransacoesSchema = z.object({
  tipo: csvOf(tipoTransacaoEnum).optional(),
  status: csvOf(statusTransacaoEnum).optional(),
  contaId: csvOf(z.string()).optional(),
  categoriaId: csvOf(z.string()).optional(),
  centroCustoId: csvOf(z.string()).optional(),
  clienteId: z.coerce.number().int().optional(),
  fornecedorId: z.coerce.number().int().optional(),
  dataInicio: z.string().optional(),
  dataFim: z.string().optional(),
  mes: z.coerce.number().int().min(1).optional(),
  ano: z.coerce.number().int().min(2e3).optional(),
  page: z.coerce.number().int().min(1).optional(),
  limit: z.coerce.number().int().min(1).optional(),
  search: z.string().optional()
});
var queryResumoSchema = z.object({
  dataInicio: z.string().optional(),
  dataFim: z.string().optional(),
  mes: z.coerce.number().int().min(1).optional(),
  ano: z.coerce.number().int().min(2e3).optional()
});
var queryFluxoCaixaSchema = z.object({
  dataInicio: z.string().optional(),
  dataFim: z.string().optional(),
  agrupamento: z.enum(["dia", "semana", "mes", "ano"]).optional(),
  contaId: z.string().optional()
});
var queryFluxoCaixaContaSchema = z.object({
  mes: z.coerce.number().int().min(1),
  ano: z.coerce.number().int().min(2e3)
});
var queryRelatorioAnualSchema = z.object({
  ano: z.coerce.number().int().min(2e3),
  visao: z.enum(["realizada", "realizado-previsto"]).optional()
});
var queryRelatorioPorCategoriaSchema = z.object({
  dataInicio: z.string().optional(),
  dataFim: z.string().optional(),
  ano: z.coerce.number().int().min(2e3).optional()
});
var queryDreSchema = z.object({
  dataInicio: z.string().optional(),
  dataFim: z.string().optional(),
  mes: z.coerce.number().int().min(1).optional(),
  ano: z.coerce.number().int().min(2e3).optional(),
  visao: z.enum(["realizada", "prevista"]).optional()
});
var contaBancariaSchema = z.object({
  id: z.string(),
  nome: z.string(),
  dashboardId: z.number(),
  createdAt: z.string(),
  updatedAt: z.string(),
  numeroConta: z.string().nullable().optional(),
  agencia: z.string().nullable().optional(),
  tipoChavePix: z.enum(["CPF", "CNPJ", "Email", "Telefone", "Aleatoria"]).nullable().optional(),
  chavePix: z.string().nullable().optional(),
  saldoAtual: z.number().optional(),
  saldoProjetado: z.number().optional()
});
var contasBancariasResponseSchema = listResponse(contaBancariaSchema);
var contaBancariaResponseSchema = dataResponse(contaBancariaSchema);
var saldoTotalResponseSchema = dataResponse(
  z.object({
    saldoAtual: z.number(),
    saldoProjetado: z.number()
  })
);
var contaRefSchema = z.object({ id: z.string(), nome: z.string() });
var categoriaRefSchema = z.object({ id: z.string(), nome: z.string() });
var centroCustoRefSchema = z.object({ id: z.string(), nome: z.string() });
var transacaoGrupoEmbeddedSchema = z.object({
  id: z.string(),
  descricao: z.string(),
  tipo: tipoGrupoEnum,
  tipoTransacao: z.enum(["entrada", "saida"]),
  totalParcelas: z.number().nullable().optional(),
  periodicidade: periodicidadeEnum,
  ativa: z.boolean().nullable().optional(),
  dataVencimento: z.string(),
  valor: z.number()
});
var transacaoSchema = z.object({
  id: z.string(),
  numeroSequencial: z.string().optional(),
  tipo: tipoTransacaoEnum,
  descricao: z.string(),
  valor: z.number(),
  dataVencimento: z.string().nullable().optional(),
  dataPagamento: z.string().nullable().optional(),
  status: statusTransacaoEnum,
  observacoes: z.string().nullable().optional(),
  conta: contaRefSchema.nullable().optional(),
  contaDestino: contaRefSchema.nullable().optional(),
  categoria: categoriaRefSchema.nullable().optional(),
  centroCusto: centroCustoRefSchema.nullable().optional(),
  grupo: z.union([z.string(), transacaoGrupoEmbeddedSchema]).nullable().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional()
});
var transacoesMetaSchema = z.object({
  page: z.number(),
  limit: z.number(),
  total: z.number(),
  totalPages: z.number()
});
var transacoesResumoSchema = z.object({
  saldoAnterior: z.number(),
  entradaPrevista: z.number(),
  entradaRealizada: z.number(),
  saidaPrevista: z.number(),
  saidaRealizada: z.number(),
  saldoPrevistoPeriodo: z.number().optional(),
  saldoRealizadoPeriodo: z.number().optional(),
  entradaPrevistaAcumulada: z.number().optional(),
  entradaRealizadaAcumulada: z.number().optional(),
  saidaPrevistaAcumulada: z.number().optional(),
  saidaRealizadaAcumulada: z.number().optional(),
  saldoAtual: z.number().optional(),
  saldoPrevistoAcumulado: z.number().optional()
});
var transacoesResponseSchema = listResponse(transacaoSchema).extend({
  resumo: transacoesResumoSchema.optional(),
  meta: transacoesMetaSchema.optional()
});
var transacaoResponseSchema = dataResponse(transacaoSchema);
var deleteTransacaoResponseSchema = messageResponseSchema;
var categoriaSchema = z.object({
  id: z.string(),
  nome: z.string(),
  tipo: tipoCategoriaEnum,
  descricao: z.string().nullable().optional(),
  ativa: z.boolean(),
  dashboardId: z.number(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var categoriasResponseSchema = listResponse(categoriaSchema);
var categoriaResponseSchema = dataResponse(categoriaSchema);
var centroCustoSchema = z.object({
  id: z.string(),
  nome: z.string(),
  descricao: z.string().nullable().optional(),
  ativo: z.boolean(),
  dashboardId: z.number(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var centrosCustoResponseSchema = listResponse(centroCustoSchema);
var centroCustoResponseSchema = dataResponse(centroCustoSchema);
var transacaoGrupoSchema = z.object({
  id: z.string(),
  tipo: tipoGrupoEnum,
  descricao: z.string(),
  valor: z.number(),
  tipoTransacao: z.enum(["entrada", "saida"]),
  periodicidade: periodicidadeEnum,
  dataVencimento: z.string(),
  dataFim: z.string().nullable().optional(),
  totalParcelas: z.number().nullable().optional(),
  ativa: z.boolean().nullable().optional(),
  removerProximasAoDesativar: z.boolean().nullable().optional(),
  conta: contaRefSchema.nullable().optional(),
  categoria: categoriaRefSchema.nullable().optional(),
  centroCusto: centroCustoRefSchema.nullable().optional(),
  totalTransacoes: z.number().optional(),
  transacoesPagas: z.number().optional(),
  transacoesPendentes: z.number().optional(),
  parcelas: z.array(transacaoSchema).optional(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var transacaoGrupoResponseSchema = dataResponse(transacaoGrupoSchema);
var transacaoGruposResponseSchema = listResponse(transacaoGrupoSchema);
var desativarTransacaoGrupoResponseSchema = z.object({
  success: z.boolean(),
  data: transacaoGrupoSchema,
  transacoesRemovidas: z.number().optional(),
  message: z.string().optional()
});
var deleteTransacaoGrupoResponseSchema = messageResponseSchema;
var conciliacaoStatusEnum = z.enum(["pendente", "parcial", "concluida"]);
var conciliacaoItemTransacaoRefSchema = z.object({
  id: z.string(),
  descricao: z.string(),
  valor: z.number(),
  tipo: z.string(),
  dataPagamento: z.string().nullable().optional(),
  status: z.string().optional()
});
var conciliacaoItemDetalheSchema = z.object({
  id: z.string(),
  conciliacaoId: z.string(),
  data: z.string(),
  descricao: z.string(),
  valor: z.number(),
  tipo: z.enum(["entrada", "saida"]),
  transacaoId: z.string().nullable(),
  dadosOriginais: z.any().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
  transacao: conciliacaoItemTransacaoRefSchema.nullable().optional()
});
var conciliacaoBancariaSchema = z.object({
  id: z.string(),
  dashboardId: z.number(),
  contaId: z.string(),
  nomeArquivo: z.string(),
  tipoArquivo: z.string(),
  arquivoUrl: z.string().nullable().optional(),
  dataUpload: z.string(),
  dadosArquivo: z.any().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
  conta: contaRefSchema.optional(),
  itens: z.array(conciliacaoItemDetalheSchema).optional(),
  totalItens: z.number().optional(),
  itensConciliados: z.number().optional(),
  itensPendentes: z.number().optional(),
  status: z.union([conciliacaoStatusEnum, z.string()]).optional()
});
var conciliacoesResponseSchema = listResponse(conciliacaoBancariaSchema);
var conciliacaoResponseSchema = dataResponse(conciliacaoBancariaSchema);
var conciliacaoItemResponseSchema = dataResponse(conciliacaoItemDetalheSchema);
var criarTransacaoDeConciliacaoResponseSchema = dataResponse(
  z.object({
    transacao: transacaoSchema,
    item: conciliacaoItemDetalheSchema
  })
);
var conciliarTransferenciaResponseSchema = dataResponse(
  z.object({
    transacao: z.any(),
    itemOrigem: z.any(),
    itemDestino: z.any(),
    observacao: z.string().optional()
  })
);
var deleteConciliacaoResponseSchema = messageResponseSchema;
var financeiroResumoItemSchema = z.object({
  receitas: z.number().catch(0),
  despesas: z.number().catch(0),
  saldo: z.number().catch(0)
});
var financeiroResumoResponseSchema = dataResponse(
  z.object({
    periodo: z.object({
      inicio: z.string().optional(),
      fim: z.string().optional()
    }).optional(),
    realizado: financeiroResumoItemSchema.optional(),
    previsto: financeiroResumoItemSchema.optional()
  })
);
var financeiroFluxoCaixaItemSchema = z.object({
  periodo: z.string(),
  entradas: z.number(),
  saidas: z.number(),
  saldo: z.number()
});
var financeiroFluxoCaixaResponseSchema = dataResponse(
  z.array(financeiroFluxoCaixaItemSchema)
);
var financeiroDreItemSchema = z.object({
  categoria: z.string(),
  valor: z.number(),
  tipo: tipoCategoriaEnum.optional()
});
var financeiroDreResponseSchema = dataResponse(
  z.object({
    receitas: z.array(financeiroDreItemSchema).catch([]),
    despesas: z.array(financeiroDreItemSchema).catch([]),
    resultado: z.number().catch(0)
  })
);
var transacaoAnexoSchema = z.object({
  id: z.number(),
  transacaoId: z.string(),
  titulo: z.string(),
  url: z.string(),
  size: z.string(),
  mimeType: z.string(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var transacaoAnexosResponseSchema = listResponse(transacaoAnexoSchema);
var transacaoAnexoResponseSchema = dataResponse(transacaoAnexoSchema);
var createTransacaoAnexoResponseSchema = dataResponse(transacaoAnexoSchema);
var updateTransacaoAnexoResponseSchema = dataResponse(transacaoAnexoSchema);
var deleteTransacaoAnexoResponseSchema = messageResponseSchema;
var deleteContaBancariaResponseSchema = messageResponseSchema;
var deleteCentroCustoResponseSchema = messageResponseSchema;
var deleteCategoriaResponseSchema = messageResponseSchema;
var marcarTransacoesComoPagasResponseSchema = messageResponseSchema;
var transacaoAnexoUploadUrlResponseSchema = dataResponse(uploadUrlDataSchema);
var transacaoAnexoAccessUrlResponseSchema = dataResponse(accessUrlDataSchema);
var createTransacaoAnexoRequestSchema = createAnexoMetadataSchema;
var updateTransacaoAnexoRequestSchema = updateAnexoMetadataSchema;
var generateTransacaoAnexoUploadUrlSchema = generateAnexoUploadUrlSchema;

// src/conversas/index.ts
var conversas_exports = {};
__export(conversas_exports, {
  addChannelInstanceTeamMemberRequestSchema: () => addChannelInstanceTeamMemberRequestSchema,
  addChannelInstanceTeamMemberResponseSchema: () => addChannelInstanceTeamMemberResponseSchema,
  addLabelToConversationRequestSchema: () => addLabelToConversationRequestSchema,
  assignResponsavelSchema: () => assignResponsavelSchema,
  assignmentActionEnum: () => assignmentActionEnum,
  assignmentHistoryItemSchema: () => assignmentHistoryItemSchema,
  assignmentHistoryResponseSchema: () => assignmentHistoryResponseSchema,
  blockConversationContactSchema: () => blockConversationContactSchema,
  cannedResponseDetailResponseSchema: () => cannedResponseDetailResponseSchema,
  cannedResponseSchema: () => cannedResponseSchema,
  cannedResponsesResponseSchema: () => cannedResponsesResponseSchema,
  channelEnum: () => channelEnum,
  channelInstanceFiltersSchema: () => channelInstanceFiltersSchema,
  channelInstanceListItemSchema: () => channelInstanceListItemSchema,
  channelInstanceListResponseSchema: () => channelInstanceListResponseSchema,
  channelInstanceResponseSchema: () => channelInstanceResponseSchema,
  channelInstanceSchema: () => channelInstanceSchema,
  channelInstanceTeamMemberSchema: () => channelInstanceTeamMemberSchema,
  channelInstanceTeamResponseSchema: () => channelInstanceTeamResponseSchema,
  channelInstanceTeamUsuarioSchema: () => channelInstanceTeamUsuarioSchema,
  channelInstancesResponseSchema: () => channelInstancesResponseSchema,
  conversaChannelInstanceSchema: () => conversaChannelInstanceSchema,
  conversaContatoSchema: () => conversaContatoSchema,
  conversaListItemSchema: () => conversaListItemSchema,
  conversaResponsavelSchema: () => conversaResponsavelSchema,
  conversaResponseSchema: () => conversaResponseSchema,
  conversaSchema: () => conversaSchema,
  conversaWhatsappInstanceSchema: () => conversaWhatsappInstanceSchema,
  conversaWithMessagesResponseSchema: () => conversaWithMessagesResponseSchema,
  conversasResponseSchema: () => conversasResponseSchema,
  conversationFiltersSchema: () => conversationFiltersSchema,
  conversationLabelSchema: () => conversationLabelSchema,
  conversationLabelsResponseSchema: () => conversationLabelsResponseSchema,
  conversationStatusEnum: () => conversationStatusEnum,
  conversationToLabelSchema: () => conversationToLabelSchema,
  createCannedResponseCategoryRequestSchema: () => createCannedResponseCategoryRequestSchema,
  createCannedResponseSchema: () => createCannedResponseSchema,
  createChannelInstanceSchema: () => createChannelInstanceSchema,
  createContactSchema: () => createContactSchema,
  createConversationLabelSchema: () => createConversationLabelSchema,
  createConversationSchema: () => createConversationSchema,
  createNoteSchema: () => createNoteSchema,
  crmBlockContactResponseSchema: () => crmBlockContactResponseSchema,
  crmBlockContactResultSchema: () => crmBlockContactResultSchema,
  deleteMessageSchema: () => deleteMessageSchema,
  labelResponseSchema: () => labelResponseSchema,
  labelSchema: () => labelSchema,
  labelsResponseSchema: () => labelsResponseSchema,
  lastMessageSchema: () => lastMessageSchema,
  mensagemDetailSchema: () => mensagemDetailSchema,
  mensagemSchema: () => mensagemSchema,
  mensagensResponseSchema: () => mensagensResponseSchema,
  messagePaginationSchema: () => messagePaginationSchema,
  messageStatusEnum: () => messageStatusEnum,
  messageTypeEnum: () => messageTypeEnum,
  messagingWindowStatusResponseSchema: () => messagingWindowStatusResponseSchema,
  messagingWindowStatusSchema: () => messagingWindowStatusSchema,
  notaResponseSchema: () => notaResponseSchema,
  notaSchema: () => notaSchema,
  notasResponseSchema: () => notasResponseSchema,
  providerEnum: () => providerEnum,
  queryCannedResponseSchema: () => queryCannedResponseSchema,
  queryConversationLabelSchema: () => queryConversationLabelSchema,
  removeChannelInstanceTeamMemberResponseSchema: () => removeChannelInstanceTeamMemberResponseSchema,
  removeResponsibleSchema: () => removeResponsibleSchema,
  sendMessageSchema: () => sendMessageSchema,
  startConversationSchema: () => startConversationSchema,
  successResponseSchema: () => successResponseSchema2,
  transferConversationSchema: () => transferConversationSchema,
  unblockConversationContactSchema: () => unblockConversationContactSchema,
  updateCannedResponseSchema: () => updateCannedResponseSchema,
  updateChannelInstanceSchema: () => updateChannelInstanceSchema,
  updateContactSchema: () => updateContactSchema,
  updateConversationLabelSchema: () => updateConversationLabelSchema,
  updateConversationSchema: () => updateConversationSchema,
  updateConversationStatusSchema: () => updateConversationStatusSchema,
  updateMessageSchema: () => updateMessageSchema,
  updateNoteSchema: () => updateNoteSchema
});
var conversationStatusEnum = z.enum([
  "EM_ABERTO",
  "PENDENTE",
  "CONCLUIDA"
]);
var messageTypeEnum = z.enum([
  "TEXT",
  "IMAGE",
  "VIDEO",
  "AUDIO",
  "DOCUMENT",
  "STICKER",
  "LOCATION",
  "CONTACT",
  "BUTTONS",
  "LIST",
  "POLL",
  "REACTION",
  "TEMPLATE",
  "PTV",
  "STATUS",
  "SYSTEM"
]);
var channelEnum = z.enum(["WHATSAPP", "INSTAGRAM", "CHAT_ONLINE"]);
var providerEnum = z.enum(["EVOLUTION_GO", "META_CLOUD"]);
var optionalInt = z.preprocess(
  (v) => v === "" || v === void 0 || v === null ? void 0 : v,
  z.coerce.number().int().optional()
);
var optionalQueryBool = z.preprocess((v) => {
  if (v === "true" || v === true || v === 1 || v === "1") return true;
  if (v === "false" || v === false || v === 0 || v === "0") return false;
  return void 0;
}, z.boolean().optional());
var createConversationSchema = z.object({
  channelInstanceId: z.number().int(),
  contactId: z.number().int(),
  responsavelId: z.number().int().optional()
});
var updateConversationSchema = z.object({
  status: conversationStatusEnum.optional(),
  responsavelId: z.number().int().optional(),
  isArchived: z.boolean().optional()
});
var updateConversationStatusSchema = z.object({
  status: conversationStatusEnum
});
var transferConversationSchema = z.object({
  newResponsavelId: z.number().int(),
  observacao: z.string().optional(),
  notificarNovoResponsavel: z.boolean().optional(),
  notificarAnteriorResponsavel: z.boolean().optional()
});
var removeResponsibleSchema = z.object({
  observacao: z.string().optional()
});
var conversationFiltersSchema = z.object({
  channelInstanceId: optionalInt,
  status: conversationStatusEnum.optional(),
  unreadOnly: optionalQueryBool,
  isOpen: optionalQueryBool,
  isFinished: optionalQueryBool,
  responsavelId: optionalInt,
  /** Quando true, filtra conversas sem responsável (`responsavelId` null). */
  semResponsavel: optionalQueryBool,
  isArchived: optionalQueryBool,
  labelId: optionalInt,
  contactId: optionalInt,
  search: z.string().optional(),
  page: optionalInt,
  limit: optionalInt
});
var sendMessageSchema = z.object({
  channelInstanceId: z.number().int(),
  conversationId: z.string(),
  type: messageTypeEnum,
  content: z.string().optional(),
  mediaUrl: z.string().optional(),
  mediaType: z.string().optional(),
  fileName: z.string().optional(),
  repliedToMessageId: z.string().optional(),
  linkUrl: z.string().optional(),
  linkTitle: z.string().optional(),
  linkDescription: z.string().optional(),
  linkImgUrl: z.string().optional(),
  reactedToMessageId: z.string().optional(),
  reactionEmoji: z.string().optional(),
  pollMaxAnswer: z.number().int().optional(),
  /** Metadados de listing compartilhado no chat (automações). */
  listingKind: z.enum(["imovel", "empreendimento"]).optional(),
  imovelId: z.number().int().optional(),
  empreendimentoId: z.number().int().optional()
});
var startConversationSchema = z.object({
  channelInstanceId: z.number().int(),
  phone: z.string(),
  type: messageTypeEnum,
  content: z.string(),
  contactName: z.string().optional(),
  responsavelId: z.number().int().optional()
});
var messagePaginationSchema = z.object({
  page: optionalInt,
  limit: optionalInt,
  search: z.string().optional()
});
var updateMessageSchema = z.object({
  content: z.string()
});
var deleteMessageSchema = z.object({
  forEveryone: z.boolean().optional()
});
var createChannelInstanceSchema = z.object({
  channel: channelEnum,
  provider: providerEnum,
  nome: z.string().optional(),
  descricao: z.string().optional(),
  whatsappInstanceId: z.number().int().optional(),
  isDefault: z.boolean().optional()
});
var updateChannelInstanceSchema = z.object({
  nome: z.string().optional(),
  descricao: z.string().optional(),
  ativo: z.boolean().optional(),
  isDefault: z.boolean().optional()
});
var channelInstanceFiltersSchema = z.object({
  channel: channelEnum.optional(),
  provider: providerEnum.optional(),
  ativo: optionalQueryBool
});
var createContactSchema = z.object({
  phone: z.string().optional(),
  email: z.string().email().optional(),
  name: z.string().optional(),
  avatar: z.string().optional()
});
var updateContactSchema = z.object({
  name: z.string().optional(),
  avatar: z.string().optional(),
  email: z.string().email().optional(),
  /** Bloqueio de segurança no CRM (espelha Contato.bloqueado). */
  isBlocked: z.boolean().optional(),
  /** Motivo opcional ao bloquear. */
  blockReason: z.string().max(500).optional().nullable()
});
var blockConversationContactSchema = z.object({
  motivo: z.string().max(500).optional().nullable(),
  /**
   * Quando true e a conversa for Meta Cloud, também tenta block_users na Graph API.
   * Default true. Falha na Meta não desfaz o bloqueio no CRM.
   */
  alsoBlockOnMeta: z.boolean().optional()
});
var unblockConversationContactSchema = z.object({
  /**
   * Quando true e a conversa for Meta Cloud, também tenta unblock na Graph API.
   * Default true. Falha na Meta não desfaz o desbloqueio no CRM.
   */
  alsoUnblockOnMeta: z.boolean().optional()
});
var crmBlockContactResultSchema = z.object({
  contactId: z.number(),
  bloqueado: z.boolean(),
  bloqueadoEm: z.string().nullable().optional(),
  bloqueadoPorId: z.number().nullable().optional(),
  bloqueadoMotivo: z.string().nullable().optional(),
  meta: z.object({
    attempted: z.boolean(),
    success: z.boolean().optional(),
    error: z.string().optional(),
    waId: z.string().nullable().optional()
  }).optional()
});
var crmBlockContactResponseSchema = dataResponse(
  crmBlockContactResultSchema
);
var createNoteSchema = z.object({
  conteudo: z.string().min(1)
});
var updateNoteSchema = z.object({
  conteudo: z.string().min(1)
});
var createCannedResponseSchema = z.object({
  conteudo: z.string(),
  atalho: z.string(),
  ativo: z.boolean().optional()
});
var updateCannedResponseSchema = z.object({
  conteudo: z.string().optional(),
  atalho: z.string().optional(),
  ativo: z.boolean().optional()
});
var queryCannedResponseSchema = z.object({
  search: z.string().optional(),
  ativo: optionalQueryBool,
  page: z.coerce.number().int().min(1).optional(),
  limit: z.coerce.number().int().min(1).optional()
});
var createConversationLabelSchema = z.object({
  nome: z.string(),
  descricao: z.string().optional(),
  cor: z.string().optional()
});
var updateConversationLabelSchema = z.object({
  nome: z.string().optional(),
  descricao: z.string().optional(),
  cor: z.string().optional()
});
var queryConversationLabelSchema = z.object({
  search: z.string().optional(),
  page: z.coerce.number().int().min(1).optional(),
  limit: z.coerce.number().int().min(1).optional()
});
var messageStatusEnum = z.enum([
  "ENVIADA",
  "ENTREGUE",
  "LIDA",
  "FALHOU",
  "RECEBIDA",
  "PENDING",
  "ENVIANDO"
]);
var assignmentActionEnum = z.enum([
  "ATRIBUIDO",
  "REMOVIDO",
  "TRANSFERIDO"
]);
var jsonPayloadSchema = z.record(z.string(), z.unknown());
var conversaContatoSchema = z.object({
  id: z.number(),
  dashboardId: z.number(),
  naturezaJuridica: z.string().nullable().optional(),
  foto: z.string().nullable().optional(),
  nome: z.string(),
  sobrenome: z.string().nullable().optional(),
  numeroCpf: z.string().nullable().optional(),
  numeroRg: z.string().nullable().optional(),
  emissaoRg: z.string().nullable().optional(),
  numeroCnh: z.string().nullable().optional(),
  emissaoCnh: z.string().nullable().optional(),
  profissao: z.string().nullable().optional(),
  tituloEleitor: z.string().nullable().optional(),
  dataNascimento: z.string().nullable().optional(),
  cidadeNascimento: z.string().nullable().optional(),
  nomeMae: z.string().nullable().optional(),
  nomePai: z.string().nullable().optional(),
  estadoCivil: z.string().nullable().optional(),
  inscricaoEstadual: z.string().nullable().optional(),
  cnpj: z.string().nullable().optional(),
  nomeFantasia: z.string().nullable().optional(),
  razaoSocial: z.string().nullable().optional(),
  estrangeiro: z.boolean().optional(),
  renda: z.union([z.string(), z.number()]).nullable().optional(),
  informacoesAdicionais: z.string().nullable().optional(),
  email: z.string().nullable().optional(),
  telefone: z.string().nullable().optional(),
  /** WhatsApp LID (ex: 123234343434@lid) — identificador alternativo do Evolution Go */
  lid: z.string().nullable().optional(),
  emailSecundario: z.string().nullable().optional(),
  telefoneSecundario: z.string().nullable().optional(),
  /** Bloqueio de segurança no CRM (não é opt-out de marketing). */
  bloqueado: z.boolean().optional(),
  bloqueadoEm: z.string().nullable().optional(),
  bloqueadoPorId: z.number().nullable().optional(),
  bloqueadoMotivo: z.string().nullable().optional(),
  cep: z.union([z.string(), z.number()]).nullable().optional(),
  rua: z.string().nullable().optional(),
  numero: z.string().nullable().optional(),
  bairro: z.string().nullable().optional(),
  cidade: z.string().nullable().optional(),
  uf: z.string().nullable().optional(),
  complemento: z.string().nullable().optional(),
  adicionadoPorId: z.number().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var conversaResponsavelSchema = z.object({
  id: z.number(),
  nome: z.string(),
  sobrenome: z.string().nullable().optional(),
  email: z.string().nullable().optional(),
  image: z.string().nullable().optional()
});
var conversaWhatsappInstanceSchema = z.object({
  id: z.number(),
  uuid: z.string(),
  dashboardId: z.number(),
  provider: z.string(),
  instanceName: z.string(),
  instanceId: z.string().nullable().optional(),
  apikey: z.string().nullable().optional(),
  token: z.string().nullable().optional(),
  connectionState: z.string(),
  integration: z.string().nullable().optional(),
  number: z.string().nullable().optional(),
  settings: jsonPayloadSchema.nullable().optional(),
  webhook: jsonPayloadSchema.nullable().optional(),
  config: jsonPayloadSchema.nullable().optional(),
  nome: z.string().nullable().optional(),
  descricao: z.string().nullable().optional(),
  isDefault: z.boolean(),
  connectedAt: z.string().nullable().optional(),
  lastSyncAt: z.string().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var conversaChannelInstanceSchema = z.object({
  id: z.number(),
  uuid: z.string(),
  dashboardId: z.number(),
  whatsappInstanceId: z.number().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
  whatsappInstance: conversaWhatsappInstanceSchema.nullable().optional()
});
var mensagemDetailSchema = z.object({
  id: z.string(),
  uuid: z.string().optional(),
  dashboardId: z.number().optional(),
  conversationId: z.string(),
  channelInstanceId: z.number().optional(),
  enviadoPorId: z.number().nullable().optional(),
  providerMessageId: z.string().nullable().optional(),
  providerKey: z.string().nullable().optional(),
  type: messageTypeEnum,
  content: z.string().nullable().optional(),
  mediaUrl: z.string().nullable().optional(),
  mediaType: z.string().nullable().optional(),
  fileName: z.string().nullable().optional(),
  fileSize: z.number().nullable().optional(),
  status: messageStatusEnum,
  fromMe: z.boolean(),
  timestamp: z.string(),
  repliedToMessageId: z.string().nullable().optional(),
  rawData: jsonPayloadSchema.nullable().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
  enviadoPor: conversaResponsavelSchema.nullable().optional()
});
var lastMessageSchema = mensagemDetailSchema.omit({ conversationId: true }).extend({
  conversationId: z.string().optional()
});
var labelSchema = z.object({
  id: z.number(),
  uuid: z.string().optional(),
  dashboardId: z.number(),
  nome: z.string(),
  descricao: z.string().nullable().optional(),
  cor: z.string().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
  _count: z.object({ conversations: z.number() }).optional()
});
var conversationToLabelSchema = z.object({
  id: z.number(),
  conversationId: z.string(),
  labelId: z.number(),
  adicionadoPorId: z.number().optional(),
  createdAt: z.string().optional(),
  label: labelSchema,
  adicionadoPor: conversaResponsavelSchema.nullable().optional()
});
var conversaListItemSchema = z.object({
  id: z.string(),
  uuid: z.string(),
  dashboardId: z.number(),
  channelInstanceId: z.number(),
  contactId: z.number(),
  responsavelId: z.number().nullable().optional(),
  responsavelAtribuidoEm: z.string().nullable().optional(),
  status: conversationStatusEnum,
  finalizadaEm: z.string().nullable().optional(),
  isGroup: z.boolean().optional(),
  isArchived: z.boolean(),
  isMuted: z.boolean().optional(),
  isPinned: z.boolean().optional(),
  unreadCount: z.number(),
  lastMessageAt: z.string().nullable(),
  lastMessageId: z.string().nullable().optional(),
  lastMessage: lastMessageSchema.nullable().optional(),
  metadata: jsonPayloadSchema.nullable().optional(),
  contact: conversaContatoSchema,
  channelInstance: conversaChannelInstanceSchema,
  responsavel: conversaResponsavelSchema.nullable().optional(),
  labels: z.array(conversationToLabelSchema).optional().default([]),
  createdAt: z.string(),
  updatedAt: z.string()
});
var notaSchema = z.object({
  id: z.number(),
  conversationId: z.string(),
  conteudo: z.string(),
  autorId: z.number(),
  createdAt: z.string(),
  updatedAt: z.string(),
  autor: z.object({
    id: z.number(),
    nome: z.string(),
    sobrenome: z.string().nullable(),
    image: z.string().nullable().optional(),
    email: z.string().nullable().optional()
  }).optional()
});
var cannedResponseSchema = z.object({
  id: z.number(),
  uuid: z.string().optional(),
  dashboardId: z.number(),
  conteudo: z.string(),
  atalho: z.string(),
  ativo: z.boolean(),
  usoCount: z.number().optional(),
  criadoPorId: z.number().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
  criadoPor: z.object({
    id: z.number(),
    nome: z.string(),
    sobrenome: z.string().nullable().optional()
  }).nullable().optional()
});
var channelInstanceSchema = z.object({
  id: z.number(),
  uuid: z.string(),
  dashboardId: z.number(),
  channel: channelEnum.optional(),
  provider: providerEnum.optional(),
  nome: z.string().nullable().optional(),
  descricao: z.string().nullable().optional(),
  ativo: z.boolean().optional(),
  isDefault: z.boolean().optional(),
  whatsappInstanceId: z.number().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
  whatsappInstance: conversaWhatsappInstanceSchema.nullable().optional()
});
var mensagemSchema = mensagemDetailSchema;
var conversaSchema = conversaListItemSchema.extend({
  contact: conversaContatoSchema.optional(),
  channelInstance: conversaChannelInstanceSchema.optional()
});
var notasResponseSchema = listResponse(notaSchema);
var notaResponseSchema = dataResponse(notaSchema);
var paginatedListMetaSchema = z.object({
  total: z.number(),
  page: z.number(),
  limit: z.number(),
  hasNext: z.boolean(),
  hasPrev: z.boolean(),
  timestamp: z.string().optional(),
  totalPages: z.number().optional()
});
var labelsResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(labelSchema),
  message: z.string().optional(),
  meta: paginatedListMetaSchema.optional(),
  total: z.number().optional(),
  page: z.number().optional(),
  limit: z.number().optional(),
  totalPages: z.number().optional()
});
var labelResponseSchema = dataResponse(labelSchema);
var cannedResponsesResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(cannedResponseSchema),
  message: z.string().optional(),
  meta: paginatedListMetaSchema.optional(),
  total: z.number().optional(),
  page: z.number().optional(),
  limit: z.number().optional(),
  totalPages: z.number().optional()
});
var cannedResponseDetailResponseSchema = dataResponse(cannedResponseSchema);
var channelInstancesResponseSchema = listResponse(channelInstanceSchema);
var channelInstanceResponseSchema = dataResponse(channelInstanceSchema);
var conversaResponseSchema = dataResponse(conversaSchema);
var conversasResponseSchema = z.object({
  data: z.array(conversaListItemSchema),
  total: z.number(),
  page: z.number(),
  limit: z.number(),
  totalPages: z.number()
});
var mensagensResponseSchema = z.object({
  data: z.array(mensagemSchema),
  total: z.number(),
  page: z.number(),
  limit: z.number(),
  totalPages: z.number()
});
var conversaWithMessagesResponseSchema = z.object({
  conversation: conversaSchema,
  messages: mensagensResponseSchema
});
var successResponseSchema2 = z.object({ success: z.boolean(), message: z.string().optional() });
var assignResponsavelSchema = z.object({
  responsavelId: z.number(),
  observacao: z.string().optional()
});
var addLabelToConversationRequestSchema = z.object({
  labelId: z.number()
});
var createCannedResponseCategoryRequestSchema = z.object({
  nome: z.string()
});
var assignmentHistoryItemSchema = z.object({
  id: z.number(),
  uuid: z.string().optional(),
  conversationId: z.string(),
  responsavelId: z.number().nullable().optional(),
  responsavelAnteriorId: z.number().nullable().optional(),
  acao: assignmentActionEnum,
  observacao: z.string().nullable().optional(),
  realizadoPorId: z.number(),
  createdAt: z.string(),
  responsavel: conversaResponsavelSchema.nullable().optional(),
  responsavelAnterior: conversaResponsavelSchema.nullable().optional(),
  realizadoPor: conversaResponsavelSchema.optional()
});
var assignmentHistoryResponseSchema = z.object({
  success: z.boolean().optional(),
  message: z.string().optional(),
  data: z.array(assignmentHistoryItemSchema)
});
var conversationLabelSchema = conversationToLabelSchema;
var conversationLabelsResponseSchema = z.object({
  success: z.boolean().optional(),
  message: z.string().optional(),
  data: z.array(conversationLabelSchema)
});
var channelInstanceTeamUsuarioSchema = z.object({
  id: z.number(),
  nome: z.string(),
  sobrenome: z.string().nullable(),
  email: z.string(),
  image: z.string().nullable().optional()
});
var channelInstanceTeamMemberSchema = z.object({
  id: z.number(),
  usuario: channelInstanceTeamUsuarioSchema,
  createdAt: z.string(),
  updatedAt: z.string()
});
var channelInstanceTeamResponseSchema = z.array(
  channelInstanceTeamMemberSchema
);
var addChannelInstanceTeamMemberRequestSchema = z.object({
  usuarioId: z.number()
});
var addChannelInstanceTeamMemberResponseSchema = channelInstanceTeamMemberSchema;
var removeChannelInstanceTeamMemberResponseSchema = z.object({
  success: z.boolean()
});
var channelInstanceListItemSchema = z.object({
  id: z.number(),
  uuid: z.string(),
  nome: z.string(),
  tipo: z.string(),
  instanceStatus: z.string(),
  conversationsCount: z.number(),
  provider: z.string().optional()
});
var channelInstanceListResponseSchema = z.array(
  channelInstanceListItemSchema
);
var messagingWindowStatusSchema = z.object({
  applicable: z.boolean(),
  isWithinWindow: z.boolean(),
  lastInboundMessageAt: z.string().nullable(),
  expiresAt: z.string().nullable(),
  remainingMs: z.number().nullable()
});
var messagingWindowStatusResponseSchema = dataResponse(
  messagingWindowStatusSchema
);

// src/ai-agents/index.ts
var ai_agents_exports = {};
__export(ai_agents_exports, {
  AI_AGENT_CONDICAO_DO_PRESETS: () => AI_AGENT_CONDICAO_DO_PRESETS,
  AI_AGENT_CONDICAO_WHEN_PRESETS: () => AI_AGENT_CONDICAO_WHEN_PRESETS,
  aiAgentArquivoResponseSchema: () => aiAgentArquivoResponseSchema,
  aiAgentArquivoSchema: () => aiAgentArquivoSchema,
  aiAgentArquivosResponseSchema: () => aiAgentArquivosResponseSchema,
  aiAgentCondicaoDoTypeEnum: () => aiAgentCondicaoDoTypeEnum,
  aiAgentCondicaoSchema: () => aiAgentCondicaoSchema,
  aiAgentCondicaoWhenTypeEnum: () => aiAgentCondicaoWhenTypeEnum,
  aiAgentPromptResponseSchema: () => aiAgentPromptResponseSchema,
  aiAgentPromptSchema: () => aiAgentPromptSchema,
  aiAgentPromptsResponseSchema: () => aiAgentPromptsResponseSchema,
  aiAgentResponseSchema: () => aiAgentResponseSchema,
  aiAgentSchema: () => aiAgentSchema,
  aiAgentTamanhoRespostasEnum: () => aiAgentTamanhoRespostasEnum,
  aiAgentTomVozEnum: () => aiAgentTomVozEnum,
  aiAgentWithChannelsSchema: () => aiAgentWithChannelsSchema,
  aiAgentsListResponseSchema: () => aiAgentsListResponseSchema,
  aiDescriptionImproveSchema: () => aiDescriptionImproveSchema,
  aiDescriptionStreamSchema: () => aiDescriptionStreamSchema,
  aiProviderSchema: () => aiProviderSchema,
  aiProviderTypeEnum: () => aiProviderTypeEnum,
  arquivoDiagnosticoSchema: () => arquivoDiagnosticoSchema,
  arquivosDiagnosticoResponseSchema: () => arquivosDiagnosticoResponseSchema,
  artigoExistenteBlogSchema: () => artigoExistenteBlogSchema,
  associateChannelRequestSchema: () => associateChannelRequestSchema,
  associateChannelResponseSchema: () => associateChannelResponseSchema,
  associateChannelSchema: () => associateChannelSchema,
  atualizarIsaCopilotConversaResponseSchema: () => atualizarIsaCopilotConversaResponseSchema,
  atualizarIsaCopilotConversaSchema: () => atualizarIsaCopilotConversaSchema,
  channelInstanceAIAgentSchema: () => channelInstanceAIAgentSchema,
  chatModelSchema: () => chatModelSchema,
  createAIAgentArquivoSchema: () => createAIAgentArquivoSchema,
  createAIAgentPromptRequestSchema: () => createAIAgentPromptRequestSchema,
  createAIAgentPromptSchema: () => createAIAgentPromptSchema,
  createAIAgentRequestSchema: () => createAIAgentRequestSchema,
  createAIAgentResponseSchema: () => createAIAgentResponseSchema,
  createAIAgentSchema: () => createAIAgentSchema,
  createLikeSchema: () => createLikeSchema,
  criarIsaCopilotConversaResponseSchema: () => criarIsaCopilotConversaResponseSchema,
  criarIsaCopilotConversaSchema: () => criarIsaCopilotConversaSchema,
  definirModoArtigoIsaSchema: () => definirModoArtigoIsaSchema,
  deleteAIAgentArquivoResponseSchema: () => deleteAIAgentArquivoResponseSchema,
  deleteAIAgentPromptResponseSchema: () => deleteAIAgentPromptResponseSchema,
  deleteAIAgentResponseSchema: () => deleteAIAgentResponseSchema,
  disassociateChannelResponseSchema: () => disassociateChannelResponseSchema,
  editarArtigoSchema: () => editarArtigoSchema,
  embeddingModelSchema: () => embeddingModelSchema,
  embeddingSchema: () => embeddingSchema,
  estadoSessaoEnum: () => estadoSessaoEnum,
  filtrosLocalizacaoSchema: () => filtrosLocalizacaoSchema,
  generateBatchEmbeddingSchema: () => generateBatchEmbeddingSchema,
  generateEmbeddingSchema: () => generateEmbeddingSchema,
  generateMissingEmbeddingSchema: () => generateMissingEmbeddingSchema,
  generateUploadUrlRequestSchema: () => generateUploadUrlRequestSchema,
  gerarArtigoSchema: () => gerarArtigoSchema,
  gerarDescricaoSchema: () => gerarDescricaoSchema,
  gerarIsaRedatoraCalendarioPreviewSchema: () => gerarIsaRedatoraCalendarioPreviewSchema,
  iniciarConversaBlogSchema: () => iniciarConversaBlogSchema,
  iniciarConversaSchema: () => iniciarConversaSchema,
  isaCopilotAcaoPendenteSchema: () => isaCopilotAcaoPendenteSchema,
  isaCopilotAcaoPendenteStatusSchema: () => isaCopilotAcaoPendenteStatusSchema,
  isaCopilotAcaoResolvidaResponseSchema: () => isaCopilotAcaoResolvidaResponseSchema,
  isaCopilotAcaoResolvidaSchema: () => isaCopilotAcaoResolvidaSchema,
  isaCopilotAcaoTipoSchema: () => isaCopilotAcaoTipoSchema,
  isaCopilotAnexoSchema: () => isaCopilotAnexoSchema,
  isaCopilotConversaDetalheResponseSchema: () => isaCopilotConversaDetalheResponseSchema,
  isaCopilotConversaDetalheSchema: () => isaCopilotConversaDetalheSchema,
  isaCopilotConversaResumoSchema: () => isaCopilotConversaResumoSchema,
  isaCopilotConversasListResponseSchema: () => isaCopilotConversasListResponseSchema,
  isaCopilotLayoutSchema: () => isaCopilotLayoutSchema,
  isaCopilotMensagemAnexoSchema: () => isaCopilotMensagemAnexoSchema,
  isaCopilotMensagemConversaSchema: () => isaCopilotMensagemConversaSchema,
  isaCopilotMensagemPersistidaSchema: () => isaCopilotMensagemPersistidaSchema,
  isaCopilotMensagemSchema: () => isaCopilotMensagemSchema,
  isaCopilotRespostaResponseSchema: () => isaCopilotRespostaResponseSchema,
  isaCopilotRespostaSchema: () => isaCopilotRespostaSchema,
  isaCopilotResultadoBuscaSchema: () => isaCopilotResultadoBuscaSchema,
  isaCopilotResultadosBuscaSchema: () => isaCopilotResultadosBuscaSchema,
  isaCopilotSearchEntitySchema: () => isaCopilotSearchEntitySchema,
  isaCopilotTranscreverAudioSchema: () => isaCopilotTranscreverAudioSchema,
  isaCopilotTranscricaoResponseSchema: () => isaCopilotTranscricaoResponseSchema,
  isaCopilotTranscricaoSchema: () => isaCopilotTranscricaoSchema,
  isaHomeModeSchema: () => isaHomeModeSchema,
  isaPersonalizacaoNivelSchema: () => isaPersonalizacaoNivelSchema,
  isaPersonalizacaoResponseSchema: () => isaPersonalizacaoResponseSchema,
  isaPersonalizacaoSchema: () => isaPersonalizacaoSchema,
  isaRedatoraAutopublicacaoModoPublicacaoSchema: () => isaRedatoraAutopublicacaoModoPublicacaoSchema,
  isaRedatoraAutopublicacaoModoTemaSchema: () => isaRedatoraAutopublicacaoModoTemaSchema,
  isaRedatoraAutopublicacaoResponseSchema: () => isaRedatoraAutopublicacaoResponseSchema,
  isaRedatoraAutopublicacaoSchema: () => isaRedatoraAutopublicacaoSchema,
  isaRedatoraCalendarioItemResponseSchema: () => isaRedatoraCalendarioItemResponseSchema,
  isaRedatoraCalendarioItemSchema: () => isaRedatoraCalendarioItemSchema,
  isaRedatoraCalendarioListQuerySchema: () => isaRedatoraCalendarioListQuerySchema,
  isaRedatoraCalendarioListResponseSchema: () => isaRedatoraCalendarioListResponseSchema,
  isaRedatoraCalendarioStatusSchema: () => isaRedatoraCalendarioStatusSchema,
  isaRedatoraConfigResponseSchema: () => isaRedatoraConfigResponseSchema,
  isaRedatoraConfigSchema: () => isaRedatoraConfigSchema,
  isaRedatoraTomSchema: () => isaRedatoraTomSchema,
  isaWhatsappConfigDataSchema: () => isaWhatsappConfigDataSchema,
  isaWhatsappConfigResponseSchema: () => isaWhatsappConfigResponseSchema,
  isaWhatsappConfigSchema: () => isaWhatsappConfigSchema,
  likeResponseSchema: () => likeResponseSchema,
  likeTipoEnum: () => likeTipoEnum,
  melhorarDescricaoResponseSchema: () => melhorarDescricaoResponseSchema,
  melhorarDescricaoSchema: () => melhorarDescricaoSchema,
  mensagemConversaSchema: () => mensagemConversaSchema,
  modelsResponseSchema: () => modelsResponseSchema,
  obterSessaoBlogSchema: () => obterSessaoBlogSchema,
  obterSessaoSchema: () => obterSessaoSchema,
  preencherIsaRedatoraResponseSchema: () => preencherIsaRedatoraResponseSchema,
  preencherIsaRedatoraSchema: () => preencherIsaRedatoraSchema,
  preferenciasConversaSchema: () => preferenciasConversaSchema,
  providerModelsResponseSchema: () => providerModelsResponseSchema,
  providerModelsSchema: () => providerModelsSchema,
  registerArquivoRequestSchema: () => registerArquivoRequestSchema,
  resolveAIAgentCondicaoDoText: () => resolveAIAgentCondicaoDoText,
  resolveAIAgentCondicaoWhenText: () => resolveAIAgentCondicaoWhenText,
  responderMensagemBlogSchema: () => responderMensagemBlogSchema,
  responderMensagemSchema: () => responderMensagemSchema,
  respostaConversaSchema: () => respostaConversaSchema,
  seoEntityTypeEnum: () => seoEntityTypeEnum,
  seoGenerationSchema: () => seoGenerationSchema,
  seoGenericSchema: () => seoGenericSchema,
  seoResponseSchema: () => seoResponseSchema,
  sessaoConversaSchema: () => sessaoConversaSchema,
  tipoEntidadeEnum: () => tipoEntidadeEnum,
  toggleArquivoAtivoSchema: () => toggleArquivoAtivoSchema,
  toggleArquivoRequestSchema: () => toggleArquivoRequestSchema,
  updateAIAgentPromptRequestSchema: () => updateAIAgentPromptRequestSchema,
  updateAIAgentPromptSchema: () => updateAIAgentPromptSchema,
  updateAIAgentRequestSchema: () => updateAIAgentRequestSchema,
  updateAIAgentResponseSchema: () => updateAIAgentResponseSchema,
  updateAIAgentSchema: () => updateAIAgentSchema,
  updateIsaPersonalizacaoSchema: () => updateIsaPersonalizacaoSchema,
  updateIsaRedatoraAutopublicacaoSchema: () => updateIsaRedatoraAutopublicacaoSchema,
  updateIsaRedatoraConfigSchema: () => updateIsaRedatoraConfigSchema,
  uploadUrlResponseSchema: () => uploadUrlResponseSchema2
});
var aiProviderTypeEnum = z.enum([
  "OPENAI",
  "GEMINI",
  "CLAUDE",
  "AZURE_OPENAI"
]);
var aiAgentTomVozEnum = z.enum([
  "AMIGAVEL",
  "PROFISSIONAL",
  "FORMAL",
  "DESCONTRAIDO",
  "EMPATICO"
]);
var aiAgentTamanhoRespostasEnum = z.enum([
  "CURTAS",
  "MEDIAS",
  "LONGAS"
]);
var aiAgentCondicaoWhenTypeEnum = z.enum([
  "price_question",
  "frustrated_sentiment",
  "no_client_response",
  "no_rag_result",
  "custom"
]);
var aiAgentCondicaoDoTypeEnum = z.enum([
  "reply",
  "handoff",
  "collect_info",
  "custom"
]);
var AI_AGENT_CONDICAO_WHEN_PRESETS = {
  price_question: {
    label: "Cliente pergunta sobre pre\xE7o",
    promptLabel: "Cliente pergunta sobre pre\xE7o / valores",
    needsDetail: false,
    detailPlaceholder: "Detalhe opcional (ex.: faixa de pre\xE7o, tipo de im\xF3vel)"
  },
  frustrated_sentiment: {
    label: "Sentimento frustrado",
    promptLabel: "Cliente demonstra sentimento frustrado ou irritado",
    needsDetail: false,
    detailPlaceholder: "Detalhe opcional (ex.: palavras-chave, sinais)"
  },
  no_client_response: {
    label: "Sem resposta do cliente h\xE1 X tempo",
    promptLabel: "Cliente n\xE3o respondeu h\xE1 algum tempo",
    needsDetail: true,
    detailPlaceholder: "Ex: Sem resposta h\xE1 30 minutos"
  },
  no_rag_result: {
    label: "Agente n\xE3o encontrou resultado (RAG/busca vazia)",
    promptLabel: "Agente n\xE3o encontrou resultado relevante na busca/RAG (lista vazia)",
    needsDetail: false,
    detailPlaceholder: "Detalhe opcional"
  },
  custom: {
    label: "Personalizado (texto livre)",
    promptLabel: "Condi\xE7\xE3o personalizada",
    needsDetail: true,
    detailPlaceholder: "Ex: Toda vez que o cliente pergunta sobre pre\xE7o"
  }
};
var AI_AGENT_CONDICAO_DO_PRESETS = {
  reply: {
    label: "Responder conforme instru\xE7\xE3o",
    promptLabel: "Responder conforme a instru\xE7\xE3o abaixo",
    needsDetail: true,
    detailPlaceholder: "Ex: Explicar o que est\xE1 inclu\xEDdo no pacote e oferecer agendar uma demonstra\xE7\xE3o"
  },
  handoff: {
    label: "Transferir atendimento para humano",
    promptLabel: "TRANSFERIR ATENDIMENTO PARA HUMANO \u2014 desligar IA e avisar o cliente",
    needsDetail: false,
    detailPlaceholder: "Mensagem opcional ao cliente (padr\xE3o: avisar que vai transferir)"
  },
  collect_info: {
    label: "Coletar informa\xE7\xE3o",
    promptLabel: "Coletar informa\xE7\xE3o do cliente",
    needsDetail: true,
    detailPlaceholder: "Ex: Perguntar bairro preferido e faixa de or\xE7amento"
  },
  custom: {
    label: "Personalizado (texto livre)",
    promptLabel: "A\xE7\xE3o personalizada",
    needsDetail: true,
    detailPlaceholder: "Ex: Explicar o que est\xE1 inclu\xEDdo no pacote e oferecer agendar uma demonstra\xE7\xE3o"
  }
};
var aiAgentCondicaoSchema = z.object({
  whenType: aiAgentCondicaoWhenTypeEnum.optional(),
  when: z.string(),
  doType: aiAgentCondicaoDoTypeEnum.optional(),
  do: z.string()
});
function resolveAIAgentCondicaoWhenText(condicao) {
  const detail = (condicao.when ?? "").trim();
  const type = condicao.whenType;
  if (!type || type === "custom") {
    return detail;
  }
  const preset = AI_AGENT_CONDICAO_WHEN_PRESETS[type];
  if (!detail) return preset.promptLabel;
  if (detail.toLowerCase() === preset.label.toLowerCase()) {
    return preset.promptLabel;
  }
  return `${preset.promptLabel} \u2014 ${detail}`;
}
function resolveAIAgentCondicaoDoText(condicao) {
  const detail = (condicao.do ?? "").trim();
  const type = condicao.doType;
  if (!type || type === "custom") {
    return detail;
  }
  const preset = AI_AGENT_CONDICAO_DO_PRESETS[type];
  if (!detail) return preset.promptLabel;
  if (detail.toLowerCase() === preset.label.toLowerCase()) {
    return preset.promptLabel;
  }
  return `${preset.promptLabel} \u2014 ${detail}`;
}
var createAIAgentSchema = z.object({
  nome: z.string(),
  descricao: z.string().optional(),
  systemPrompt: z.string(),
  tomVoz: aiAgentTomVozEnum.optional(),
  tamanhoRespostas: aiAgentTamanhoRespostasEnum.optional(),
  diretrizes: z.array(z.string()).optional(),
  condicoes: z.array(aiAgentCondicaoSchema).optional(),
  provider: aiProviderTypeEnum,
  modelo: z.string(),
  embeddingProvider: aiProviderTypeEnum,
  embeddingModel: z.string(),
  incluirVenda: z.boolean().optional(),
  incluirLocacao: z.boolean().optional(),
  apenasPublicados: z.boolean().optional(),
  filtrosLocalizacao: z.any().optional(),
  keywordsEscalacao: z.array(z.string()).optional(),
  confidenceThreshold: z.number().min(0).max(1).optional(),
  temperature: z.number().min(0).max(2).optional(),
  maxTokens: z.number().min(1).max(4e3).optional()
});
var updateAIAgentSchema = z.object({
  nome: z.string().optional(),
  descricao: z.string().optional(),
  systemPrompt: z.string().optional(),
  tomVoz: aiAgentTomVozEnum.optional(),
  tamanhoRespostas: aiAgentTamanhoRespostasEnum.optional(),
  diretrizes: z.array(z.string()).optional(),
  condicoes: z.array(aiAgentCondicaoSchema).optional(),
  provider: aiProviderTypeEnum.optional(),
  modelo: z.string().optional(),
  embeddingProvider: aiProviderTypeEnum.optional(),
  embeddingModel: z.string().optional(),
  incluirVenda: z.boolean().optional(),
  incluirLocacao: z.boolean().optional(),
  apenasPublicados: z.boolean().optional(),
  filtrosLocalizacao: z.any().optional(),
  keywordsEscalacao: z.array(z.string()).optional(),
  confidenceThreshold: z.number().min(0).max(1).optional(),
  temperature: z.number().min(0).max(2).optional(),
  maxTokens: z.number().min(1).max(4e3).optional()
});
var associateChannelSchema = z.object({
  channelInstanceId: z.number(),
  enabled: z.boolean().optional(),
  priority: z.number().optional()
});
var createAIAgentPromptSchema = z.object({
  titulo: z.string().min(1),
  conteudo: z.string().min(1),
  ordem: z.number().int().min(0).optional(),
  ativo: z.boolean().optional()
});
var updateAIAgentPromptSchema = z.object({
  titulo: z.string().min(1).optional(),
  conteudo: z.string().min(1).optional(),
  ordem: z.number().int().min(0).optional(),
  ativo: z.boolean().optional()
});
var createAIAgentArquivoSchema = z.object({
  nome: z.string().min(1),
  nomeArquivo: z.string().min(1),
  filePath: z.string().min(1),
  mimeType: z.string().min(1),
  tamanho: z.number().min(0),
  extensao: z.string().min(1)
});
var toggleArquivoAtivoSchema = z.object({
  ativo: z.boolean()
});
var tipoEntidadeEnum = z.enum([
  "imovel",
  "empreendimento",
  "incorporadora",
  "artigo"
]);
var iniciarConversaSchema = z.object({
  tipo: tipoEntidadeEnum,
  entidadeId: z.number().min(1)
});
var responderMensagemSchema = z.object({
  sessaoId: z.string().uuid(),
  resposta: z.string().min(1)
});
var gerarDescricaoSchema = z.object({
  sessaoId: z.string().uuid()
});
var obterSessaoSchema = z.object({
  sessaoId: z.string().uuid()
});
var likeTipoEnum = z.enum(["descricao", "seo"]);
var createLikeSchema = z.object({
  imovelId: z.coerce.number().optional(),
  empreendimentoId: z.coerce.number().optional(),
  valor: z.coerce.number().int().min(1).max(5),
  tipo: likeTipoEnum.optional(),
  ipAddress: z.string().optional(),
  userAgent: z.string().optional()
});
var editorJsContentBlogSchema = z.object({
  time: z.number().optional(),
  blocks: z.array(z.record(z.string(), z.unknown())).min(1),
  version: z.string().optional()
});
var artigoExistenteBlogSchema = z.object({
  titulo: z.string().min(1),
  slug: z.string().optional(),
  metaTitle: z.string().optional(),
  metaDescription: z.string().optional(),
  conteudo: editorJsContentBlogSchema
});
var iniciarConversaBlogSchema = z.object({
  siteId: z.coerce.number().min(1),
  artigoExistente: artigoExistenteBlogSchema.optional()
});
var definirModoArtigoIsaSchema = z.object({
  sessaoId: z.string().uuid(),
  modo: z.enum(["editar_existente", "criar_novo"])
});
var responderMensagemBlogSchema = z.object({
  sessaoId: z.string().uuid(),
  resposta: z.string().min(1)
});
var gerarArtigoSchema = z.object({ sessaoId: z.string().uuid() });
var editarArtigoSchema = z.object({
  sessaoId: z.string().uuid(),
  solicitacao: z.string().min(1)
});
var obterSessaoBlogSchema = z.object({ sessaoId: z.string().uuid() });
var melhorarDescricaoSchema = z.object({
  dashboardId: z.coerce.number().int().min(1).optional(),
  tipo: tipoEntidadeEnum,
  entidadeId: z.coerce.number().int().min(1),
  texto: z.string().min(1)
});
var aiDescriptionImproveSchema = melhorarDescricaoSchema;
var aiDescriptionStreamSchema = z.object({
  tipo: tipoEntidadeEnum,
  entidadeId: z.coerce.number().min(1),
  prompt: z.string().optional()
});
var seoGenerationSchema = z.object({
  titulo: z.string().optional(),
  descricao: z.any().optional(),
  tipo: tipoEntidadeEnum.optional(),
  entidadeId: z.coerce.number().optional()
});
var embeddingSchema = z.object({
  text: z.string().min(1),
  model: z.string().optional()
});
var generateEmbeddingSchema = z.object({
  provider: aiProviderTypeEnum
});
var generateBatchEmbeddingSchema = z.object({
  ids: z.array(z.coerce.number().int().min(1)).min(1),
  type: z.enum(["imovel", "empreendimento"]),
  provider: aiProviderTypeEnum
});
var generateMissingEmbeddingSchema = z.object({
  provider: aiProviderTypeEnum,
  limit: z.coerce.number().int().min(1).optional()
});
var seoEntityTypeEnum = z.enum([
  "imovel-to-site",
  "empreendimento-to-site",
  "incorporadora-to-site",
  "site-artigo",
  "imovel-campanha"
]);
var seoGenericSchema = z.object({
  entityType: seoEntityTypeEnum,
  entityId: z.coerce.number().int().min(1),
  siteId: z.coerce.number().int().min(1).optional()
});
var seoResponseSchema = z.object({
  metaTitle: z.string(),
  metaDescription: z.string(),
  keyword: z.string().optional(),
  slug: z.string()
});
var preferenciasConversaSchema = z.object({
  estilo: z.enum(["profissional", "casual", "persuasivo", "informativo"]).optional(),
  foco: z.string().optional(),
  publicoAlvo: z.string().optional(),
  informacoesAdicionais: z.string().optional()
});
var estadoSessaoEnum = z.enum([
  "aguardando_resposta",
  "gerando",
  "finalizada"
]);
var mensagemConversaSchema = z.object({
  tipo: z.enum(["ia", "usuario"]),
  conteudo: z.string(),
  timestamp: z.string()
});
var sessaoConversaSchema = z.object({
  id: z.string().uuid(),
  tipo: tipoEntidadeEnum,
  entidadeId: z.number(),
  estado: estadoSessaoEnum,
  historico: z.array(mensagemConversaSchema),
  preferencias: preferenciasConversaSchema.optional(),
  descricaoGerada: z.string().optional(),
  criadoEm: z.string(),
  atualizadoEm: z.string()
});
var respostaConversaSchema = z.object({
  sessao: sessaoConversaSchema,
  mensagemIA: z.string().optional(),
  podeGerar: z.boolean(),
  gerarAutomaticamente: z.boolean().optional()
});
var melhorarDescricaoResponseSchema = z.object({
  texto: z.string()
});
var likeResponseSchema = z.object({
  media: z.number(),
  total: z.number(),
  distribuicao: z.record(z.coerce.number(), z.number())
});
var filtrosLocalizacaoSchema = z.object({
  cidade: z.string().optional(),
  bairro: z.string().optional(),
  uf: z.string().optional()
}).nullable().optional();
var aiAgentSchema = z.object({
  id: z.number(),
  dashboardId: z.number(),
  nome: z.string(),
  descricao: z.string().nullable().optional(),
  systemPrompt: z.string(),
  tomVoz: aiAgentTomVozEnum.default("AMIGAVEL"),
  tamanhoRespostas: aiAgentTamanhoRespostasEnum.default("CURTAS"),
  diretrizes: z.array(z.string()).default([]),
  condicoes: z.array(aiAgentCondicaoSchema).default([]),
  provider: aiProviderTypeEnum,
  modelo: z.string(),
  embeddingProvider: aiProviderTypeEnum,
  embeddingModel: z.string(),
  incluirVenda: z.boolean(),
  incluirLocacao: z.boolean(),
  apenasPublicados: z.boolean(),
  filtrosLocalizacao: filtrosLocalizacaoSchema,
  keywordsEscalacao: z.array(z.string()),
  confidenceThreshold: z.number().min(0).max(1).nullable().optional(),
  temperature: z.number().min(0).max(2),
  maxTokens: z.number().min(1).max(4e3),
  createdAt: z.string(),
  updatedAt: z.string()
});
var channelInstanceAIAgentSchema = z.object({
  channelInstanceId: z.number(),
  enabled: z.boolean(),
  priority: z.number(),
  channelInstance: z.object({
    id: z.number(),
    dashboardId: z.number(),
    whatsappInstanceId: z.number().nullable().optional(),
    createdAt: z.string(),
    updatedAt: z.string()
  }).optional()
});
var aiAgentWithChannelsSchema = aiAgentSchema.extend({
  channels: z.array(channelInstanceAIAgentSchema).optional()
});
var aiAgentsListResponseSchema = listResponse(aiAgentSchema);
var aiAgentResponseSchema = dataResponse(aiAgentWithChannelsSchema);
var createAIAgentResponseSchema = dataResponse(aiAgentSchema);
var updateAIAgentResponseSchema = dataResponse(aiAgentSchema);
var deleteAIAgentResponseSchema = messageResponseSchema;
var deleteAIAgentPromptResponseSchema = messageResponseSchema;
var deleteAIAgentArquivoResponseSchema = messageResponseSchema;
var associateChannelResponseSchema = messageResponseSchema;
var disassociateChannelResponseSchema = messageResponseSchema;
var aiAgentPromptSchema = z.object({
  id: z.number(),
  aiAgentId: z.number(),
  titulo: z.string(),
  conteudo: z.string(),
  ordem: z.number(),
  ativo: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var aiAgentPromptsResponseSchema = listResponse(aiAgentPromptSchema);
var aiAgentPromptResponseSchema = dataResponse(aiAgentPromptSchema);
var aiAgentArquivoSchema = z.object({
  id: z.number(),
  aiAgentId: z.number(),
  nome: z.string(),
  nomeArquivo: z.string(),
  url: z.string(),
  filePath: z.string().optional(),
  mimeType: z.string(),
  tamanho: z.number(),
  extensao: z.string(),
  ativo: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var aiAgentArquivosResponseSchema = listResponse(aiAgentArquivoSchema);
var aiAgentArquivoResponseSchema = dataResponse(aiAgentArquivoSchema);
var chatModelSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().optional(),
  maxTokens: z.number().optional(),
  contextWindow: z.number().optional()
});
var embeddingModelSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().optional()
});
var providerModelsSchema = z.object({
  provider: aiProviderTypeEnum,
  available: z.boolean(),
  chatModels: z.array(chatModelSchema),
  embeddingModels: z.array(embeddingModelSchema)
});
var modelsResponseSchema = listResponse(providerModelsSchema);
var providerModelsResponseSchema = dataResponse(providerModelsSchema);
var aiProviderSchema = aiProviderTypeEnum;
var createAIAgentRequestSchema = z.object({
  nome: z.string().min(1, "Nome \xE9 obrigat\xF3rio"),
  descricao: z.string().optional(),
  systemPrompt: z.string().min(1, "System prompt \xE9 obrigat\xF3rio"),
  tomVoz: aiAgentTomVozEnum.default("AMIGAVEL"),
  tamanhoRespostas: aiAgentTamanhoRespostasEnum.default("CURTAS"),
  diretrizes: z.array(z.string()).default([]),
  condicoes: z.array(aiAgentCondicaoSchema).default([]),
  provider: aiProviderTypeEnum,
  modelo: z.string().min(1, "Modelo \xE9 obrigat\xF3rio"),
  embeddingProvider: aiProviderTypeEnum,
  embeddingModel: z.string().min(1, "Modelo de embedding \xE9 obrigat\xF3rio"),
  incluirVenda: z.boolean().default(true),
  incluirLocacao: z.boolean().default(true),
  apenasPublicados: z.boolean().default(true),
  filtrosLocalizacao: filtrosLocalizacaoSchema,
  keywordsEscalacao: z.array(z.string()).default([]),
  confidenceThreshold: z.number().min(0).max(1).default(0.7).optional(),
  temperature: z.number().min(0).max(2).default(0.7),
  maxTokens: z.number().min(1).max(4e3).default(500)
});
var updateAIAgentRequestSchema = createAIAgentRequestSchema.partial();
var createAIAgentPromptRequestSchema = z.object({
  titulo: z.string().min(1, "T\xEDtulo \xE9 obrigat\xF3rio"),
  conteudo: z.string().min(1, "Conte\xFAdo \xE9 obrigat\xF3rio"),
  ordem: z.number().default(0).optional(),
  ativo: z.boolean().default(true)
});
var updateAIAgentPromptRequestSchema = createAIAgentPromptRequestSchema.partial();
var generateUploadUrlRequestSchema = z.object({
  fileName: z.string().min(1, "Nome do arquivo \xE9 obrigat\xF3rio"),
  fileType: z.string().min(1, "Tipo do arquivo \xE9 obrigat\xF3rio"),
  size: z.number().optional()
});
var uploadUrlResponseSchema2 = z.object({
  presignedUrl: z.string(),
  fileUrl: z.string(),
  filePath: z.string(),
  expiresIn: z.number(),
  fileName: z.string(),
  fileType: z.string(),
  folder: z.string(),
  dashboardId: z.number(),
  tipoConteudo: z.string(),
  conteudoId: z.number(),
  isPublico: z.boolean()
});
var registerArquivoRequestSchema = createAIAgentArquivoSchema;
var toggleArquivoRequestSchema = toggleArquivoAtivoSchema;
var associateChannelRequestSchema = z.object({
  channelInstanceId: z.number(),
  enabled: z.boolean().default(false),
  priority: z.number().default(0)
});
var arquivoDiagnosticoSchema = z.object({
  id: z.number(),
  nome: z.string(),
  statusProcessamento: z.enum([
    "processado",
    "conteudo_extraido_sem_embedding",
    "pendente"
  ]),
  disponivelParaAgente: z.boolean(),
  temConteudoExtraido: z.boolean(),
  tamanhoConteudoExtraido: z.number().nullable().optional(),
  temEmbedding: z.boolean(),
  embeddingProvider: aiProviderTypeEnum.nullable().optional(),
  ativo: z.boolean()
});
var arquivosDiagnosticoResponseSchema = z.object({
  agentId: z.number(),
  agentNome: z.string(),
  embeddingProvider: aiProviderTypeEnum,
  embeddingModel: z.string(),
  totalArquivos: z.number(),
  arquivosAtivos: z.number(),
  arquivosProcessados: z.number(),
  arquivosDisponiveisParaAgente: z.number(),
  arquivos: z.array(arquivoDiagnosticoSchema),
  recomendacoes: z.array(z.string())
});
var isaCopilotLayoutSchema = z.enum(["sidebar", "floating"]);
var isaHomeModeSchema = z.enum(["dashboard", "chat"]);
var isaCopilotAnexoSchema = z.object({
  nome: z.string().min(1).max(255),
  mimeType: z.string().min(1).max(128),
  base64: z.string().min(1)
});
var isaCopilotMensagemAnexoSchema = z.object({
  nome: z.string(),
  mimeType: z.string(),
  categoria: z.enum(["imagem", "documento"]),
  url: z.string()
});
var isaCopilotSearchEntitySchema = z.enum([
  "contatos",
  "imoveis",
  "empreendimentos",
  "incorporadoras",
  "leads",
  "oportunidades",
  "tarefas",
  "propostas",
  "ajuda"
]);
var isaCopilotResultadoBuscaSchema = z.object({
  tipo: isaCopilotSearchEntitySchema,
  total: z.number(),
  items: z.array(z.record(z.string(), z.unknown()))
});
var isaCopilotResultadosBuscaSchema = z.array(
  isaCopilotResultadoBuscaSchema
);
var isaCopilotMensagemSchema = z.object({
  conversationId: z.string().uuid().optional(),
  mensagem: z.string().optional(),
  anexos: z.array(isaCopilotAnexoSchema).max(5).optional()
}).refine(
  (data) => (data.mensagem?.trim()?.length ?? 0) > 0 || (data.anexos?.length ?? 0) > 0,
  { message: "Informe uma mensagem ou envie pelo menos um anexo" }
);
var isaCopilotTranscreverAudioSchema = z.object({
  audioBase64: z.string().min(1),
  mimeType: z.string().optional().default("audio/webm")
});
var isaCopilotTranscricaoSchema = z.object({
  texto: z.string()
});
var isaCopilotTranscricaoResponseSchema = dataResponse(
  isaCopilotTranscricaoSchema
);
var isaCopilotMensagemConversaSchema = z.object({
  tipo: z.enum(["ia", "usuario"]),
  conteudo: z.string(),
  timestamp: z.string(),
  anexos: z.array(isaCopilotMensagemAnexoSchema).optional(),
  resultadosBusca: isaCopilotResultadosBuscaSchema.optional()
});
var isaCopilotAcaoTipoSchema = z.enum([
  "atualizarContato",
  "criarContato",
  "excluirContato",
  "criarLead",
  "criarIncorporadora",
  "atualizarIncorporadora",
  "criarImovel",
  "criarEmpreendimento",
  "criarOportunidade",
  "atualizarOportunidade",
  "marcarOportunidadeGanha",
  "criarTarefa",
  "concluirTarefa",
  "atualizarLead",
  "converterLead",
  "criarProposta",
  "atualizarImovel",
  "atualizarEmpreendimento"
]);
var isaCopilotAcaoPendenteStatusSchema = z.enum([
  "pending",
  "approved",
  "rejected"
]);
var isaCopilotAcaoPendenteSchema = z.object({
  id: z.string().uuid(),
  actionType: isaCopilotAcaoTipoSchema,
  descricao: z.string(),
  payload: z.record(z.string(), z.unknown()),
  status: isaCopilotAcaoPendenteStatusSchema,
  mensagemId: z.string().uuid().nullable().optional(),
  createdAt: z.string()
});
var isaCopilotRespostaSchema = z.object({
  conversationId: z.string().uuid(),
  resposta: z.string(),
  historico: z.array(isaCopilotMensagemConversaSchema).optional(),
  acaoPendente: isaCopilotAcaoPendenteSchema.optional().nullable()
});
var isaCopilotRespostaResponseSchema = dataResponse(
  isaCopilotRespostaSchema
);
var criarIsaCopilotConversaSchema = z.object({
  titulo: z.string().optional()
});
var atualizarIsaCopilotConversaSchema = z.object({
  titulo: z.string().min(1).max(60).optional(),
  favorito: z.boolean().optional(),
  arquivada: z.boolean().optional()
}).refine(
  (data) => data.titulo !== void 0 || data.favorito !== void 0 || data.arquivada !== void 0,
  {
    message: "Informe titulo, favorito ou arquivada para atualizar a conversa"
  }
);
var isaCopilotConversaResumoSchema = z.object({
  id: z.string().uuid(),
  titulo: z.string().nullable().optional(),
  favorito: z.boolean().default(false),
  arquivada: z.boolean().default(false),
  createdAt: z.string(),
  updatedAt: z.string()
});
var isaCopilotMensagemPersistidaSchema = z.object({
  id: z.string().uuid(),
  tipo: z.enum(["ia", "usuario"]),
  conteudo: z.string(),
  timestamp: z.string(),
  anexos: z.array(isaCopilotMensagemAnexoSchema).optional(),
  resultadosBusca: isaCopilotResultadosBuscaSchema.optional()
});
var isaCopilotConversaDetalheSchema = z.object({
  id: z.string().uuid(),
  titulo: z.string().nullable().optional(),
  mensagens: z.array(isaCopilotMensagemPersistidaSchema),
  acaoPendente: isaCopilotAcaoPendenteSchema.optional().nullable(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var isaCopilotConversasListResponseSchema = listResponse(
  isaCopilotConversaResumoSchema
);
var isaCopilotConversaDetalheResponseSchema = dataResponse(
  isaCopilotConversaDetalheSchema
);
var criarIsaCopilotConversaResponseSchema = dataResponse(
  isaCopilotConversaResumoSchema
);
var atualizarIsaCopilotConversaResponseSchema = dataResponse(
  isaCopilotConversaResumoSchema
);
var isaCopilotAcaoResolvidaSchema = z.object({
  acao: isaCopilotAcaoPendenteSchema,
  mensagemConfirmacao: z.string().optional(),
  mensagemCancelamento: z.string().optional(),
  resultadosBusca: isaCopilotResultadosBuscaSchema.optional(),
  acaoPendente: z.null().optional()
});
var isaCopilotAcaoResolvidaResponseSchema = dataResponse(
  isaCopilotAcaoResolvidaSchema
);
var isaPersonalizacaoNivelSchema = z.enum(["mais", "padrao", "menos"]);
var isaPersonalizacaoSchema = z.object({
  apelido: z.string().max(100).nullable().optional(),
  ocupacao: z.string().max(200).nullable().optional(),
  sobre: z.string().max(2e3).nullable().optional(),
  acolhedor: isaPersonalizacaoNivelSchema.default("padrao"),
  entusiasmado: isaPersonalizacaoNivelSchema.default("padrao"),
  listasCabecalhos: isaPersonalizacaoNivelSchema.default("padrao"),
  emoji: isaPersonalizacaoNivelSchema.default("padrao"),
  instrucoesPersonalizadas: z.string().max(4e3).nullable().optional()
});
var updateIsaPersonalizacaoSchema = isaPersonalizacaoSchema.partial();
var isaPersonalizacaoResponseSchema = dataResponse(
  isaPersonalizacaoSchema
);
var isaWhatsappConfigSchema = z.object({
  ativo: z.boolean(),
  dashboardPreferidoId: z.coerce.number().int().positive().optional()
});
var isaWhatsappConfigDataSchema = z.object({
  ativo: z.boolean(),
  dashboardPreferidoId: z.number().nullable()
});
var isaWhatsappConfigResponseSchema = dataResponse(
  isaWhatsappConfigDataSchema
);
var isaRedatoraTomSchema = z.enum([
  "profissional",
  "educativo",
  "inspirador",
  "consultivo",
  "descontraido",
  "tecnico"
]);
var isaRedatoraConfigSchema = z.object({
  tomEditorial: isaRedatoraTomSchema.nullable().optional(),
  tomArtigos: isaRedatoraTomSchema.nullable().optional(),
  sobreImobiliaria: z.string().nullable().optional(),
  diferenciais: z.string().nullable().optional(),
  publicoAlvo: z.string().nullable().optional(),
  temasPreferidos: z.string().nullable().optional(),
  palavrasEvitar: z.string().nullable().optional(),
  instrucoesAdicionais: z.string().nullable().optional()
});
var updateIsaRedatoraConfigSchema = isaRedatoraConfigSchema;
var isaRedatoraConfigResponseSchema = isaRedatoraConfigSchema.extend({
  id: z.number(),
  dashboardId: z.number(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var preencherIsaRedatoraSchema = z.object({
  siteId: z.coerce.number().int().positive().optional()
});
var preencherIsaRedatoraResponseSchema = isaRedatoraConfigSchema;
var isaRedatoraAutopublicacaoModoTemaSchema = z.enum([
  "automatico",
  "lista_fixa"
]);
var isaRedatoraAutopublicacaoModoPublicacaoSchema = z.enum([
  "rascunho",
  "publicado"
]);
var isaRedatoraAutopublicacaoSchema = z.object({
  ativo: z.boolean(),
  siteId: z.coerce.number().int().positive().nullable().optional(),
  diasSemana: z.array(z.number().int().min(0).max(6)),
  horarioPublicacao: z.string(),
  modoTema: isaRedatoraAutopublicacaoModoTemaSchema,
  temasLista: z.string().nullable().optional(),
  modoPublicacao: isaRedatoraAutopublicacaoModoPublicacaoSchema
});
var updateIsaRedatoraAutopublicacaoSchema = isaRedatoraAutopublicacaoSchema.partial();
var isaRedatoraAutopublicacaoResponseSchema = isaRedatoraAutopublicacaoSchema.extend({
  id: z.number(),
  dashboardId: z.number(),
  ultimaExecucao: z.string().nullable(),
  indiceTemaLista: z.number(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var isaRedatoraCalendarioStatusSchema = z.enum([
  "Planejado",
  "Gerando",
  "Gerado",
  "Excluido"
]);
var isaRedatoraCalendarioItemSchema = z.object({
  id: z.string(),
  dashboardId: z.number(),
  siteId: z.number(),
  dataPlanejada: z.string(),
  assunto: z.string(),
  status: isaRedatoraCalendarioStatusSchema,
  artigoId: z.number().nullable(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var isaRedatoraCalendarioListQuerySchema = z.object({
  from: z.string().optional(),
  to: z.string().optional(),
  incluirExcluidos: z.coerce.boolean().optional()
});
var gerarIsaRedatoraCalendarioPreviewSchema = z.object({
  quantidade: z.coerce.number().int().min(1).max(30).optional(),
  substituirPlanejados: z.boolean().optional()
});
var isaRedatoraCalendarioItemResponseSchema = dataResponse(
  isaRedatoraCalendarioItemSchema
);
var isaRedatoraCalendarioListResponseSchema = listResponse(
  isaRedatoraCalendarioItemSchema
);

// src/api-keys/index.ts
var api_keys_exports = {};
__export(api_keys_exports, {
  apiKeyResponseSchema: () => apiKeyResponseSchema,
  apiKeySchema: () => apiKeySchema,
  apiKeysListResponseSchema: () => apiKeysListResponseSchema,
  createApiKeyDataSchema: () => createApiKeyDataSchema,
  createApiKeyResponseSchema: () => createApiKeyResponseSchema,
  createApiKeySchema: () => createApiKeySchema,
  deleteApiKeyResponseSchema: () => deleteApiKeyResponseSchema,
  updateApiKeyResponseSchema: () => updateApiKeyResponseSchema,
  updateApiKeySchema: () => updateApiKeySchema
});
var createApiKeySchema = z.object({
  name: z.string().trim().min(1, "Nome \xE9 obrigat\xF3rio").max(255),
  expiresAt: z.string().optional()
});
var updateApiKeySchema = createApiKeySchema.partial().extend({
  active: z.boolean().optional(),
  canCreateLead: z.boolean().optional(),
  canUpdateLead: z.boolean().optional(),
  canCreateOportunidade: z.boolean().optional(),
  canUpdateOportunidade: z.boolean().optional(),
  canCreateLeadAnotacao: z.boolean().optional(),
  canCreateOportunidadeAnotacao: z.boolean().optional(),
  canCreateContato: z.boolean().optional(),
  canUpdateContato: z.boolean().optional(),
  expiresAt: z.string().optional()
});
var apiKeySchema = z.object({
  id: z.number(),
  name: z.string(),
  active: z.boolean(),
  lastUsedAt: z.string().nullable(),
  expiresAt: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  canCreateLead: z.boolean(),
  canUpdateLead: z.boolean(),
  canCreateOportunidade: z.boolean(),
  canUpdateOportunidade: z.boolean(),
  canCreateLeadAnotacao: z.boolean(),
  canCreateOportunidadeAnotacao: z.boolean(),
  canCreateContato: z.boolean(),
  canUpdateContato: z.boolean()
});
var createApiKeyDataSchema = z.object({
  id: z.number(),
  name: z.string(),
  apiKey: z.string(),
  createdAt: z.string()
});
var createApiKeyResponseSchema = dataResponse(createApiKeyDataSchema);
var apiKeysListResponseSchema = listResponse(apiKeySchema);
var apiKeyResponseSchema = dataResponse(apiKeySchema);
var updateApiKeyResponseSchema = dataResponse(apiKeySchema);
var deleteApiKeyResponseSchema = messageResponseSchema;

// src/webhooks/index.ts
var webhooks_exports = {};
__export(webhooks_exports, {
  createWebhookResponseSchema: () => createWebhookResponseSchema,
  createWebhookSchema: () => createWebhookSchema,
  deleteWebhookResponseSchema: () => deleteWebhookResponseSchema,
  evolutionWebhookEventEnum: () => evolutionWebhookEventEnum,
  evolutionWebhookResponseSchema: () => evolutionWebhookResponseSchema,
  evolutionWebhookSchema: () => evolutionWebhookSchema,
  leadWhatsappWebhookResponseSchema: () => leadWhatsappWebhookResponseSchema,
  leadWhatsappWebhookSchema: () => leadWhatsappWebhookSchema,
  updateWebhookResponseSchema: () => updateWebhookResponseSchema,
  updateWebhookSchema: () => updateWebhookSchema,
  webhookEventSchema: () => webhookEventSchema,
  webhookEventsResponseSchema: () => webhookEventsResponseSchema,
  webhookResponseSchema: () => webhookResponseSchema,
  webhookSchema: () => webhookSchema,
  webhooksListResponseSchema: () => webhooksListResponseSchema,
  wpElementorWebhookResponseSchema: () => wpElementorWebhookResponseSchema,
  wpElementorWebhookSchema: () => wpElementorWebhookSchema
});
var createWebhookSchema = z.object({
  name: z.string().trim().min(1, "Nome \xE9 obrigat\xF3rio").max(255),
  url: z.string().url("URL deve ser v\xE1lida").max(500),
  secret: z.preprocess(
    (v) => typeof v === "string" ? v.trim() || null : v,
    z.string().max(255).nullable()
  ).optional(),
  eventoLeadCriado: z.boolean().optional(),
  eventoLeadAtualizado: z.boolean().optional(),
  eventoOportunidadeCriada: z.boolean().optional(),
  eventoOportunidadeAtualizada: z.boolean().optional(),
  eventoConversaIniciada: z.boolean().optional(),
  eventoContatoCriado: z.boolean().optional(),
  eventoContatoAtualizado: z.boolean().optional()
});
var updateWebhookSchema = createWebhookSchema.partial().extend({
  active: z.boolean().optional()
});
var webhookSchema = z.object({
  id: z.number(),
  name: z.string(),
  url: z.string(),
  secret: z.string().nullable(),
  active: z.boolean(),
  eventoLeadCriado: z.boolean(),
  eventoLeadAtualizado: z.boolean(),
  eventoOportunidadeCriada: z.boolean(),
  eventoOportunidadeAtualizada: z.boolean(),
  eventoConversaIniciada: z.boolean(),
  eventoContatoCriado: z.boolean(),
  eventoContatoAtualizado: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var webhooksListResponseSchema = listResponse(webhookSchema);
var webhookResponseSchema = dataResponse(webhookSchema);
var createWebhookResponseSchema = dataResponse(webhookSchema);
var updateWebhookResponseSchema = dataResponse(webhookSchema);
var deleteWebhookResponseSchema = messageResponseSchema;
var webhookEventSchema = z.object({
  code: z.string(),
  field: z.string(),
  label: z.string(),
  description: z.string(),
  category: z.string()
});
var webhookEventsResponseSchema = listResponse(webhookEventSchema);
var evolutionWebhookEventEnum = z.enum([
  "APPLICATION_STARTUP",
  "QRCODE_UPDATED",
  "MESSAGES_SET",
  "MESSAGES_UPSERT",
  "MESSAGES_UPDATE",
  "MESSAGES_DELETE",
  "SEND_MESSAGE",
  "CONTACTS_SET",
  "CONTACTS_UPSERT",
  "CONTACTS_UPDATE",
  "PRESENCE_UPDATE",
  "CHATS_SET",
  "CHATS_UPSERT",
  "CHATS_UPDATE",
  "CHATS_DELETE",
  "GROUPS_UPSERT",
  "GROUP_UPDATE",
  "GROUP_PARTICIPANTS_UPDATE",
  "CONNECTION_UPDATE",
  "LABELS_EDIT",
  "LABELS_ASSOCIATION",
  "CALL",
  "TYPEBOT_START",
  "TYPEBOT_CHANGE_STATUS",
  "REMOVE_INSTANCE",
  "connection.update",
  "messages.upsert"
]);
var evolutionWebhookSchema = z.object({
  event: z.union([evolutionWebhookEventEnum, z.string()]).optional(),
  type: z.string().optional(),
  instance: z.string().optional(),
  instanceName: z.string().optional(),
  number: z.string().optional(),
  numberId: z.string().optional(),
  data: z.unknown().optional(),
  qrcode: z.object({
    base64: z.string().optional(),
    code: z.string().optional()
  }).optional(),
  connection: z.object({
    state: z.string().optional(),
    status: z.string().optional()
  }).optional(),
  key: z.object({
    remoteJid: z.string().optional(),
    fromMe: z.boolean().optional(),
    id: z.string().optional(),
    participant: z.string().optional()
  }).optional(),
  message: z.unknown().optional(),
  messages: z.array(z.unknown()).optional(),
  contacts: z.array(z.unknown()).optional(),
  chats: z.array(z.unknown()).optional(),
  groups: z.array(z.unknown()).optional(),
  presence: z.unknown().optional()
}).passthrough();
var evolutionWebhookResponseSchema = z.object({
  status: z.enum(["success", "error"]),
  message: z.string().optional()
});
var leadWhatsappWebhookSchema = z.object({
  event: z.literal("messages.upsert"),
  data: z.object({
    key: z.object({
      remoteJid: z.string(),
      fromMe: z.boolean().optional()
    }),
    message: z.object({
      conversation: z.string().optional(),
      extendedTextMessage: z.object({ text: z.string().optional() }).optional(),
      buttonsResponseMessage: z.object({ selectedDisplayText: z.string().optional() }).optional(),
      templateButtonReplyMessage: z.object({
        selectedDisplayText: z.string().optional(),
        selectedId: z.string().optional()
      }).optional()
    }).passthrough()
  })
});
var leadWhatsappWebhookResponseSchema = z.object({
  status: z.string(),
  processed: z.number(),
  messages: z.number()
});
var wpElementorWebhookSchema = z.object({
  form: z.object({
    id: z.union([z.string(), z.number()]).optional(),
    name: z.string().optional()
  }).optional(),
  fields: z.record(z.string(), z.unknown()).optional(),
  meta: z.record(z.string(), z.unknown()).optional()
}).passthrough();
var wpElementorWebhookResponseSchema = z.object({
  success: z.boolean(),
  message: z.string().optional(),
  data: z.unknown().optional()
});

// src/email-templates/index.ts
var email_templates_exports = {};
__export(email_templates_exports, {
  createEmailTemplateResponseSchema: () => createEmailTemplateResponseSchema,
  createEmailTemplateSchema: () => createEmailTemplateSchema,
  deleteEmailTemplateResponseSchema: () => deleteEmailTemplateResponseSchema,
  emailTemplateDetailSchema: () => emailTemplateDetailSchema,
  emailTemplateListQuerySchema: () => emailTemplateListQuerySchema,
  emailTemplateResponseSchema: () => emailTemplateResponseSchema,
  emailTemplateSchema: () => emailTemplateSchema,
  emailTemplateVariaveisCategoriaSchema: () => emailTemplateVariaveisCategoriaSchema,
  emailTemplateVariaveisListResponseSchema: () => emailTemplateVariaveisListResponseSchema,
  emailTemplateVariaveisResponseSchema: () => emailTemplateVariaveisResponseSchema,
  emailTemplateVariavelSchema: () => emailTemplateVariavelSchema,
  emailTemplatesResponseSchema: () => emailTemplatesResponseSchema,
  updateEmailTemplateResponseSchema: () => updateEmailTemplateResponseSchema,
  updateEmailTemplateSchema: () => updateEmailTemplateSchema
});
var createEmailTemplateSchema = z.object({
  nome: z.string().min(1).max(255),
  assunto: z.string().min(1).max(500),
  conteudo: z.any(),
  html: z.string().min(1),
  ativo: z.boolean().optional()
});
var updateEmailTemplateSchema = z.object({
  nome: z.string().max(255).optional(),
  assunto: z.string().max(500).optional(),
  conteudo: z.any().optional(),
  html: z.string().optional(),
  ativo: z.boolean().optional()
});
var emailTemplateListQuerySchema = z.object({
  page: z.coerce.number().optional(),
  take: z.coerce.number().optional(),
  search: z.string().optional(),
  ativo: booleanLike.optional()
});
var emailTemplateSchema = z.object({
  id: z.string(),
  dashboardId: z.number().optional(),
  nome: z.string(),
  assunto: z.string(),
  ativo: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var emailTemplateDetailSchema = emailTemplateSchema.extend({
  conteudo: z.any(),
  html: z.string(),
  criadoPor: z.object({
    id: z.number(),
    nome: z.string(),
    email: z.string()
  }).nullable().optional()
});
var emailTemplateListMetaSchema = z.object({
  total: z.number(),
  page: z.number(),
  take: z.number().optional(),
  limit: z.number().optional(),
  hasNext: z.boolean().optional(),
  hasPrev: z.boolean().optional(),
  timestamp: z.string().optional(),
  pageCount: z.number().optional(),
  totalPages: z.number().optional(),
  pages: z.number().optional()
});
var emailTemplatesResponseSchema = z.object({
  success: z.boolean().optional(),
  message: z.string().optional(),
  data: z.array(emailTemplateSchema),
  meta: emailTemplateListMetaSchema
});
var emailTemplateResponseSchema = dataResponse(emailTemplateDetailSchema);
var createEmailTemplateResponseSchema = dataResponse(emailTemplateDetailSchema);
var updateEmailTemplateResponseSchema = dataResponse(emailTemplateDetailSchema);
var deleteEmailTemplateResponseSchema = messageResponseSchema;
var emailTemplateVariavelSchema = z.object({
  variavel: z.string(),
  exemplo: z.string(),
  descricao: z.string()
});
var emailTemplateVariaveisCategoriaSchema = z.object({
  categoria: z.string(),
  variaveis: z.array(emailTemplateVariavelSchema)
});
var emailTemplateVariaveisResponseSchema = z.array(
  emailTemplateVariaveisCategoriaSchema
);
var emailTemplateVariaveisListResponseSchema = dataResponse(
  emailTemplateVariaveisResponseSchema
);

// src/whatsapp-templates/index.ts
var whatsapp_templates_exports = {};
__export(whatsapp_templates_exports, {
  createWhatsAppTemplateResponseSchema: () => createWhatsAppTemplateResponseSchema,
  createWhatsAppTemplateSchema: () => createWhatsAppTemplateSchema,
  deleteWhatsAppTemplateResponseSchema: () => deleteWhatsAppTemplateResponseSchema,
  metaTemplateApprovalStatusSchema: () => metaTemplateApprovalStatusSchema,
  updateWhatsAppTemplateResponseSchema: () => updateWhatsAppTemplateResponseSchema,
  updateWhatsAppTemplateSchema: () => updateWhatsAppTemplateSchema,
  whatsAppTemplateDeliveryModeSchema: () => whatsAppTemplateDeliveryModeSchema,
  whatsAppTemplateDetailSchema: () => whatsAppTemplateDetailSchema,
  whatsAppTemplateListQuerySchema: () => whatsAppTemplateListQuerySchema,
  whatsAppTemplateResponseSchema: () => whatsAppTemplateResponseSchema,
  whatsAppTemplateSchema: () => whatsAppTemplateSchema,
  whatsAppTemplateTipoEnum: () => whatsAppTemplateTipoEnum,
  whatsAppTemplateVariaveisCategoriaSchema: () => whatsAppTemplateVariaveisCategoriaSchema,
  whatsAppTemplateVariaveisResponseSchema: () => whatsAppTemplateVariaveisResponseSchema,
  whatsAppTemplateVariavelSchema: () => whatsAppTemplateVariavelSchema,
  whatsAppTemplatesResponseSchema: () => whatsAppTemplatesResponseSchema
});
var whatsAppTemplateTipoEnum = z.enum([
  "texto",
  "imagem",
  "video",
  "documento",
  "audio"
]);
var createWhatsAppTemplateSchema = z.object({
  nome: z.string().min(1).max(255),
  tipo: whatsAppTemplateTipoEnum,
  conteudo: z.any(),
  mensagem: z.string().min(1),
  midiaKey: z.string().optional(),
  ativo: z.boolean().optional()
});
var updateWhatsAppTemplateSchema = z.object({
  nome: z.string().max(255).optional(),
  tipo: whatsAppTemplateTipoEnum.optional(),
  conteudo: z.any().optional(),
  mensagem: z.string().optional(),
  midiaKey: z.string().optional(),
  ativo: z.boolean().optional()
});
var whatsAppTemplateDeliveryModeSchema = z.enum([
  "FREE_FORM",
  "CLOUD_TEMPLATE"
]);
var whatsAppTemplateListQuerySchema = z.object({
  page: z.coerce.number().optional(),
  take: z.coerce.number().optional(),
  search: z.string().optional(),
  tipo: whatsAppTemplateTipoEnum.optional(),
  ativo: booleanLike.optional(),
  deliveryMode: whatsAppTemplateDeliveryModeSchema.optional()
});
var metaTemplateApprovalStatusSchema = z.enum([
  "DRAFT",
  "PENDING",
  "APPROVED",
  "REJECTED",
  "PAUSED"
]);
var whatsAppTemplateSchema = z.object({
  id: z.string(),
  dashboardId: z.number().optional(),
  nome: z.string(),
  tipo: whatsAppTemplateTipoEnum,
  mensagem: z.string(),
  midiaKey: z.string().nullable().optional(),
  midiaUrl: z.string().nullable().optional(),
  ativo: z.boolean(),
  deliveryMode: whatsAppTemplateDeliveryModeSchema.optional(),
  metaApprovalStatus: metaTemplateApprovalStatusSchema.optional(),
  metaTemplateName: z.string().optional(),
  conteudo: z.any().optional(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var whatsAppTemplateDetailSchema = whatsAppTemplateSchema.extend({
  conteudo: z.any(),
  criadoPor: z.object({
    id: z.number(),
    nome: z.string(),
    sobrenome: z.string().optional(),
    email: z.string()
  }).nullable().optional()
});
var whatsAppTemplatesResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(whatsAppTemplateSchema),
  message: z.string().optional(),
  meta: z.object({
    total: z.number(),
    page: z.number(),
    limit: z.number().optional(),
    take: z.number().optional(),
    hasNext: z.boolean().optional(),
    hasPrev: z.boolean().optional(),
    pageCount: z.number().optional(),
    totalPages: z.number().optional(),
    pages: z.number().optional()
  })
});
var whatsAppTemplateResponseSchema = dataResponse(whatsAppTemplateDetailSchema);
var createWhatsAppTemplateResponseSchema = dataResponse(whatsAppTemplateDetailSchema);
var updateWhatsAppTemplateResponseSchema = dataResponse(whatsAppTemplateDetailSchema);
var deleteWhatsAppTemplateResponseSchema = messageResponseSchema;
var whatsAppTemplateVariavelSchema = z.object({
  nome: z.string(),
  label: z.string(),
  descricao: z.string(),
  exemplo: z.string()
});
var whatsAppTemplateVariaveisCategoriaSchema = z.object({
  categoria: z.string(),
  variaveis: z.array(whatsAppTemplateVariavelSchema)
});
var whatsAppTemplateVariaveisResponseSchema = dataResponse(
  z.array(whatsAppTemplateVariaveisCategoriaSchema)
);

// src/segmentos/index.ts
var segmentos_exports = {};
__export(segmentos_exports, {
  addContatoManualSchema: () => addContatoManualSchema,
  createSegmentoResponseSchema: () => createSegmentoResponseSchema,
  createSegmentoSchema: () => createSegmentoSchema,
  deleteSegmentoResponseSchema: () => deleteSegmentoResponseSchema,
  previewSegmentoResponseSchema: () => previewSegmentoResponseSchema,
  previewSegmentoSchema: () => previewSegmentoSchema,
  reprocessarSegmentoResponseSchema: () => reprocessarSegmentoResponseSchema,
  segmentoContatoItemSchema: () => segmentoContatoItemSchema,
  segmentoContatoJunctionListResponseSchema: () => segmentoContatoJunctionListResponseSchema,
  segmentoContatoJunctionSchema: () => segmentoContatoJunctionSchema,
  segmentoContatoJunctionSegmentoSchema: () => segmentoContatoJunctionSegmentoSchema,
  segmentoContatoOrigemFiltroEnum: () => segmentoContatoOrigemFiltroEnum,
  segmentoContatosQuerySchema: () => segmentoContatosQuerySchema,
  segmentoContatosResponseSchema: () => segmentoContatosResponseSchema,
  segmentoFiltroSchema: () => segmentoFiltroSchema,
  segmentoFormDataResponseSchema: () => segmentoFormDataResponseSchema,
  segmentoGrupoSchema: () => segmentoGrupoSchema,
  segmentoModoEnum: () => segmentoModoEnum,
  segmentoRegraLogicaEnum: () => segmentoRegraLogicaEnum,
  segmentoRegraSchema: () => segmentoRegraSchema,
  segmentoRegraTypeEnum: () => segmentoRegraTypeEnum,
  segmentoResponseSchema: () => segmentoResponseSchema,
  segmentoSchema: () => segmentoSchema,
  segmentoTipoEnum: () => segmentoTipoEnum,
  segmentosResponseSchema: () => segmentosResponseSchema,
  updateSegmentoResponseSchema: () => updateSegmentoResponseSchema,
  updateSegmentoSchema: () => updateSegmentoSchema
});
var segmentoTipoEnum = z.enum(["MANUAL", "AUTOMATICO"]);
var segmentoModoEnum = z.enum(["DINAMICO", "CONGELADO"]);
var segmentoRegraLogicaEnum = z.enum(["E", "OU"]);
var segmentoRegraTypeEnum = z.enum([
  "TODOS_CONTATOS",
  "LEAD_ORIGEM",
  "LEAD_STATUS",
  "LEAD_UTM_SOURCE",
  "LEAD_UTM_MEDIUM",
  "LEAD_UTM_CAMPAIGN",
  "LEAD_CAPTADO_PERIODO",
  "LEAD_RESPONSAVEL",
  "LEAD_INTERESSE_EMPREENDIMENTO",
  "LEAD_INTERESSE_IMOVEL",
  "CONTATO_PROPRIETARIO_IMOVEL",
  "OPORTUNIDADE_FUNIL",
  "OPORTUNIDADE_STATUS",
  "OPORTUNIDADE_FUNIL_STATUS",
  "OPORTUNIDADE_INTERESSE_EMPREENDIMENTO",
  "OPORTUNIDADE_INTERESSE_IMOVEL",
  "OPORTUNIDADE_COMPOSTA"
]);
var segmentoContatoOrigemFiltroEnum = z.enum(["REGRA", "MANUAL"]);
var segmentoRegraSchema = z.object({
  tipo: segmentoRegraTypeEnum,
  valores: z.array(z.any())
});
var segmentoGrupoSchema = z.object({
  logica: segmentoRegraLogicaEnum,
  regras: z.array(segmentoRegraSchema).min(1)
});
var segmentoFiltroSchema = z.object({
  logica: segmentoRegraLogicaEnum,
  regras: z.array(segmentoRegraSchema).optional(),
  grupos: z.array(segmentoGrupoSchema).optional()
});
var createSegmentoSchema = z.object({
  label: z.string().min(1),
  value: z.string().optional(),
  description: z.string().nullable().optional(),
  tipo: segmentoTipoEnum.optional(),
  modo: segmentoModoEnum.optional(),
  filtro: segmentoFiltroSchema.optional()
});
var updateSegmentoSchema = z.object({
  label: z.string().min(1),
  description: z.string().nullable().optional(),
  modo: segmentoModoEnum.optional(),
  filtro: segmentoFiltroSchema.optional()
});
var previewSegmentoSchema = z.object({
  filtro: segmentoFiltroSchema
});
var segmentoContatosQuerySchema = z.object({
  page: z.coerce.number().int().min(1).optional().default(1),
  limit: z.coerce.number().int().min(1).optional().default(20),
  bloqueado: z.preprocess((v) => {
    if (v === "true") return true;
    if (v === "false") return false;
    return v;
  }, z.boolean()).optional(),
  origemEntrada: segmentoContatoOrigemFiltroEnum.optional(),
  search: z.string().optional()
});
var addContatoManualSchema = z.object({
  contatoId: z.number()
});
var segmentoSchema = z.object({
  id: z.number(),
  dashboardId: z.number().nullable(),
  label: z.string(),
  value: z.string(),
  description: z.string().nullable().optional(),
  tipo: segmentoTipoEnum,
  modo: segmentoModoEnum,
  filtro: segmentoFiltroSchema.nullable().optional(),
  ativo: z.boolean().optional(),
  ultimoProcessamento: z.string().nullable().optional(),
  contatosCount: z.number().optional(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var segmentosResponseSchema = listResponse(segmentoSchema);
var segmentoResponseSchema = dataResponse(segmentoSchema);
var createSegmentoResponseSchema = dataResponse(segmentoSchema);
var updateSegmentoResponseSchema = dataResponse(segmentoSchema);
var deleteSegmentoResponseSchema = messageResponseSchema;
var previewSegmentoResponseSchema = dataResponse(z.object({ total: z.number() }));
var reprocessarSegmentoResponseSchema = dataResponse(
  z.object({
    adicionados: z.number(),
    removidos: z.number(),
    total: z.number()
  })
);
var segmentoContatoItemSchema = z.object({
  contatoId: z.number(),
  origemEntrada: z.enum(["REGRA", "MANUAL"]),
  bloqueado: z.boolean(),
  adicionadoEm: z.string(),
  contato: z.object({
    id: z.number(),
    nome: z.string(),
    email: z.string().nullable(),
    telefone: z.string().nullable(),
    foto: z.string().nullable()
  })
});
var segmentoContatosResponseSchema = z.object({
  success: z.boolean(),
  message: z.string().optional(),
  data: z.array(segmentoContatoItemSchema),
  meta: z.object({
    total: z.number(),
    page: z.number(),
    limit: z.number(),
    totalPages: z.number(),
    hasNext: z.boolean(),
    hasPrev: z.boolean()
  })
});
var segmentoFormDataResponseSchema = dataResponse(
  z.object({
    leadStatus: z.array(z.object({ value: z.string(), label: z.string() })),
    oportunidadeStatus: z.array(z.object({ value: z.string(), label: z.string() })),
    origens: z.array(z.object({ value: z.string(), label: z.string() })),
    responsaveis: z.array(
      z.object({
        id: z.number(),
        nome: z.string(),
        avatar: z.string().nullable()
      })
    ),
    funis: z.array(z.object({ id: z.number(), label: z.string() }))
  })
);
var segmentoContatoJunctionSegmentoSchema = z.object({
  id: z.number(),
  label: z.string(),
  value: z.string(),
  description: z.string().nullable()
});
var segmentoContatoJunctionSchema = z.object({
  contatoId: z.number(),
  segmentoId: z.number(),
  createdAt: z.string(),
  updatedAt: z.string(),
  segmento: segmentoContatoJunctionSegmentoSchema.optional()
});
var segmentoContatoJunctionListResponseSchema = dataResponse(
  z.array(segmentoContatoJunctionSchema)
);

// src/motivos-perda/index.ts
var motivos_perda_exports = {};
__export(motivos_perda_exports, {
  createMotivoPerdaResponseSchema: () => createMotivoPerdaResponseSchema,
  createMotivoPerdaSchema: () => createMotivoPerdaSchema,
  deleteMotivoPerdaResponseSchema: () => deleteMotivoPerdaResponseSchema,
  motivoPerdaListQuerySchema: () => motivoPerdaListQuerySchema,
  motivoPerdaResponseSchema: () => motivoPerdaResponseSchema,
  motivoPerdaSchema: () => motivoPerdaSchema2,
  motivosPerdaResponseSchema: () => motivosPerdaResponseSchema,
  updateMotivoPerdaResponseSchema: () => updateMotivoPerdaResponseSchema,
  updateMotivoPerdaSchema: () => updateMotivoPerdaSchema
});
var createMotivoPerdaSchema = z.object({
  value: z.string().max(100).optional(),
  label: z.string().min(1, "Label \xE9 obrigat\xF3rio").max(255)
});
var updateMotivoPerdaSchema = z.object({
  value: z.string().max(100).optional(),
  label: z.string().max(255).optional()
});
var motivoPerdaListQuerySchema = z.object({
  padrao: booleanLike.optional(),
  search: z.string().optional()
});
var motivoPerdaSchema2 = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string(),
  padrao: z.boolean(),
  dashboardId: z.number().nullable(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var motivosPerdaResponseSchema = listResponse(motivoPerdaSchema2);
var motivoPerdaResponseSchema = dataResponse(motivoPerdaSchema2);
var createMotivoPerdaResponseSchema = dataResponse(motivoPerdaSchema2);
var updateMotivoPerdaResponseSchema = dataResponse(motivoPerdaSchema2);
var deleteMotivoPerdaResponseSchema = messageResponseSchema;

// src/documentos-digitais/index.ts
var documentos_digitais_exports = {};
__export(documentos_digitais_exports, {
  createDocumentoGeradoResponseSchema: () => createDocumentoGeradoResponseSchema,
  createDocumentoModeloResponseSchema: () => createDocumentoModeloResponseSchema,
  createGeradoSchema: () => createGeradoSchema,
  createModeloSchema: () => createModeloSchema,
  deleteDocumentoGeradoResponseSchema: () => deleteDocumentoGeradoResponseSchema,
  deleteDocumentoModeloResponseSchema: () => deleteDocumentoModeloResponseSchema,
  documentoConteudoSchema: () => documentoConteudoSchema,
  documentoGeradoResponseSchema: () => documentoGeradoResponseSchema,
  documentoGeradoSchema: () => documentoGeradoSchema,
  documentoModeloResponseSchema: () => documentoModeloResponseSchema,
  documentoModeloSchema: () => documentoModeloSchema,
  documentosDigitaisListQuerySchema: () => documentosDigitaisListQuerySchema,
  documentosGeradosListResponseSchema: () => documentosGeradosListResponseSchema,
  documentosModelosListResponseSchema: () => documentosModelosListResponseSchema,
  editorJsOutputSchema: () => editorJsOutputSchema,
  envolvidoGrupoSchema: () => envolvidoGrupoSchema,
  envolvidoGrupoTipoEnum: () => envolvidoGrupoTipoEnum,
  geradoContextoSchema: () => geradoContextoSchema,
  gerarDocumentoEnvolvidoSelecaoSchema: () => gerarDocumentoEnvolvidoSelecaoSchema,
  gerarDocumentoResponseSchema: () => gerarDocumentoResponseSchema,
  gerarDocumentoSchema: () => gerarDocumentoSchema,
  tiptapDocumentSchema: () => tiptapDocumentSchema,
  updateDocumentoGeradoResponseSchema: () => updateDocumentoGeradoResponseSchema,
  updateDocumentoModeloResponseSchema: () => updateDocumentoModeloResponseSchema,
  updateGeradoSchema: () => updateGeradoSchema,
  updateModeloSchema: () => updateModeloSchema
});
var envolvidoGrupoTipoEnum = z.enum([
  "contato",
  "imovel",
  "empreendimento",
  "proposta",
  "registro_chave"
]);
var envolvidoGrupoSchema = z.object({
  id: z.string(),
  label: z.string(),
  slug: z.string(),
  tipo: envolvidoGrupoTipoEnum
});
var editorJsBlockSchema = z.object({
  id: z.string().optional(),
  type: z.string(),
  data: z.record(z.string(), z.unknown()),
  tunes: z.record(z.string(), z.unknown()).optional()
});
var editorJsOutputSchema = z.object({
  time: z.number().optional(),
  version: z.string().optional(),
  blocks: z.array(editorJsBlockSchema)
});
z.object({
  type: z.string(),
  attrs: z.record(z.string(), z.unknown()).optional()
});
var tiptapDocumentSchema = z.object({
  type: z.literal("doc"),
  content: z.array(z.record(z.string(), z.unknown())).optional()
});
var documentoConteudoSchema = tiptapDocumentSchema;
var createModeloSchema = z.object({
  titulo: z.string().min(1),
  conteudo: tiptapDocumentSchema,
  envolvidos: z.array(envolvidoGrupoSchema).optional()
});
var updateModeloSchema = z.object({
  titulo: z.string().min(1).optional(),
  conteudo: tiptapDocumentSchema.optional(),
  envolvidos: z.array(envolvidoGrupoSchema).optional()
});
var geradoContextoEnvolvidoSchema = z.object({
  slug: z.string(),
  label: z.string(),
  tipo: envolvidoGrupoTipoEnum,
  entityId: z.number().optional(),
  entityNome: z.string().optional(),
  entitySublabel: z.string().optional(),
  contatoId: z.number().optional(),
  contatoNome: z.string().optional()
});
var geradoContextoEntidadeSchema = z.object({
  id: z.number(),
  nome: z.string(),
  sublabel: z.string().optional()
});
var geradoContextoSchema = z.object({
  modeloId: z.string().nullable().optional(),
  modeloTitulo: z.string(),
  envolvidosGrupos: z.array(geradoContextoEnvolvidoSchema).optional(),
  contatos: z.array(geradoContextoEntidadeSchema).optional(),
  imoveis: z.array(geradoContextoEntidadeSchema).optional(),
  contatoId: z.number().optional(),
  contatoNome: z.string().optional(),
  imovelId: z.number().optional(),
  imovelTitulo: z.string().optional(),
  corretorId: z.number().optional(),
  corretorNome: z.string().optional()
});
var createGeradoSchema = z.object({
  titulo: z.string().min(1),
  conteudo: tiptapDocumentSchema,
  contexto: geradoContextoSchema
});
var gerarDocumentoEnvolvidoSelecaoSchema = z.object({
  slug: z.string(),
  label: z.string(),
  tipo: envolvidoGrupoTipoEnum,
  entityId: z.number().int().min(1).optional(),
  entityNome: z.string().optional(),
  entitySublabel: z.string().optional()
});
var gerarDocumentoSchema = z.object({
  modeloId: z.string().min(1),
  titulo: z.string().min(1).optional(),
  envolvidos: z.array(gerarDocumentoEnvolvidoSelecaoSchema).optional(),
  contatoIds: z.array(z.number().int().min(1)).optional(),
  imovelIds: z.array(z.number().int().min(1)).optional(),
  corretorId: z.number().int().min(1).optional()
});
var updateGeradoSchema = z.object({
  titulo: z.string().min(1).optional(),
  conteudo: tiptapDocumentSchema.optional()
});
var documentosDigitaisListQuerySchema = z.object({
  search: z.string().optional(),
  page: z.coerce.number().min(1).optional(),
  take: z.coerce.number().min(1).max(100).optional()
});
var documentoModeloSchema = z.object({
  id: z.string(),
  titulo: z.string(),
  conteudo: tiptapDocumentSchema,
  envolvidos: z.array(envolvidoGrupoSchema).optional().nullable(),
  criadoPorNome: z.string(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var documentoGeradoSchema = z.object({
  id: z.string(),
  titulo: z.string(),
  conteudo: tiptapDocumentSchema,
  contexto: geradoContextoSchema,
  geradoPorNome: z.string(),
  modeloId: z.string().optional().nullable(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var documentoModeloResponseSchema = dataResponse(documentoModeloSchema);
var documentosModelosListResponseSchema = listResponse(documentoModeloSchema);
var createDocumentoModeloResponseSchema = dataResponse(documentoModeloSchema);
var updateDocumentoModeloResponseSchema = dataResponse(documentoModeloSchema);
var deleteDocumentoModeloResponseSchema = messageResponseSchema;
var documentoGeradoResponseSchema = dataResponse(documentoGeradoSchema);
var documentosGeradosListResponseSchema = listResponse(documentoGeradoSchema);
var createDocumentoGeradoResponseSchema = dataResponse(documentoGeradoSchema);
var gerarDocumentoResponseSchema = dataResponse(documentoGeradoSchema);
var updateDocumentoGeradoResponseSchema = dataResponse(documentoGeradoSchema);
var deleteDocumentoGeradoResponseSchema = messageResponseSchema;

// src/autentique/index.ts
var autentique_exports = {};
__export(autentique_exports, {
  assinaturaDeliveryMethodEnum: () => assinaturaDeliveryMethodEnum,
  assinaturaSignatarioActionEnum: () => assinaturaSignatarioActionEnum,
  assinaturaSignatarioInputSchema: () => assinaturaSignatarioInputSchema,
  assinaturaSignatarioSchema: () => assinaturaSignatarioSchema,
  assinaturaSignatarioStatusEnum: () => assinaturaSignatarioStatusEnum,
  assinaturaSignatarioTipoEnum: () => assinaturaSignatarioTipoEnum,
  autentiqueCanalEnum: () => autentiqueCanalEnum,
  autentiqueConfigDataSchema: () => autentiqueConfigDataSchema,
  autentiqueConfigResponseSchema: () => autentiqueConfigResponseSchema,
  autentiqueConfigSchema: () => autentiqueConfigSchema,
  autentiqueSignatarioAcaoEnum: () => autentiqueSignatarioAcaoEnum,
  autentiqueSignatarioStatusEnum: () => autentiqueSignatarioStatusEnum,
  autentiqueTestConnectionResponseSchema: () => autentiqueTestConnectionResponseSchema,
  autentiqueWebhookEventSchema: () => autentiqueWebhookEventSchema,
  cancelarAssinaturaResponseSchema: () => cancelarAssinaturaResponseSchema,
  createAssinaturaSchema: () => createAssinaturaSchema,
  createDocumentoAssinaturaResponseSchema: () => createDocumentoAssinaturaResponseSchema,
  criarAssinaturaDocumentoOptionsSchema: () => criarAssinaturaDocumentoOptionsSchema,
  criarAssinaturaResponseSchema: () => criarAssinaturaResponseSchema,
  criarAssinaturaSchema: () => criarAssinaturaSchema,
  criarDocumentoAssinaturaResponseSchema: () => criarDocumentoAssinaturaResponseSchema,
  criarDocumentoAssinaturaSchema: () => criarDocumentoAssinaturaSchema,
  criarDocumentoAssinaturaSignatarioSchema: () => criarDocumentoAssinaturaSignatarioSchema,
  documentoAssinaturaResponseSchema: () => documentoAssinaturaResponseSchema,
  documentoAssinaturaResumoSchema: () => documentoAssinaturaResumoSchema,
  documentoAssinaturaSchema: () => documentoAssinaturaSchema,
  documentoAssinaturaSignatarioSchema: () => documentoAssinaturaSignatarioSchema,
  documentoAssinaturaStatusEnum: () => documentoAssinaturaStatusEnum,
  documentosAssinaturaListQuerySchema: () => documentosAssinaturaListQuerySchema,
  documentosAssinaturasListResponseSchema: () => documentosAssinaturasListResponseSchema,
  reenviarAssinaturaSchema: () => reenviarAssinaturaSchema,
  reenviarDocumentoAssinaturaResponseSchema: () => reenviarDocumentoAssinaturaResponseSchema,
  reenviarDocumentoAssinaturaSchema: () => reenviarDocumentoAssinaturaSchema,
  testAutentiqueConnectionDataSchema: () => testAutentiqueConnectionDataSchema,
  testAutentiqueConnectionResponseSchema: () => testAutentiqueConnectionResponseSchema,
  testAutentiqueResponseSchema: () => testAutentiqueResponseSchema,
  updateAutentiqueConfigResponseSchema: () => updateAutentiqueConfigResponseSchema,
  updateAutentiqueConfigSchema: () => updateAutentiqueConfigSchema
});
var autentiqueConfigSchema = z.object({
  enabled: z.boolean(),
  sandbox: z.boolean(),
  hasToken: z.boolean(),
  organizationId: z.string().nullish()
});
var updateAutentiqueConfigSchema = z.object({
  apiToken: z.string().optional(),
  sandbox: z.boolean().optional(),
  enabled: z.boolean().optional(),
  organizationId: z.union([z.string(), z.number().int()]).nullable().optional()
});
var testAutentiqueConnectionDataSchema = z.object({
  connected: z.boolean(),
  organizationId: z.string().optional(),
  organizationName: z.string().optional(),
  sandbox: z.boolean().optional(),
  message: z.string().optional()
});
var testAutentiqueConnectionResponseSchema = dataResponse(
  testAutentiqueConnectionDataSchema
);
var autentiqueConfigResponseSchema = dataResponse(autentiqueConfigSchema);
var updateAutentiqueConfigResponseSchema = dataResponse(autentiqueConfigSchema);
var assinaturaSignatarioTipoEnum = z.enum(["envolvido", "testemunha"]);
var assinaturaSignatarioActionEnum = z.enum([
  "SIGN",
  "SIGN_AS_A_WITNESS",
  "APPROVE",
  "RECOGNIZE",
  "ACKNOWLEDGE_RECEIPT",
  "ENDORSE_IN_BLACK",
  "ENDORSE_IN_WHITE"
]);
var assinaturaDeliveryMethodEnum = z.enum(["EMAIL", "WHATSAPP", "LINK"]);
var assinaturaSignatarioInputSchema = z.object({
  slug: z.string().optional(),
  label: z.string().min(1),
  tipo: assinaturaSignatarioTipoEnum,
  action: assinaturaSignatarioActionEnum,
  deliveryMethod: assinaturaDeliveryMethodEnum,
  email: z.string().email().optional(),
  phone: z.string().optional(),
  nome: z.string().optional()
});
var criarAssinaturaDocumentoOptionsSchema = z.object({
  refusable: z.boolean().optional(),
  sortable: z.boolean().optional(),
  message: z.string().optional(),
  deadline_at: z.string().optional()
});
var criarAssinaturaSchema = z.object({
  signatarios: z.array(assinaturaSignatarioInputSchema).min(1),
  document: criarAssinaturaDocumentoOptionsSchema.optional()
});
var assinaturaSignatarioStatusEnum = z.enum([
  "pendente",
  "visualizado",
  "assinado",
  "recusado",
  "expirado",
  "erro"
]);
var assinaturaSignatarioSchema = z.object({
  id: z.string(),
  slug: z.string().nullish(),
  label: z.string(),
  tipo: assinaturaSignatarioTipoEnum,
  action: assinaturaSignatarioActionEnum,
  deliveryMethod: assinaturaDeliveryMethodEnum,
  email: z.string().nullish(),
  phone: z.string().nullish(),
  nome: z.string().nullish(),
  status: assinaturaSignatarioStatusEnum,
  link: z.string().nullish(),
  autentiquePublicId: z.string().nullish(),
  viewedAt: z.string().nullish(),
  signedAt: z.string().nullish(),
  rejectedAt: z.string().nullish(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var documentoAssinaturaStatusEnum = z.enum([
  "rascunho",
  "enviado",
  "parcial",
  "concluido",
  "recusado",
  "cancelado",
  "expirado",
  "erro"
]);
var documentoAssinaturaSchema = z.object({
  id: z.string(),
  documentoGeradoId: z.string().nullish(),
  titulo: z.string(),
  status: documentoAssinaturaStatusEnum,
  autentiqueDocumentId: z.string().nullish(),
  signatarios: z.array(assinaturaSignatarioSchema),
  refusable: z.boolean().optional(),
  sortable: z.boolean().optional(),
  message: z.string().nullish(),
  deadlineAt: z.string().nullish(),
  signedFileUrl: z.string().nullish(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var documentoAssinaturaResponseSchema = dataResponse(documentoAssinaturaSchema);
var documentosAssinaturaListQuerySchema = z.object({
  search: z.string().optional(),
  status: documentoAssinaturaStatusEnum.optional(),
  page: z.coerce.number().min(1).optional(),
  take: z.coerce.number().min(1).max(100).optional()
});
var documentoAssinaturaResumoSchema = z.object({
  id: z.string(),
  documentoGeradoId: z.string(),
  documentoTitulo: z.string(),
  status: documentoAssinaturaStatusEnum,
  signatariosTotal: z.number(),
  signatariosPendentes: z.number(),
  signatariosAssinados: z.number(),
  deadlineAt: z.string().nullish(),
  signedFileUrl: z.string().nullish(),
  updatedAt: z.string()
});
var documentosAssinaturasListResponseSchema = listResponse(
  documentoAssinaturaResumoSchema
);
var criarAssinaturaResponseSchema = dataResponse(documentoAssinaturaSchema);
var cancelarAssinaturaResponseSchema = messageResponseSchema;
var autentiqueWebhookEventSchema = z.object({
  event: z.object({
    type: z.string(),
    organization: z.union([z.number(), z.string()]),
    data: z.object({
      object: z.record(z.string(), z.unknown())
    })
  })
});
var autentiqueConfigDataSchema = autentiqueConfigSchema;
var testAutentiqueResponseSchema = testAutentiqueConnectionResponseSchema;
var autentiqueTestConnectionResponseSchema = testAutentiqueConnectionResponseSchema;
var createAssinaturaSchema = criarAssinaturaSchema;
var createDocumentoAssinaturaResponseSchema = criarAssinaturaResponseSchema;
var criarDocumentoAssinaturaSchema = criarAssinaturaSchema;
var criarDocumentoAssinaturaResponseSchema = criarAssinaturaResponseSchema;
var criarDocumentoAssinaturaSignatarioSchema = assinaturaSignatarioInputSchema;
var documentoAssinaturaSignatarioSchema = assinaturaSignatarioSchema;
var autentiqueSignatarioStatusEnum = assinaturaSignatarioStatusEnum;
var autentiqueCanalEnum = assinaturaDeliveryMethodEnum;
var autentiqueSignatarioAcaoEnum = assinaturaSignatarioActionEnum;
var reenviarAssinaturaSchema = z.object({
  /** IDs locais dos signatários. Vazio = reenvia para todos os pendentes. */
  signatarioIds: z.array(z.string()).optional()
});
var reenviarDocumentoAssinaturaSchema = reenviarAssinaturaSchema;
var reenviarDocumentoAssinaturaResponseSchema = messageResponseSchema;

// src/email-config/index.ts
var email_config_exports = {};
__export(email_config_exports, {
  dashboardEmailConfigResponseSchema: () => dashboardEmailConfigResponseSchema,
  dashboardEmailConfigSchema: () => dashboardEmailConfigSchema,
  emailConfigDominioSchema: () => emailConfigDominioSchema,
  emailConfigLocalPartSchema: () => emailConfigLocalPartSchema,
  updateDashboardEmailConfigResponseSchema: () => updateDashboardEmailConfigResponseSchema,
  updateDashboardEmailConfigSchema: () => updateDashboardEmailConfigSchema
});
var emailConfigDominioSchema = z.string().trim().max(253, "Dom\xEDnio muito longo (m\xE1ximo 253 caracteres)").regex(
  /^([a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,}$/i,
  "Formato de dom\xEDnio inv\xE1lido (ex: imobiliaria.com.br)"
);
var emailConfigLocalPartSchema = z.string().trim().min(1, "Informe a parte local do e-mail (ex: contato)").max(64, "Parte local muito longa (m\xE1ximo 64 caracteres)").regex(
  /^[a-z0-9._+-]+$/i,
  "Use apenas letras, n\xFAmeros, ponto, h\xEDfen ou underscore"
);
var dashboardEmailConfigSchema = z.object({
  enabled: z.boolean(),
  dominio: emailConfigDominioSchema.nullable(),
  fromLocalPart: emailConfigLocalPartSchema,
  fromName: z.string().trim().max(120).nullable(),
  replyToEmail: z.string().trim().email("Reply-To inv\xE1lido").nullable(),
  fromPreview: z.string().nullable(),
  /** Remetente efetivo hoje: domínio próprio ou padrão ImobDesk. */
  effectiveFromPreview: z.string(),
  usesPlatformDefault: z.boolean(),
  platformDefaultFrom: z.string(),
  suggestedDominio: z.string().nullable(),
  /** null = domínio desativado ou SES indisponível para consulta */
  sesDominioVerificado: z.boolean().nullable(),
  sesDominioStatus: z.enum(["Success", "Pending", "Failed", "NotStarted", "Unknown"]).nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime()
});
var updateDashboardEmailConfigSchema = z.object({
  enabled: z.boolean().optional(),
  dominio: emailConfigDominioSchema.nullable().optional(),
  fromLocalPart: emailConfigLocalPartSchema.optional(),
  fromName: z.string().trim().max(120).nullable().optional(),
  replyToEmail: z.string().trim().email("Reply-To inv\xE1lido").nullable().optional()
}).superRefine((data, ctx) => {
  if (data.enabled === true) {
    if (data.dominio === void 0) {
      ctx.addIssue({
        code: "custom",
        message: "Informe o dom\xEDnio quando o envio personalizado estiver ativo",
        path: ["dominio"]
      });
    } else if (!data.dominio) {
      ctx.addIssue({
        code: "custom",
        message: "Informe o dom\xEDnio quando o envio personalizado estiver ativo",
        path: ["dominio"]
      });
    }
  }
});
var dashboardEmailConfigResponseSchema = dataResponse(
  dashboardEmailConfigSchema
);
var updateDashboardEmailConfigResponseSchema = messageResponseSchema.extend(
  {
    data: dashboardEmailConfigSchema
  }
);

// src/data-comodidades/index.ts
var data_comodidades_exports = {};
__export(data_comodidades_exports, {
  categoriaComodidadeComComodidadesSchema: () => categoriaComodidadeComComodidadesSchema,
  categoriaComodidadeSchema: () => categoriaComodidadeSchema,
  categoriasComodidadeEmpreendimentosResponseSchema: () => categoriasComodidadeEmpreendimentosResponseSchema,
  categoriasComodidadeResponseSchema: () => categoriasComodidadeResponseSchema,
  comodidadeDetailResponseSchema: () => comodidadeDetailResponseSchema,
  comodidadeSchema: () => comodidadeSchema,
  comodidadeTipoEnum: () => comodidadeTipoEnum,
  comodidadesResponseSchema: () => comodidadesResponseSchema,
  createComodidadeRequestSchema: () => createComodidadeRequestSchema,
  createComodidadeResponseSchema: () => createComodidadeResponseSchema,
  createDataComodidadeSchema: () => createDataComodidadeSchema,
  dataComodidadeResponseSchema: () => dataComodidadeResponseSchema,
  dataComodidadeSchema: () => dataComodidadeSchema,
  dataComodidadesResponseSchema: () => dataComodidadesResponseSchema,
  deleteComodidadeResponseSchema: () => deleteComodidadeResponseSchema,
  deleteDataComodidadeResponseSchema: () => deleteDataComodidadeResponseSchema,
  updateComodidadeRequestSchema: () => updateComodidadeRequestSchema,
  updateComodidadeResponseSchema: () => updateComodidadeResponseSchema,
  updateDataComodidadeSchema: () => updateDataComodidadeSchema
});
var comodidadeTipoEnum = z.enum(["imovel", "empreendimento"]);
var createDataComodidadeSchema = z.object({
  label: z.string().min(1),
  value: z.string().optional(),
  quantidades: z.boolean(),
  categoria: z.number()
});
var updateDataComodidadeSchema = createDataComodidadeSchema;
var dataComodidadeSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string(),
  quantidades: z.boolean(),
  padrao: z.boolean(),
  dashboardId: z.number().nullable(),
  categoriaId: z.number(),
  categoria: z.object({ id: z.number(), value: z.string(), label: z.string() }).optional()
});
var dataComodidadesResponseSchema = listResponse(dataComodidadeSchema);
var dataComodidadeResponseSchema = dataResponse(dataComodidadeSchema);
var deleteDataComodidadeResponseSchema = messageResponseSchema;
var categoriaComodidadeSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string()
});
var categoriaComodidadeComComodidadesSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string(),
  comodidades: z.array(
    z.object({
      id: z.number(),
      value: z.string(),
      label: z.string(),
      quantidades: z.boolean(),
      padrao: z.boolean(),
      categoriaId: z.number()
    })
  ).optional()
});
var categoriasComodidadeResponseSchema = listResponse(
  categoriaComodidadeSchema
);
var categoriasComodidadeEmpreendimentosResponseSchema = listResponse(
  categoriaComodidadeComComodidadesSchema
);
var comodidadeSchema = dataComodidadeSchema.extend({
  dashboardId: z.preprocess(
    (val) => val === void 0 ? null : val,
    z.number().nullable()
  ),
  categoriaId: z.number().optional(),
  categoria: categoriaComodidadeSchema.optional()
});
var comodidadesResponseSchema = listResponse(comodidadeSchema);
var comodidadeDetailResponseSchema = dataResponse(comodidadeSchema);
var createComodidadeRequestSchema = z.object({
  label: z.string().max(255, "O label deve ter no m\xE1ximo 255 caracteres"),
  value: z.string().max(50, "O value deve ter no m\xE1ximo 50 caracteres").regex(
    /^[a-z0-9-]+$/,
    "O value deve ser um slug v\xE1lido (apenas letras min\xFAsculas, n\xFAmeros e h\xEDfens)"
  ).transform((val) => val.replace(/^-+|-+$/g, "")).refine(
    (val) => !val || /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(val),
    "O value n\xE3o pode come\xE7ar ou terminar com tra\xE7o"
  ).optional(),
  quantidades: z.boolean(),
  categoria: z.number().int().positive("A categoria \xE9 obrigat\xF3ria")
});
var createComodidadeResponseSchema = dataResponse(comodidadeSchema).extend({
  message: z.string()
});
var updateComodidadeRequestSchema = z.object({
  label: z.string().max(255).optional(),
  value: z.string().max(50, "O value deve ter no m\xE1ximo 50 caracteres").regex(
    /^[a-z0-9-]+$/,
    "O value deve ser um slug v\xE1lido (apenas letras min\xFAsculas, n\xFAmeros e h\xEDfens)"
  ).transform((val) => val.replace(/^-+|-+$/g, "")).refine(
    (val) => !val || /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(val),
    "O value n\xE3o pode come\xE7ar ou terminar com tra\xE7o"
  ).optional(),
  quantidades: z.boolean().optional(),
  categoria: z.number().int().positive().optional()
});
var updateComodidadeResponseSchema = dataResponse(comodidadeSchema).extend({
  message: z.string()
});
var deleteComodidadeResponseSchema = messageResponseSchema;

// src/lead-checkin/index.ts
var lead_checkin_exports = {};
__export(lead_checkin_exports, {
  checkinAtivoItemSchema: () => checkinAtivoItemSchema,
  checkinDataSchema: () => checkinDataSchema,
  checkinResponseSchema: () => checkinResponseSchema2,
  checkinSchema: () => checkinSchema,
  checkinStatusDataSchema: () => checkinStatusDataSchema,
  checkinStatusResponseSchema: () => checkinStatusResponseSchema2,
  checkinsAtivosResponseSchema: () => checkinsAtivosResponseSchema,
  checkoutSchema: () => checkoutSchema,
  historicoCheckinItemSchema: () => historicoCheckinItemSchema,
  historicoCheckinQuerySchema: () => historicoCheckinQuerySchema,
  historicoCheckinResponseSchema: () => historicoCheckinResponseSchema,
  pausaSchema: () => pausaSchema,
  publicCheckinRenovacaoDataSchema: () => publicCheckinRenovacaoDataSchema,
  publicCheckinRenovacaoResponseSchema: () => publicCheckinRenovacaoResponseSchema,
  publicCheckinStatusDataSchema: () => publicCheckinStatusDataSchema,
  publicCheckinStatusResponseSchema: () => publicCheckinStatusResponseSchema,
  publicCheckinTokenParamSchema: () => publicCheckinTokenParamSchema
});
var checkinSchema = z.object({
  checkinFim: z.string().optional()
});
var checkoutSchema = z.object({
  motivo: z.string().optional()
});
var pausaSchema = z.object({
  pausaFim: z.string().optional(),
  motivo: z.string().optional()
});
var historicoCheckinQuerySchema = z.object({
  page: z.coerce.number().int().min(1).optional(),
  limit: z.coerce.number().int().min(1).optional(),
  usuarioId: z.coerce.number().int().optional(),
  tipo: z.string().optional()
});
var checkinDataSchema = z.object({
  usuarioId: z.number(),
  checkinAtivo: z.boolean(),
  checkinInicio: z.string().nullable(),
  checkinFim: z.string().nullable(),
  checkinPausado: z.boolean(),
  checkinUltimaRenovacao: z.string().nullable()
});
var checkinResponseSchema2 = z.object({
  success: z.boolean(),
  message: z.string(),
  data: checkinDataSchema
});
var checkinStatusDataSchema = checkinDataSchema.extend({
  nome: z.string().nullable(),
  sobrenome: z.string().nullable(),
  checkinPausaInicio: z.string().nullable(),
  checkinPausaFim: z.string().nullable(),
  proximaRenovacao: z.string().nullable(),
  disponibilidade: z.string(),
  intervaloRevalidacao: z.number().nullable(),
  permitirPausa: z.boolean(),
  habilitarPlantao: z.boolean().optional().default(false)
});
var checkinStatusResponseSchema2 = dataResponse(checkinStatusDataSchema);
var checkinAtivoItemSchema = z.object({
  usuarioId: z.number(),
  nome: z.string().nullable(),
  sobrenome: z.string().nullable(),
  checkinAtivo: z.boolean(),
  checkinInicio: z.string().nullable(),
  checkinFim: z.string().nullable(),
  checkinPausado: z.boolean(),
  checkinUltimaRenovacao: z.string().nullable()
});
var checkinsAtivosResponseSchema = dataResponse(
  z.array(checkinAtivoItemSchema)
);
var historicoCheckinItemSchema = z.object({
  id: z.number(),
  tipo: z.string(),
  motivo: z.string().nullable(),
  origemAcao: z.string(),
  usuarioId: z.number(),
  usuarioNome: z.string().nullable(),
  checkinInicioRef: z.string().nullable(),
  metadados: z.any().nullable(),
  createdAt: z.string()
});
var historicoCheckinResponseSchema = z.object({
  success: z.boolean(),
  data: z.object({
    registros: z.array(historicoCheckinItemSchema),
    paginacao: z.object({
      page: z.number(),
      limit: z.number(),
      total: z.number(),
      totalPages: z.number()
    })
  })
});
var publicCheckinTokenParamSchema = z.object({
  token: z.string().min(1)
});
var publicCheckinStatusDataSchema = z.object({
  nome: z.string(),
  dashboard: z.string(),
  checkinAtivo: z.boolean(),
  checkinPausado: z.boolean(),
  tempoRestanteMinutos: z.number().nullable(),
  intervaloRevalidacao: z.number().nullable()
});
var publicCheckinStatusResponseSchema = dataResponse(
  publicCheckinStatusDataSchema
);
var publicCheckinRenovacaoDataSchema = z.object({
  checkinAtivo: z.boolean(),
  renovadoEm: z.string(),
  proximaRenovacao: z.string().nullable()
});
var publicCheckinRenovacaoResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  data: publicCheckinRenovacaoDataSchema
});

// src/pulse-carteira/index.ts
var pulse_carteira_exports = {};
__export(pulse_carteira_exports, {
  marcarStatusImovelVerificacaoResponseSchema: () => marcarStatusImovelVerificacaoResponseSchema,
  marcarStatusImovelVerificacaoSchema: () => marcarStatusImovelVerificacaoSchema,
  pulseCarteiraBulkPulseRequestSchema: () => pulseCarteiraBulkPulseRequestSchema,
  pulseCarteiraBulkPulseResponseSchema: () => pulseCarteiraBulkPulseResponseSchema,
  pulseCarteiraConfigResponseSchema: () => pulseCarteiraConfigResponseSchema,
  pulseCarteiraConfigSchema: () => pulseCarteiraConfigSchema,
  pulseCarteiraDispararAgoraResponseSchema: () => pulseCarteiraDispararAgoraResponseSchema,
  pulseCarteiraDispararResponseSchema: () => pulseCarteiraDispararResponseSchema,
  pulseCarteiraImoveisQuerySchema: () => pulseCarteiraImoveisQuerySchema,
  pulseCarteiraImoveisResponseSchema: () => pulseCarteiraImoveisResponseSchema,
  pulseCarteiraImovelPulseResponseSchema: () => pulseCarteiraImovelPulseResponseSchema,
  pulseCarteiraMetricasResponseSchema: () => pulseCarteiraMetricasResponseSchema,
  pulseCarteiraMetricasSchema: () => pulseCarteiraMetricasSchema,
  pulseCarteiraPreviewTokenResponseSchema: () => pulseCarteiraPreviewTokenResponseSchema,
  pulseCarteiraReenviarResponseSchema: () => pulseCarteiraReenviarResponseSchema,
  pulseCarteiraRespostaEnum: () => pulseCarteiraRespostaEnum,
  pulseCarteiraRespostasQuerySchema: () => pulseCarteiraRespostasQuerySchema,
  pulseCarteiraRespostasResponseSchema: () => pulseCarteiraRespostasResponseSchema,
  pulseCarteiraStatusEnum: () => pulseCarteiraStatusEnum,
  pulseCarteiraVerificacaoContatoSchema: () => pulseCarteiraVerificacaoContatoSchema,
  pulseCarteiraVerificacaoImovelSchema: () => pulseCarteiraVerificacaoImovelSchema,
  pulseCarteiraVerificacaoSchema: () => pulseCarteiraVerificacaoSchema,
  pulseCarteiraVerificacoesQuerySchema: () => pulseCarteiraVerificacoesQuerySchema,
  pulseCarteiraVerificacoesResponseSchema: () => pulseCarteiraVerificacoesResponseSchema,
  pulseCarteiraWhatsappInstancesResponseSchema: () => pulseCarteiraWhatsappInstancesResponseSchema,
  pulseImovelListItemSchema: () => pulseImovelListItemSchema,
  pulsePerguntaSchema: () => pulsePerguntaSchema,
  pulsePublicPreviewDataSchema: () => pulsePublicPreviewDataSchema,
  pulsePublicPreviewResponseSchema: () => pulsePublicPreviewResponseSchema,
  pulsePublicRespostaResponseSchema: () => pulsePublicRespostaResponseSchema,
  pulsePublicVerificacaoDataSchema: () => pulsePublicVerificacaoDataSchema,
  pulsePublicVerificacaoResponseSchema: () => pulsePublicVerificacaoResponseSchema,
  pulseRespostaItemSchema: () => pulseRespostaItemSchema,
  pulseRespostaPublicaSchema: () => pulseRespostaPublicaSchema,
  pulseWhatsappInstanceRefSchema: () => pulseWhatsappInstanceRefSchema,
  updateImovelPulseSchema: () => updateImovelPulseSchema,
  updatePulseCarteiraConfigSchema: () => updatePulseCarteiraConfigSchema
});
var pulseCarteiraStatusEnum = z.enum([
  "PENDENTE",
  "FILA",
  "ENVIADO",
  "VISUALIZADO",
  "RESPONDIDO",
  "EXPIRADO",
  "FALHOU",
  "CANCELADO"
]);
var pulseCarteiraRespostaEnum = z.enum(["DISPONIVEL", "VENDIDO", "LOCADO"]);
var pulsePerguntaSchema = z.object({
  id: z.string(),
  titulo: z.string(),
  tipo: z.string(),
  obrigatoria: z.boolean(),
  ordem: z.number().int(),
  ativa: z.boolean(),
  opcoes: z.array(z.object({ id: z.string(), label: z.string(), ordem: z.number() })).optional(),
  exibirQuando: z.array(z.enum(["DISPONIVEL", "VENDIDO", "LOCADO"])).optional(),
  condicional: z.object({ perguntaId: z.string(), valor: z.string() }).optional()
});
var updatePulseCarteiraConfigSchema = z.object({
  ativo: z.boolean().optional(),
  intervaloEmDias: z.number().int().min(1).max(365).optional(),
  mensagemTemplate: z.string().optional(),
  mudarStatusAuto: z.boolean().optional(),
  statusDestino: z.string().optional(),
  acaoExpiracaoAtiva: z.boolean().optional(),
  statusAoExpirar: z.string().optional(),
  horarioEnvio: z.string().optional(),
  diasSemana: z.array(z.number().int()).optional(),
  diasExpiracaoToken: z.number().int().min(1).max(30).optional(),
  reenviarCadaDias: z.number().int().min(1).max(30).nullish(),
  perguntas: z.array(pulsePerguntaSchema).optional(),
  whatsappInstanceId: z.number().int().nullish()
});
var pulseCarteiraVerificacoesQuerySchema = z.object({
  status: z.string().optional(),
  resposta: z.string().optional(),
  busca: z.string().optional(),
  dataInicio: z.string().optional(),
  dataFim: z.string().optional(),
  page: z.coerce.number().int().min(1).optional().default(1),
  perPage: z.coerce.number().int().min(1).max(100).optional().default(20)
});
var pulseRespostaPublicaSchema = z.object({
  resposta: z.string(),
  respostaPesquisa: z.record(z.string(), z.any()).optional()
});
var updateImovelPulseSchema = z.object({
  pulseCarteiraAtivo: z.boolean()
});
var marcarStatusImovelVerificacaoSchema = z.object({
  statusImovel: z.enum(["Publicado", "Indisponivel"])
});
var pulseWhatsappInstanceRefSchema = z.object({
  id: z.number(),
  instanceName: z.string(),
  nome: z.string().nullable().optional(),
  number: z.string().nullable().optional(),
  connectionState: z.string(),
  isDefault: z.boolean().optional()
});
var pulseLocalizacaoSchema = z.object({
  rua: z.string().nullable().optional(),
  numero: z.string().nullable().optional(),
  bairro: z.string().nullable().optional(),
  cidade: z.string().nullable().optional(),
  uf: z.string().nullable().optional()
});
var pulseCarteiraConfigSchema = z.object({
  id: z.number(),
  dashboardId: z.number(),
  ativo: z.boolean(),
  intervaloEmDias: z.number(),
  mensagemTemplate: z.string().nullable().optional(),
  mudarStatusAuto: z.boolean(),
  statusDestino: z.string().nullable().optional(),
  acaoExpiracaoAtiva: z.boolean(),
  statusAoExpirar: z.string().nullable().optional(),
  horarioEnvio: z.string(),
  diasSemana: z.array(z.number()),
  diasExpiracaoToken: z.number(),
  reenviarCadaDias: z.number().nullable().optional(),
  perguntas: z.array(pulsePerguntaSchema),
  whatsappInstanceId: z.number().nullable().optional(),
  whatsappInstance: pulseWhatsappInstanceRefSchema.nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var pulseCarteiraVerificacaoImovelSchema = z.object({
  id: z.number(),
  codigo: z.string(),
  titulo: z.string(),
  status: z.string(),
  localizacao: pulseLocalizacaoSchema.nullable().optional()
});
var pulseCarteiraVerificacaoContatoSchema = z.object({
  id: z.number(),
  nome: z.string(),
  telefone: z.string().nullable().optional(),
  email: z.string().nullable().optional()
});
var pulseCarteiraVerificacaoSchema = z.object({
  id: z.number(),
  dashboardId: z.number(),
  imovelId: z.number(),
  contatoId: z.number(),
  token: z.string(),
  status: pulseCarteiraStatusEnum,
  agendadoPara: z.string(),
  enviadoEm: z.string().nullable().optional(),
  visualizadoEm: z.string().nullable().optional(),
  respondidoEm: z.string().nullable().optional(),
  expiraEm: z.string(),
  resposta: pulseCarteiraRespostaEnum.nullable().optional(),
  respostaPesquisa: z.record(z.string(), z.any()).nullable().optional(),
  perguntasSnapshot: z.any().nullable().optional(),
  tentativas: z.number(),
  falhaMotivo: z.string().nullable().optional(),
  rodadaId: z.string().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
  imovel: pulseCarteiraVerificacaoImovelSchema.optional(),
  contato: pulseCarteiraVerificacaoContatoSchema.optional()
});
var pulseCarteiraMetricasSchema = z.object({
  total: z.number(),
  porStatus: z.record(z.string(), z.number()),
  porResposta: z.record(z.string(), z.number()),
  taxaResposta: z.number(),
  respostasPesquisa: z.object({
    porPergunta: z.record(z.string(), z.record(z.string(), z.number())),
    satisfacaoMedia: z.number().nullable(),
    totalRespondidas: z.number()
  }),
  periodo: z.string()
});
var pulseCarteiraConfigResponseSchema = pulseCarteiraConfigSchema;
var pulseCarteiraVerificacoesResponseSchema = z.object({
  items: z.array(pulseCarteiraVerificacaoSchema),
  total: z.number().catch(0),
  page: z.number().catch(1),
  perPage: z.number().catch(20),
  totalPages: z.number().catch(0)
});
var pulseCarteiraMetricasResponseSchema = pulseCarteiraMetricasSchema;
var marcarStatusImovelVerificacaoResponseSchema = z.object({
  success: z.boolean(),
  imovelId: z.number(),
  statusImovel: z.enum(["Publicado", "Indisponivel"])
});
var pulsePublicDashboardSchema = z.object({
  titulo: z.string(),
  logo: z.string().nullable().optional()
});
var pulsePublicFinalidadeSchema = z.object({
  finalidade: z.object({ label: z.string() })
});
var pulsePublicImovelSchema = z.object({
  id: z.number().optional(),
  codigo: z.string(),
  titulo: z.string(),
  status: z.string().optional(),
  fotos: z.array(z.object({ url: z.string() })).optional(),
  localizacao: pulseLocalizacaoSchema.optional(),
  valoresVenda: z.array(z.object({ valor: z.union([z.string(), z.number()]) })).optional(),
  valoresLocacao: z.array(z.object({ valor: z.union([z.string(), z.number()]) })).optional(),
  finalidades: z.array(pulsePublicFinalidadeSchema).optional()
});
var pulsePublicVerificacaoDataSchema = z.object({
  jaRespondido: z.boolean(),
  imovel: pulsePublicImovelSchema,
  contato: z.object({ nome: z.string().nullable().optional() }),
  dashboard: pulsePublicDashboardSchema,
  perguntas: z.array(z.any()).optional(),
  respostaAnterior: pulseCarteiraRespostaEnum.nullable().optional()
});
var pulsePublicVerificacaoResponseSchema = dataResponse(
  pulsePublicVerificacaoDataSchema
);
var pulsePublicPreviewDataSchema = z.object({
  isPreview: z.literal(true),
  dashboard: pulsePublicDashboardSchema,
  perguntas: z.array(pulsePerguntaSchema),
  imovel: pulsePublicImovelSchema,
  contato: z.object({ nome: z.string() })
});
var pulsePublicPreviewResponseSchema = dataResponse(
  pulsePublicPreviewDataSchema
);
var pulsePublicRespostaResponseSchema = messageResponseSchema;
var pulseCarteiraImoveisQuerySchema = z.object({
  busca: z.string().optional(),
  pulseAtivo: booleanLike.optional(),
  page: z.coerce.number().int().min(1).optional().default(1),
  perPage: z.coerce.number().int().min(1).max(100).optional().default(20)
});
var pulseCarteiraRespostasQuerySchema = z.object({
  page: z.coerce.number().int().min(1).optional().default(1),
  perPage: z.coerce.number().int().min(1).max(100).optional().default(20),
  resposta: z.string().optional()
});
var pulseCarteiraBulkPulseRequestSchema = z.object({
  imovelIds: z.array(z.number().int()),
  pulseCarteiraAtivo: z.boolean()
});
var pulseCarteiraDispararResponseSchema = z.object({
  success: z.boolean(),
  criadas: z.number(),
  enviadas: z.number()
});
var pulseCarteiraReenviarResponseSchema = messageResponseSchema;
var pulseCarteiraPreviewTokenResponseSchema = z.object({
  token: z.string(),
  expiresAt: z.string()
});
var pulseCarteiraWhatsappInstancesResponseSchema = z.array(
  pulseWhatsappInstanceRefSchema
);
var pulseCarteiraImovelPulseResponseSchema = z.object({
  id: z.number(),
  codigo: z.string(),
  titulo: z.string(),
  pulseCarteiraAtivo: z.boolean()
});
var pulseCarteiraDispararAgoraResponseSchema = z.object({
  criadas: z.number(),
  enfileiradas: z.number(),
  mensagem: z.string()
});
var pulseCarteiraBulkPulseResponseSchema = z.object({
  success: z.boolean(),
  updated: z.number()
});
var pulseImovelProprietarioRefSchema = z.object({
  proprietario: z.object({
    nome: z.string().nullable().optional(),
    telefone: z.string().nullable().optional()
  })
});
var pulseImovelListItemSchema = z.object({
  id: z.number(),
  codigo: z.string(),
  titulo: z.string(),
  status: z.string(),
  pulseCarteiraAtivo: z.boolean(),
  localizacao: pulseLocalizacaoSchema.nullable().optional(),
  proprietarios: z.array(pulseImovelProprietarioRefSchema).optional(),
  _count: z.object({
    pulseCarteiraVerificacoes: z.number().optional()
  }).optional()
});
var pulseCarteiraImoveisResponseSchema = z.object({
  data: z.array(pulseImovelListItemSchema),
  pagination: z.object({
    page: z.number(),
    perPage: z.number(),
    total: z.number(),
    totalPages: z.number()
  })
});
var pulseRespostaItemSchema = z.object({
  id: z.number(),
  resposta: z.string().nullable().optional(),
  respostaPesquisa: z.record(z.string(), z.any()).nullable().optional(),
  perguntasSnapshot: z.any().nullable().optional(),
  respondidoEm: z.string().nullable().optional(),
  imovel: z.object({
    id: z.number(),
    codigo: z.string(),
    titulo: z.string(),
    localizacao: pulseLocalizacaoSchema.nullable().optional()
  }).optional(),
  contato: z.object({
    id: z.number(),
    nome: z.string(),
    telefone: z.string().nullable().optional()
  }).optional()
});
var pulseCarteiraRespostasResponseSchema = z.object({
  items: z.array(pulseRespostaItemSchema),
  total: z.number().catch(0),
  page: z.number().catch(1),
  perPage: z.number().catch(20),
  totalPages: z.number().catch(0)
});

// src/planos/index.ts
var planos_exports = {};
__export(planos_exports, {
  adicionarAddonSchema: () => adicionarAddonSchema,
  adicionarLimiteExtraSchema: () => adicionarLimiteExtraSchema,
  adminAddonsStatsRecentItemSchema: () => adminAddonsStatsRecentItemSchema,
  adminAddonsStatsSchema: () => adminAddonsStatsSchema,
  adminDashboardAddonListSchema: () => adminDashboardAddonListSchema,
  adminDashboardAddonSchema: () => adminDashboardAddonSchema,
  adminDashboardBillingSyncResultSchema: () => adminDashboardBillingSyncResultSchema,
  adminDashboardLimiteExtraListSchema: () => adminDashboardLimiteExtraListSchema,
  adminDashboardLimiteExtraSchema: () => adminDashboardLimiteExtraSchema,
  adminLimiteExtrasStatsRecentItemSchema: () => adminLimiteExtrasStatsRecentItemSchema,
  adminLimiteExtrasStatsSchema: () => adminLimiteExtrasStatsSchema,
  adminPlanoDetailSchema: () => adminPlanoDetailSchema,
  adminPlanoLimiteSchema: () => adminPlanoLimiteSchema,
  adminPlanoMutationResponseSchema: () => adminPlanoMutationResponseSchema,
  adminPlanoSchema: () => adminPlanoSchema,
  adminPlanosListSchema: () => adminPlanosListSchema,
  adminTiposLimitesResponseSchema: () => adminTiposLimitesResponseSchema,
  adminTiposModulosResponseSchema: () => adminTiposModulosResponseSchema,
  assinarPlanoSchema: () => assinarPlanoSchema,
  assinaturaSchema: () => assinaturaSchema,
  ativarAssinaturaSchema: () => ativarAssinaturaSchema,
  ativarRequestSchema: () => ativarRequestSchema,
  ativarResponseSchema: () => ativarResponseSchema,
  atualizarLimiteExtraBodySchema: () => atualizarLimiteExtraBodySchema,
  atualizarLimiteExtraSchema: () => atualizarLimiteExtraSchema,
  confirmarLimiteExtraRequestSchema: () => confirmarLimiteExtraRequestSchema,
  confirmarLimiteExtraResponseSchema: () => confirmarLimiteExtraResponseSchema,
  consumoResponseSchema: () => consumoResponseSchema,
  contratarPlanoSchema: () => contratarPlanoSchema,
  createPlanoSchema: () => createPlanoSchema,
  dashboardFaturasResponseSchema: () => dashboardFaturasResponseSchema,
  extrasSchema: () => extrasSchema,
  faturaLinhaSchema: () => faturaLinhaSchema,
  faturaStripeSchema: () => faturaStripeSchema,
  itemTimingOptionsSchema: () => itemTimingOptionsSchema,
  limiteConsumoSchema: () => limiteConsumoSchema,
  limiteExtraInfoSchema: () => limiteExtraInfoSchema,
  planoBaseSchema: () => planoBaseSchema,
  planoCompletoSchema: () => planoCompletoSchema,
  planoLimiteSchema: () => planoLimiteSchema,
  portalResponseSchema: () => portalResponseSchema,
  publicPlanoLimiteSchema: () => publicPlanoLimiteSchema,
  publicPlanoSchema: () => publicPlanoSchema,
  publicPlanosListSchema: () => publicPlanosListSchema,
  registrarUpgradeInteresseResponseSchema: () => registrarUpgradeInteresseResponseSchema,
  registrarUpgradeInteresseSchema: () => registrarUpgradeInteresseSchema,
  removeItemOptionsSchema: () => removeItemOptionsSchema,
  solicitarLimiteExtraRequestSchema: () => solicitarLimiteExtraRequestSchema,
  solicitarLimiteExtraResponseSchema: () => solicitarLimiteExtraResponseSchema,
  timingOptionEnum: () => timingOptionEnum,
  tipoLimiteEnum: () => tipoLimiteEnum,
  tipoModuloEnum: () => tipoModuloEnum,
  totaisSchema: () => totaisSchema,
  updatePlanoSchema: () => updatePlanoSchema
});
var tipoLimiteEnum = z.enum([
  "IMOVEIS",
  "EMPREENDIMENTOS",
  "INCORPORADORA",
  "CANAIS",
  "EMAILS",
  "SMS",
  "TOKENS",
  "USUARIOS"
]);
var tipoModuloEnum = z.enum([
  "IMOVEIS",
  "EMPREENDIMENTOS",
  "INCORPORADORA",
  "CAMPANHAS",
  "LEADS",
  "CONTATOS",
  "OPORTUNIDADES",
  "PROPOSTAS",
  "DOCUMENTOS",
  "REGISTRO_CHAVES",
  "FINANCEIRO",
  "RELATORIOS",
  "SITE",
  "CONVERSATIONS",
  "MARKETING",
  "IA_BLOG",
  "IA_TOOLS",
  "IA_AGENTES",
  "PORTAIS",
  "WEBHOOKS",
  "API",
  "MATCHES",
  "PULSE",
  "AUTOMACOES"
]);
var timingOptionEnum = z.enum([
  "IMMEDIATELY",
  "END_OF_PERIOD",
  "CUSTOM_DATE"
]);
var planoLimiteSchema = z.object({
  tipo: tipoLimiteEnum,
  quantidadeInclusa: z.coerce.number().min(0),
  precoPorUnidadeExtra: z.coerce.number().min(0).optional(),
  // Prisma serializa IDs Stripe ausentes como null (mesmo padrão do plano base).
  stripeProductId: z.string().nullable().optional(),
  stripePriceIdMensal: z.string().nullable().optional(),
  stripePriceIdAnual: z.string().nullable().optional(),
  stripeMeterId: z.string().nullable().optional()
});
var createPlanoSchema = z.object({
  nome: z.string().min(1).max(255),
  slug: z.string().max(255).optional(),
  descricao: z.string().optional(),
  precoMensal: z.coerce.number().min(0),
  precoAnual: z.coerce.number().min(0).optional(),
  stripeProductIdBase: z.string().optional(),
  stripePriceIdMensal: z.string().optional(),
  stripePriceIdAnual: z.string().optional(),
  ativo: z.boolean().optional(),
  modulos: z.array(tipoModuloEnum).optional(),
  limites: z.array(planoLimiteSchema).optional()
});
var updatePlanoSchema = z.object({
  nome: z.string().max(255).optional(),
  slug: z.string().max(255).optional(),
  descricao: z.string().optional(),
  precoMensal: z.coerce.number().min(0).optional(),
  precoAnual: z.coerce.number().min(0).optional(),
  ativo: z.boolean().optional(),
  modulos: z.array(tipoModuloEnum).optional(),
  limites: z.array(planoLimiteSchema).optional(),
  stripeProductIdBase: z.string().optional(),
  stripePriceIdMensal: z.string().optional(),
  stripePriceIdAnual: z.string().optional()
});
var assinarPlanoSchema = z.object({
  planoId: z.coerce.number(),
  priceId: z.string(),
  trial: z.coerce.number().min(0).optional(),
  card: z.boolean().optional()
});
var atualizarLimiteExtraSchema = z.object({
  quantidade: z.coerce.number().min(0)
});
var ativarAssinaturaSchema = z.object({
  planoId: z.coerce.number(),
  ciclo: z.enum(["mensal", "anual"]),
  trial: z.coerce.number().min(0).optional(),
  card: z.boolean().optional(),
  cupom: z.string().optional()
});
var registrarUpgradeInteresseSchema = z.object({
  module: z.string(),
  moduleLabel: z.string().optional(),
  channel: z.enum(["whatsapp"]).optional()
});
var registrarUpgradeInteresseResponseSchema = z.object({
  success: z.boolean(),
  message: z.string()
});
var contratarPlanoSchema = z.object({
  planoId: z.coerce.number(),
  priceId: z.string(),
  nomeImobiliaria: z.string().min(3),
  trial: z.coerce.number().min(0).optional(),
  card: z.boolean().optional()
});
var itemTimingOptionsSchema = z.object({
  timing: timingOptionEnum.optional(),
  customDate: z.coerce.number().min(0).optional(),
  proration: z.boolean().optional()
});
var removeItemOptionsSchema = z.object({
  timing: timingOptionEnum.optional(),
  customDate: z.coerce.number().min(0).optional(),
  proration: z.boolean().optional()
});
var adicionarLimiteExtraSchema = z.object({
  tipo: tipoLimiteEnum,
  stripePriceId: z.string(),
  quantidadeExtra: z.coerce.number().min(1),
  timing: timingOptionEnum.optional(),
  customDate: z.coerce.number().min(0).optional(),
  proration: z.boolean().optional()
});
var adicionarAddonSchema = z.object({
  modulo: tipoModuloEnum,
  stripePriceId: z.string(),
  timing: timingOptionEnum.optional(),
  customDate: z.coerce.number().min(0).optional(),
  proration: z.boolean().optional()
});
var publicPlanoLimiteSchema = planoLimiteSchema.extend({
  id: z.number().optional(),
  planoId: z.number().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional()
});
var publicPlanoSchema = z.object({
  id: z.number(),
  nome: z.string(),
  slug: z.string().nullable().optional(),
  descricao: z.string().nullable().optional(),
  precoMensal: z.coerce.number(),
  precoAnual: z.coerce.number().nullable().optional(),
  stripeProductIdBase: z.string().nullable().optional(),
  stripePriceIdMensal: z.string().nullable().optional(),
  stripePriceIdAnual: z.string().nullable().optional(),
  ativo: z.boolean().optional(),
  modulos: z.array(z.string()).optional(),
  limites: z.array(publicPlanoLimiteSchema).optional(),
  /** Trial metadata — optional until persisted on Plano; consumers may enrich. */
  trialDias: z.number().nullable().optional(),
  trialRequerCartao: z.boolean().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional()
});
var publicPlanosListSchema = z.array(publicPlanoSchema);
var adminPlanoLimiteSchema = publicPlanoLimiteSchema;
var adminPlanoSchema = publicPlanoSchema;
var adminPlanosListSchema = z.array(adminPlanoSchema);
var adminPlanoDetailSchema = adminPlanoSchema;
var adminPlanoMutationResponseSchema = adminPlanoSchema;
var assinaturaSchema = z.object({
  id: z.number(),
  status: z.string(),
  stripeSubscriptionId: z.string().nullable().optional(),
  stripeCustomerId: z.string().nullable().optional(),
  dataInicio: z.string().nullable().optional(),
  dataFim: z.string().nullable().optional(),
  trialIniciadoEm: z.string().nullable().optional(),
  trialExpiraEm: z.string().nullable().optional(),
  canceladoEm: z.string().nullable().optional(),
  periodoAtual: z.object({
    inicio: z.string().nullable(),
    fim: z.string().nullable()
  }).nullable().optional()
});
var planoBaseSchema = z.object({
  id: z.number(),
  nome: z.string(),
  slug: z.string(),
  descricao: z.string().nullable(),
  modulos: z.array(z.string()),
  limites: z.array(
    z.object({
      tipo: z.string(),
      quantidade: z.number()
    })
  )
});
var extrasSchema = z.object({
  modulos: z.array(
    z.object({
      modulo: z.string(),
      adicionadoEm: z.string()
    })
  ),
  limites: z.array(
    z.object({
      tipo: z.string(),
      quantidadeExtra: z.number(),
      adicionadoEm: z.string()
    })
  )
});
var totaisSchema = z.object({
  modulos: z.array(z.string()),
  limites: z.array(
    z.object({
      tipo: z.string(),
      base: z.number(),
      extra: z.number(),
      total: z.number()
    })
  )
});
var planoCompletoSchema = z.union([
  z.object({
    plano: z.literal(false)
  }),
  z.object({
    stripeSubscriptionId: z.string().nullable().optional(),
    stripeCustomerId: z.string().nullable().optional(),
    status: z.string(),
    trialExpiraEm: z.string().nullable().optional(),
    assinatura: assinaturaSchema,
    plano: planoBaseSchema,
    extras: extrasSchema,
    totais: totaisSchema
  })
]);
var limiteConsumoSchema = z.object({
  tipo: z.string(),
  limiteBase: z.number().nullable().optional(),
  limiteExtra: z.number().nullable().optional(),
  limiteTotal: z.number().nullable().optional(),
  consumoAtual: z.number().nullable().optional(),
  disponivel: z.number().nullable().optional(),
  percentualUso: z.number().nullable().optional(),
  atingiuLimite: z.boolean().nullable().optional()
});
var consumoResponseSchema = z.object({
  limites: z.array(limiteConsumoSchema).optional().default([])
});
var faturaLinhaSchema = z.object({
  id: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  descricao: z.string().nullable().optional(),
  quantity: z.number().nullable().optional(),
  quantidade: z.number().nullable().optional(),
  amount: z.number().nullable().optional(),
  valor: z.number().nullable().optional(),
  currency: z.string().nullable().optional(),
  period: z.object({
    start: z.string().nullable().optional(),
    end: z.string().nullable().optional(),
    inicio: z.string().nullable().optional(),
    fim: z.string().nullable().optional()
  }).nullable().optional(),
  periodo: z.object({
    inicio: z.string().nullable().optional(),
    fim: z.string().nullable().optional()
  }).nullable().optional()
});
var faturaStripeSchema = z.object({
  id: z.string().nullable().optional(),
  number: z.string().nullable().optional(),
  status: z.string().nullable().optional(),
  total: z.number().nullable().optional(),
  currency: z.string().nullable().optional(),
  created: z.string().nullable().optional(),
  period_start: z.string().nullable().optional(),
  period_end: z.string().nullable().optional(),
  status_transitions: z.object({
    paid_at: z.string().nullable().optional()
  }).nullable().optional(),
  invoice_pdf: z.string().nullable().optional(),
  hosted_invoice_url: z.string().nullable().optional(),
  lines: z.object({
    data: z.array(faturaLinhaSchema).optional().default([])
  }).nullable().optional(),
  numero: z.string().nullable().optional(),
  statusStripe: z.string().nullable().optional(),
  valor: z.number().nullable().optional(),
  moeda: z.string().nullable().optional(),
  dataVencimento: z.string().nullable().optional(),
  dataPagamento: z.string().nullable().optional(),
  dataCriacao: z.string().nullable().optional(),
  periodoInicio: z.string().nullable().optional(),
  periodoFim: z.string().nullable().optional(),
  linkPdf: z.string().nullable().optional(),
  linkHosted: z.string().nullable().optional(),
  descricao: z.string().nullable().optional(),
  linhas: z.array(faturaLinhaSchema).optional().default([])
});
var dashboardFaturasResponseSchema = z.object({
  faturas: z.array(faturaStripeSchema).optional().default([]),
  total: z.number().optional().default(0),
  subscriptionId: z.string().nullable().optional()
});
var portalResponseSchema = z.object({
  url: z.string()
});
var ativarRequestSchema = ativarAssinaturaSchema;
var ativarResponseSchema = z.union([
  z.object({
    type: z.literal("checkout"),
    url: z.string(),
    sessionId: z.string()
  }),
  z.object({
    type: z.literal("update"),
    success: z.boolean(),
    message: z.string()
  })
]);
var limiteExtraInfoSchema = z.object({
  tipo: z.string(),
  nome: z.string(),
  descricao: z.string().nullable().optional(),
  quantidade: z.number(),
  precoMensal: z.object({
    priceId: z.string(),
    valor: z.number(),
    moeda: z.string(),
    intervalo: z.string()
  }).nullable().optional(),
  precoAnual: z.object({
    priceId: z.string(),
    valor: z.number(),
    moeda: z.string(),
    intervalo: z.string()
  }).nullable().optional(),
  produto: z.object({
    id: z.string(),
    nome: z.string(),
    descricao: z.string().nullable().optional()
  }).nullable().optional()
});
var solicitarLimiteExtraRequestSchema = z.object({
  quantidade: z.number().int().min(1).optional().default(1)
});
var solicitarLimiteExtraResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  expiresIn: z.number(),
  confirmationToken: z.string(),
  quantidade: z.number(),
  quantidadeTotal: z.number(),
  valorMensalTotal: z.number()
});
var confirmarLimiteExtraRequestSchema = z.object({
  confirmationCode: z.string().length(6),
  confirmationToken: z.string()
});
var confirmarLimiteExtraResponseSchema = z.object({
  id: z.number(),
  dashboardId: z.number(),
  tipo: z.string(),
  quantidadeExtra: z.number(),
  stripeSubscriptionItemId: z.string().nullable().optional(),
  stripePriceId: z.string().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var atualizarLimiteExtraBodySchema = z.object({
  stripePriceId: z.string(),
  quantidadeExtra: z.coerce.number().min(1)
});
var adminDashboardAddonSchema = z.object({
  id: z.number(),
  dashboardId: z.number(),
  modulo: z.string(),
  stripeSubscriptionItemId: z.string(),
  createdAt: z.string(),
  updatedAt: z.string()
}).passthrough();
var adminDashboardAddonListSchema = z.array(adminDashboardAddonSchema);
var adminDashboardBillingSyncResultSchema = z.object({
  success: z.literal(true),
  message: z.string(),
  dashboardId: z.number()
});
var adminAddonsStatsRecentItemSchema = z.object({
  id: z.number(),
  modulo: z.string(),
  dashboardId: z.number(),
  dashboardTitulo: z.string(),
  createdAt: z.string()
}).passthrough();
var adminAddonsStatsSchema = z.object({
  periodo: z.string(),
  dataInicial: z.string().optional(),
  totalAddons: z.number(),
  totalAddonsAtivos: z.number(),
  addonsPorModulo: z.record(z.string(), z.number()),
  dashboardsComAddons: z.number(),
  addonsRecentes: z.array(adminAddonsStatsRecentItemSchema)
}).passthrough();
var adminDashboardLimiteExtraSchema = z.object({
  id: z.number(),
  dashboardId: z.number(),
  tipo: z.string(),
  quantidadeExtra: z.number(),
  stripeSubscriptionItemId: z.string(),
  stripePriceId: z.string(),
  createdAt: z.string(),
  updatedAt: z.string()
}).passthrough();
var adminDashboardLimiteExtraListSchema = z.array(
  adminDashboardLimiteExtraSchema
);
var adminLimiteExtrasStatsRecentItemSchema = z.object({
  id: z.number(),
  tipo: z.string(),
  quantidadeExtra: z.number(),
  dashboardId: z.number(),
  dashboardTitulo: z.string(),
  createdAt: z.string()
}).passthrough();
var adminLimiteExtrasStatsSchema = z.object({
  periodo: z.string(),
  dataInicial: z.string().optional(),
  totalLimitesExtras: z.number(),
  totalLimitesAtivos: z.number(),
  limitesPorTipo: z.record(z.string(), z.number()),
  quantidadePorTipo: z.record(z.string(), z.number()),
  dashboardsComLimitesExtras: z.number(),
  limitesRecentes: z.array(adminLimiteExtrasStatsRecentItemSchema)
}).passthrough();
var adminTiposModulosResponseSchema = z.object({
  modulos: z.array(z.string())
});
var adminTiposLimitesResponseSchema = z.object({
  limites: z.array(z.string())
});

// src/admin/index.ts
var admin_exports = {};
__export(admin_exports, {
  adminBackupArtifactSchema: () => adminBackupArtifactSchema,
  adminBackupAssetHealthSchema: () => adminBackupAssetHealthSchema,
  adminBackupManifestSchema: () => adminBackupManifestSchema,
  adminBackupMultipartUploadSchema: () => adminBackupMultipartUploadSchema,
  adminBackupOverviewResponseSchema: () => adminBackupOverviewResponseSchema,
  adminBackupOverviewSchema: () => adminBackupOverviewSchema,
  adminBackupStatusEnum: () => adminBackupStatusEnum,
  adminBootstrapSuporteClienteResponseSchema: () => adminBootstrapSuporteClienteResponseSchema,
  adminBootstrapSuporteClienteSchema: () => adminBootstrapSuporteClienteSchema,
  adminCancelDashboardPlanSchema: () => adminCancelDashboardPlanSchema,
  adminCatalogDeleteDataSchema: () => adminCatalogDeleteDataSchema,
  adminCatalogDeleteResponseSchema: () => adminCatalogDeleteResponseSchema,
  adminCatalogEntitySchema: () => adminCatalogEntitySchema,
  adminCatalogItemResponseSchema: () => adminCatalogItemResponseSchema,
  adminCatalogListResponseSchema: () => adminCatalogListResponseSchema,
  adminChangeDashboardOwnerSchema: () => adminChangeDashboardOwnerSchema,
  adminChangeDashboardPlanSchema: () => adminChangeDashboardPlanSchema,
  adminCreateUsuarioSchema: () => adminCreateUsuarioSchema,
  adminDashboardDeleteResponseSchema: () => adminDashboardDeleteResponseSchema,
  adminDashboardDetailResponseSchema: () => adminDashboardDetailResponseSchema,
  adminDashboardInvoiceSchema: () => adminDashboardInvoiceSchema,
  adminDashboardInvoiceStatusEnum: () => adminDashboardInvoiceStatusEnum,
  adminDashboardInvoicesListSchema: () => adminDashboardInvoicesListSchema,
  adminDashboardInvoicesResponseSchema: () => adminDashboardInvoicesResponseSchema,
  adminDashboardListResponseSchema: () => adminDashboardListResponseSchema,
  adminDashboardMutationResponseSchema: () => adminDashboardMutationResponseSchema,
  adminDashboardOptionSchema: () => adminDashboardOptionSchema,
  adminDashboardOwnerChangeResponseSchema: () => adminDashboardOwnerChangeResponseSchema,
  adminDashboardOwnerChangeResultSchema: () => adminDashboardOwnerChangeResultSchema,
  adminDashboardPlanChangeTimingEnum: () => adminDashboardPlanChangeTimingEnum,
  adminDashboardPlanMutationResponseSchema: () => adminDashboardPlanMutationResponseSchema,
  adminDashboardPlanMutationResultSchema: () => adminDashboardPlanMutationResultSchema,
  adminDashboardProprietarioSchema: () => adminDashboardProprietarioSchema,
  adminDashboardQuerySchema: () => adminDashboardQuerySchema,
  adminDashboardSchema: () => adminDashboardSchema,
  adminDashboardStripeSyncInfoSchema: () => adminDashboardStripeSyncInfoSchema,
  adminDashboardUsuarioRowSchema: () => adminDashboardUsuarioRowSchema,
  adminDashboardUsuariosListResponseSchema: () => adminDashboardUsuariosListResponseSchema,
  adminDashboardUsuariosMetaSchema: () => adminDashboardUsuariosMetaSchema,
  adminDeleteDashboardWithOtpSchema: () => adminDeleteDashboardWithOtpSchema,
  adminDeletePlanoWithOtpSchema: () => adminDeletePlanoWithOtpSchema,
  adminDeleteUsuarioWithOtpSchema: () => adminDeleteUsuarioWithOtpSchema,
  adminEmailSesApiResponseSchema: () => adminEmailSesApiResponseSchema,
  adminEmailStatusResponseSchema: () => adminEmailStatusResponseSchema,
  adminEmailStatusSchema: () => adminEmailStatusSchema,
  adminEmailTemplateSchema: () => adminEmailTemplateSchema,
  adminEmailTemplatesResponseSchema: () => adminEmailTemplatesResponseSchema,
  adminEmailTestResponseSchema: () => adminEmailTestResponseSchema,
  adminEmailTestResultSchema: () => adminEmailTestResultSchema,
  adminEnviarNotificacaoResponseSchema: () => adminEnviarNotificacaoResponseSchema,
  adminFacebookChecklistItemSchema: () => adminFacebookChecklistItemSchema,
  adminFacebookChecklistStatusSchema: () => adminFacebookChecklistStatusSchema,
  adminFacebookLeadAdsStatusResponseSchema: () => adminFacebookLeadAdsStatusResponseSchema,
  adminFacebookLeadAdsStatusSchema: () => adminFacebookLeadAdsStatusSchema,
  adminGeneratePortalUrlResponseSchema: () => adminGeneratePortalUrlResponseSchema,
  adminGeneratePortalUrlResultSchema: () => adminGeneratePortalUrlResultSchema,
  adminGeneratePortalUrlSchema: () => adminGeneratePortalUrlSchema,
  adminImovelIndiceReajusteListResponseSchema: () => adminImovelIndiceReajusteListResponseSchema,
  adminImovelIndiceReajusteResponseSchema: () => adminImovelIndiceReajusteResponseSchema,
  adminMessageResponseSchema: () => adminMessageResponseSchema,
  adminNotificacaoAgendadaDashboardSchema: () => adminNotificacaoAgendadaDashboardSchema,
  adminNotificacaoAgendadaDetailResponseSchema: () => adminNotificacaoAgendadaDetailResponseSchema,
  adminNotificacaoAgendadaItemSchema: () => adminNotificacaoAgendadaItemSchema,
  adminNotificacaoAgendadaListResponseSchema: () => adminNotificacaoAgendadaListResponseSchema,
  adminNotificacaoAgendadaStatusEnum: () => adminNotificacaoAgendadaStatusEnum,
  adminNotificacaoAgendadaUsuarioSchema: () => adminNotificacaoAgendadaUsuarioSchema,
  adminNotificacaoHistoricoDashboardSchema: () => adminNotificacaoHistoricoDashboardSchema,
  adminNotificacaoHistoricoItemSchema: () => adminNotificacaoHistoricoItemSchema,
  adminNotificacaoHistoricoListResponseSchema: () => adminNotificacaoHistoricoListResponseSchema,
  adminNotificacaoHistoricoUsuarioSchema: () => adminNotificacaoHistoricoUsuarioSchema,
  adminNotificacaoSchema: () => adminNotificacaoSchema,
  adminNotificacaoWithOtpSchema: () => adminNotificacaoWithOtpSchema,
  adminOtpActionEnum: () => adminOtpActionEnum,
  adminOtpSendResponseSchema: () => adminOtpSendResponseSchema,
  adminOtpSendSchema: () => adminOtpSendSchema,
  adminPortaisListResponseSchema: () => adminPortaisListResponseSchema,
  adminPortalDetailResponseSchema: () => adminPortalDetailResponseSchema,
  adminPortalEntitySchema: () => adminPortalEntitySchema,
  adminPortalSchema: () => adminPortalSchema,
  adminRecriarSubscriptionResponseSchema: () => adminRecriarSubscriptionResponseSchema,
  adminRecriarSubscriptionResultSchema: () => adminRecriarSubscriptionResultSchema,
  adminRevokeUsuarioSessionResponseSchema: () => revokeSessionResponseSchema,
  adminSensitiveOtpCodeSchema: () => adminSensitiveOtpCodeSchema,
  adminSuporteSyncListResponseSchema: () => adminSuporteSyncListResponseSchema,
  adminSuporteSyncUsuarioRowSchema: () => adminSuporteSyncUsuarioRowSchema,
  adminSuporteUsuarioIdSchema: () => adminSuporteUsuarioIdSchema,
  adminSuporteUsuarioLookupResponseSchema: () => adminSuporteUsuarioLookupResponseSchema,
  adminTestEmailResponseSchema: () => adminTestEmailResponseSchema,
  adminTestEmailResultSchema: () => adminTestEmailResultSchema,
  adminTipoAnuncioPortalEnum: () => adminTipoAnuncioPortalEnum,
  adminTrustUnlockResponseSchema: () => adminTrustUnlockResponseSchema,
  adminTrustUnlockSchema: () => adminTrustUnlockSchema,
  adminUpdatePasswordSchema: () => adminUpdatePasswordSchema,
  adminUpdatePasswordWithOtpSchema: () => adminUpdatePasswordWithOtpSchema,
  adminUpdatePortalSchema: () => adminUpdatePortalSchema,
  adminUpdateUsuarioSchema: () => adminUpdateUsuarioSchema,
  adminUpdateUsuarioWithOtpSchema: () => adminUpdateUsuarioWithOtpSchema,
  adminUsuarioBuscaSchema: () => adminUsuarioBuscaSchema,
  adminUsuarioCreateResponseSchema: () => adminUsuarioCreateResponseSchema,
  adminUsuarioCreateStripeCustomerSchema: () => adminUsuarioCreateStripeCustomerSchema,
  adminUsuarioDashboardsListResponseSchema: () => adminUsuarioDashboardsListResponseSchema,
  adminUsuarioDeleteResponseSchema: () => adminUsuarioDeleteResponseSchema,
  adminUsuarioDeleteResultSchema: () => adminUsuarioDeleteResultSchema,
  adminUsuarioExportListResponseSchema: () => adminUsuarioExportListResponseSchema,
  adminUsuarioExportRowSchema: () => adminUsuarioExportRowSchema,
  adminUsuarioListQuerySchema: () => adminUsuarioListQuerySchema,
  adminUsuarioLoginResponseSchema: () => adminUsuarioLoginResponseSchema,
  adminUsuarioLoginResultSchema: () => adminUsuarioLoginResultSchema,
  adminUsuarioPasswordUpdateResponseSchema: () => adminUsuarioPasswordUpdateResponseSchema,
  adminUsuarioRecuperarSenhaResponseSchema: () => adminUsuarioRecuperarSenhaResponseSchema,
  adminUsuarioResponseSchema: () => adminUsuarioResponseSchema,
  adminUsuarioSchema: () => adminUsuarioSchema,
  adminUsuarioSessionRowSchema: () => authSessionRowSchema,
  adminUsuarioSessionsListResponseSchema: () => sessionsListResponseSchema,
  adminUsuarioStripeCustomerResponseSchema: () => adminUsuarioStripeCustomerResponseSchema,
  adminUsuarioStripeCustomerResultSchema: () => adminUsuarioStripeCustomerResultSchema,
  adminUsuarioTipoEnum: () => adminUsuarioTipoEnum,
  adminUsuarioUpdateResponseSchema: () => adminUsuarioUpdateResponseSchema,
  adminUsuariosListResponseSchema: () => adminUsuariosListResponseSchema,
  adminVercelAddDomainResponseSchema: () => adminVercelAddDomainResponseSchema,
  adminVercelAddDomainResultSchema: () => adminVercelAddDomainResultSchema,
  adminVercelDnsSchema: () => adminVercelDnsSchema,
  adminVercelDnsVerificationSchema: () => adminVercelDnsVerificationSchema,
  adminVercelDomainEntrySchema: () => adminVercelDomainEntrySchema,
  adminVercelDomainsListResponseSchema: () => adminVercelDomainsListResponseSchema,
  adminVercelIntegrationTestResponseSchema: () => adminVercelIntegrationTestResponseSchema,
  adminVercelIntegrationTestResultSchema: () => adminVercelIntegrationTestResultSchema,
  adminVercelIntegrationTestStepSchema: () => adminVercelIntegrationTestStepSchema,
  adminVercelRemoveDomainResponseSchema: () => adminVercelRemoveDomainResponseSchema,
  adminVercelRemoveDomainResultSchema: () => adminVercelRemoveDomainResultSchema,
  adminVercelStatusResponseSchema: () => adminVercelStatusResponseSchema,
  adminVercelStatusSchema: () => adminVercelStatusSchema,
  adminWhatsappMetaApiResponseSchema: () => adminWhatsappMetaApiResponseSchema,
  adminWhatsappMetaStatusResponseSchema: () => adminWhatsappMetaStatusResponseSchema,
  adminWhatsappMetaStatusSchema: () => adminWhatsappMetaStatusSchema,
  adminWhatsappMetaTemplateSchema: () => adminWhatsappMetaTemplateSchema,
  adminWhatsappMetaTemplatesResponseSchema: () => adminWhatsappMetaTemplatesResponseSchema,
  adminWhatsappMetaTestResponseSchema: () => adminWhatsappMetaTestResponseSchema,
  adminWhatsappMetaTestResultSchema: () => adminWhatsappMetaTestResultSchema,
  createAdminDashboardSchema: () => createAdminDashboardSchema,
  createEmpreendimentoComodidadeAdminSchema: () => createEmpreendimentoComodidadeAdminSchema,
  createHistoricoEventosSchema: () => createHistoricoEventosSchema,
  createImovelComodidadeAdminSchema: () => createImovelComodidadeAdminSchema,
  createImovelComodidadeCategoriaSchema: () => createImovelComodidadeCategoriaSchema,
  createImovelFinalidadeMotivoSchema: () => createImovelFinalidadeMotivoSchema,
  createImovelIndiceReajusteSchema: () => createImovelIndiceReajusteSchema,
  createMotivosPerdaAdminSchema: () => createMotivosPerdaAdminSchema,
  createOportunidadeOrigemSchema: () => createOportunidadeOrigemSchema,
  createTarefaAcaoSchema: () => createTarefaAcaoSchema,
  createTarefaStatusSchema: () => createTarefaStatusSchema,
  dashboardPaymentUrlTypeEnum: () => dashboardPaymentUrlTypeEnum,
  dashboardStatusEnum: () => dashboardStatusEnum,
  envioNotificacaoResponseSchema: () => envioNotificacaoResponseSchema,
  extendTrialSchema: () => extendTrialSchema,
  generateCheckoutUrlSchema: () => generateCheckoutUrlSchema,
  imovelComodidadeCategoriaListResponseSchema: () => imovelComodidadeCategoriaListResponseSchema,
  imovelComodidadeCategoriaResponseSchema: () => imovelComodidadeCategoriaResponseSchema,
  imovelComodidadeCategoriaSchema: () => imovelComodidadeCategoriaSchema,
  imovelIndiceReajusteEntitySchema: () => imovelIndiceReajusteEntitySchema,
  recriarSubscriptionSchema: () => recriarSubscriptionSchema,
  updateAdminDashboardSchema: () => updateAdminDashboardSchema,
  updateEmpreendimentoComodidadeAdminSchema: () => updateEmpreendimentoComodidadeAdminSchema,
  updateHistoricoEventosSchema: () => updateHistoricoEventosSchema,
  updateImovelComodidadeAdminSchema: () => updateImovelComodidadeAdminSchema,
  updateImovelComodidadeCategoriaSchema: () => updateImovelComodidadeCategoriaSchema,
  updateImovelFinalidadeMotivoSchema: () => updateImovelFinalidadeMotivoSchema,
  updateImovelIndiceReajusteSchema: () => updateImovelIndiceReajusteSchema,
  updateMotivosPerdaAdminSchema: () => updateMotivosPerdaAdminSchema,
  updateOportunidadeOrigemSchema: () => updateOportunidadeOrigemSchema,
  updateTarefaAcaoSchema: () => updateTarefaAcaoSchema,
  updateTarefaStatusSchema: () => updateTarefaStatusSchema
});
var catalogCreateSchema = z.object({
  value: z.string().min(1).max(100),
  label: z.string().min(1).max(255),
  padrao: z.boolean().optional(),
  dashboardId: z.coerce.number().optional()
});
var catalogUpdateSchema = z.object({
  label: z.string().min(1).max(255).optional(),
  padrao: z.boolean().optional(),
  dashboardId: z.coerce.number().optional()
});
var createImovelIndiceReajusteSchema = z.object({
  valor: z.coerce.number(),
  indice: z.string().min(1),
  padrao: z.boolean().optional(),
  dashboardId: z.coerce.number().optional()
});
var updateImovelIndiceReajusteSchema = z.object({
  valor: z.coerce.number().optional(),
  indice: z.string().min(1).optional(),
  padrao: z.boolean().optional(),
  dashboardId: z.coerce.number().optional()
});
var createImovelFinalidadeMotivoSchema = catalogCreateSchema;
var updateImovelFinalidadeMotivoSchema = catalogUpdateSchema;
var createImovelComodidadeAdminSchema = catalogCreateSchema.extend({
  quantidades: z.boolean().optional(),
  categoriaId: z.coerce.number()
});
var updateImovelComodidadeAdminSchema = catalogUpdateSchema.extend({
  quantidades: z.boolean().optional(),
  categoriaId: z.coerce.number().optional()
});
var createEmpreendimentoComodidadeAdminSchema = createImovelComodidadeAdminSchema;
var updateEmpreendimentoComodidadeAdminSchema = updateImovelComodidadeAdminSchema;
var createTarefaStatusSchema = catalogCreateSchema;
var updateTarefaStatusSchema = catalogUpdateSchema;
var createTarefaAcaoSchema = catalogCreateSchema;
var updateTarefaAcaoSchema = catalogUpdateSchema;
var createHistoricoEventosSchema = catalogCreateSchema;
var updateHistoricoEventosSchema = catalogUpdateSchema;
var createOportunidadeOrigemSchema = catalogCreateSchema;
var updateOportunidadeOrigemSchema = catalogUpdateSchema;
var createMotivosPerdaAdminSchema = catalogCreateSchema;
var updateMotivosPerdaAdminSchema = catalogUpdateSchema;
var createImovelComodidadeCategoriaSchema = z.object({
  value: z.string().min(1),
  label: z.string().min(1)
});
var updateImovelComodidadeCategoriaSchema = z.object({
  value: z.string().min(1).optional(),
  label: z.string().min(1).optional()
});
var imovelComodidadeCategoriaSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string(),
  _count: z.object({ comodidades: z.number() }).optional()
});
var imovelComodidadeCategoriaListResponseSchema = listResponse(
  imovelComodidadeCategoriaSchema
);
var imovelComodidadeCategoriaResponseSchema = dataResponse(
  imovelComodidadeCategoriaSchema
);
var adminUsuarioListQuerySchema = z.object({
  search: z.string().optional(),
  page: z.coerce.number().optional(),
  take: z.coerce.number().optional()
});
var cpf11 = z.string().length(11).regex(/^\d{11}$/);
var celular11 = z.string().length(11).regex(/^\d{11}$/);
var adminPassword = z.string().min(6).max(18);
var adminCreateUsuarioSchema = z.object({
  nome: z.string().min(1),
  sobrenome: z.string().min(1),
  email: z.string().email(),
  cpf: cpf11,
  celular: celular11,
  password: adminPassword
});
var adminUpdateUsuarioSchema = adminCreateUsuarioSchema.partial({
  password: true
});
var adminOtpActionEnum = z.enum([
  "UPDATE_ADMIN_USUARIO",
  "DELETE_USUARIO",
  "UPDATE_USUARIO_PASSWORD",
  "DELETE_DASHBOARD",
  "SEND_NOTIFICACAO",
  "SCHEDULE_NOTIFICACAO",
  "DELETE_PLANO"
]);
var adminOtpSendSchema = z.object({
  action: adminOtpActionEnum
});
var adminOtpSendResponseSchema = dataResponse(
  z.object({ expiresIn: z.number() })
);
var adminSensitiveOtpCodeSchema = z.object({
  otpCode: z.string().regex(/^\d{6}$/, "C\xF3digo OTP deve ter 6 d\xEDgitos")
});
var adminUpdateUsuarioWithOtpSchema = adminUpdateUsuarioSchema.extend({
  otpCode: z.string().regex(/^\d{6}$/).optional()
});
var adminUpdatePasswordFieldsSchema = z.object({
  password: adminPassword,
  confirmationPassword: z.string().min(6).max(18)
});
var adminUpdatePasswordMatchRefine = (d) => d.password === d.confirmationPassword;
var adminUpdatePasswordMatchRefineOptions = {
  message: "As senhas devem ser iguais",
  path: ["confirmationPassword"]
};
var adminUpdatePasswordSchema = adminUpdatePasswordFieldsSchema.refine(
  adminUpdatePasswordMatchRefine,
  adminUpdatePasswordMatchRefineOptions
);
var adminUpdatePasswordWithOtpSchema = adminUpdatePasswordFieldsSchema.extend(adminSensitiveOtpCodeSchema.shape).refine(adminUpdatePasswordMatchRefine, adminUpdatePasswordMatchRefineOptions);
var adminBootstrapSuporteClienteSchema = z.object({
  nome: z.string().min(1),
  sobrenome: z.string().max(120).optional(),
  email: z.string().email(),
  celular: z.string().max(40).optional()
});
var adminSuporteUsuarioIdSchema = z.object({
  id: z.number()
});
var adminSuporteUsuarioLookupResponseSchema = dataResponse(
  adminSuporteUsuarioIdSchema
);
var adminBootstrapSuporteClienteResponseSchema = dataResponse(
  adminSuporteUsuarioIdSchema
);
var adminSuporteSyncUsuarioRowSchema = z.object({
  id: z.number(),
  nome: z.string().nullable(),
  sobrenome: z.string().nullable(),
  email: z.string(),
  celular: z.string().nullable(),
  updatedAt: z.string().optional()
});
var adminSuporteSyncListResponseSchema = listResponse(
  adminSuporteSyncUsuarioRowSchema
);
var dashboardStatusEnum = z.enum([
  "Trial",
  "Ativo",
  "Suspenso",
  "Pendente",
  "Cancelado"
]);
var dashboardPaymentUrlTypeEnum = z.enum([
  "invoice",
  "checkout",
  "portal"
]);
var adminDashboardProprietarioSchema = z.object({
  id: z.number(),
  nome: z.string().nullable().optional(),
  sobrenome: z.string().nullable().optional(),
  celular: z.string().nullable().optional(),
  email: z.string()
});
var adminDashboardSchema = z.object({
  id: z.number(),
  titulo: z.string(),
  proprietarioId: z.number(),
  status: dashboardStatusEnum,
  trial: z.boolean(),
  trialExpiration: z.string().nullable(),
  desbloqueioConfiancaAte: z.string().nullable().optional(),
  desbloqueioConfiancaAtivo: z.boolean().optional(),
  desbloqueioConfiancaElegivel: z.boolean().optional(),
  paymentUrl: z.string().url().nullable().optional(),
  paymentUrlType: dashboardPaymentUrlTypeEnum.nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
  proprietario: adminDashboardProprietarioSchema.optional()
}).passthrough();
var adminDashboardDetailResponseSchema = dataResponse(adminDashboardSchema);
var adminDashboardMutationResponseSchema = dataResponse(
  adminDashboardSchema
);
var adminDashboardDeleteResponseSchema = dataResponse(z.boolean());
var adminRecriarSubscriptionResultSchema = z.object({
  subscriptionId: z.string(),
  status: z.string(),
  trialEnd: z.string().nullable().optional(),
  dashboardId: z.number()
});
var adminRecriarSubscriptionResponseSchema = dataResponse(
  adminRecriarSubscriptionResultSchema
);
var createAdminDashboardSchema = z.object({
  titulo: z.string().min(1),
  proprietario: z.coerce.number(),
  status: dashboardStatusEnum.optional(),
  creci: z.string().optional(),
  trialDays: z.coerce.number().int().min(1).max(60).optional(),
  trialExpiration: z.string().optional(),
  planoId: z.coerce.number().optional(),
  formasPagamento: z.array(z.enum(["card", "boleto"])).min(1).optional(),
  stripeCustomerId: z.string().optional(),
  stripeSubscriptionId: z.string().optional(),
  razaoSocial: z.string().optional(),
  email: z.string().email().optional(),
  cpfCnpj: z.string().optional(),
  personType: z.enum(["FISICA", "JURIDICA"]).optional(),
  companyType: z.string().optional(),
  telefone: z.string().optional(),
  mobilePhone: z.string().optional(),
  endereco: z.string().optional(),
  numero: z.string().optional(),
  complemento: z.string().optional(),
  bairro: z.string().optional(),
  cep: z.string().optional(),
  cidade: z.string().optional(),
  uf: z.string().optional(),
  pais: z.string().optional()
});
var updateAdminDashboardSchema = z.object({
  titulo: z.string().min(1),
  status: dashboardStatusEnum,
  planoId: z.coerce.number().optional(),
  stripeCustomerId: z.string().optional(),
  stripeSubscriptionId: z.string().optional(),
  razaoSocial: z.string().optional(),
  email: z.string().email().optional(),
  cpfCnpj: z.string().optional(),
  personType: z.enum(["FISICA", "JURIDICA"]).optional(),
  companyType: z.string().optional(),
  telefone: z.string().optional(),
  mobilePhone: z.string().optional(),
  endereco: z.string().optional(),
  numero: z.string().optional(),
  complemento: z.string().optional(),
  bairro: z.string().optional(),
  cep: z.string().optional(),
  cidade: z.string().optional(),
  uf: z.string().optional(),
  pais: z.string().optional()
});
var extendTrialSchema = z.object({
  extendDays: z.coerce.number().int().min(1).max(90)
});
var generateCheckoutUrlSchema = z.object({
  planoId: z.coerce.number(),
  priceId: z.string().min(1),
  trial: z.coerce.number().min(0).optional(),
  card: z.boolean().optional(),
  successUrl: z.string().optional(),
  cancelUrl: z.string().optional()
});
var adminGeneratePortalUrlSchema = z.object({
  returnUrl: z.string().optional()
});
var adminTrustUnlockSchema = z.object({});
var adminTrustUnlockResponseSchema = dataResponse(adminDashboardSchema);
var recriarSubscriptionSchema = z.object({
  planoId: z.coerce.number(),
  ciclo: z.enum(["mensal", "anual"]),
  trialDays: z.coerce.number().min(0).optional(),
  pagamentoImediato: z.boolean().optional(),
  diasVencimento: z.coerce.number().int().min(1).optional(),
  formasPagamento: z.array(z.enum(["card", "boleto"])).min(1).optional(),
  /** Cancela a assinatura ativa e recria mesmo com dashboard Ativo/Trial */
  forcar: z.boolean().optional()
});
var adminDashboardPlanChangeTimingEnum = z.enum([
  "immediate",
  "period_end"
]);
var adminChangeDashboardPlanSchema = z.object({
  planoId: z.coerce.number().int().min(1),
  timing: adminDashboardPlanChangeTimingEnum
});
var adminCancelDashboardPlanSchema = z.object({
  timing: adminDashboardPlanChangeTimingEnum
});
var adminChangeDashboardOwnerSchema = z.object({
  proprietario: z.coerce.number().int().min(1)
});
var adminDashboardStripeSyncInfoSchema = z.object({
  subscriptionId: z.string().nullable(),
  customerId: z.string().nullable(),
  status: z.string(),
  cancelAtPeriodEnd: z.boolean(),
  currentPeriodEnd: z.string().nullable(),
  cancelAt: z.string().nullable(),
  canceledAt: z.string().nullable(),
  pendingPlanId: z.number().nullable().optional(),
  pendingPlanEffectiveAt: z.string().nullable().optional(),
  scheduleId: z.string().nullable().optional(),
  oldSubscriptionId: z.string().nullable().optional(),
  newSubscriptionId: z.string().nullable().optional(),
  paymentUrl: z.string().url().nullable().optional(),
  paymentUrlType: dashboardPaymentUrlTypeEnum.nullable().optional(),
  recreatedOnOwnerChange: z.boolean().optional(),
  previousSubscriptionCancelFailed: z.boolean().optional(),
  previousSubscriptionCancelError: z.string().nullable().optional()
});
var adminDashboardPlanMutationResultSchema = z.object({
  dashboard: adminDashboardSchema,
  stripe: adminDashboardStripeSyncInfoSchema
});
var adminDashboardOwnerChangeResultSchema = z.object({
  dashboard: adminDashboardSchema,
  stripe: adminDashboardStripeSyncInfoSchema
});
var adminDashboardPlanMutationResponseSchema = dataResponse(
  adminDashboardPlanMutationResultSchema
);
var adminDashboardOwnerChangeResponseSchema = dataResponse(
  adminDashboardOwnerChangeResultSchema
);
var adminDashboardInvoiceStatusEnum = z.enum([
  "draft",
  "open",
  "paid",
  "uncollectible",
  "void"
]);
var adminDashboardInvoiceSchema = z.object({
  id: z.string(),
  number: z.string().nullable(),
  status: adminDashboardInvoiceStatusEnum.nullable(),
  amount: z.number(),
  currency: z.string(),
  dueDate: z.string().nullable(),
  paidAt: z.string().nullable(),
  hostedInvoiceUrl: z.string().url().nullable(),
  invoicePdf: z.string().url().nullable()
});
var adminDashboardInvoicesListSchema = z.object({
  invoices: z.array(adminDashboardInvoiceSchema),
  total: z.number().int(),
  hasStripe: z.boolean()
});
var adminDashboardInvoicesResponseSchema = dataResponse(
  adminDashboardInvoicesListSchema
);
var adminDashboardQuerySchema = z.object({
  search: z.string().optional(),
  page: z.coerce.number().optional(),
  take: z.coerce.number().optional()
});
var adminPortalSchema = z.object({
  value: z.string().min(1),
  nome: z.string().min(1)
});
var adminUpdatePortalSchema = adminPortalSchema.partial();
var adminTipoAnuncioPortalEnum = z.enum([
  "Normal",
  "Destaque",
  "SuperDestaque"
]);
var adminPortalEntitySchema = z.object({
  id: z.number(),
  value: z.string(),
  nome: z.string(),
  logo: z.string().nullable().optional(),
  tiposAnuncioDisponiveis: z.array(adminTipoAnuncioPortalEnum).optional(),
  createdAt: z.string(),
  updatedAt: z.string()
}).passthrough();
var adminPortaisListResponseSchema = listResponse(
  adminPortalEntitySchema
);
var adminPortalDetailResponseSchema = dataResponse(
  adminPortalEntitySchema
);
var imovelIndiceReajusteEntitySchema = z.object({
  id: z.number(),
  valor: z.coerce.number(),
  indice: z.string(),
  padrao: z.boolean().optional(),
  dashboardId: z.number().nullable().optional()
}).passthrough();
var adminImovelIndiceReajusteListResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(imovelIndiceReajusteEntitySchema),
  message: z.string().optional()
});
var adminImovelIndiceReajusteResponseSchema = dataResponse(
  imovelIndiceReajusteEntitySchema
);
var notificacaoTipoEnum2 = z.enum([
  "LEAD",
  "MENSAGEM",
  "OPORTUNIDADE",
  "TAREFA",
  "SISTEMA",
  "INTEGRACAO",
  "CUSTOMIZADA"
]);
var notificacaoCanalEnum = z.enum(["SISTEMA", "EMAIL", "WHATSAPP"]);
var adminNotificacaoSchema = z.object({
  titulo: z.string().min(1),
  corpo: z.string().optional(),
  tipo: notificacaoTipoEnum2.optional(),
  canaisEnviados: z.array(notificacaoCanalEnum).optional(),
  dados: z.record(z.string(), z.any()).optional(),
  agendadoPara: z.string().optional(),
  enviarParaTodasDashboards: z.boolean().optional(),
  dashboardIds: z.array(z.coerce.number().int().min(1)).optional(),
  enviarApenasProprietario: z.boolean().optional(),
  destinos: z.array(
    z.object({
      dashboardId: z.coerce.number().int().min(1),
      usuarioIds: z.array(z.coerce.number().int().min(1)).min(1)
    })
  ).optional()
});
var adminNotificacaoWithOtpSchema = adminNotificacaoSchema.extend(
  adminSensitiveOtpCodeSchema.shape
);
var adminDeletePlanoWithOtpSchema = adminSensitiveOtpCodeSchema;
var adminDeleteDashboardWithOtpSchema = adminSensitiveOtpCodeSchema;
var adminDeleteUsuarioWithOtpSchema = adminSensitiveOtpCodeSchema;
var envioNotificacaoResponseSchema = z.object({
  totalCriadas: z.number(),
  totalDashboards: z.number(),
  totalUsuarios: z.number(),
  notificacoes: z.array(
    z.object({
      id: z.string(),
      dashboardId: z.number(),
      usuarioId: z.number().nullable(),
      tipo: z.string(),
      titulo: z.string(),
      corpo: z.string().optional(),
      createdAt: z.string()
    })
  ),
  erros: z.array(z.string())
});
var adminEnviarNotificacaoResponseSchema = dataResponse(
  envioNotificacaoResponseSchema
);
var adminNotificacaoHistoricoDashboardSchema = z.object({
  id: z.number(),
  titulo: z.string()
});
var adminNotificacaoHistoricoUsuarioSchema = z.object({
  id: z.number(),
  nome: z.string().nullable().optional(),
  sobrenome: z.string().nullable().optional(),
  email: z.string()
});
var adminNotificacaoHistoricoItemSchema = z.object({
  id: z.string(),
  dashboardId: z.number(),
  usuarioId: z.number().nullable(),
  tipo: notificacaoTipoEnum2,
  titulo: z.string(),
  corpo: z.string().nullable().optional(),
  lida: z.boolean(),
  createdAt: z.string(),
  dashboard: adminNotificacaoHistoricoDashboardSchema,
  usuario: adminNotificacaoHistoricoUsuarioSchema.nullable()
}).passthrough();
var adminNotificacaoHistoricoListResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(adminNotificacaoHistoricoItemSchema),
  meta: paginationMetaSchema,
  message: z.string().optional()
});
var adminNotificacaoAgendadaStatusEnum = z.enum([
  "PENDENTE",
  "ENVIADA",
  "CANCELADA",
  "ERRO"
]);
var adminNotificacaoAgendadaDashboardSchema = z.object({
  id: z.number(),
  titulo: z.string()
});
var adminNotificacaoAgendadaUsuarioSchema = z.object({
  id: z.number(),
  nome: z.string().nullable().optional(),
  sobrenome: z.string().nullable().optional(),
  email: z.string(),
  celular: z.string().nullable().optional()
});
var adminNotificacaoAgendadaItemSchema = z.object({
  id: z.string(),
  dashboardId: z.number().nullable(),
  usuarioId: z.number().nullable(),
  tipo: z.string(),
  titulo: z.string(),
  corpo: z.string().nullable().optional(),
  dados: z.record(z.string(), z.any()).nullable().optional(),
  canaisEnviados: z.array(z.string()),
  agendadoPara: z.string(),
  status: adminNotificacaoAgendadaStatusEnum,
  erroMensagem: z.string().nullable().optional(),
  processadaEm: z.string().nullable().optional(),
  notificacaoId: z.string().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string().optional(),
  dashboard: adminNotificacaoAgendadaDashboardSchema.nullable(),
  usuario: adminNotificacaoAgendadaUsuarioSchema.nullable()
}).passthrough();
var adminNotificacaoAgendadaListResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(adminNotificacaoAgendadaItemSchema),
  meta: paginationMetaSchema,
  message: z.string().optional()
});
var adminNotificacaoAgendadaDetailResponseSchema = dataResponse(
  adminNotificacaoAgendadaItemSchema
);
var adminCatalogEntitySchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string(),
  padrao: z.boolean().optional(),
  dashboardId: z.number().nullable().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional()
}).passthrough();
var adminCatalogDeleteDataSchema = z.object({
  success: z.literal(true)
});
var adminCatalogDeleteResponseSchema = dataResponse(
  adminCatalogDeleteDataSchema
);
var adminCatalogItemResponseSchema = dataResponse(
  adminCatalogEntitySchema
);
var adminCatalogListResponseSchema = listResponse(
  z.object({ id: z.number(), value: z.string(), label: z.string() })
);
var adminMessageResponseSchema = messageResponseSchema;
var adminUsuarioTipoEnum = z.enum(["ADMIN", "CLIENTE", "AGENCIA"]);
var adminUsuarioBuscaSchema = z.object({
  id: z.number(),
  nome: z.string().nullable().optional(),
  sobrenome: z.string().nullable().optional(),
  email: z.string(),
  celular: z.string().nullable().optional(),
  cpf: z.string().nullable().optional(),
  tipo: adminUsuarioTipoEnum.optional(),
  status: z.boolean().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
  /** Contagem agregada quando enriquecida no consumer; ausente na API bare. */
  totalDashboards: z.number().optional(),
  /** Último acesso à plataforma (login ou atividade de sessão). */
  ultimoAcessoEm: z.string().nullable().optional()
});
var adminUsuariosListResponseSchema = listResponse(
  adminUsuarioBuscaSchema
);
var adminDashboardOptionSchema = z.object({
  id: z.number(),
  titulo: z.string(),
  logo: z.string().nullable().optional(),
  status: dashboardStatusEnum.optional(),
  /** Status do vínculo usuário↔dashboard quando aplicável (UsuarioDashboardStatus). */
  userStatus: z.string().optional(),
  proprietarioId: z.number().optional(),
  createdAt: z.string().optional()
});
var adminDashboardListResponseSchema = listResponse(
  adminDashboardOptionSchema
);
var adminUsuarioDashboardsListResponseSchema = listResponse(
  adminDashboardOptionSchema
);
var adminUsuarioSchema = adminUsuarioBuscaSchema.extend({
  stripeCustomerId: z.string().nullable().optional(),
  googleSub: z.string().nullable().optional(),
  image: z.string().nullable().optional(),
  dashboardPrincipalId: z.number().nullable().optional(),
  tokenPassword: z.string().nullable().optional(),
  pin: z.number().nullable().optional(),
  /** Hash bcrypt — a API ainda devolve o campo hoje; consumidores devem ignorá-lo. */
  password: z.string().optional()
});
var adminUsuarioResponseSchema = dataResponse(adminUsuarioSchema);
var adminUsuarioCreateResponseSchema = adminUsuarioResponseSchema;
var adminUsuarioUpdateResponseSchema = adminUsuarioResponseSchema;
var adminUsuarioDeleteResultSchema = z.object({
  success: z.boolean()
});
var adminUsuarioDeleteResponseSchema = dataResponse(
  adminUsuarioDeleteResultSchema
);
var adminUsuarioPasswordUpdateResponseSchema = dataResponse(
  adminUsuarioDeleteResultSchema
);
var adminUsuarioLoginResultSchema = z.object({
  accessLink: z.string(),
  code: z.string(),
  fullToken: z.string(),
  expiresIn: z.number(),
  message: z.string()
});
var adminUsuarioLoginResponseSchema = dataResponse(
  adminUsuarioLoginResultSchema
);
var adminUsuarioRecuperarSenhaResponseSchema = dataResponse(
  messageResponseSchema
);
var adminTestEmailResultSchema = z.object({
  destinatario: z.string().email()
});
var adminTestEmailResponseSchema = dataResponse(adminTestEmailResultSchema);
var adminEmailStatusSchema = z.object({
  enabled: z.boolean(),
  hasAccessKeyId: z.boolean(),
  hasSecretAccessKey: z.boolean(),
  region: z.string(),
  nodeEnv: z.string(),
  isProduction: z.boolean(),
  devRedirectEnabled: z.boolean(),
  devRedirectEmail: z.string().nullable(),
  fromEmail: z.string(),
  replyToEmail: z.string(),
  accessKeyIdMasked: z.string().nullable()
});
var adminEmailStatusResponseSchema = dataResponse(adminEmailStatusSchema);
var adminEmailTemplateSchema = z.object({
  id: z.string(),
  subject: z.string(),
  descricaoUso: z.string().optional(),
  metodoCodigo: z.string().optional(),
  parametros: z.array(z.record(z.string(), z.unknown())).optional(),
  parametrosExemplo: z.array(z.string()).optional()
}).passthrough();
var adminEmailTemplatesResponseSchema = dataResponse(
  z.array(adminEmailTemplateSchema)
);
var adminEmailSesApiResponseSchema = z.object({
  ok: z.boolean(),
  originalEmail: z.string(),
  targetEmail: z.string(),
  redirected: z.boolean(),
  request: z.record(z.string(), z.unknown()),
  response: z.unknown()
}).passthrough();
var adminEmailTestResultSchema = z.object({
  email: z.string(),
  templateId: z.string(),
  subject: z.string(),
  parametros: z.record(z.string(), z.string()),
  sesApiResponse: adminEmailSesApiResponseSchema
}).passthrough();
var adminEmailTestResponseSchema = z.object({
  success: z.boolean(),
  data: adminEmailTestResultSchema,
  message: z.string()
});
var adminWhatsappMetaStatusSchema = z.object({
  enabled: z.boolean(),
  cloudEnabledFlag: z.boolean(),
  hasAccessToken: z.boolean(),
  phoneNumberId: z.string().nullable(),
  apiVersion: z.string(),
  languageCode: z.string()
});
var adminWhatsappMetaStatusResponseSchema = dataResponse(
  adminWhatsappMetaStatusSchema
);
var adminWhatsappMetaTemplateSchema = z.object({
  id: z.string(),
  metaTemplateName: z.string(),
  languageCode: z.string(),
  categoriaMeta: z.string().optional(),
  descricaoUso: z.string().optional(),
  corpoParaAprovacao: z.string().optional(),
  parametros: z.array(z.record(z.string(), z.unknown())).optional(),
  parametrosExemplo: z.array(z.string()).optional(),
  metodoCodigo: z.string().optional()
}).passthrough();
var adminWhatsappMetaTemplatesResponseSchema = dataResponse(
  z.array(adminWhatsappMetaTemplateSchema)
);
var adminWhatsappMetaApiResponseSchema = z.object({
  ok: z.boolean(),
  httpStatus: z.number(),
  body: z.unknown().optional()
}).passthrough();
var adminWhatsappMetaTestResultSchema = z.object({
  telefone: z.string(),
  templateId: z.string(),
  metaTemplateName: z.string(),
  languageCode: z.string(),
  bodyParameters: z.array(z.string()),
  headerMedia: z.unknown().nullable().optional(),
  buttonUrlParameters: z.array(z.object({ index: z.number(), text: z.string() })).optional(),
  buttonQuickReplyParameters: z.array(z.object({ index: z.number(), payload: z.string() })).optional(),
  metaApiResponse: adminWhatsappMetaApiResponseSchema
}).passthrough();
var adminWhatsappMetaTestResponseSchema = z.object({
  success: z.boolean(),
  data: adminWhatsappMetaTestResultSchema,
  message: z.string()
});
var adminUsuarioExportRowSchema = z.object({
  id: z.number(),
  nome: z.string(),
  sobrenome: z.string(),
  email: z.string(),
  celular: z.string().nullable().optional(),
  dashboards: z.array(z.string())
});
var adminUsuarioExportListResponseSchema = dataResponse(
  z.array(adminUsuarioExportRowSchema)
);
var adminUsuarioStripeCustomerResultSchema = z.object({
  stripeCustomerId: z.string(),
  message: z.string()
});
var adminUsuarioCreateStripeCustomerSchema = z.object({
  /** Força criação de um novo customer mesmo quando já existe um vinculado (ex.: deletado no Stripe) */
  forcar: z.boolean().optional()
});
var adminUsuarioStripeCustomerResponseSchema = dataResponse(
  adminUsuarioStripeCustomerResultSchema
);
var adminDashboardUsuarioRowSchema = z.object({
  id: z.number(),
  nome: z.string().nullable().optional(),
  sobrenome: z.string().nullable().optional(),
  email: z.string(),
  celular: z.string().nullable().optional(),
  tipo: z.string().optional(),
  statusUsuario: z.boolean().optional(),
  statusNaDashboard: z.string().optional(),
  role: z.string().optional(),
  createdAt: z.string().optional(),
  associadoEm: z.string().optional()
}).passthrough();
var adminDashboardUsuariosMetaSchema = paginationMetaSchema.extend({
  dashboard: z.object({
    id: z.number(),
    titulo: z.string()
  })
});
var adminDashboardUsuariosListResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(adminDashboardUsuarioRowSchema),
  meta: adminDashboardUsuariosMetaSchema,
  message: z.string().optional()
});
var adminGeneratePortalUrlResultSchema = z.object({
  url: z.string()
});
var adminGeneratePortalUrlResponseSchema = dataResponse(
  adminGeneratePortalUrlResultSchema
);
var adminVercelStatusSchema = z.object({
  enabled: z.boolean(),
  hasApiToken: z.boolean(),
  hasProjectName: z.boolean(),
  hasTeamId: z.boolean(),
  projectName: z.string().nullable(),
  teamId: z.string().nullable(),
  apiTokenMasked: z.string().nullable()
});
var adminVercelStatusResponseSchema = dataResponse(
  adminVercelStatusSchema
);
var adminVercelDnsVerificationSchema = z.object({
  type: z.string(),
  domain: z.string(),
  value: z.string(),
  reason: z.string().optional()
});
var adminVercelDnsSchema = z.object({
  root: z.object({
    type: z.string(),
    values: z.array(z.string())
  }),
  www: z.object({
    type: z.string(),
    value: z.string()
  }),
  verification: z.array(adminVercelDnsVerificationSchema).optional()
});
var adminVercelDomainEntrySchema = z.object({
  name: z.string(),
  verified: z.boolean(),
  wwwVerified: z.boolean().nullable(),
  hasWwwRedirect: z.boolean(),
  createdAt: z.number().nullable(),
  dnsConfigured: z.boolean().nullable(),
  dns: adminVercelDnsSchema.nullable(),
  dnsError: z.string().nullable(),
  vercelStatus: z.enum([
    "ready",
    "pending_verification",
    "misconfigured",
    "unknown"
  ])
});
var adminVercelDomainsListResponseSchema = dataResponse(
  z.array(adminVercelDomainEntrySchema)
);
var adminVercelAddDomainResultSchema = z.object({
  domain: z.string(),
  vercelResponse: z.unknown().optional(),
  dnsConfigured: z.boolean().nullable(),
  dns: adminVercelDnsSchema.nullable(),
  dnsError: z.string().nullable()
});
var adminVercelAddDomainResponseSchema = dataResponse(
  adminVercelAddDomainResultSchema
);
var adminVercelRemoveDomainResultSchema = z.object({
  domain: z.string(),
  removed: z.boolean()
});
var adminVercelRemoveDomainResponseSchema = dataResponse(
  adminVercelRemoveDomainResultSchema
);
var adminVercelIntegrationTestStepSchema = z.object({
  id: z.enum([
    "config",
    "list_domains",
    "add_domain",
    "dns_config",
    "remove_domain"
  ]),
  label: z.string(),
  ok: z.boolean(),
  message: z.string(),
  details: z.unknown().optional(),
  durationMs: z.number()
});
var adminVercelIntegrationTestResultSchema = z.object({
  ok: z.boolean(),
  steps: z.array(adminVercelIntegrationTestStepSchema),
  testDomain: z.string().nullable(),
  domainsCount: z.number().nullable(),
  finishedAt: z.string()
});
var adminVercelIntegrationTestResponseSchema = dataResponse(
  adminVercelIntegrationTestResultSchema
);
var adminBackupStatusEnum = z.enum([
  "SUCCESS",
  "FAILED",
  "RUNNING"
]);
var adminBackupArtifactSchema = z.object({
  key: z.string().min(1),
  sizeBytes: z.number().nonnegative(),
  sha256: z.string().regex(/^[a-f0-9]{64}$/).nullable(),
  mediaType: z.string().min(1),
  objectCount: z.number().int().nonnegative().optional(),
  verifiedBy: z.string().min(1)
});
var adminBackupManifestSchema = z.object({
  schemaVersion: z.string(),
  runId: z.string().min(1),
  asset: z.string().min(1),
  environment: z.string().optional(),
  startedAt: z.string(),
  finishedAt: z.string(),
  status: adminBackupStatusEnum,
  stage: z.string(),
  artifacts: z.array(adminBackupArtifactSchema),
  error: z.string().nullable(),
  restore: z.object({
    status: z.string(),
    testedAt: z.string().nullable(),
    durationSeconds: z.number().nonnegative().nullable(),
    sourceRunId: z.string().optional()
  }),
  notifications: z.object({
    email: z.string(),
    whatsapp: z.string()
  })
});
var adminBackupAssetHealthSchema = z.object({
  asset: z.string(),
  label: z.string(),
  coverage: z.enum(["PITR", "LOGICAL", "SNAPSHOT", "REBUILDABLE", "DRILL"]),
  expectedMaxAgeMinutes: z.number().positive().nullable(),
  lastSuccessAt: z.string().nullable(),
  ageMinutes: z.number().nonnegative().nullable(),
  rpoMinutes: z.number().nonnegative().nullable(),
  status: z.enum(["HEALTHY", "STALE", "FAILED", "MISSING", "REBUILDABLE"]),
  latestManifest: adminBackupManifestSchema.nullable()
});
var adminBackupMultipartUploadSchema = z.object({
  key: z.string(),
  uploadId: z.string(),
  initiatedAt: z.string().nullable(),
  ageMinutes: z.number().nonnegative().nullable(),
  stale: z.boolean()
});
var adminBackupOverviewSchema = z.object({
  configured: z.boolean(),
  generatedAt: z.string(),
  overallStatus: z.enum(["HEALTHY", "WARNING", "CRITICAL", "UNCONFIGURED"]),
  bucket: z.string().nullable(),
  prefix: z.string().nullable(),
  readOnly: z.literal(true),
  assets: z.array(adminBackupAssetHealthSchema),
  history: z.array(adminBackupManifestSchema),
  multipartUploads: z.array(adminBackupMultipartUploadSchema),
  pagination: z.object({
    page: z.number().int().positive(),
    pageSize: z.number().int().positive(),
    total: z.number().int().nonnegative(),
    totalPages: z.number().int().nonnegative()
  })
});
var adminBackupOverviewResponseSchema = dataResponse(
  adminBackupOverviewSchema
);
var adminFacebookChecklistStatusSchema = z.enum([
  "ok",
  "warn",
  "fail",
  "unknown"
]);
var adminFacebookChecklistItemSchema = z.object({
  id: z.string(),
  label: z.string(),
  status: adminFacebookChecklistStatusSchema,
  detail: z.string().optional()
});
var adminFacebookLeadAdsStatusSchema = z.object({
  enabled: z.boolean(),
  env: z.object({
    appId: z.boolean(),
    appIdMasked: z.string().nullable(),
    appSecret: z.boolean(),
    redirectUri: z.boolean(),
    redirectUriValue: z.string().nullable(),
    webhookVerifyToken: z.boolean()
  }),
  requiredScopes: z.array(z.string()),
  graph: z.object({
    appTokenOk: z.boolean(),
    appTokenError: z.string().nullable(),
    pageWebhookSubscription: z.object({
      checked: z.boolean(),
      active: z.boolean().nullable(),
      hasLeadgenField: z.boolean().nullable(),
      callbackUrl: z.string().nullable(),
      fields: z.array(z.string()),
      error: z.string().nullable()
    })
  }),
  pages: z.object({
    totalConnected: z.number(),
    sampleChecked: z.number(),
    withLeadgen: z.number(),
    samples: z.array(
      z.object({
        pageId: z.string(),
        name: z.string(),
        dashboardId: z.number(),
        hasLeadgen: z.boolean().nullable(),
        error: z.string().nullable()
      })
    )
  }),
  checklist: z.array(adminFacebookChecklistItemSchema)
});
var adminFacebookLeadAdsStatusResponseSchema = dataResponse(
  adminFacebookLeadAdsStatusSchema
);

// src/public-api/index.ts
var public_api_exports = {};
__export(public_api_exports, {
  createPublicAnotacaoSchema: () => createPublicAnotacaoSchema,
  createPublicContatoSchema: () => createPublicContatoSchema,
  createPublicLeadSchema: () => createPublicLeadSchema,
  createPublicOportunidadeSchema: () => createPublicOportunidadeSchema,
  dashboardApiCreatePublicLeadSchema: () => dashboardApiCreatePublicLeadSchema,
  leadAtenderPorHashResponseSchema: () => leadAtenderPorHashResponseSchema,
  leadDadosPorHashResponseSchema: () => leadDadosPorHashResponseSchema,
  portalLeadSchema: () => portalLeadSchema,
  publicAnotacaoResponseSchema: () => publicAnotacaoResponseSchema,
  publicArtigoDetailResponseSchema: () => publicArtigoDetailResponseSchema,
  publicArtigoListResponseSchema: () => publicArtigoListResponseSchema,
  publicCaracteristicasSchema: () => publicCaracteristicasSchema,
  publicContatoResponseSchema: () => publicContatoResponseSchema,
  publicLeadResponseSchema: () => publicLeadResponseSchema,
  publicLocalizacaoSchema: () => publicLocalizacaoSchema,
  publicOportunidadeResponseSchema: () => publicOportunidadeResponseSchema,
  publicSiteArtigoDetailSchema: () => publicSiteArtigoDetailSchema,
  publicSiteArtigoListItemSchema: () => publicSiteArtigoListItemSchema,
  publicSiteArtigoResponseSchema: () => publicSiteArtigoResponseSchema,
  publicSiteArtigosQuerySchema: () => publicSiteArtigosQuerySchema,
  publicSiteArtigosResponseSchema: () => publicSiteArtigosResponseSchema,
  publicSiteCampanhaListItemSchema: () => publicSiteCampanhaListItemSchema,
  publicSiteCampanhasResponseSchema: () => publicSiteCampanhasResponseSchema,
  publicSiteEmpreendimentoDetailSchema: () => publicSiteEmpreendimentoDetailSchema,
  publicSiteEmpreendimentoListItemSchema: () => publicSiteEmpreendimentoListItemSchema,
  publicSiteEmpreendimentoResponseSchema: () => publicSiteEmpreendimentoResponseSchema,
  publicSiteEmpreendimentosQuerySchema: () => publicSiteEmpreendimentosQuerySchema,
  publicSiteEmpreendimentosResponseSchema: () => publicSiteEmpreendimentosResponseSchema,
  publicSiteImoveisQuerySchema: () => publicSiteImoveisQuerySchema,
  publicSiteImoveisResponseSchema: () => publicSiteImoveisResponseSchema,
  publicSiteImoveisSearchDataQuerySchema: () => publicSiteImoveisSearchDataQuerySchema,
  publicSiteImoveisSearchDataResponseSchema: () => publicSiteImoveisSearchDataResponseSchema,
  publicSiteImovelDetailSchema: () => publicSiteImovelDetailSchema,
  publicSiteImovelListItemSchema: () => publicSiteImovelListItemSchema,
  publicSiteImovelResponseSchema: () => publicSiteImovelResponseSchema,
  publicSiteIncorporadoraDetailSchema: () => publicSiteIncorporadoraDetailSchema,
  publicSiteIncorporadoraListItemSchema: () => publicSiteIncorporadoraListItemSchema,
  publicSiteIncorporadoraResponseSchema: () => publicSiteIncorporadoraResponseSchema,
  publicSiteIncorporadorasQuerySchema: () => publicSiteIncorporadorasQuerySchema,
  publicSiteIncorporadorasResponseSchema: () => publicSiteIncorporadorasResponseSchema,
  publicSiteInfoResponseSchema: () => publicSiteInfoResponseSchema,
  publicSiteInfoSchema: () => publicSiteInfoSchema,
  publicSiteLeadDataSchema: () => publicSiteLeadDataSchema,
  publicSiteLeadResponseSchema: () => publicSiteLeadResponseSchema,
  publicTaxasImpostosSchema: () => publicTaxasImpostosSchema,
  trackLeadResponseSchema: () => trackLeadResponseSchema,
  trackLeadSchema: () => trackLeadSchema,
  unsubscribeByTokenResponseSchema: () => unsubscribeByTokenResponseSchema,
  unsubscribeEmailRequestSchema: () => unsubscribeEmailRequestSchema,
  unsubscribeEmailResponseSchema: () => unsubscribeEmailResponseSchema,
  updatePublicContatoSchema: () => updatePublicContatoSchema,
  updatePublicLeadSchema: () => updatePublicLeadSchema,
  updatePublicOportunidadeSchema: () => updatePublicOportunidadeSchema
});
var portalLeadSchema = z.object({
  nome: z.string().max(255).optional(),
  email: z.string().email().max(255).optional(),
  celular: z.string().max(20).optional(),
  cpf: z.string().max(14).optional(),
  finalidade: leadFinalidadeEnum.optional(),
  imovelId: z.coerce.number(),
  anotacoes: z.string().max(1e3).optional()
}).refine((data) => Boolean(data.email?.trim()) || Boolean(data.celular?.trim()), {
  message: "Email ou celular \xE9 obrigat\xF3rio",
  path: ["email"]
});
var createPublicLeadSchema = z.object({
  nome: z.string().min(1).max(255),
  email: z.string().email().optional(),
  celular: z.string().max(20).optional(),
  cpf: z.string().max(14).optional(),
  finalidade: leadFinalidadeEnum.optional(),
  origem: z.string().max(100).optional(),
  status: z.string().max(50).optional(),
  empreendimentos: z.array(z.coerce.number()).optional(),
  imoveis: z.array(z.coerce.number()).optional(),
  utmSource: z.string().max(100).optional(),
  utmMedium: z.string().max(100).optional(),
  utmCampaign: z.string().max(100).optional(),
  utmTerm: z.string().max(100).optional(),
  utmContent: z.string().max(100).optional(),
  anotacoes: z.string().max(5e3).optional(),
  formId: z.string().max(100).optional(),
  leadgenId: z.string().max(100).optional(),
  fingerprintId: z.string().max(255).optional()
});
var dashboardApiCreatePublicLeadSchema = z.object({
  contatoId: z.coerce.number().optional(),
  nome: z.string().max(255).optional(),
  email: z.string().email().max(255).optional(),
  finalidade: leadFinalidadeEnum.optional(),
  celular: z.string().max(20).optional(),
  cpf: z.string().max(14).optional(),
  origem: z.string().max(100).optional(),
  responsavelId: z.coerce.number().optional(),
  imoveisIds: z.array(z.coerce.number()).optional(),
  empreendimentosIds: z.array(z.coerce.number()).optional()
}).refine(
  (d) => d.contatoId != null || Boolean(d.nome?.trim()),
  { message: "Nome \xE9 obrigat\xF3rio quando contatoId n\xE3o \xE9 fornecido", path: ["nome"] }
);
var updatePublicLeadSchema = z.object({
  status: z.string().optional(),
  responsavelId: z.coerce.number().optional(),
  atendido: z.boolean().optional(),
  imoveisIds: z.array(z.coerce.number()).optional(),
  empreendimentosIds: z.array(z.coerce.number()).optional()
});
var createPublicContatoSchema = z.object({
  naturezaJuridica: naturezaJuridicaEnum.default("PF"),
  nome: z.string().min(1).max(255),
  email: z.string().email().optional(),
  telefone: z.string().optional(),
  celular: z.string().optional()
});
var updatePublicContatoSchema = createPublicContatoSchema.partial();
var createPublicOportunidadeSchema = z.object({
  titulo: z.string().min(1).max(255),
  contatoId: z.coerce.number(),
  funilId: z.coerce.number().optional(),
  etapaId: z.coerce.number().optional()
});
var updatePublicOportunidadeSchema = createPublicOportunidadeSchema.partial();
var createPublicAnotacaoSchema = z.object({
  conteudo: z.any()
});
var trackLeadSchema = z.object({
  eventName: z.string().min(1),
  eventId: z.string().optional(),
  email: z.string().email().optional(),
  phone: z.string().optional(),
  name: z.string().optional(),
  value: z.coerce.number().optional(),
  gaClientId: z.string().optional(),
  gaSessionId: z.string().optional(),
  leadSource: z.string().optional(),
  planSlug: z.string().optional(),
  formId: z.string().optional(),
  formName: z.string().optional(),
  materialId: z.string().optional(),
  materialName: z.string().optional(),
  pageLocation: z.string().optional(),
  pageReferrer: z.string().optional(),
  utmSource: z.string().optional(),
  utmMedium: z.string().optional(),
  utmCampaign: z.string().optional(),
  utmContent: z.string().optional(),
  utmTerm: z.string().optional(),
  gclid: z.string().optional(),
  fbclid: z.string().optional()
});
var publicLeadResponseSchema = dataResponse(z.object({ id: z.number() }));
var trackLeadResponseSchema = messageResponseSchema;
var publicSiteLeadDataSchema = z.object({
  id: z.number(),
  responsavel: z.object({
    celular: z.string().nullable().optional()
  }).nullable().optional()
}).passthrough();
var publicSiteLeadResponseSchema = z.object({
  success: z.boolean(),
  message: z.string().optional(),
  data: publicSiteLeadDataSchema.optional()
});
var publicContatoResponseSchema = dataResponse(contatoSchema);
var publicOportunidadeResponseSchema = dataResponse(
  oportunidadeDetalhesSchema
);
var publicAnotacaoResponseSchema = dataResponse(oportunidadeAnotacaoSchema);
var publicSiteInfoSchema = z.object({
  id: z.number(),
  dashboardId: z.number(),
  nome: z.string(),
  dominioDev: z.string(),
  dominioProprio: z.string().nullable(),
  publicado: z.boolean(),
  creci: z.string().nullable()
});
var publicSiteInfoResponseSchema = z.object({
  success: z.boolean(),
  message: z.string().optional(),
  data: publicSiteInfoSchema.optional()
});
var publicSitePaginationUtilsSchema = z.object({
  currentPage: z.number(),
  totalPages: z.number(),
  totalItems: z.number(),
  nextPage: z.number().nullable(),
  prevPage: z.number().nullable()
});
var publicSiteLabelValueSchema = z.object({
  label: z.string(),
  value: z.string()
});
var publicSiteMediaSchema = z.object({
  titulo: z.string(),
  url: z.string()
});
var publicSiteSeoSchema = z.object({
  metaTitle: z.string().optional(),
  metaDescription: z.string().optional(),
  slug: z.string(),
  keywords: z.string().optional()
});
var publicLocalizacaoSchema = z.object({
  rua: z.string().nullable().optional(),
  bairro: z.string().nullable().optional(),
  cidade: z.string().nullable().optional(),
  uf: z.string().nullable().optional(),
  cep: z.union([z.string(), z.number()]).nullable().optional(),
  numero: z.union([z.string(), z.number()]).nullable().optional(),
  rua_slug: z.string().nullable().optional(),
  bairro_slug: z.string().nullable().optional(),
  cidade_slug: z.string().nullable().optional(),
  cidadeSlug: z.string().nullable().optional(),
  distanciaPraia: z.union([z.number(), z.string()]).nullable().optional(),
  latitude: z.union([z.number(), z.string()]).nullable().optional(),
  longitude: z.union([z.number(), z.string()]).nullable().optional()
});
var publicSiteArtigosQuerySchema = z.object({
  page: z.coerce.number().int().min(1).optional(),
  take: z.coerce.number().int().min(1).max(100).optional(),
  tags: z.string().optional(),
  exclude: z.string().optional()
});
var publicSiteArtigoListItemSchema = z.object({
  id: z.number(),
  imagemDestaque: z.string().nullable(),
  titulo: z.string(),
  slug: z.string(),
  tags: z.array(publicSiteLabelValueSchema),
  createdAt: z.string()
});
var publicSiteArtigosResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(publicSiteArtigoListItemSchema),
  utils: publicSitePaginationUtilsSchema
});
var publicArtigoListResponseSchema = publicSiteArtigosResponseSchema;
var publicSiteArtigoDetailSchema = z.object({
  id: z.number(),
  titulo: z.string(),
  conteudo: z.any(),
  createdAt: z.string(),
  imagemDestaque: z.string().nullable(),
  slug: z.string(),
  metaDescription: z.string().nullable().optional(),
  metaTitle: z.string().nullable().optional(),
  tags: z.array(publicSiteLabelValueSchema),
  autores: z.array(
    z.object({
      nome: z.string(),
      sobrenome: z.string().nullable().optional()
    })
  )
});
var publicSiteArtigoResponseSchema = z.object({
  success: z.boolean(),
  data: publicSiteArtigoDetailSchema
});
var publicArtigoDetailResponseSchema = publicSiteArtigoResponseSchema;
var publicSiteStringArrayParam = z.union([z.string(), z.array(z.string())]);
var publicSiteImoveisQuerySchema = z.object({
  page: z.coerce.number().int().min(1).optional(),
  take: z.coerce.number().int().min(1).max(100).optional(),
  order: z.string().optional(),
  search: z.string().optional(),
  ids: z.string().optional(),
  empreendimento: z.coerce.number().optional(),
  incorporadora: z.coerce.number().optional(),
  finalidade: z.string().optional(),
  uso: z.string().optional(),
  tipo: z.string().optional(),
  subTipo: z.string().optional(),
  valorVendaMin: z.coerce.number().optional(),
  valorVendaMax: z.coerce.number().optional(),
  valorLocacaoMin: z.coerce.number().optional(),
  valorLocacaoMax: z.coerce.number().optional(),
  totalDormitorios: z.string().optional(),
  totalDormitoriosMin: z.coerce.number().optional(),
  totalDormitoriosMax: z.coerce.number().optional(),
  suites: z.string().optional(),
  suitesMin: z.coerce.number().optional(),
  suitesMax: z.coerce.number().optional(),
  banheiros: z.string().optional(),
  banheirosMin: z.coerce.number().optional(),
  banheirosMax: z.coerce.number().optional(),
  dormitorios: z.string().optional(),
  dormitoriosMin: z.coerce.number().optional(),
  dormitoriosMax: z.coerce.number().optional(),
  demiSuites: z.string().optional(),
  demiSuitesMin: z.coerce.number().optional(),
  demiSuitesMax: z.coerce.number().optional(),
  salas: z.string().optional(),
  salasMin: z.coerce.number().optional(),
  salasMax: z.coerce.number().optional(),
  vagasGaragem: z.string().optional(),
  vagasGaragemMin: z.coerce.number().optional(),
  vagasGaragemMax: z.coerce.number().optional(),
  condicao: z.string().optional(),
  mobiliado: z.string().optional(),
  uf: z.string().optional(),
  cidade: z.string().optional(),
  bairro: z.string().optional(),
  rua: z.string().optional(),
  distanciaPraia: z.string().optional(),
  campanha: z.string().optional(),
  campanhas: publicSiteStringArrayParam.optional(),
  campanhasIds: publicSiteStringArrayParam.optional()
});
var publicSiteImoveisSearchDataQuerySchema = publicSiteImoveisQuerySchema;
var publicSiteValorFaixaSchema = z.object({
  valor: z.coerce.number().nullable().optional()
});
var publicSiteComodidadeSchema = z.object({
  value: z.string(),
  label: z.string(),
  quantidade: z.number().nullable().optional()
});
var publicSiteMobiliadoSchema = z.union([z.boolean(), publicSiteLabelValueSchema]).nullable().optional();
var publicCaracteristicasSchema = z.object({
  salas: z.number().nullable().optional(),
  totalDormitorios: z.number().nullable().optional(),
  dormitorios: z.number().nullable().optional(),
  suites: z.number().nullable().optional(),
  demiSuites: z.number().nullable().optional(),
  banheiros: z.number().nullable().optional(),
  vagasGaragem: z.number().nullable().optional(),
  entregaObra: z.string().nullable().optional(),
  mobiliado: publicSiteMobiliadoSchema,
  condicao: publicSiteLabelValueSchema.nullable().optional(),
  valorDe: z.number().nullable().optional(),
  valorAte: z.number().nullable().optional(),
  dormitoriosDe: z.number().nullable().optional(),
  dormitoriosAte: z.number().nullable().optional(),
  suitesDe: z.number().nullable().optional(),
  suitesAte: z.number().nullable().optional(),
  demiSuitesDe: z.number().nullable().optional(),
  demiSuitesAte: z.number().nullable().optional(),
  areaDe: z.number().nullable().optional(),
  areaAte: z.number().nullable().optional(),
  vagasGaragemDe: z.number().nullable().optional(),
  vagasGaragemAte: z.number().nullable().optional(),
  salasDe: z.number().nullable().optional(),
  salasAte: z.number().nullable().optional(),
  banheirosDe: z.number().nullable().optional(),
  banheirosAte: z.number().nullable().optional(),
  lavabosDe: z.number().nullable().optional(),
  lavabosAte: z.number().nullable().optional(),
  anoConstrucao: z.string().nullable().optional(),
  dataEntrega: z.string().nullable().optional(),
  totalTorres: z.number().nullable().optional(),
  totalUnidades: z.number().nullable().optional()
}).passthrough();
var publicTaxaPeriodoSchema = z.union([
  z.enum(["Mensal", "Anual"]),
  z.enum(["mensal", "anual"]),
  z.string()
]).nullable().optional();
var publicTaxasImpostosSchema = z.object({
  id: z.number().optional(),
  imovelId: z.number().optional(),
  condominio: z.boolean().optional(),
  condominioValor: z.number().nullable().optional(),
  condominioOcultarValor: z.boolean().optional(),
  iptuIsento: z.boolean().optional(),
  iptuPeriodo: publicTaxaPeriodoSchema,
  iptuValor: z.number().nullable().optional(),
  iptuOcultarValor: z.boolean().optional(),
  seguroIncendio: z.boolean().optional(),
  seguroIncendioPeriodo: publicTaxaPeriodoSchema,
  seguroIncendioValor: z.number().nullable().optional(),
  seguroIncendioOcultarValor: z.boolean().optional(),
  informacoesAdicionais: z.string().nullable().optional()
}).passthrough();
var publicSiteImovelListItemSchema = z.object({
  id: z.number(),
  titulo: z.string(),
  createdAt: z.coerce.string(),
  uso: publicSiteLabelValueSchema.nullable().optional(),
  tipo: publicSiteLabelValueSchema.nullable().optional(),
  subTipo: publicSiteLabelValueSchema.nullable().optional(),
  fotos: z.array(publicSiteMediaSchema).optional(),
  finalidades: z.array(publicSiteLabelValueSchema).optional(),
  valoresVenda: publicSiteValorFaixaSchema.nullable().optional(),
  valoresLocacao: publicSiteValorFaixaSchema.nullable().optional(),
  caracteristicas: publicCaracteristicasSchema.nullable().optional(),
  areaTotal: z.number().nullable().optional(),
  localizacao: publicLocalizacaoSchema.nullable().optional(),
  videos: z.array(publicSiteMediaSchema).optional(),
  tourVirtuais: z.array(publicSiteMediaSchema).optional(),
  incorporadora: z.object({
    nome: z.string().optional(),
    logo: z.string().nullable().optional()
  }).nullable().optional(),
  seo: publicSiteSeoSchema.nullable().optional(),
  empreendimento: z.object({
    id: z.number(),
    nome: z.string()
  }).nullable().optional()
}).passthrough();
var publicSiteImoveisResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(publicSiteImovelListItemSchema),
  utils: publicSitePaginationUtilsSchema
});
var publicSiteImovelDetailSchema = z.object({
  id: z.number(),
  titulo: z.string(),
  codigo: z.string().optional(),
  descricao: z.any().optional(),
  createdAt: z.coerce.string(),
  tipo: publicSiteLabelValueSchema,
  uso: publicSiteLabelValueSchema,
  subTipo: publicSiteLabelValueSchema.nullable().optional(),
  videos: z.array(publicSiteMediaSchema),
  fotos: z.array(publicSiteMediaSchema),
  finalidades: z.array(z.object({ finalidade: publicSiteLabelValueSchema })),
  valoresVenda: z.object({
    valor: z.number().nullable(),
    ocultarValor: z.boolean()
  }),
  valoresLocacao: z.object({
    valor: z.number().nullable(),
    ocultarValor: z.boolean()
  }),
  caracteristicas: publicCaracteristicasSchema.nullable().optional(),
  areasConstrucao: z.object({ areaTotal: z.number().nullable().optional() }),
  areasTerreno: z.object({ areaTotal: z.number().nullable().optional() }),
  taxasImpostos: publicTaxasImpostosSchema.nullable().optional(),
  localizacao: publicLocalizacaoSchema.nullable().optional(),
  comodidades: z.array(publicSiteComodidadeSchema),
  empreendimento: z.object({
    id: z.number(),
    titulo: z.string(),
    slug: z.string(),
    comodidades: z.array(publicSiteComodidadeSchema),
    fotos: z.array(publicSiteMediaSchema)
  }).nullable().optional(),
  seo: publicSiteSeoSchema
}).passthrough();
var publicSiteImovelResponseSchema = z.object({
  success: z.boolean(),
  data: publicSiteImovelDetailSchema
});
var publicSiteImoveisSearchDataResponseSchema = z.object({
  success: z.boolean(),
  data: z.object({
    usos: z.array(publicSiteLabelValueSchema),
    tipos: z.array(publicSiteLabelValueSchema),
    subtipos: z.array(publicSiteLabelValueSchema),
    enderecos: z.array(
      z.object({
        cidade: z.string(),
        cidade_slug: z.string().nullable().optional(),
        bairro_slug: z.string().nullable().optional(),
        uf: z.string(),
        filter: z.string(),
        label: z.string()
      })
    ),
    localizacoes: z.object({
      ufs: z.array(z.string()),
      cidades: z.array(z.object({ label: z.string(), slug: z.string() })),
      bairros: z.array(
        z.object({
          cidadeSlug: z.string(),
          label: z.string(),
          slug: z.string()
        })
      ),
      ruas: z.array(z.object({ label: z.string(), slug: z.string() })),
      distanciasPraia: z.array(z.number()),
      label: z.string(),
      value: z.string()
    }),
    empreendimentos: z.array(
      z.object({
        id: z.string(),
        nome: z.string(),
        slug: z.string()
      })
    ),
    incorporadoras: z.array(
      z.object({
        id: z.string(),
        nome: z.string(),
        slug: z.string()
      })
    ),
    valores: z.object({
      compra: z.object({ min: z.number().nullable(), max: z.number().nullable() }),
      aluguel: z.object({ min: z.number().nullable(), max: z.number().nullable() })
    })
  }),
  utils: z.object({
    totalItems: z.number()
  })
});
var publicSiteIncorporadorasQuerySchema = z.object({
  page: z.coerce.number().int().min(1).optional(),
  take: z.coerce.number().int().min(1).max(100).optional()
});
var publicSiteIncorporadoraListItemSchema = z.object({
  id: z.number(),
  nome: z.string(),
  logo: z.string().nullable(),
  slug: z.string(),
  empreendimentos: z.number(),
  imoveis: z.number()
});
var publicSiteIncorporadorasResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(publicSiteIncorporadoraListItemSchema),
  utils: publicSitePaginationUtilsSchema
});
var publicSiteIncorporadoraDetailSchema = z.object({
  id: z.number(),
  nome: z.string(),
  logo: z.string().nullable(),
  descricao: z.any().nullable(),
  seo: publicSiteSeoSchema
});
var publicSiteIncorporadoraResponseSchema = z.object({
  success: z.boolean(),
  data: publicSiteIncorporadoraDetailSchema
});
var publicSiteEmpreendimentosQuerySchema = z.object({
  page: z.coerce.number().int().min(1).optional(),
  take: z.coerce.number().int().min(1).max(100).optional(),
  uf: z.string().optional(),
  cidade: z.string().optional(),
  bairro: z.string().optional(),
  distanciaPraia: z.coerce.number().optional(),
  pesquisa: z.string().optional(),
  incorporadora: z.coerce.number().optional(),
  order: z.string().optional()
});
var publicSiteEmpreendimentoListItemSchema = z.object({
  id: z.number(),
  tipo: publicSiteLabelValueSchema,
  nome: z.string(),
  createdAt: z.coerce.string(),
  imagemDestaque: z.string().nullable(),
  logo: z.string().nullable(),
  incorporadora: z.string().nullable(),
  descricao: z.any().nullable(),
  fase: publicSiteLabelValueSchema.nullable().optional(),
  // API retorna boolean (Prisma `Boolean?`); string mantida por compatibilidade
  plantaoLocal: z.union([z.boolean(), z.string()]).nullable().optional(),
  comodidades: z.array(publicSiteComodidadeSchema),
  caracteristicas: publicCaracteristicasSchema.nullable().optional(),
  localizacao: publicLocalizacaoSchema.nullable().optional(),
  videos: z.array(publicSiteMediaSchema),
  tourVirtuais: z.array(publicSiteMediaSchema),
  fotos: z.array(publicSiteMediaSchema),
  seo: publicSiteSeoSchema.nullable()
}).passthrough();
var publicSiteEmpreendimentosResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(publicSiteEmpreendimentoListItemSchema),
  utils: publicSitePaginationUtilsSchema
});
var publicSiteEmpreendimentoDetailSchema = z.object({
  id: z.number(),
  tipo: publicSiteLabelValueSchema,
  nome: z.string(),
  createdAt: z.coerce.string(),
  imagemDestaque: z.string().nullable(),
  logo: z.string().nullable(),
  incorporadora: z.string().nullable(),
  descricao: z.any().nullable(),
  fase: publicSiteLabelValueSchema.nullable().optional(),
  // API retorna boolean (Prisma `Boolean?`); string mantida por compatibilidade
  plantaoLocal: z.union([z.boolean(), z.string()]).nullable().optional(),
  comodidades: z.array(publicSiteComodidadeSchema),
  caracteristicas: publicCaracteristicasSchema.nullable().optional(),
  localizacao: publicLocalizacaoSchema.nullable().optional(),
  videos: z.array(publicSiteMediaSchema),
  tourVirtuais: z.array(publicSiteMediaSchema),
  fotos: z.array(publicSiteMediaSchema),
  seo: publicSiteSeoSchema
}).passthrough();
var publicSiteEmpreendimentoResponseSchema = z.object({
  success: z.boolean(),
  data: publicSiteEmpreendimentoDetailSchema
});
var publicSiteCampanhaListItemSchema = z.object({
  id: z.number(),
  nome: z.string(),
  slug: z.string(),
  descricao: z.any().nullable().optional(),
  metaTitle: z.string(),
  metaDescription: z.string().nullable().optional(),
  createdAt: z.union([z.string(), z.coerce.date()]),
  updatedAt: z.union([z.string(), z.coerce.date()])
});
var publicSiteCampanhasResponseSchema = z.object({
  success: z.boolean(),
  message: z.string().optional(),
  data: z.array(publicSiteCampanhaListItemSchema).optional()
});
var leadAtenderPorHashResponseSchema = z.object({
  success: z.boolean(),
  leadId: z.string(),
  dashboardId: z.union([z.string(), z.number()]).optional(),
  status: z.string(),
  atendidoEm: z.string().nullable(),
  dadosUrl: z.string()
});
var unsubscribeEmailRequestSchema = z.object({
  email: z.string().email()
});
var unsubscribeEmailResponseSchema = messageResponseSchema;
var unsubscribeByTokenResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  alreadyOptedOut: z.boolean().optional()
});
var leadDadosPorHashResponseSchema = z.object({
  leadId: z.string(),
  dashboardId: z.union([z.string(), z.number()]).optional(),
  status: z.string(),
  atendido: z.union([z.string(), z.null()]).optional(),
  finalidade: z.string().optional(),
  contato: z.object({
    nome: z.string().optional(),
    email: z.string().nullable().optional(),
    celular: z.string().nullable().optional()
  }).optional(),
  interesses: z.object({
    imoveis: z.array(z.object({ id: z.number(), titulo: z.string() })).optional(),
    empreendimentos: z.array(z.object({ id: z.number(), nome: z.string() })).optional()
  }).optional(),
  anotacoes: z.array(
    z.object({
      id: z.union([z.number(), z.string()]),
      conteudo: z.string().nullable(),
      createdAt: z.coerce.string()
    })
  ).optional()
});

// src/upload/index.ts
var upload_exports = {};
__export(upload_exports, {
  generatePortalLogoUploadUrlSchema: () => generatePortalLogoUploadUrlSchema,
  generateSiteUploadUrlSchema: () => generateSiteUploadUrlSchema,
  presignedUrlDataSchema: () => presignedUrlDataSchema,
  presignedUrlRequestSchema: () => presignedUrlRequestSchema2,
  presignedUrlResponseSchema: () => presignedUrlResponseSchema2,
  supportedFileTypesDataSchema: () => supportedFileTypesDataSchema,
  supportedFileTypesResponseSchema: () => supportedFileTypesResponseSchema,
  tipoConteudoEnum: () => tipoConteudoEnum,
  uploadFolderEnum: () => uploadFolderEnum2
});
var tipoConteudoEnum = z.enum([
  "imovel",
  "empreendimento",
  "incorporadora",
  "artigo",
  "usuario",
  "site",
  "assets",
  "ai-agent"
]);
var uploadFolderEnum2 = z.enum([
  "fotos",
  "anexos",
  "videos",
  "tours",
  "avatar",
  "logo",
  "favicon",
  "imagens",
  "arquivos",
  "audios"
]);
var presignedUrlRequestSchema2 = z.object({
  dashboardId: z.coerce.number().int().min(1),
  tipoConteudo: tipoConteudoEnum,
  conteudoId: z.coerce.number().int().min(1).optional(),
  folder: uploadFolderEnum2,
  fileName: z.string().min(1).max(255).regex(/^[a-zA-Z0-9._-]+\.[a-zA-Z0-9]+$/),
  fileType: z.string().min(1),
  size: z.coerce.number().min(1).optional(),
  isPublico: z.boolean().optional()
}).refine(
  (data) => data.tipoConteudo === "assets" || typeof data.conteudoId === "number",
  {
    message: "conteudoId \xE9 obrigat\xF3rio para este tipo de conte\xFAdo",
    path: ["conteudoId"]
  }
);
var presignedUrlDataSchema = presignedUploadDataSchema.extend({
  folder: uploadFolderEnum2.optional(),
  dashboardId: z.number().optional(),
  tipoConteudo: tipoConteudoEnum.optional(),
  conteudoId: z.number().optional(),
  isPublico: z.boolean().optional()
});
var presignedUrlResponseSchema2 = apiSuccess(presignedUrlDataSchema);
var supportedFileTypesDataSchema = z.object({
  folder: uploadFolderEnum2,
  supportedTypes: z.array(z.string())
});
var supportedFileTypesResponseSchema = apiSuccess(
  supportedFileTypesDataSchema
);
var generateSiteUploadUrlSchema = z.object({
  fileName: z.string().min(1).max(255),
  contentType: z.string().min(1),
  size: z.coerce.number().min(1),
  folder: z.string().optional()
});
var generatePortalLogoUploadUrlSchema = z.object({
  fileName: z.string().min(1).max(255),
  fileType: z.string().min(1)
});

// src/portal/index.ts
var portal_exports = {};
__export(portal_exports, {
  createPortalConfigSchema: () => createPortalConfigSchema,
  createPortalSchema: () => createPortalSchema,
  dashboardPortaisResponseSchema: () => dashboardPortaisResponseSchema,
  dashboardPortalConfigSchema: () => dashboardPortalConfigSchema,
  dashboardPortalListItemSchema: () => dashboardPortalListItemSchema,
  dashboardPortalResponseSchema: () => dashboardPortalResponseSchema,
  deletePortalResponseSchema: () => deletePortalResponseSchema,
  portaisResponseSchema: () => portaisResponseSchema,
  portalConfigResponseSchema: () => portalConfigResponseSchema2,
  portalConfigSchema: () => portalConfigSchema2,
  portalResponseSchema: () => portalResponseSchema2,
  portalSchema: () => portalSchema,
  portalStatsResponseSchema: () => portalStatsResponseSchema,
  portalStatsSchema: () => portalStatsSchema,
  updatePortalConfigSchema: () => updatePortalConfigSchema,
  updatePortalSchema: () => updatePortalSchema
});
var createPortalSchema = z.object({
  value: z.string().min(1),
  nome: z.string().min(1)
});
var updatePortalSchema = z.object({
  value: z.string().optional(),
  nome: z.string().optional()
});
var createPortalConfigSchema = z.object({
  portalValue: z.string().min(1),
  anuncioNormal: z.coerce.number().int().min(0).optional(),
  anuncioDestaque: z.coerce.number().int().min(0).optional(),
  anuncioSuperDestaque: z.coerce.number().int().min(0).optional(),
  custo: z.coerce.number().int().min(0).optional()
});
var updatePortalConfigSchema = z.object({
  anuncioNormal: z.coerce.number().int().min(0).optional(),
  anuncioDestaque: z.coerce.number().int().min(0).optional(),
  anuncioSuperDestaque: z.coerce.number().int().min(0).optional(),
  custo: z.coerce.number().int().min(0).optional()
});
var portalConfigSchema2 = z.object({
  id: z.number(),
  portalValue: z.string(),
  anuncioNormal: z.number().nullable().optional(),
  anuncioDestaque: z.number().nullable().optional(),
  anuncioSuperDestaque: z.number().nullable().optional(),
  custo: z.number().nullable().optional()
});
var portalConfigResponseSchema2 = dataResponse(portalConfigSchema2);
var portalSchema = z.object({
  id: z.number(),
  value: z.string(),
  nome: z.string(),
  dashboardId: z.number(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var dashboardPortalConfigSchema = z.object({
  id: z.number(),
  token: z.string().nullable(),
  ativo: z.boolean(),
  anuncioNormal: z.number().nullable(),
  anuncioDestaque: z.number().nullable(),
  anuncioSuperDestaque: z.number().nullable(),
  custo: z.number().nullable(),
  url: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var dashboardPortalListItemSchema = z.object({
  id: z.number(),
  value: z.string(),
  nome: z.string(),
  logo: z.string().nullable().optional(),
  tiposAnuncioDisponiveis: z.array(z.string()).optional(),
  ativo: z.boolean(),
  config: dashboardPortalConfigSchema.nullable(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var portaisResponseSchema = listResponse(portalSchema);
var dashboardPortaisResponseSchema = listResponse(
  dashboardPortalListItemSchema
);
var dashboardPortalResponseSchema = dataResponse(
  dashboardPortalListItemSchema
);
var portalResponseSchema2 = dataResponse(portalSchema);
var deletePortalResponseSchema = messageResponseSchema;
var portalStatsSchema = z.object({
  totalPortais: z.number(),
  portaisComImoveis: z.array(
    z.object({
      id: z.number(),
      nome: z.string(),
      value: z.string(),
      totalImoveis: z.number(),
      porTipoAnuncio: z.object({
        Normal: z.number(),
        Destaque: z.number(),
        SuperDestaque: z.number()
      })
    })
  )
});
var portalStatsResponseSchema = dataResponse(portalStatsSchema);

// src/site/index.ts
var site_exports = {};
__export(site_exports, {
  artigoConteudoSchema: () => artigoConteudoSchema,
  artigoListPageSchema: () => artigoListPageSchema,
  artigoListQuerySchema: () => artigoListQuerySchema,
  artigoParamsSchema: () => artigoParamsSchema,
  artigoResponseSchema: () => artigoResponseSchema2,
  artigoSchema: () => artigoSchema2,
  artigosListResponseSchema: () => artigosListResponseSchema,
  artigosResponseSchema: () => artigosResponseSchema2,
  createArtigoSchema: () => createArtigoSchema,
  createSiteSchema: () => createSiteSchema,
  createTagSchema: () => createTagSchema,
  deleteArtigoResponseSchema: () => deleteArtigoResponseSchema,
  deleteSiteResponseSchema: () => deleteSiteResponseSchema,
  deleteSiteUploadResponseSchema: () => deleteSiteUploadResponseSchema,
  deleteTagResponseSchema: () => deleteTagResponseSchema2,
  generateSiteDocumentUploadUrlSchema: () => generateSiteDocumentUploadUrlSchema,
  generateSiteImageUploadUrlSchema: () => generateSiteImageUploadUrlSchema,
  generateSiteUploadUrlSchema: () => generateSiteUploadUrlSchema2,
  generateSiteVideoUploadUrlSchema: () => generateSiteVideoUploadUrlSchema,
  publicArtigoListQuerySchema: () => publicArtigoListQuerySchema,
  publicEmpreendimentoListQuerySchema: () => publicEmpreendimentoListQuerySchema,
  publicIncorporadoraListQuerySchema: () => publicIncorporadoraListQuerySchema,
  siteArtigoStatusAprovacaoSchema: () => siteArtigoStatusAprovacaoSchema,
  siteArtigoStatusSchema: () => siteArtigoStatusSchema,
  siteParamsSchema: () => siteParamsSchema2,
  siteResponseSchema: () => siteResponseSchema2,
  siteSchema: () => siteSchema2,
  siteUploadUrlResponseSchema: () => siteUploadUrlResponseSchema,
  sitesResponseSchema: () => sitesResponseSchema2,
  tagResponseSchema: () => tagResponseSchema,
  tagSchema: () => tagSchema2,
  tagsResponseSchema: () => tagsResponseSchema2,
  updateArtigoSchema: () => updateArtigoSchema,
  updateSiteSchema: () => updateSiteSchema2,
  updateTagSchema: () => updateTagSchema
});
var artigoConteudoSchema = z.union([
  editorJsContentSchema,
  z.object({
    type: z.literal("doc"),
    content: z.array(z.record(z.string(), z.unknown())).optional()
  }),
  z.object({
    blocks: z.array(z.record(z.string(), z.unknown()))
  }),
  z.record(z.string(), z.unknown())
]);
var jsonArtigoConteudo = z.preprocess((v) => {
  if (typeof v === "string") {
    try {
      return JSON.parse(v);
    } catch {
      return v;
    }
  }
  return v;
}, artigoConteudoSchema);
var siteDominioProprioSchema = z.string().max(253, "Dom\xEDnio muito longo (m\xE1ximo 253 caracteres)").regex(
  /^([a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,}$/i,
  "Formato de dom\xEDnio inv\xE1lido (ex: exemplo.com.br)"
);
var createSiteSchema = z.object({
  nome: z.string().min(3).max(100),
  dominioDev: z.string().min(3).max(50).regex(/^[a-z0-9-]+$/),
  dominioProprio: siteDominioProprioSchema.optional(),
  publicado: z.boolean().optional(),
  creci: z.string().max(20).optional()
});
var updateSiteSchema2 = createSiteSchema.partial().extend({
  dominioProprio: siteDominioProprioSchema.nullable().optional()
});
var siteParamsSchema2 = z.object({
  dashboardId: z.coerce.number().int().min(1),
  siteId: z.coerce.number().int().min(1)
});
var artigoParamsSchema = siteParamsSchema2.extend({
  id: z.coerce.number().int().min(1)
});
var siteSchema2 = z.object({
  id: z.number(),
  nome: z.string(),
  dominioDev: z.string(),
  dominioProprio: z.string().nullable(),
  publicado: z.boolean(),
  creci: z.string().nullable(),
  dashboardId: z.number(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var sitesResponseSchema2 = listResponse(siteSchema2);
var siteResponseSchema2 = dataResponse(siteSchema2);
var deleteSiteResponseSchema = messageResponseSchema;
var deleteArtigoResponseSchema = messageResponseSchema;
var createArtigoSchema = z.object({
  titulo: z.string().min(5).max(200),
  conteudo: jsonArtigoConteudo,
  metaTitle: z.string().max(200).optional(),
  metaDescription: z.string().max(500).optional(),
  slug: z.string().max(255).optional(),
  imagemDestaque: z.string().optional(),
  keyword: z.string().max(255).optional(),
  publicado: z.boolean().optional(),
  tags: z.array(z.string()).optional()
});
var updateArtigoSchema = createArtigoSchema.partial();
var artigoListQuerySchema = z.object({
  page: z.coerce.number().optional(),
  itemsPerPage: z.coerce.number().optional(),
  status: z.string().optional(),
  search: z.string().optional(),
  tags: z.union([z.array(z.string()), z.string()]).optional()
});
var publicArtigoListQuerySchema = z.object({
  page: z.coerce.number().int().min(1).optional(),
  take: z.coerce.number().int().min(1).max(100).optional(),
  tags: z.string().optional(),
  exclude: z.string().optional()
});
var publicEmpreendimentoListQuerySchema = z.object({
  page: z.coerce.number().int().min(1).optional(),
  take: z.coerce.number().int().min(1).max(100).optional(),
  uf: z.string().optional(),
  cidade: z.string().optional(),
  bairro: z.string().optional(),
  distanciaPraia: z.coerce.number().int().min(0).optional(),
  pesquisa: z.string().optional(),
  incorporadora: z.coerce.number().int().min(1).optional(),
  order: z.enum(["novidades", "alfabetica"]).optional()
});
var publicIncorporadoraListQuerySchema = z.object({
  page: z.coerce.number().int().min(1).optional(),
  take: z.coerce.number().int().min(1).max(100).optional()
});
var createTagSchema = z.object({
  nome: z.string().min(2).max(50),
  value: z.string().regex(/^[a-z0-9-]+$/).max(50).optional()
});
var updateTagSchema = createTagSchema.partial();
var generateSiteUploadUrlSchema2 = z.object({
  fileName: z.string().min(1).max(255),
  contentType: z.string().min(1),
  size: z.coerce.number().int().min(1),
  folder: z.string().optional()
});
var generateSiteImageUploadUrlSchema = generateSiteUploadUrlSchema2.extend({
  folder: z.enum(["capas", "galeria", "perfil"]).optional()
});
var generateSiteDocumentUploadUrlSchema = generateSiteUploadUrlSchema2.extend({
  folder: z.enum(["documentos", "anexos"]).optional()
});
var generateSiteVideoUploadUrlSchema = generateSiteUploadUrlSchema2.extend({
  contentType: z.enum([
    "video/mp4",
    "video/webm",
    "video/quicktime",
    "video/ogg"
  ]),
  size: z.coerce.number().int().min(1).max(104857600),
  // 100MB
  folder: z.enum(["galeria-videos"]).optional()
});
var siteArtigoStatusAprovacaoSchema = z.enum([
  "Pendente",
  "Aprovado",
  "Rejeitado"
]);
var siteArtigoStatusSchema = z.enum(["Publicado", "Rascunho", "Removido"]);
var artigoSchema2 = z.object({
  id: z.number(),
  siteId: z.number(),
  titulo: z.string(),
  slug: z.string(),
  publicado: z.boolean(),
  conteudo: artigoConteudoSchema.nullish(),
  status: siteArtigoStatusSchema.optional(),
  metaTitle: z.string().nullable().optional(),
  metaDescription: z.string().nullable().optional(),
  keyword: z.string().nullable().optional(),
  imagemDestaque: z.string().nullable().optional(),
  tags: z.array(z.string()).optional(),
  adicionadoPor: userMiniSchema.nullable().optional(),
  geradoPorIa: z.boolean().optional(),
  statusAprovacao: siteArtigoStatusAprovacaoSchema.nullable().optional(),
  dataPublicacaoAgendada: z.string().nullable().optional(),
  publishedAt: z.string().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var artigosResponseSchema2 = listResponse(artigoSchema2);
var artigoResponseSchema2 = dataResponse(artigoSchema2);
var artigoListPageSchema = z.object({
  items: z.array(artigoSchema2),
  totalItems: z.number(),
  totalPages: z.number(),
  currentPage: z.number(),
  itemsPerPage: z.number()
});
var artigosListResponseSchema = z.object({
  success: z.boolean(),
  data: artigoListPageSchema,
  message: z.string().optional()
});
var tagSchema2 = z.object({
  id: z.number(),
  siteId: z.number(),
  label: z.string(),
  value: z.string()
});
var tagsResponseSchema2 = listResponse(tagSchema2);
var tagResponseSchema = dataResponse(tagSchema2);
var deleteTagResponseSchema2 = messageResponseSchema;
var siteUploadUrlResponseSchema = dataResponse(uploadUrlDataSchema);
var deleteSiteUploadResponseSchema = messageResponseSchema;

// src/integracoes/index.ts
var integracoes_exports = {};
__export(integracoes_exports, {
  dwvConfigDataSchema: () => dwvConfigDataSchema,
  dwvConfigResponseSchema: () => dwvConfigResponseSchema,
  dwvConfigSchema: () => dwvConfigSchema,
  dwvLogsResponseSchema: () => dwvLogsResponseSchema,
  dwvStatusResponseSchema: () => dwvStatusResponseSchema,
  dwvSuccessResponseSchema: () => dwvSuccessResponseSchema,
  dwvSyncLogSchema: () => dwvSyncLogSchema,
  dwvSyncSchema: () => dwvSyncSchema,
  dwvSyncStatusResponseSchema: () => dwvSyncStatusResponseSchema,
  dwvSyncStatusSchema: () => dwvSyncStatusSchema,
  facebookAuthCallbackSchema: () => facebookAuthCallbackSchema,
  facebookAuthResponseSchema: () => facebookAuthResponseSchema,
  facebookConfigValidationResponseSchema: () => facebookConfigValidationResponseSchema,
  facebookDeleteResponseSchema: () => facebookDeleteResponseSchema,
  facebookImportLeadsRequestSchema: () => facebookImportLeadsRequestSchema,
  facebookImportResponseSchema: () => facebookImportResponseSchema,
  facebookLogEntrySchema: () => facebookLogEntrySchema,
  facebookLogsResponseSchema: () => facebookLogsResponseSchema,
  facebookPageConfigSchema: () => facebookPageConfigSchema,
  facebookPageExtendedSchema: () => facebookPageExtendedSchema,
  facebookPageSchema: () => facebookPageSchema,
  facebookPageStatusResponseSchema: () => facebookPageStatusResponseSchema,
  facebookPageStatusSchema: () => facebookPageStatusSchema,
  facebookPagesListResponseSchema: () => facebookPagesListResponseSchema,
  facebookPagesStatsResponseSchema: () => facebookPagesStatsResponseSchema,
  facebookReconnectPageSchema: () => facebookReconnectPageSchema,
  facebookSyncCheckResponseSchema: () => facebookSyncCheckResponseSchema,
  facebookSyncFormSchema: () => facebookSyncFormSchema,
  facebookSyncLeadSchema: () => facebookSyncLeadSchema,
  facebookWebhookSchema: () => facebookWebhookSchema,
  facebookWebhookVerifySchema: () => facebookWebhookVerifySchema,
  metaCapiConfigResponseSchema: () => metaCapiConfigResponseSchema,
  metaCapiConfigSchema: () => metaCapiConfigSchema,
  metaCapiEventLogSchema: () => metaCapiEventLogSchema,
  metaCapiEventsResponseSchema: () => metaCapiEventsResponseSchema,
  metaCapiTokenSourceSchema: () => metaCapiTokenSourceSchema,
  metaCtwaConfigDataSchema: () => metaCtwaConfigDataSchema,
  metaCtwaConfigResponseSchema: () => metaCtwaConfigResponseSchema,
  metaCtwaConfigSchema: () => metaCtwaConfigSchema,
  metaHealthItemSchema: () => metaHealthItemSchema,
  metaHealthResponseSchema: () => metaHealthResponseSchema,
  metaHealthStatusSchema: () => metaHealthStatusSchema,
  metaRemarketingConfigDataSchema: () => metaRemarketingConfigDataSchema,
  metaRemarketingConfigResponseSchema: () => metaRemarketingConfigResponseSchema,
  metaRemarketingConfigSchema: () => metaRemarketingConfigSchema,
  metaRemarketingTemplateInfoSchema: () => metaRemarketingTemplateInfoSchema,
  metaRoiCampaignSchema: () => metaRoiCampaignSchema,
  metaRoiResponseSchema: () => metaRoiResponseSchema,
  triggerDwvSyncRequestSchema: () => triggerDwvSyncRequestSchema,
  triggerDwvSyncResponseSchema: () => triggerDwvSyncResponseSchema,
  triggerDwvSyncSchema: () => triggerDwvSyncSchema,
  ultimaSincronizacaoSchema: () => ultimaSincronizacaoSchema,
  updateDwvConfigRequestSchema: () => updateDwvConfigRequestSchema,
  updateDwvConfigSchema: () => updateDwvConfigSchema,
  validateDwvTokenRequestSchema: () => validateDwvTokenRequestSchema,
  validateDwvTokenResponseSchema: () => validateDwvTokenResponseSchema,
  validateDwvTokenSchema: () => validateDwvTokenSchema
});
var facebookWebhookVerifySchema = z.object({
  "hub.mode": z.string().min(1),
  "hub.verify_token": z.string().min(1),
  "hub.challenge": z.string().min(1)
});
var facebookPageConfigSchema = z.object({
  pageId: z.string().optional(),
  pageAccessToken: z.string().optional(),
  enabled: z.boolean().optional()
});
var dwvSyncSchema = z.object({
  force: z.boolean().optional()
});
var dwvConfigSchema = z.object({
  apiKey: z.string().optional(),
  enabled: z.boolean().optional()
});
var dwvStatusResponseSchema = dataResponse(z.record(z.string(), z.any()));
var validateDwvTokenSchema = z.object({
  token: z.string().min(1)
});
var updateDwvConfigSchema = z.object({
  dwvToken: z.string().optional(),
  dwvEnabled: z.boolean().optional()
});
var triggerDwvSyncSchema = z.object({
  token: z.string().optional()
});
var facebookAuthCallbackSchema = z.object({
  code: z.string().min(1),
  state: z.string().min(1),
  error: z.string().optional()
});
var facebookReconnectPageSchema = z.object({
  newDashboard: z.coerce.number()
});
var facebookPageStatusSchema = z.object({
  pageId: z.string().min(1)
});
var facebookWebhookSchema = z.object({
  object: z.string().optional(),
  entry: z.array(z.any()).optional()
});
var facebookConfigValidationResponseSchema = z.object({
  success: z.boolean(),
  configuration: z.object({
    appId: z.boolean(),
    redirectUri: z.boolean(),
    webhookToken: z.boolean(),
    appSecret: z.boolean()
  }),
  status: z.enum(["Configura\xE7\xE3o completa", "Configura\xE7\xE3o incompleta"])
});
var facebookAuthResponseSchema = z.object({
  success: z.boolean(),
  authUrl: z.string(),
  dashboard: z.number(),
  scopes: z.array(z.string()),
  instructions: z.object({
    step1: z.string(),
    step2: z.string(),
    step3: z.string()
  })
});
var facebookPageSchema = z.object({
  id: z.string(),
  pageId: z.string(),
  name: z.string(),
  /** Nunca retornado pela API de listagem (omitido por segurança). */
  accessToken: z.string().optional(),
  dashboardId: z.number(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var facebookPageExtendedSchema = facebookPageSchema.omit({ accessToken: true }).extend({
  isActive: z.boolean(),
  connectedSince: z.string(),
  lastUpdate: z.string()
});
var facebookPagesListResponseSchema = dataResponse(
  z.object({
    dashboard: z.number(),
    count: z.number(),
    pages: z.array(facebookPageExtendedSchema)
  })
);
var facebookPagesStatsResponseSchema = z.object({
  success: z.boolean(),
  stats: z.object({
    totalPages: z.number(),
    activePages: z.number(),
    inactivePages: z.number(),
    dashboardId: z.number()
  })
});
var facebookPageStatusResponseSchema = dataResponse(
  z.object({
    pageId: z.string(),
    status: z.object({
      status: z.enum(["active", "error"]),
      pageId: z.string().optional(),
      name: z.string().optional(),
      isPublished: z.boolean().optional(),
      message: z.string().optional()
    })
  })
);
var facebookDeleteResponseSchema = messageResponseSchema;
var facebookSyncCelularSchema = z.union([z.string(), z.null()]).nullish().transform((value) => {
  if (value == null) return null;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
});
var facebookSyncLeadSchema = z.object({
  leadgenId: z.string(),
  nome: z.string(),
  email: z.string().nullable(),
  criadoFacebook: z.string(),
  importado: z.boolean(),
  crmLeadId: z.string().nullable(),
  crmCriadoEm: z.string().nullable(),
  crmContato: z.object({
    nome: z.string(),
    email: z.string().nullable(),
    /** Pode faltar no CRM — sync/preview não deve falhar por isso. */
    celular: facebookSyncCelularSchema
  }).nullable()
});
var facebookSyncFormSchema = z.object({
  formId: z.string(),
  formName: z.string(),
  status: z.string(),
  total: z.number(),
  importados: z.number(),
  pendentes: z.number(),
  leads: z.array(facebookSyncLeadSchema)
});
var facebookSyncCheckResponseSchema = dataResponse(
  z.object({
    page: z.object({ id: z.string(), name: z.string() }),
    checkedAt: z.string(),
    summary: z.object({
      totalFacebook: z.number(),
      importados: z.number(),
      pendentes: z.number()
    }),
    forms: z.array(facebookSyncFormSchema)
  })
);
var facebookImportLeadsRequestSchema = z.object({
  leadgenIds: z.array(z.string())
});
var facebookImportResponseSchema = dataResponse(
  z.object({
    total: z.number(),
    importados: z.number(),
    duplicados: z.number(),
    erros: z.number(),
    detalhes: z.object({
      importados: z.array(
        z.object({
          leadgenId: z.string(),
          crmLeadId: z.string(),
          nome: z.string()
        })
      ),
      duplicados: z.array(
        z.object({ leadgenId: z.string(), crmLeadId: z.string() })
      ),
      erros: z.array(z.object({ leadgenId: z.string(), erro: z.string() }))
    })
  })
);
var facebookLogEntrySchema = z.object({
  id: z.string(),
  dashboardId: z.number(),
  pageId: z.string().nullable(),
  pageName: z.string().nullable(),
  tipo: z.string(),
  status: z.string(),
  /** Prisma Json — opaque webhook/log payload. */
  dados: z.unknown(),
  mensagem: z.string().nullable(),
  createdAt: z.string()
});
var facebookLogsResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(facebookLogEntrySchema),
  meta: z.object({
    total: z.number(),
    page: z.number(),
    limit: z.number(),
    totalPages: z.number()
  })
});
var dwvConfigDataSchema = z.object({
  hasToken: z.boolean(),
  dwvEnabled: z.boolean(),
  dwvLastSync: z.string().nullable(),
  totalImoveisSincronizados: z.number(),
  syncEmAndamento: z.boolean()
});
var dwvConfigResponseSchema = dataResponse(dwvConfigDataSchema);
var updateDwvConfigRequestSchema = updateDwvConfigSchema;
var ultimaSincronizacaoSchema = z.object({
  id: z.number(),
  status: z.string(),
  trigger: z.string(),
  startedAt: z.string().nullable(),
  finishedAt: z.string().nullable(),
  durationMs: z.number().nullable(),
  totalDwv: z.number().nullable(),
  criados: z.number(),
  atualizados: z.number(),
  inativados: z.number(),
  ignorados: z.number(),
  erros: z.number(),
  imagensUp: z.number()
});
var dwvSyncStatusSchema = z.object({
  syncEmAndamento: z.boolean(),
  jobProgress: z.number().nullable(),
  totalImoveisSincronizados: z.number(),
  ultimaSincronizacao: ultimaSincronizacaoSchema.nullable()
});
var dwvSyncStatusResponseSchema = dataResponse(dwvSyncStatusSchema);
var triggerDwvSyncRequestSchema = triggerDwvSyncSchema;
var triggerDwvSyncResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  data: z.object({
    jobId: z.string()
  }).optional()
});
var dwvSyncLogSchema = z.object({
  id: z.number(),
  dashboardId: z.number(),
  status: z.string(),
  trigger: z.string(),
  startedAt: z.string().nullable(),
  finishedAt: z.string().nullable(),
  durationMs: z.number().nullable(),
  totalDwv: z.number().nullable(),
  criados: z.number(),
  atualizados: z.number(),
  inativados: z.number(),
  ignorados: z.number(),
  erros: z.number(),
  imagensUp: z.number(),
  errorMessage: z.string().nullable(),
  createdAt: z.string()
});
var dwvLogsResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(dwvSyncLogSchema),
  pagination: z.object({
    total: z.number(),
    page: z.number(),
    limit: z.number(),
    lastPage: z.number()
  })
});
var dwvSuccessResponseSchema = messageResponseSchema;
var validateDwvTokenRequestSchema = validateDwvTokenSchema;
var validateDwvTokenResponseSchema = z.object({
  success: z.boolean(),
  valid: z.boolean(),
  message: z.string(),
  data: z.object({
    totalImoveis: z.number()
  }).optional(),
  error: z.string().optional()
});
var metaCapiTokenSourceSchema = z.enum(["LEAD_ADS_PAGE", "WHATSAPP_WABA"]);
var metaCapiConfigSchema = z.object({
  datasetId: z.string().min(1),
  tokenSource: metaCapiTokenSourceSchema.default("LEAD_ADS_PAGE"),
  ativo: z.boolean().default(true),
  testEventCode: z.string().nullable().optional()
});
var metaCapiConfigResponseSchema = dataResponse(
  z.object({
    dashboardId: z.number(),
    datasetId: z.string(),
    tokenSource: metaCapiTokenSourceSchema,
    ativo: z.boolean(),
    testEventCode: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string()
  }).nullable()
);
var metaCapiEventLogSchema = z.object({
  id: z.string(),
  eventName: z.string(),
  eventSource: z.string(),
  leadId: z.string().nullable(),
  success: z.boolean(),
  errorMessage: z.string().nullable(),
  createdAt: z.string()
});
var metaCapiEventsResponseSchema = dataResponse(
  z.array(metaCapiEventLogSchema)
);
var metaRoiCampaignSchema = z.object({
  campaignId: z.string().nullable(),
  campaignName: z.string().nullable(),
  leadsForm: z.number(),
  leadsCtwa: z.number(),
  leadsTotal: z.number(),
  qualificados: z.number(),
  ganhos: z.number(),
  spend: z.number().nullable(),
  currency: z.string().nullable(),
  costPerLead: z.number().nullable()
});
var metaRoiResponseSchema = dataResponse(
  z.object({
    periodo: z.object({ inicio: z.string(), fim: z.string() }),
    spendDisponivel: z.boolean(),
    spendFallbackMotivo: z.string().nullable(),
    totais: z.object({
      leadsForm: z.number(),
      leadsCtwa: z.number(),
      leadsTotal: z.number(),
      qualificados: z.number(),
      ganhos: z.number(),
      spend: z.number().nullable()
    }),
    campanhas: z.array(metaRoiCampaignSchema)
  })
);
var metaHealthStatusSchema = z.enum(["ok", "warn", "fail", "unknown"]);
var metaHealthItemSchema = z.object({
  id: z.string(),
  label: z.string(),
  status: metaHealthStatusSchema,
  detail: z.string().optional()
});
var metaHealthResponseSchema = dataResponse(
  z.object({
    whatsapp: z.object({
      conectado: z.boolean(),
      provider: z.string().nullable(),
      connectionState: z.string().nullable(),
      phoneNumberId: z.string().nullable(),
      wabaId: z.string().nullable()
    }),
    paginas: z.object({
      total: z.number(),
      comLeadgenOk: z.number(),
      samples: z.array(
        z.object({
          pageId: z.string(),
          name: z.string(),
          hasLeadgen: z.boolean().nullable(),
          error: z.string().nullable()
        })
      )
    }),
    checklist: z.array(metaHealthItemSchema)
  })
);
var metaRemarketingConfigSchema = z.object({
  ativo: z.boolean(),
  minutosSemAtendimento: z.number().int().min(5).max(10080),
  templateId: z.string().nullable().optional()
});
var metaRemarketingTemplateInfoSchema = z.object({
  id: z.string(),
  nome: z.string(),
  ativo: z.boolean(),
  deliveryMode: z.string().nullable(),
  metaApprovalStatus: z.string().nullable()
}).nullable();
var metaRemarketingConfigDataSchema = z.object({
  dashboardId: z.number(),
  ativo: z.boolean(),
  minutosSemAtendimento: z.number(),
  templateId: z.string().nullable(),
  createdAt: z.string().nullable(),
  updatedAt: z.string().nullable(),
  template: metaRemarketingTemplateInfoSchema,
  status: z.object({
    templateConfigurado: z.boolean(),
    templateAprovado: z.boolean(),
    hasWhatsAppOficial: z.boolean(),
    enviadosSucesso7d: z.number(),
    ultimaExecucao: z.string().nullable()
  }),
  enviosRecentes: z.array(
    z.object({
      id: z.number(),
      leadId: z.string(),
      templateUsado: z.string().nullable(),
      sucesso: z.boolean(),
      erro: z.string().nullable(),
      createdAt: z.string()
    })
  )
});
var metaRemarketingConfigResponseSchema = dataResponse(
  metaRemarketingConfigDataSchema
);
var metaCtwaConfigSchema = z.object({
  ativo: z.boolean(),
  finalidadePadrao: z.enum([
    "Comprar",
    "Alugar",
    "Temporada",
    "AnunciarLocacao",
    "AnunciarVenda"
  ]).optional()
});
var metaCtwaConfigDataSchema = z.object({
  dashboardId: z.number(),
  ativo: z.boolean(),
  finalidadePadrao: z.string(),
  createdAt: z.string().nullable(),
  updatedAt: z.string().nullable(),
  status: z.object({
    leadsCtwa7d: z.number(),
    criaConversa: z.string()
  }),
  leadsRecentes: z.array(
    z.object({
      id: z.string(),
      status: z.string(),
      headline: z.string().nullable(),
      nome: z.string().nullable(),
      createdAt: z.string()
    })
  )
});
var metaCtwaConfigResponseSchema = dataResponse(metaCtwaConfigDataSchema);

// src/usuarios/index.ts
var usuarios_exports = {};
__export(usuarios_exports, {
  addCapabilityOverrideRequestSchema: () => addCapabilityOverrideRequestSchema,
  addCapabilityOverrideResponseSchema: () => addCapabilityOverrideResponseSchema,
  capabilitiesByRoleResponseSchema: () => capabilitiesByRoleResponseSchema,
  capabilitiesDisponiveisResponseSchema: () => capabilitiesDisponiveisResponseSchema,
  capabilityEnum: () => capabilityEnum,
  capabilityInfoSchema: () => capabilityInfoSchema,
  capabilityItemSchema: () => capabilityItemSchema,
  capabilityOverrideDetailSchema: () => capabilityOverrideDetailSchema,
  capabilityOverrideSchema: () => capabilityOverrideSchema,
  capabilityOverrideTypeSchema: () => capabilityOverrideTypeSchema,
  clearCapabilityOverrideResponseSchema: () => clearCapabilityOverrideResponseSchema,
  createUsuarioRequestSchema: () => createUsuarioRequestSchema,
  createUsuarioResponseSchema: () => createUsuarioResponseSchema,
  createUsuarioSchema: () => createUsuarioSchema,
  dashboardUsuarioSchema: () => dashboardUsuarioSchema2,
  deleteUsuarioRequestSchema: () => deleteUsuarioRequestSchema,
  deleteUsuarioResponseSchema: () => deleteUsuarioResponseSchema,
  deleteUsuarioSchema: () => deleteUsuarioSchema,
  disponibilidadeDetailResponseSchema: () => disponibilidadeDetailResponseSchema,
  disponibilidadeResponseSchema: () => disponibilidadeResponseSchema,
  hasCapabilityResponseSchema: () => hasCapabilityResponseSchema,
  meCapabilitiesResponseSchema: () => meCapabilitiesResponseSchema,
  permissionCategorySchema: () => permissionCategorySchema,
  permissionSchema: () => permissionSchema,
  permissoesDisponiveisResponseSchema: () => permissoesDisponiveisResponseSchema,
  resetUsuarioCapabilitiesResponseSchema: () => resetUsuarioCapabilitiesResponseSchema,
  roleCapabilitiesSchema: () => roleCapabilitiesSchema,
  setPermissoesRequestSchema: () => setPermissoesRequestSchema,
  setPermissoesResponseSchema: () => setPermissoesResponseSchema,
  updateDisponibilidadeRequestSchema: () => updateDisponibilidadeRequestSchema,
  updateDisponibilidadeResponseSchema: () => updateDisponibilidadeResponseSchema,
  updateDisponibilidadeSchema: () => updateDisponibilidadeSchema,
  updateUsuarioRequestSchema: () => updateUsuarioRequestSchema,
  updateUsuarioResponseSchema: () => updateUsuarioResponseSchema,
  updateUsuarioSchema: () => updateUsuarioSchema,
  usuarioCapabilitiesDetailedResponseSchema: () => usuarioCapabilitiesDetailedResponseSchema,
  usuarioCapabilitiesResponseSchema: () => usuarioCapabilitiesResponseSchema,
  usuarioDashboardSchema: () => usuarioDashboardSchema,
  usuarioDashboardStatusEnum: () => usuarioDashboardStatusEnum,
  usuarioDashboardStatusSchema: () => usuarioDashboardStatusSchema,
  usuarioDisponibilidadeEnum: () => usuarioDisponibilidadeEnum,
  usuarioDisponibilidadeSchema: () => usuarioDisponibilidadeSchema,
  usuarioInfoSchema: () => usuarioInfoSchema,
  usuarioListQuerySchema: () => usuarioListQuerySchema,
  usuarioParamSchema: () => usuarioParamSchema,
  usuarioPermissoesResponseSchema: () => usuarioPermissoesResponseSchema,
  usuarioResponseSchema: () => usuarioResponseSchema,
  usuarioRoleEnum: () => usuarioRoleEnum,
  usuarioRoleResponseSchema: () => usuarioRoleResponseSchema,
  usuarioRoleSchema: () => usuarioRoleSchema,
  usuariosResponseSchema: () => usuariosResponseSchema
});
var usuarioRoleEnum = z.enum([
  "Administrador",
  "Gerente",
  "GerenteFinanceiro",
  "GerenteImobiliario",
  "Corretor",
  "CorretorSenior",
  "CorretorPleno",
  "Marketing",
  "WebDesign",
  "Atendimento",
  "Backoffice"
]);
var usuarioDashboardStatusEnum = z.enum([
  "Ativo",
  "Bloqueado",
  "Convidado"
]);
var usuarioDisponibilidadeEnum = z.enum([
  "Disponivel",
  "Ocupado",
  "Ausente",
  "Pausado"
]);
var createUsuarioSchema = z.object({
  email: z.string().email(),
  nome: z.string().min(1).max(255),
  role: usuarioRoleEnum
});
var updateUsuarioSchema = z.object({
  role: usuarioRoleEnum.optional(),
  status: usuarioDashboardStatusEnum.optional()
});
var usuarioListQuerySchema = z.object({
  status: usuarioDashboardStatusEnum.optional(),
  role: usuarioRoleEnum.optional(),
  search: z.string().max(255).optional()
});
var usuarioParamSchema = z.object({
  usuario: z.coerce.number().int().min(1)
});
var deleteUsuarioSchema = z.object({
  novoUsuarioid: z.coerce.number().int().min(1)
});
var updateDisponibilidadeSchema = z.object({
  disponibilidade: usuarioDisponibilidadeEnum,
  observacoes: z.string().max(500).optional()
});
var capabilityEnum = z.enum([
  "manageDashboardConfig",
  "viewReports",
  "manageSitesBlog",
  "viewImobData",
  "editImobData",
  "leadsAll",
  "leadsOwn",
  "viewLeadDistributionHistory",
  "crmAll",
  "crmOwn",
  "propostasAll",
  "propostasOwn",
  "contatosAll",
  "contatosOwn",
  "canaisAll",
  "canaisTeam",
  "conversasAll",
  "conversasOwn",
  "conversasOwnIn",
  "marketingAll",
  "financeFull",
  "keysAll",
  "keysOwn",
  "keysManage",
  "viewAudit"
]);
var capabilityOverrideSchema = z.object({
  capability: capabilityEnum
});
var dashboardUsuarioSchema2 = z.object({
  id: z.number(),
  dashboardId: z.number(),
  usuarioId: z.number(),
  role: usuarioRoleEnum,
  status: usuarioDashboardStatusEnum,
  createdAt: z.string(),
  updatedAt: z.string(),
  usuario: z.object({
    nome: z.string(),
    sobrenome: z.string().nullable(),
    image: z.string().nullable(),
    cpf: z.string().nullable(),
    email: z.string(),
    celular: z.string().nullable()
  })
});
var usuariosResponseSchema = listResponse(dashboardUsuarioSchema2);
var usuarioResponseSchema = dataResponse(dashboardUsuarioSchema2);
var deleteUsuarioResponseSchema = messageResponseSchema;
var usuarioRoleSchema = usuarioRoleEnum;
var usuarioDashboardStatusSchema = usuarioDashboardStatusEnum;
var usuarioDisponibilidadeSchema = usuarioDisponibilidadeEnum;
var usuarioInfoSchema = dashboardUsuarioSchema2.shape.usuario;
var usuarioDashboardSchema = dashboardUsuarioSchema2;
var createUsuarioRequestSchema = createUsuarioSchema;
var createUsuarioResponseSchema = dataResponse(dashboardUsuarioSchema2).extend({
  message: z.string()
});
var updateUsuarioRequestSchema = updateUsuarioSchema;
var updateUsuarioResponseSchema = dataResponse(dashboardUsuarioSchema2).extend({
  message: z.string()
});
var deleteUsuarioRequestSchema = deleteUsuarioSchema;
var disponibilidadeResponseSchema = z.object({
  id: z.number(),
  dashboardId: z.number(),
  usuarioId: z.number(),
  disponibilidade: usuarioDisponibilidadeEnum,
  ultimaAtividade: z.string(),
  ultimoStatus: z.string().nullable(),
  observacoes: z.string().nullable(),
  updatedAt: z.string()
});
var disponibilidadeDetailResponseSchema = dataResponse(
  disponibilidadeResponseSchema
);
var updateDisponibilidadeRequestSchema = updateDisponibilidadeSchema;
var updateDisponibilidadeResponseSchema = dataResponse(
  disponibilidadeResponseSchema
).extend({ message: z.string() });
var usuarioRoleResponseSchema = dataResponse(
  z.object({
    role: usuarioRoleEnum,
    id: z.number()
  })
);
var permissionSchema = z.object({
  permissao: z.string(),
  label: z.string()
});
var permissionCategorySchema = z.object({
  categoria: z.string(),
  permissoes: z.array(permissionSchema)
});
var permissoesDisponiveisResponseSchema = listResponse(
  permissionCategorySchema
);
var usuarioPermissoesResponseSchema = dataResponse(
  z.object({
    usuarioId: z.number(),
    dashboardId: z.number(),
    permissoes: z.array(permissionSchema),
    total: z.number()
  })
);
var setPermissoesRequestSchema = z.object({
  permissoes: z.array(z.string())
});
var setPermissoesResponseSchema = messageResponseSchema;
var capabilityInfoSchema = z.object({
  capability: z.string(),
  label: z.string(),
  fromRole: z.boolean(),
  fromOverride: z.boolean(),
  hasCapability: z.boolean()
});
var usuarioCapabilitiesDetailedResponseSchema = dataResponse(
  z.object({
    role: usuarioRoleEnum,
    roleCapabilities: z.array(z.string()),
    overrideCapabilities: z.array(z.string()),
    effectiveCapabilities: z.array(z.string()),
    allCapabilities: z.array(capabilityInfoSchema)
  })
);
var capabilityItemSchema = z.object({
  value: z.string(),
  label: z.string()
});
var capabilitiesDisponiveisResponseSchema = dataResponse(
  z.object({
    capabilities: z.array(capabilityItemSchema)
  })
);
var roleCapabilitiesSchema = z.object({
  role: usuarioRoleEnum,
  capabilities: z.array(capabilityItemSchema)
});
var capabilitiesByRoleResponseSchema = dataResponse(
  z.object({
    roles: z.array(roleCapabilitiesSchema),
    allCapabilities: z.array(capabilityItemSchema)
  })
);
var meCapabilitiesResponseSchema = dataResponse(
  z.object({
    capabilities: z.array(z.string())
  })
);
var hasCapabilityResponseSchema = dataResponse(
  z.object({
    capability: z.string(),
    hasCapability: z.boolean()
  })
);
var capabilityOverrideTypeSchema = z.enum(["ADD", "REMOVE"]);
var capabilityOverrideDetailSchema = z.object({
  id: z.number(),
  usuarioId: z.number().optional(),
  dashboardId: z.number().optional(),
  capability: z.string(),
  type: capabilityOverrideTypeSchema,
  createdAt: z.string(),
  updatedAt: z.string()
});
var usuarioCapabilitiesResponseSchema = dataResponse(
  z.object({
    overrides: z.array(capabilityOverrideDetailSchema),
    effectiveCapabilities: z.array(z.string())
  })
);
var addCapabilityOverrideRequestSchema = z.object({
  capability: z.string()
});
var addCapabilityOverrideResponseSchema = dataResponse(
  capabilityOverrideDetailSchema.nullable()
);
var resetUsuarioCapabilitiesResponseSchema = dataResponse(
  z.object({ deletedOverridesCount: z.number() })
);
var clearCapabilityOverrideResponseSchema = messageResponseSchema;

// src/data/index.ts
var data_exports = {};
__export(data_exports, {
  cidadeItemSchema: () => cidadeItemSchema,
  cidadesResponseSchema: () => cidadesResponseSchema,
  comodidadeCategoriaComComodidadesSchema: () => comodidadeCategoriaComComodidadesSchema,
  comodidadeCategoriaRefSchema: () => comodidadeCategoriaRefSchema,
  comodidadeComCategoriaSchema: () => comodidadeComCategoriaSchema,
  comodidadeSchema: () => comodidadeSchema2,
  empreendimentoComodidadeCategoriaComComodidadesSchema: () => empreendimentoComodidadeCategoriaComComodidadesSchema,
  empreendimentoComodidadeComCategoriaSchema: () => empreendimentoComodidadeComCategoriaSchema,
  empreendimentoFaseSchema: () => empreendimentoFaseSchema,
  empreendimentoSistemaVendaSchema: () => empreendimentoSistemaVendaSchema,
  empreendimentoTipoSchema: () => empreendimentoTipoSchema,
  empreendimentosComodidadesCategoriasResponseSchema: () => empreendimentosComodidadesCategoriasResponseSchema,
  empreendimentosFasesResponseSchema: () => empreendimentosFasesResponseSchema,
  empreendimentosSistemasVendaResponseSchema: () => empreendimentosSistemasVendaResponseSchema,
  empreendimentosTiposResponseSchema: () => empreendimentosTiposResponseSchema,
  enumOptionSchema: () => enumOptionSchema,
  imoveisAtividadesRuraisResponseSchema: () => imoveisAtividadesRuraisResponseSchema,
  imoveisCampanhasResponseSchema: () => imoveisCampanhasResponseSchema,
  imoveisComodidadesCategoriasResponseSchema: () => imoveisComodidadesCategoriasResponseSchema,
  imoveisComodidadesResponseSchema: () => imoveisComodidadesResponseSchema,
  imoveisCondicoesResponseSchema: () => imoveisCondicoesResponseSchema,
  imoveisCondominioTaxasImpostosResponseSchema: () => imoveisCondominioTaxasImpostosResponseSchema,
  imoveisDocumentosCertificadosResponseSchema: () => imoveisDocumentosCertificadosResponseSchema,
  imoveisFinalidadeMotivosResponseSchema: () => imoveisFinalidadeMotivosResponseSchema,
  imoveisFinalidadesResponseSchema: () => imoveisFinalidadesResponseSchema,
  imoveisIndicesReajustesResponseSchema: () => imoveisIndicesReajustesResponseSchema,
  imoveisIptuPeriodosResponseSchema: () => imoveisIptuPeriodosResponseSchema,
  imoveisLocalizacoesResponseSchema: () => imoveisLocalizacoesResponseSchema,
  imoveisMobiliadoResponseSchema: () => imoveisMobiliadoResponseSchema,
  imoveisOrientacoesSolarResponseSchema: () => imoveisOrientacoesSolarResponseSchema,
  imoveisPadroesLocalizacaoResponseSchema: () => imoveisPadroesLocalizacaoResponseSchema,
  imoveisPadroesResponseSchema: () => imoveisPadroesResponseSchema,
  imoveisPosicoesResponseSchema: () => imoveisPosicoesResponseSchema,
  imoveisResponsavelFuncoesResponseSchema: () => imoveisResponsavelFuncoesResponseSchema,
  imoveisSeguroIncendioPeriodosResponseSchema: () => imoveisSeguroIncendioPeriodosResponseSchema,
  imoveisStatusResponseSchema: () => imoveisStatusResponseSchema,
  imoveisTiposFinanciamentosResponseSchema: () => imoveisTiposFinanciamentosResponseSchema,
  imoveisTopografiaResponseSchema: () => imoveisTopografiaResponseSchema,
  imoveisUsosResponseSchema: () => imoveisUsosResponseSchema,
  imovelAtividadeRuralSchema: () => imovelAtividadeRuralSchema,
  imovelCampanhaSchema: () => imovelCampanhaSchema2,
  imovelCondicaoSchema: () => imovelCondicaoSchema,
  imovelDocumentosCertificadosSchema: () => imovelDocumentosCertificadosSchema,
  imovelFinalidadeMotivoSchema: () => imovelFinalidadeMotivoSchema,
  imovelFinalidadeSchema: () => imovelFinalidadeSchema,
  imovelIndiceReajusteSchema: () => imovelIndiceReajusteSchema,
  imovelMobiliadoSchema: () => imovelMobiliadoSchema,
  imovelOrientacaoSolarSchema: () => imovelOrientacaoSolarSchema,
  imovelPadraoLocalizacaoSchema: () => imovelPadraoLocalizacaoSchema,
  imovelPadraoSchema: () => imovelPadraoSchema,
  imovelPosicaoSchema: () => imovelPosicaoSchema,
  imovelResponsavelFuncaoSchema: () => imovelResponsavelFuncaoSchema,
  imovelStatusSchema: () => imovelStatusSchema,
  imovelSubTipoSchema: () => imovelSubTipoSchema,
  imovelTaxasImpostosCondominioInclusoSchema: () => imovelTaxasImpostosCondominioInclusoSchema,
  imovelTipoFinanciamentoSchema: () => imovelTipoFinanciamentoSchema,
  imovelTipoSchema: () => imovelTipoSchema,
  imovelTopografiaSchema: () => imovelTopografiaSchema,
  imovelUsoSchema: () => imovelUsoSchema,
  iptuPeriodoSchema: () => iptuPeriodoSchema,
  leadOrigemSchema: () => leadOrigemSchema,
  leadsOrigensResponseSchema: () => leadsOrigensResponseSchema,
  localizacaoBairroSchema: () => localizacaoBairroSchema,
  localizacaoCidadeSchema: () => localizacaoCidadeSchema,
  localizacaoSchema: () => localizacaoSchema,
  oportunidadeOrigemSchema: () => oportunidadeOrigemSchema,
  oportunidadeStatusSchema: () => oportunidadeStatusSchema,
  oportunidadesOrigensResponseSchema: () => oportunidadesOrigensResponseSchema,
  oportunidadesStatusResponseSchema: () => oportunidadesStatusResponseSchema,
  seguroIncendioPeriodoSchema: () => seguroIncendioPeriodoSchema
});
var successResponseSchema3 = apiSuccess;
var enumOptionSchema = valueLabelSchema;
var imovelSubTipoSchema = z.object({
  id: z.number(),
  label: z.string(),
  value: z.string(),
  tipoId: z.number().optional()
});
var imovelTipoSchema = z.object({
  id: z.number(),
  label: z.string(),
  value: z.string(),
  usoId: z.number().optional(),
  subTipos: z.array(imovelSubTipoSchema)
});
var imovelUsoSchema = z.object({
  id: z.number(),
  label: z.string(),
  value: z.string(),
  tipos: z.array(imovelTipoSchema)
});
var imoveisUsosResponseSchema = successResponseSchema3(
  z.array(imovelUsoSchema)
);
var localizacaoCidadeSchema = z.object({
  cidade: z.string(),
  slug: z.string().nullable()
});
var localizacaoBairroSchema = z.object({
  bairro: z.string(),
  slug: z.string().nullable()
});
var localizacaoSchema = z.object({
  cidades: z.array(localizacaoCidadeSchema),
  bairros: z.array(localizacaoBairroSchema)
});
var imoveisLocalizacoesResponseSchema = successResponseSchema3(localizacaoSchema);
var cidadeItemSchema = z.object({
  id: z.number(),
  nome: z.string(),
  slug: z.string(),
  uf: z.string()
});
var cidadesResponseSchema = successResponseSchema3(
  z.array(cidadeItemSchema)
);
var imovelFinalidadeSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string()
});
var imoveisFinalidadesResponseSchema = successResponseSchema3(
  z.array(imovelFinalidadeSchema)
);
var imovelFinalidadeMotivoSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string(),
  padrao: z.boolean()
});
var imoveisFinalidadeMotivosResponseSchema = successResponseSchema3(
  z.array(imovelFinalidadeMotivoSchema)
);
var imovelCampanhaSchema2 = z.object({
  id: z.number(),
  nome: z.string(),
  slug: z.string()
});
var imoveisCampanhasResponseSchema = successResponseSchema3(
  z.array(imovelCampanhaSchema2)
);
var imovelTipoFinanciamentoSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string()
});
var imoveisTiposFinanciamentosResponseSchema = successResponseSchema3(
  z.array(imovelTipoFinanciamentoSchema)
);
var imovelIndiceReajusteSchema = z.object({
  id: z.number(),
  valor: z.number(),
  indice: z.string(),
  padrao: z.boolean()
});
var imoveisIndicesReajustesResponseSchema = successResponseSchema3(
  z.array(imovelIndiceReajusteSchema)
);
var imovelTaxasImpostosCondominioInclusoSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string()
});
var imoveisCondominioTaxasImpostosResponseSchema = successResponseSchema3(
  z.array(imovelTaxasImpostosCondominioInclusoSchema)
);
var iptuPeriodoSchema = z.enum(["Mensal", "Anual"]);
var imoveisIptuPeriodosResponseSchema = successResponseSchema3(
  z.array(iptuPeriodoSchema)
);
var seguroIncendioPeriodoSchema = z.enum(["Mensal", "Anual"]);
var imoveisSeguroIncendioPeriodosResponseSchema = successResponseSchema3(z.array(seguroIncendioPeriodoSchema));
var imovelStatusSchema = z.enum([
  "Publicado",
  "Rascunho",
  "Pendente",
  "Reprovado",
  "Indisponivel",
  "Negociacao",
  "Negociado",
  "Desativado"
]);
var imoveisStatusResponseSchema = successResponseSchema3(
  z.array(imovelStatusSchema)
);
var imovelResponsavelFuncaoSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string()
});
var imoveisResponsavelFuncoesResponseSchema = successResponseSchema3(
  z.array(imovelResponsavelFuncaoSchema)
);
var comodidadeCategoriaRefSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string()
});
var comodidadeSchema2 = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string(),
  quantidades: z.boolean(),
  padrao: z.boolean(),
  categoria: comodidadeCategoriaRefSchema
});
var imoveisComodidadesResponseSchema = successResponseSchema3(
  z.array(comodidadeSchema2)
);
var comodidadeComCategoriaSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string(),
  quantidades: z.boolean(),
  padrao: z.boolean(),
  categoriaId: z.number()
});
var comodidadeCategoriaComComodidadesSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string(),
  comodidades: z.array(comodidadeComCategoriaSchema)
});
var imoveisComodidadesCategoriasResponseSchema = successResponseSchema3(z.array(comodidadeCategoriaComComodidadesSchema));
var imovelDocumentosCertificadosSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string()
});
var imoveisDocumentosCertificadosResponseSchema = successResponseSchema3(z.array(imovelDocumentosCertificadosSchema));
var imovelPadraoSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string()
});
var imoveisPadroesResponseSchema = successResponseSchema3(
  z.array(imovelPadraoSchema)
);
var imovelPadraoLocalizacaoSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string()
});
var imoveisPadroesLocalizacaoResponseSchema = successResponseSchema3(
  z.array(imovelPadraoLocalizacaoSchema)
);
var imovelOrientacaoSolarSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string()
});
var imoveisOrientacoesSolarResponseSchema = successResponseSchema3(
  z.array(imovelOrientacaoSolarSchema)
);
var imovelCondicaoSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string()
});
var imoveisCondicoesResponseSchema = successResponseSchema3(
  z.array(imovelCondicaoSchema)
);
var imovelMobiliadoSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string()
});
var imoveisMobiliadoResponseSchema = successResponseSchema3(
  z.array(imovelMobiliadoSchema)
);
var imovelPosicaoSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string()
});
var imoveisPosicoesResponseSchema = successResponseSchema3(
  z.array(imovelPosicaoSchema)
);
var imovelTopografiaSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string()
});
var imoveisTopografiaResponseSchema = successResponseSchema3(
  z.array(imovelTopografiaSchema)
);
var imovelAtividadeRuralSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string()
});
var imoveisAtividadesRuraisResponseSchema = successResponseSchema3(
  z.array(imovelAtividadeRuralSchema)
);
var oportunidadeStatusSchema = z.enum([
  "Novo",
  "Pausado",
  "EmAndamento",
  "Ganho",
  "Perdido",
  "Arquivado"
]);
var oportunidadesStatusResponseSchema = successResponseSchema3(
  z.array(oportunidadeStatusSchema)
);
var oportunidadeOrigemSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string(),
  padrao: z.boolean()
});
var oportunidadesOrigensResponseSchema = successResponseSchema3(
  z.array(oportunidadeOrigemSchema)
);
var empreendimentoTipoSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string()
});
var empreendimentosTiposResponseSchema = successResponseSchema3(
  z.array(empreendimentoTipoSchema)
);
var empreendimentoFaseSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string()
});
var empreendimentosFasesResponseSchema = successResponseSchema3(
  z.array(empreendimentoFaseSchema)
);
var empreendimentoSistemaVendaSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string()
});
var empreendimentosSistemasVendaResponseSchema = successResponseSchema3(
  z.array(empreendimentoSistemaVendaSchema)
);
var empreendimentoComodidadeComCategoriaSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string(),
  quantidades: z.boolean(),
  padrao: z.boolean(),
  categoriaId: z.number()
});
var empreendimentoComodidadeCategoriaComComodidadesSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string(),
  comodidades: z.array(empreendimentoComodidadeComCategoriaSchema)
});
var empreendimentosComodidadesCategoriasResponseSchema = successResponseSchema3(
  z.array(empreendimentoComodidadeCategoriaComComodidadesSchema)
);
var leadOrigemSchema = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string(),
  padrao: z.boolean().optional()
});
var leadsOrigensResponseSchema = successResponseSchema3(
  z.array(leadOrigemSchema)
);

// src/meilisearch/index.ts
var meilisearch_exports = {};
__export(meilisearch_exports, {
  empreendimentoDocumentSchema: () => empreendimentoDocumentSchema,
  empreendimentoFotoDocSchema: () => empreendimentoFotoDocSchema,
  empreendimentosMeiliSearchResponseSchema: () => empreendimentosMeiliSearchResponseSchema,
  imoveisMeiliSearchResponseSchema: () => imoveisMeiliSearchResponseSchema,
  imovelDocumentSchema: () => imovelDocumentSchema,
  imovelFotoDocSchema: () => imovelFotoDocSchema,
  incorporadoraDocumentSchema: () => incorporadoraDocumentSchema,
  incorporadorasMeiliSearchResponseSchema: () => incorporadorasMeiliSearchResponseSchema,
  meiliFacetDistributionSchema: () => meiliFacetDistributionSchema,
  meiliFacetStatsSchema: () => meiliFacetStatsSchema,
  meiliSearchResultSchema: () => meiliSearchResultSchema,
  meiliSiteEntrySchema: () => meiliSiteEntrySchema,
  meilisearchIndexesSchema: () => meilisearchIndexesSchema,
  meilisearchTenantTokenResponseSchema: () => meilisearchTenantTokenResponseSchema
});
var meiliSiteEntrySchema = z.object({
  siteId: z.number(),
  slug: z.string()
});
var imovelFotoDocSchema = z.object({
  id: z.number(),
  url: z.string(),
  titulo: z.string()
});
var imovelDocumentSchema = z.object({
  id: z.number(),
  dashboardId: z.number(),
  siteIds: z.array(z.number()).default([]),
  sites: z.array(meiliSiteEntrySchema).default([]),
  codigo: z.string(),
  status: z.string(),
  createdAt: z.number(),
  updatedAt: z.number(),
  fotos: z.array(imovelFotoDocSchema).default([]),
  temVideo: z.boolean(),
  temTour: z.boolean(),
  temChaves: z.boolean().default(false),
  titulo: z.string(),
  uso: z.string().nullish(),
  tipo: z.string().nullish(),
  subTipo: z.string().nullish(),
  finalidades: z.array(z.string()).default([]),
  finalidadesValues: z.array(z.string()).default([]),
  descricao: z.string().nullish(),
  cep: z.number().nullish(),
  uf: z.string().nullish(),
  cidade: z.string().nullish(),
  cidadeSlug: z.string().nullish(),
  bairro: z.string().nullish(),
  rua: z.string().nullish(),
  numero: z.string().nullish(),
  complemento: z.string().nullish(),
  pontoReferencia: z.string().nullish(),
  padraoLocalizacao: z.string().nullish(),
  distanciaPraia: z.number().nullish(),
  distanciaPraiaLabel: z.string().nullish(),
  latitude: z.string().nullish(),
  longitude: z.string().nullish(),
  dormitorios: z.number().nullish(),
  totalDormitorios: z.number().nullish(),
  suites: z.number().nullish(),
  demiSuites: z.number().nullish(),
  banheiros: z.number().nullish(),
  lavabos: z.number().nullish(),
  salas: z.number().nullish(),
  closets: z.number().nullish(),
  pessoas: z.number().nullish(),
  vagasGaragem: z.number().nullish(),
  vagasRotativas: z.number().nullish(),
  andar: z.number().nullish(),
  qtdAndar: z.number().nullish(),
  qtdUnidadePorAndar: z.number().nullish(),
  anoConstrucao: z.number().nullish(),
  anoReforma: z.string().nullish(),
  entregaObra: z.string().nullish(),
  condicao: z.string().nullish(),
  mobiliado: z.string().nullish(),
  padraoClasse: z.string().nullish(),
  aceitaPet: z.boolean().nullish(),
  esquina: z.boolean().nullish(),
  precisaReforma: z.boolean().nullish(),
  zoneamento: z.string().nullish(),
  orientacoesSolares: z.array(z.string()).default([]),
  posicoes: z.array(z.string()).default([]),
  topografias: z.array(z.string()).default([]),
  atividadesRurais: z.array(z.string()).default([]),
  areaTotal: z.number().nullish(),
  areaPrivativa: z.number().nullish(),
  areaUtil: z.number().nullish(),
  alturaPeDireito: z.number().nullish(),
  terrenoAreaTotal: z.number().nullish(),
  terrenoFrente: z.number().nullish(),
  terrenoFundo: z.number().nullish(),
  terrenoLateralEsquerda: z.number().nullish(),
  terrenoLateralDireita: z.number().nullish(),
  ruralAreaTotal: z.number().nullish(),
  ruralAreaAravel: z.number().nullish(),
  ruralSedes: z.number().nullish(),
  precoVenda: z.number().nullish(),
  precoVendaComDesconto: z.number().nullish(),
  precoVendaAvaliacao: z.number().nullish(),
  ocultarValorVenda: z.boolean().nullish(),
  financiavel: z.boolean().nullish(),
  usoFGTS: z.boolean().nullish(),
  tiposFinanciamento: z.array(z.string()).default([]),
  precoLocacao: z.number().nullish(),
  precoLocacaoBase: z.number().nullish(),
  precoLocacaoComDesconto: z.number().nullish(),
  precoLocacaoAvaliacao: z.number().nullish(),
  ocultarValorLocacao: z.boolean().nullish(),
  indiceReajuste: z.string().nullish(),
  condominio: z.boolean().default(false),
  condominioValor: z.number().nullish(),
  condominioOcultarValor: z.boolean().nullish(),
  iptuValor: z.number().nullish(),
  iptuIsento: z.boolean().nullish(),
  iptuPeriodo: z.string().nullish(),
  iptuOcultarValor: z.boolean().nullish(),
  comodidades: z.array(z.string()).default([]),
  empreendimentoId: z.number().nullish(),
  empreendimentoNome: z.string().nullish(),
  empreendimentoTipo: z.string().nullish(),
  empreendimentoFase: z.string().nullish(),
  empreendimentoStatus: z.string().nullish(),
  empreendimentoCidade: z.string().nullish(),
  empreendimentoCidadeSlug: z.string().nullish(),
  empreendimentoBairro: z.string().nullish(),
  empreendimentoUf: z.string().nullish(),
  empreendimentoFotoUrl: z.string().nullish(),
  incorporadoraId: z.number().nullish(),
  incorporadoraNome: z.string().nullish(),
  incorporadoraDescricao: z.string().nullish()
});
var empreendimentoFotoDocSchema = z.object({
  id: z.number(),
  url: z.string(),
  titulo: z.string()
});
var empreendimentoDocumentSchema = z.object({
  id: z.number(),
  dashboardId: z.number(),
  siteIds: z.array(z.number()).default([]),
  sites: z.array(meiliSiteEntrySchema).default([]),
  status: z.string(),
  createdAt: z.number(),
  updatedAt: z.number(),
  fotos: z.array(empreendimentoFotoDocSchema).default([]),
  temVideo: z.boolean(),
  temTour: z.boolean(),
  nome: z.string(),
  tipo: z.string().nullish(),
  fase: z.string().nullish(),
  sistemaVenda: z.string().nullish(),
  padraoClasse: z.string().nullish(),
  descricao: z.string().nullish(),
  tags: z.array(z.string()).default([]),
  cep: z.number().nullish(),
  uf: z.string().nullish(),
  cidade: z.string().nullish(),
  cidadeSlug: z.string().nullish(),
  bairro: z.string().nullish(),
  rua: z.string().nullish(),
  numero: z.string().nullish(),
  complemento: z.string().nullish(),
  pontoReferencia: z.string().nullish(),
  padraoLocalizacao: z.string().nullish(),
  distanciaPraia: z.number().nullish(),
  distanciaPraiaLabel: z.string().nullish(),
  latitude: z.string().nullish(),
  longitude: z.string().nullish(),
  dormitoriosDe: z.number().nullish(),
  dormitoriosAte: z.number().nullish(),
  suitesDe: z.number().nullish(),
  suitesAte: z.number().nullish(),
  areaDe: z.number().nullish(),
  areaAte: z.number().nullish(),
  vagasGaragemDe: z.number().nullish(),
  vagasGaragemAte: z.number().nullish(),
  banheirosDe: z.number().nullish(),
  banheirosAte: z.number().nullish(),
  salasDe: z.number().nullish(),
  salasAte: z.number().nullish(),
  lavabosDe: z.number().nullish(),
  lavabosAte: z.number().nullish(),
  anoConstrucao: z.string().nullish(),
  dataEntrega: z.string().nullish(),
  valorDe: z.number().nullish(),
  valorAte: z.number().nullish(),
  comodidades: z.array(z.string()).default([]),
  comodidadesValues: z.array(z.string()).default([]),
  incorporadoraId: z.number().nullish(),
  incorporadoraNome: z.string().nullish(),
  incorporadoraDescricao: z.string().nullish(),
  totalImoveis: z.number(),
  imoveisTexto: z.string().nullish()
});
var incorporadoraDocumentSchema = z.object({
  id: z.number(),
  dashboardId: z.number(),
  siteIds: z.array(z.number()).default([]),
  sites: z.array(meiliSiteEntrySchema).default([]),
  createdAt: z.number(),
  updatedAt: z.number(),
  nome: z.string(),
  logo: z.string().nullish(),
  descricao: z.string().nullish(),
  totalEmpreendimentos: z.number(),
  totalImoveis: z.number(),
  cidades: z.array(z.string()).default([]),
  estados: z.array(z.string()).default([]),
  empreendimentosTexto: z.string().nullish()
});
var meiliFacetDistributionSchema = z.record(
  z.string(),
  z.record(z.string(), z.number())
);
var meiliFacetStatsSchema = z.record(
  z.string(),
  z.object({
    min: z.number(),
    max: z.number()
  })
);
function meiliSearchResultSchema(hitSchema) {
  return z.object({
    hits: z.array(hitSchema),
    totalHits: z.number(),
    page: z.number(),
    hitsPerPage: z.number(),
    totalPages: z.number(),
    processingTimeMs: z.number(),
    query: z.string(),
    facetDistribution: meiliFacetDistributionSchema.optional(),
    facetStats: meiliFacetStatsSchema.optional()
  });
}
var imoveisMeiliSearchResponseSchema = meiliSearchResultSchema(
  imovelDocumentSchema
);
var empreendimentosMeiliSearchResponseSchema = meiliSearchResultSchema(
  empreendimentoDocumentSchema
);
var incorporadorasMeiliSearchResponseSchema = meiliSearchResultSchema(
  incorporadoraDocumentSchema
);

// src/meilisearch/index.ts
var meilisearchIndexesSchema = z.object({
  imoveis: z.string(),
  empreendimentos: z.string(),
  incorporadoras: z.string()
});
var meilisearchTenantTokenResponseSchema = z.object({
  token: z.string(),
  expiresAt: z.string(),
  host: z.string(),
  indexes: meilisearchIndexesSchema
});

// src/push/index.ts
var push_exports = {};
__export(push_exports, {
  pushConfigResponseSchema: () => pushConfigResponseSchema,
  pushEmptyResponseSchema: () => pushEmptyResponseSchema,
  pushSubscribeRequestSchema: () => pushSubscribeRequestSchema,
  pushUnsubscribeRequestSchema: () => pushUnsubscribeRequestSchema
});
var pushConfigResponseSchema = z.object({
  enabled: z.boolean(),
  publicKey: z.string().nullable()
});
var pushSubscribeRequestSchema = z.object({
  endpoint: z.string().max(2048),
  p256dh: z.string().max(512),
  auth: z.string().max(512)
});
var pushUnsubscribeRequestSchema = z.object({
  endpoint: z.string().max(2048)
});
var pushEmptyResponseSchema = z.undefined();

// src/contratacao/index.ts
var contratacao_exports = {};
__export(contratacao_exports, {
  contratacaoCelularFieldSchema: () => contratacaoCelularFieldSchema,
  contratacaoDashboardOptionSchema: () => contratacaoDashboardOptionSchema,
  contratacaoDashboardsResponseSchema: () => contratacaoDashboardsResponseSchema,
  contratacaoEmailFieldSchema: () => contratacaoEmailFieldSchema,
  contratacaoNomeFieldSchema: () => contratacaoNomeFieldSchema,
  contratacaoNomeImobiliariaFieldSchema: () => contratacaoNomeImobiliariaFieldSchema,
  contratacaoOnboardingFormSchema: () => contratacaoOnboardingFormSchema
});
var contratacaoEmailFieldSchema = z.string().trim().email("Digite um e-mail v\xE1lido");
var contratacaoNomeFieldSchema = z.string().trim().min(2, "Digite seu nome completo");
var contratacaoNomeImobiliariaFieldSchema = z.string().trim().min(2, "Digite o nome da imobili\xE1ria");
var contratacaoCelularFieldSchema = z.string().trim().min(10, "Digite um WhatsApp v\xE1lido").max(20, "Digite um WhatsApp v\xE1lido").refine(
  (value) => value.replace(/\D/g, "").length >= 10,
  "Digite um WhatsApp v\xE1lido"
);
var contratacaoOnboardingFormSchema = z.object({
  nomeImobiliaria: z.string().min(2, "Nome da imobili\xE1ria deve ter no m\xEDnimo 2 caracteres").max(255),
  siteAtual: z.string().optional().default("")
});
var contratacaoDashboardOptionSchema = dashboardSchema;
var contratacaoDashboardsResponseSchema = dashboardsResponseSchema;

// src/builder/index.ts
var builder_exports = {};
__export(builder_exports, {
  builderAddressDisplayTypeSchema: () => builderAddressDisplayTypeSchema,
  builderAddressSchema: () => builderAddressSchema,
  builderAddressTypeSchema: () => builderAddressTypeSchema,
  builderBordersFormSchema: () => builderBordersFormSchema,
  builderColorsFormSchema: () => builderColorsFormSchema,
  builderConfigGeneralFormSchema: () => builderConfigGeneralFormSchema,
  builderEmailSchema: () => builderEmailSchema,
  builderFontsFormSchema: () => builderFontsFormSchema,
  builderIntegrationsFormSchema: () => builderIntegrationsFormSchema,
  builderLayoutFormSchema: () => builderLayoutFormSchema,
  builderLogoFormSchema: () => builderLogoFormSchema,
  builderMenuConfigFormSchema: () => builderMenuConfigFormSchema,
  builderMenuConfigRequestSchema: () => builderMenuConfigRequestSchema,
  builderPageSchema: () => builderPageSchema,
  builderPageSeoFormSchema: () => builderPageSeoFormSchema,
  builderPageStatusSchema: () => builderPageStatusSchema,
  builderPageStickySchema: () => builderPageStickySchema,
  builderPageStickyTypeSchema: () => builderPageStickyTypeSchema,
  builderPhoneSchema: () => builderPhoneSchema,
  builderSiteConfigResponseSchema: () => builderSiteConfigResponseSchema,
  builderSiteConfigSchema: () => builderSiteConfigSchema,
  builderSiteScriptsFormSchema: () => builderSiteScriptsFormSchema,
  builderSocialNetworkSchema: () => builderSocialNetworkSchema,
  builderSocialSchema: () => builderSocialSchema,
  builderTeamSchema: () => builderTeamSchema,
  builderWhatsappFloatingPositionSchema: () => builderWhatsappFloatingPositionSchema,
  builderWhatsappFloatingTypeSchema: () => builderWhatsappFloatingTypeSchema,
  builderWhatsappPhoneSelectionSchema: () => builderWhatsappPhoneSelectionSchema,
  publicArtigoDetailResponseSchema: () => publicArtigoDetailResponseSchema,
  publicArtigoListResponseSchema: () => publicArtigoListResponseSchema,
  publicSiteArtigoDetailSchema: () => publicSiteArtigoDetailSchema,
  publicSiteArtigoListItemSchema: () => publicSiteArtigoListItemSchema,
  publicSiteArtigosQuerySchema: () => publicSiteArtigosQuerySchema,
  publicSiteInfoResponseSchema: () => publicSiteInfoResponseSchema,
  publicSiteInfoSchema: () => publicSiteInfoSchema
});
var builderAddressDisplayTypeSchema = z.enum([
  "CITY_STATE",
  "NEIGHBORHOOD_CITY_STATE",
  "STREET_NEIGHBORHOOD_CITY_STATE",
  "FULL_ADDRESS_WITH_NUMBER",
  "FULL_ADDRESS"
]);
var builderWhatsappFloatingPositionSchema = z.enum(["LEFT", "RIGHT"]);
var builderWhatsappFloatingTypeSchema = z.enum(["DIRECT", "FORM"]);
var builderWhatsappPhoneSelectionSchema = z.enum([
  "RESPONSIBLE",
  "SPECIFIC",
  "RANDOM",
  "USER_CHOICE"
]);
var builderPageStatusSchema = z.enum(["DRAFT", "PUBLISHED"]);
var builderPageStickyTypeSchema = z.enum([
  "HOME",
  "IMOVEIS",
  "IMOVEL",
  "INCORPORADORAS",
  "INCORPORADORA",
  "EMPREENDIMENTOS",
  "EMPREENDIMENTO",
  "BLOG",
  "ARTIGO",
  "ATENDIMENTO"
]);
var builderSocialNetworkSchema = z.enum([
  "instagram",
  "youtube",
  "facebook",
  "telegram",
  "pinterest",
  "linkedin",
  "twitter",
  "tiktok",
  "kwai",
  "threads"
]);
var builderAddressTypeSchema = z.enum(["headquarters", "branch"]);
var builderPageSchema = z.object({
  id: z.string(),
  title: z.string(),
  metaTitle: z.string().nullable().optional(),
  metaDescription: z.string().nullable().optional(),
  featuredImage: z.string().nullable().optional(),
  slug: z.string(),
  content: z.any().nullable().optional(),
  status: builderPageStatusSchema,
  createdAt: z.string(),
  updatedAt: z.string(),
  siteId: z.string()
});
var builderPageStickySchema = z.object({
  id: z.string(),
  type: builderPageStickyTypeSchema,
  metaTitle: z.string().nullable().optional(),
  metaDescription: z.string().nullable().optional(),
  featuredImage: z.string().nullable().optional(),
  content: z.any().nullable().optional(),
  siteId: z.string(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var builderAddressSchema = z.object({
  id: z.string(),
  siteId: z.string(),
  country: z.string(),
  zipcode: z.string(),
  state: z.string(),
  city: z.string(),
  street: z.string().nullable().optional(),
  number: z.string().nullable().optional(),
  neighborhood: z.string().nullable().optional(),
  complement: z.string().nullable().optional(),
  reference: z.string().nullable().optional(),
  longitude: z.string().nullable().optional(),
  latitude: z.string().nullable().optional(),
  type: builderAddressTypeSchema,
  createdAt: z.string(),
  updatedAt: z.string()
});
var builderPhoneSchema = z.object({
  id: z.string(),
  siteId: z.string(),
  phone: z.string(),
  title: z.string(),
  whatsapp: z.boolean(),
  notifications: z.boolean(),
  showInFooter: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var builderEmailSchema = z.object({
  id: z.string(),
  email: z.string(),
  title: z.string(),
  notifications: z.boolean(),
  siteId: z.string(),
  showInFooter: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var builderSocialSchema = z.object({
  id: z.string(),
  network: builderSocialNetworkSchema,
  url: z.string().nullable().optional(),
  siteId: z.string().nullable().optional(),
  teamId: z.string().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var builderTeamSchema = z.object({
  id: z.string(),
  name: z.string(),
  role: z.string(),
  photo: z.string().nullable().optional(),
  email: z.string().nullable().optional(),
  phone: z.string().nullable().optional(),
  registry: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  siteId: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  social: z.array(builderSocialSchema).optional()
});
var builderSiteConfigSchema = z.object({
  id: z.string(),
  siteId: z.string(),
  name: z.string(),
  logo: z.string().nullable().optional(),
  favicon: z.string().nullable().optional(),
  domain: z.string().nullable().optional(),
  subDomain: z.string(),
  globalStyles: z.any(),
  globalHeader: z.string(),
  globalFooter: z.string(),
  tagManager: z.string().nullable().optional(),
  facebookPixel: z.string().nullable().optional(),
  googleAdsFormConversion: z.string().nullable().optional(),
  googleAdsWhatsappConversion: z.string().nullable().optional(),
  addressDisplayType: builderAddressDisplayTypeSchema,
  whatsappFloatingEnabled: z.boolean(),
  whatsappFloatingPosition: builderWhatsappFloatingPositionSchema,
  whatsappFloatingType: builderWhatsappFloatingTypeSchema,
  whatsappFloatingPhoneSelection: builderWhatsappPhoneSelectionSchema,
  whatsappFloatingSpecificPhoneId: z.string().nullable().optional(),
  customScriptHead: z.string().nullable().optional(),
  customScriptBody: z.string().nullable().optional(),
  customScriptAfterBody: z.string().nullable().optional(),
  published: z.boolean(),
  creci: z.string().nullable().optional(),
  aiIndexingEnabled: z.boolean().optional().default(true),
  aiInstitutionalDescription: z.string().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
  pages: z.array(builderPageSchema).optional(),
  pagesSticky: z.array(builderPageStickySchema).optional(),
  addresses: z.array(builderAddressSchema).optional(),
  phones: z.array(builderPhoneSchema).optional(),
  social: z.array(builderSocialSchema).optional(),
  emails: z.array(builderEmailSchema).optional(),
  team: z.array(builderTeamSchema).optional()
});
var builderSiteConfigResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  data: builderSiteConfigSchema.nullable().optional()
});
var builderMenuDropdownChildSchema = z.object({
  id: z.string(),
  href: z.string(),
  label: z.string(),
  order: z.number(),
  type: z.enum(["fixed", "custom", "custom-link", "dropdown"]),
  children: z.array(z.any()).optional()
});
var builderMenuFixedLinkSchema = z.object({
  enabled: z.boolean(),
  label: z.string(),
  order: z.number()
});
var builderMenuConfigFormSchema = z.object({
  fixedLinks: z.object({
    comprar: builderMenuFixedLinkSchema,
    alugar: builderMenuFixedLinkSchema,
    empreendimentos: builderMenuFixedLinkSchema,
    incorporadoras: builderMenuFixedLinkSchema,
    blog: builderMenuFixedLinkSchema,
    atendimento: builderMenuFixedLinkSchema
  }),
  customPages: z.array(
    z.object({
      pageId: z.string(),
      enabled: z.boolean(),
      label: z.string(),
      order: z.number()
    })
  ),
  customLinks: z.array(
    z.object({
      id: z.string(),
      enabled: z.boolean(),
      label: z.string(),
      href: z.string(),
      order: z.number()
    })
  ),
  dropdownMenus: z.array(
    z.object({
      id: z.string(),
      enabled: z.boolean(),
      label: z.string(),
      order: z.number(),
      children: z.array(builderMenuDropdownChildSchema)
    })
  )
});
var builderMenuConfigRequestSchema = builderMenuConfigFormSchema;
var builderHexColorSchema = z.string().regex(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, {
  message: "Cor inv\xE1lida"
});
var builderOptionalHexColorSchema = builderHexColorSchema.optional();
var builderHeaderFooterColorsSchema = z.object({
  background: builderOptionalHexColorSchema,
  link: builderOptionalHexColorSchema,
  linkHover: builderOptionalHexColorSchema,
  linkActive: builderOptionalHexColorSchema,
  buttonBg: builderOptionalHexColorSchema,
  buttonText: builderOptionalHexColorSchema,
  buttonBgHover: builderOptionalHexColorSchema,
  buttonTextHover: builderOptionalHexColorSchema,
  border: builderOptionalHexColorSchema
});
var builderFooterColorsSchema = z.object({
  background: builderOptionalHexColorSchema,
  text: builderOptionalHexColorSchema,
  textHover: builderOptionalHexColorSchema,
  buttonBg: builderOptionalHexColorSchema,
  buttonBgHover: builderOptionalHexColorSchema,
  buttonText: builderOptionalHexColorSchema,
  buttonTextHover: builderOptionalHexColorSchema,
  border: builderOptionalHexColorSchema
});
var builderColorsFormSchema = z.object({
  primary: builderHexColorSchema,
  primaryHover: builderHexColorSchema,
  primaryText: builderHexColorSchema,
  primaryTextHover: builderHexColorSchema,
  secondary: builderHexColorSchema,
  secondaryHover: builderHexColorSchema,
  secondaryText: builderHexColorSchema,
  secondaryTextHover: builderHexColorSchema,
  background: builderHexColorSchema,
  text: builderHexColorSchema,
  header: builderHeaderFooterColorsSchema.optional(),
  footer: builderFooterColorsSchema.optional()
});
var builderBordersFormSchema = z.object({
  buttonRadius: z.number().min(0, "Valor min\xEDmo \xE9 de 0px").max(100, "Valor m\xE1ximo \xE9 de 100px"),
  cardRadius: z.number().min(0, "Valor min\xEDmo \xE9 de 0px").max(24, "Valor m\xE1ximo \xE9 de 24px"),
  buttonShadow: z.boolean(),
  cardShadow: z.boolean()
});
var builderFontsFormSchema = z.object({
  fontTitle: z.string(),
  fontText: z.string()
});
var builderLogoFormSchema = z.object({
  logo: z.string(),
  favicon: z.string(),
  logoHeaderHeight: z.number().min(40, "M\xEDnimo 40px").max(240, "M\xE1ximo 240px").default(120),
  logoFooterHeight: z.number().min(40, "M\xEDnimo 40px").max(300, "M\xE1ximo 300px").default(160)
});
var builderLayoutFormSchema = z.object({
  globalHeader: z.enum(["atlas", "masp"]).optional(),
  globalFooter: z.enum(["atlas", "masp"]).optional()
});
var builderIntegrationsFormSchema = z.object({
  tagManager: z.string().optional(),
  facebookPixel: z.string().optional(),
  googleAdsFormConversion: z.string().optional(),
  googleAdsWhatsappConversion: z.string().optional(),
  addressDisplayType: builderAddressDisplayTypeSchema.optional()
});
var builderConfigGeneralFormSchema = z.object({
  addressDisplayType: builderAddressDisplayTypeSchema.optional(),
  formRedirectEnabled: z.boolean().optional()
});
var builderPageSeoFormSchema = z.object({
  metaTitle: z.string().optional(),
  metaDescription: z.string().optional(),
  featuredImage: z.string().optional()
});
var builderSiteScriptsFormSchema = z.object({
  customScriptHead: z.string().optional(),
  customScriptBody: z.string().optional(),
  customScriptAfterBody: z.string().optional()
});

// src/suporte/index.ts
var suporte_exports = {};
__export(suporte_exports, {
  suporteAdminDataResponse: () => suporteAdminDataResponse,
  suporteAdminErrorResponseSchema: () => suporteAdminErrorResponseSchema,
  suporteAdminIdResponseSchema: () => suporteAdminIdResponseSchema,
  suporteAdminUserSchema: () => suporteAdminUserSchema,
  suporteApiErrorSchema: () => suporteApiErrorSchema,
  suporteArticleCommentSchema: () => suporteArticleCommentSchema,
  suporteArticleGuestBodyVisibilityEnum: () => suporteArticleGuestBodyVisibilityEnum,
  suporteArticleStatusEnum: () => suporteArticleStatusEnum,
  suporteArtigoCategoriesListResponseSchema: () => suporteArtigoCategoriesListResponseSchema,
  suporteArtigoCategoryInputSchema: () => suporteArtigoCategoryInputSchema,
  suporteArtigoCategorySchema: () => suporteArtigoCategorySchema,
  suporteArtigoDetailResponseSchema: () => suporteArtigoDetailResponseSchema,
  suporteArtigoDetailSchema: () => suporteArtigoDetailSchema,
  suporteArtigoInputSchema: () => suporteArtigoInputSchema,
  suporteArtigoListItemSchema: () => suporteArtigoListItemSchema,
  suporteArtigoNextStepsCatalogItemSchema: () => suporteArtigoNextStepsCatalogItemSchema,
  suporteArtigoNextStepsResponseSchema: () => suporteArtigoNextStepsResponseSchema,
  suporteArtigoNextStepsSaveRequestSchema: () => suporteArtigoNextStepsSaveRequestSchema,
  suporteArtigoNextStepsSchema: () => suporteArtigoNextStepsSchema,
  suporteArtigoRagSyncResponseSchema: () => suporteArtigoRagSyncResponseSchema,
  suporteArtigosListResponseSchema: () => suporteArtigosListResponseSchema,
  suporteChamadoDetailResponseSchema: () => suporteChamadoDetailResponseSchema,
  suporteChamadoDetailSchema: () => suporteChamadoDetailSchema,
  suporteChamadoListItemSchema: () => suporteChamadoListItemSchema,
  suporteChamadoMessageCreatedResponseSchema: () => suporteChamadoMessageCreatedResponseSchema,
  suporteChamadosListResponseSchema: () => suporteChamadosListResponseSchema,
  suporteChamadosMetaResponseSchema: () => suporteChamadosMetaResponseSchema,
  suporteChamadosMetaSchema: () => suporteChamadosMetaSchema,
  suporteComentariosListDataSchema: () => suporteComentariosListDataSchema,
  suporteComentariosListResponseSchema: () => suporteComentariosListResponseSchema,
  suporteComentariosPendingCountResponseSchema: () => suporteComentariosPendingCountResponseSchema,
  suporteComentariosPendingCountSchema: () => suporteComentariosPendingCountSchema,
  suporteCommentAuthorRoleEnum: () => suporteCommentAuthorRoleEnum,
  suporteCommentBanLiftResponseSchema: () => suporteCommentBanLiftResponseSchema,
  suporteCommentBanRequestSchema: () => suporteCommentBanRequestSchema,
  suporteCommentBanResponseSchema: () => suporteCommentBanResponseSchema,
  suporteCommentBanSchema: () => suporteCommentBanSchema,
  suporteCommentPatchRequestSchema: () => suporteCommentPatchRequestSchema,
  suporteCommentReplyRequestSchema: () => suporteCommentReplyRequestSchema,
  suporteCommentReplyResponseSchema: () => suporteCommentReplyResponseSchema,
  suporteCommentSpamPatchResponseSchema: () => suporteCommentSpamPatchResponseSchema,
  suporteCourseModuleSchema: () => suporteCourseModuleSchema,
  suporteCoursePricingEnum: () => suporteCoursePricingEnum,
  suporteCourseSchema: () => suporteCourseSchema,
  suporteCourseStatusEnum: () => suporteCourseStatusEnum,
  suporteCreateChamadoMessageRequestSchema: () => suporteCreateChamadoMessageRequestSchema,
  suporteCreateChamadoRequestSchema: () => suporteCreateChamadoRequestSchema,
  suporteCursoDetailResponseSchema: () => suporteCursoDetailResponseSchema,
  suporteCursosListResponseSchema: () => suporteCursosListResponseSchema,
  suporteImobdeskSyncListResponseSchema: () => adminSuporteSyncListResponseSchema,
  suporteImobdeskUsuarioSummarySchema: () => suporteImobdeskUsuarioSummarySchema,
  suporteLessonContentTypeEnum: () => suporteLessonContentTypeEnum,
  suporteLessonDownloadAssetSchema: () => suporteLessonDownloadAssetSchema,
  suporteLessonSchema: () => suporteLessonSchema,
  suporteLessonVisibilityEnum: () => suporteLessonVisibilityEnum,
  suporteMessageAuthorEnum: () => suporteMessageAuthorEnum,
  suporteMessageVisibilityEnum: () => suporteMessageVisibilityEnum,
  suporteNovidadeDetailResponseSchema: () => suporteNovidadeDetailResponseSchema,
  suporteNovidadeInputSchema: () => suporteNovidadeInputSchema,
  suporteNovidadeSchema: () => suporteNovidadeSchema,
  suporteNovidadesListResponseSchema: () => suporteNovidadesListResponseSchema,
  suporteNovidadesReplaceRequestSchema: () => suporteNovidadesReplaceRequestSchema,
  suporteNovidadesReplaceResponseSchema: () => suporteNovidadesReplaceResponseSchema,
  suporteR2PresignedPutResponseSchema: () => suporteR2PresignedPutResponseSchema,
  suporteRagArticleExportItemSchema: () => suporteRagArticleExportItemSchema,
  suporteRagArticleImageSchema: () => suporteRagArticleImageSchema,
  suporteRagArticleSyncedResponseSchema: () => suporteRagArticleSyncedResponseSchema,
  suporteRagArticlesExportResponseSchema: () => suporteRagArticlesExportResponseSchema,
  suporteReleaseNoteKindEnum: () => suporteReleaseNoteKindEnum,
  suporteSendToDevResponseSchema: () => suporteSendToDevResponseSchema,
  suporteStripeWebhookDuplicateResponseSchema: () => suporteStripeWebhookDuplicateResponseSchema,
  suporteStripeWebhookReceivedResponseSchema: () => suporteStripeWebhookReceivedResponseSchema,
  suporteTicketAssigneeHistorySchema: () => suporteTicketAssigneeHistorySchema,
  suporteTicketAttachmentKindEnum: () => suporteTicketAttachmentKindEnum,
  suporteTicketCategoriesListResponseSchema: () => suporteTicketCategoriesListResponseSchema,
  suporteTicketCategoryInputSchema: () => suporteTicketCategoryInputSchema,
  suporteTicketCategorySchema: () => suporteTicketCategorySchema,
  suporteTicketEntitySchema: () => suporteTicketEntitySchema,
  suporteTicketMessageAttachmentSchema: () => suporteTicketMessageAttachmentSchema,
  suporteTicketMessageSchema: () => suporteTicketMessageSchema,
  suporteTicketOriginEnum: () => suporteTicketOriginEnum,
  suporteTicketStatusEnum: () => suporteTicketStatusEnum,
  suporteUpdateChamadoRequestSchema: () => suporteUpdateChamadoRequestSchema
});
var suporteAdminErrorResponseSchema = z.object({
  success: z.literal(false),
  message: z.string()
});
function suporteAdminDataResponse(item) {
  return z.object({
    success: z.literal(true),
    data: item
  });
}
var suporteAdminIdResponseSchema = suporteAdminDataResponse(
  z.object({ id: z.string() })
);
var suporteTicketStatusEnum = z.enum([
  "pending",
  "in_progress",
  "in_review",
  "resolved"
]);
var suporteTicketOriginEnum = z.enum(["internal", "site", "ai_agent"]);
var suporteChamadoListItemSchema = z.object({
  id: z.string(),
  subject: z.string(),
  status: suporteTicketStatusEnum,
  origin: suporteTicketOriginEnum,
  createdAt: z.string(),
  updatedAt: z.string(),
  dueAt: z.string().nullable().optional(),
  imobdeskUsuarioId: z.number(),
  dashboardId: z.number(),
  assigneeId: z.string(),
  categoryId: z.string().nullable().optional(),
  customerName: z.string(),
  customerEmail: z.string().optional(),
  assigneeName: z.string(),
  openedByAdminName: z.string().nullable().optional(),
  categoryName: z.string(),
  categoryColor: z.string()
});
var suporteChamadosListResponseSchema = suporteAdminDataResponse(
  z.array(suporteChamadoListItemSchema)
);
var suporteTicketCategorySchema = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string(),
  description: z.string(),
  color: z.string(),
  order: z.number()
});
var suporteAdminUserSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string(),
  role: z.string()
});
var suporteImobdeskUsuarioSummarySchema = z.object({
  id: z.number(),
  name: z.string(),
  email: z.string()
});
var suporteChamadosMetaSchema = z.object({
  usuarios: z.array(suporteImobdeskUsuarioSummarySchema),
  usuariosError: z.string().optional(),
  adminUsers: z.array(suporteAdminUserSchema),
  ticketCategories: z.array(suporteTicketCategorySchema)
});
var suporteChamadosMetaResponseSchema = suporteAdminDataResponse(
  suporteChamadosMetaSchema
);
var suporteTicketCategoriesListResponseSchema = suporteAdminDataResponse(
  z.array(suporteTicketCategorySchema)
);
var suporteMessageAuthorEnum = z.enum(["customer", "agent", "ai"]);
var suporteMessageVisibilityEnum = z.enum(["public", "internal"]);
var suporteTicketAttachmentKindEnum = z.enum(["image", "video", "document"]);
var suporteTicketMessageAttachmentSchema = z.object({
  id: z.string(),
  ticketMessageId: z.string(),
  kind: suporteTicketAttachmentKindEnum,
  fileName: z.string(),
  contentType: z.string(),
  fileSize: z.number(),
  objectKey: z.string(),
  publicUrl: z.string(),
  createdAt: z.string()
});
var suporteTicketMessageSchema = z.object({
  id: z.string(),
  ticketId: z.string(),
  authorType: suporteMessageAuthorEnum,
  authorName: z.string(),
  body: z.string(),
  createdAt: z.string(),
  visibility: suporteMessageVisibilityEnum,
  attachments: z.array(suporteTicketMessageAttachmentSchema)
});
var suporteTicketAssigneeHistorySchema = z.object({
  id: z.string(),
  previousAssigneeId: z.string().nullable(),
  previousAssigneeName: z.string().nullable(),
  newAssigneeId: z.string(),
  newAssigneeName: z.string(),
  changedByAdminId: z.string(),
  changedByAdminName: z.string(),
  createdAt: z.string()
});
var suporteTicketEntitySchema = z.object({
  id: z.string(),
  subject: z.string(),
  origin: suporteTicketOriginEnum,
  openedByAdminId: z.string().nullable(),
  status: suporteTicketStatusEnum,
  categoryId: z.string().nullable(),
  imobdeskUsuarioId: z.number(),
  dashboardId: z.number(),
  assigneeId: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  dueAt: z.string().nullable(),
  cursorAgentId: z.string().nullable().optional(),
  cursorAgentStatus: z.string().nullable().optional(),
  cursorAgentUrl: z.string().nullable().optional(),
  cursorAgentSentAt: z.string().nullable().optional(),
  cursorAgentError: z.string().nullable().optional()
});
var suporteSendToDevResponseSchema = suporteAdminDataResponse(
  z.object({
    cursorAgentId: z.string(),
    cursorAgentStatus: z.string(),
    cursorAgentUrl: z.string(),
    cursorAgentSentAt: z.string(),
    cursorAgentError: z.string().nullable()
  })
);
var suporteChamadoDetailSchema = z.object({
  ticket: suporteTicketEntitySchema,
  customerName: z.string(),
  customerEmail: z.string().optional(),
  assigneeName: z.string(),
  categoryName: z.string(),
  messages: z.array(suporteTicketMessageSchema),
  assigneeHistory: z.array(suporteTicketAssigneeHistorySchema)
});
var suporteChamadoDetailResponseSchema = suporteAdminDataResponse(
  suporteChamadoDetailSchema
);
var suporteChamadoMessageCreatedResponseSchema = suporteAdminDataResponse(
  z.object({ ticketId: z.string() })
);
var suporteArticleStatusEnum = z.enum(["draft", "published"]);
var suporteArticleGuestBodyVisibilityEnum = z.enum([
  "full",
  "teaser_then_login"
]);
var suporteArtigoListItemSchema = z.object({
  id: z.string(),
  title: z.string(),
  slug: z.string(),
  categoryId: z.string(),
  categoryName: z.string(),
  status: suporteArticleStatusEnum,
  viewCount: z.number(),
  guestBodyVisibility: suporteArticleGuestBodyVisibilityEnum,
  createdAt: z.string(),
  updatedAt: z.string(),
  lastRagSyncedAt: z.string().nullable()
});
var suporteArtigosListResponseSchema = suporteAdminDataResponse(
  z.array(suporteArtigoListItemSchema)
);
var suporteArtigoCategorySchema = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string(),
  description: z.string(),
  iconKey: z.string(),
  order: z.number()
});
var suporteArtigoCategoriesListResponseSchema = suporteAdminDataResponse(
  z.array(suporteArtigoCategorySchema)
);
var suporteArtigoDetailSchema = z.object({
  id: z.string(),
  title: z.string(),
  slug: z.string(),
  body: z.string(),
  categoryId: z.string(),
  categoryName: z.string(),
  status: suporteArticleStatusEnum,
  viewCount: z.number(),
  guestBodyVisibility: suporteArticleGuestBodyVisibilityEnum,
  createdAt: z.string(),
  updatedAt: z.string(),
  lastRagSyncedAt: z.string().nullable(),
  teaserHtml: z.string().nullable()
});
var suporteArtigoDetailResponseSchema = suporteAdminDataResponse(
  suporteArtigoDetailSchema
);
var suporteArtigoNextStepsCatalogItemSchema = z.object({
  id: z.string(),
  title: z.string(),
  slug: z.string(),
  status: suporteArticleStatusEnum
});
var suporteArtigoNextStepsSchema = z.object({
  orderedTargetIds: z.array(z.string()),
  catalog: z.array(suporteArtigoNextStepsCatalogItemSchema)
});
var suporteArtigoNextStepsResponseSchema = suporteAdminDataResponse(
  suporteArtigoNextStepsSchema
);
var suporteArtigoRagSyncResponseSchema = suporteAdminDataResponse(
  z.object({
    syncedAt: z.string(),
    lastRagSyncedAt: z.string()
  })
);
var suporteCommentAuthorRoleEnum = z.enum(["customer", "staff"]);
var suporteArticleCommentSchema = z.object({
  id: z.string(),
  articleSlug: z.string(),
  parentId: z.string().nullable(),
  body: z.string(),
  createdAt: z.string(),
  authorRole: suporteCommentAuthorRoleEnum,
  authorIdentifier: z.string(),
  authorDisplayName: z.string(),
  spam: z.boolean(),
  adminAuthorHref: z.string().optional()
});
var suporteCommentBanSchema = z.object({
  identifier: z.string(),
  untilIso: z.string().nullable(),
  createdAt: z.string()
});
var suporteComentariosListDataSchema = z.object({
  comments: z.array(suporteArticleCommentSchema),
  bans: z.array(suporteCommentBanSchema),
  labelMap: z.record(z.string(), z.string())
});
var suporteComentariosListResponseSchema = suporteAdminDataResponse(
  suporteComentariosListDataSchema
);
var suporteComentariosPendingCountSchema = z.object({
  count: z.number().int()
});
var suporteComentariosPendingCountResponseSchema = suporteAdminDataResponse(
  suporteComentariosPendingCountSchema
);
var suporteCommentSpamPatchResponseSchema = suporteAdminDataResponse(
  z.object({ id: z.string(), spam: z.boolean() })
);
var suporteCommentReplyResponseSchema = suporteAdminDataResponse(
  suporteArticleCommentSchema
);
var suporteCommentBanResponseSchema = suporteAdminDataResponse(
  suporteCommentBanSchema
);
var suporteCommentBanLiftResponseSchema = suporteAdminDataResponse(
  z.object({ identifier: z.string() })
);
var suporteReleaseNoteKindEnum = z.enum(["feature", "improvement", "fix"]);
var suporteNovidadeSchema = z.object({
  id: z.string(),
  title: z.string(),
  body: z.string(),
  kind: suporteReleaseNoteKindEnum,
  publishedAt: z.string(),
  published: z.boolean()
});
var suporteNovidadesListResponseSchema = suporteAdminDataResponse(
  z.array(suporteNovidadeSchema)
);
var suporteNovidadeDetailResponseSchema = suporteAdminDataResponse(
  suporteNovidadeSchema
);
var suporteNovidadesReplaceResponseSchema = suporteAdminDataResponse(
  z.array(suporteNovidadeSchema)
);
var suporteCoursePricingEnum = z.enum(["free", "paid"]);
var suporteCourseStatusEnum = z.enum(["draft", "published"]);
var suporteLessonVisibilityEnum = z.enum([
  "public",
  "members",
  "purchased"
]);
var suporteLessonContentTypeEnum = z.enum(["video", "text"]);
var suporteLessonDownloadAssetSchema = z.object({
  id: z.string(),
  label: z.string(),
  r2ObjectKey: z.string(),
  signedUrlMock: z.string().optional()
});
var suporteLessonSchema = z.object({
  id: z.string(),
  slug: z.string(),
  title: z.string(),
  summary: z.string(),
  position: z.number(),
  visibility: suporteLessonVisibilityEnum,
  contentType: suporteLessonContentTypeEnum,
  descriptionHtml: z.string(),
  videoEmbedUrl: z.string().nullable().optional(),
  downloadAssets: z.array(suporteLessonDownloadAssetSchema).optional(),
  bodyHtml: z.string(),
  durationLabel: z.string().optional()
});
var suporteCourseModuleSchema = z.object({
  id: z.string(),
  title: z.string(),
  position: z.number(),
  lessons: z.array(suporteLessonSchema)
});
var suporteCourseSchema = z.object({
  id: z.string(),
  slug: z.string(),
  title: z.string(),
  subtitle: z.string(),
  description: z.string(),
  status: suporteCourseStatusEnum,
  pricing: suporteCoursePricingEnum,
  priceLabel: z.string().optional(),
  priceBrl: z.number(),
  stripeProductId: z.string().optional(),
  stripePriceId: z.string().optional(),
  coverImageSrc: z.string(),
  coverVideoSrc: z.string().optional(),
  coverGradient: z.string(),
  estimatedHours: z.number().optional(),
  modules: z.array(suporteCourseModuleSchema)
});
var suporteCursosListResponseSchema = suporteAdminDataResponse(
  z.array(suporteCourseSchema)
);
var suporteCursoDetailResponseSchema = suporteAdminDataResponse(
  suporteCourseSchema
);
var suporteCreateChamadoRequestSchema = z.object({
  imobdeskUsuarioId: z.coerce.number(),
  dashboardId: z.coerce.number(),
  subject: z.string().min(1),
  assigneeId: z.string().min(1),
  categoryId: z.string().min(1),
  body: z.string().min(1),
  origin: suporteTicketOriginEnum.optional(),
  status: suporteTicketStatusEnum.optional(),
  dueAt: z.string().nullable().optional(),
  attachments: z.unknown().optional()
});
var suporteUpdateChamadoRequestSchema = z.object({
  assigneeId: z.string().optional(),
  categoryId: z.string().optional(),
  imobdeskUsuarioId: z.coerce.number().optional(),
  dashboardId: z.coerce.number().optional(),
  status: suporteTicketStatusEnum.optional(),
  dueAt: z.string().nullable().optional()
});
var suporteCreateChamadoMessageRequestSchema = z.object({
  body: z.string().min(1),
  visibility: suporteMessageVisibilityEnum,
  attachments: z.unknown().optional()
});
var suporteTicketCategoryInputSchema = z.object({
  name: z.string().min(1),
  slug: z.string().min(1),
  description: z.string().min(1),
  color: z.string().min(1),
  order: z.coerce.number()
});
var suporteArtigoInputSchema = z.object({
  title: z.string().min(1),
  slug: z.string().min(1),
  body: z.string(),
  categoryId: z.string().min(1),
  status: suporteArticleStatusEnum,
  guestBodyVisibility: suporteArticleGuestBodyVisibilityEnum,
  teaserHtml: z.string().nullable()
});
var suporteArtigoCategoryInputSchema = z.object({
  name: z.string().min(1),
  slug: z.string().min(1),
  description: z.string().min(1),
  iconKey: z.string().min(1),
  order: z.coerce.number()
});
var suporteArtigoNextStepsSaveRequestSchema = z.object({
  orderedTargetIds: z.array(z.string())
});
var suporteCommentPatchRequestSchema = z.object({
  body: z.string().optional(),
  spam: z.boolean().optional()
}).refine((v) => typeof v.body === "string" || typeof v.spam === "boolean", {
  message: "Informe spam ou body"
});
var suporteCommentReplyRequestSchema = z.object({
  body: z.string().min(1)
});
var suporteCommentBanRequestSchema = z.object({
  identifier: z.string().min(1),
  preset: z.enum(["24h", "7d", "30d", "permanent"])
});
var suporteNovidadeInputSchema = z.object({
  title: z.string().min(1),
  body: z.string(),
  kind: suporteReleaseNoteKindEnum,
  publishedAt: z.string(),
  published: z.boolean(),
  id: z.string().optional()
});
var suporteNovidadesReplaceRequestSchema = z.object({
  notes: z.array(suporteNovidadeSchema)
});
var suporteApiErrorSchema = z.object({
  error: z.string()
});
var suporteR2PresignedPutResponseSchema = z.object({
  uploadUrl: z.string().url(),
  publicUrl: z.string().url(),
  key: z.string(),
  headers: z.object({ "Content-Type": z.string() })
});
var suporteRagArticleImageSchema = z.object({
  url: z.string(),
  ocr_text: z.string().nullable().optional()
});
var suporteRagArticleExportItemSchema = z.object({
  id: z.string(),
  slug: z.string(),
  title: z.string(),
  body: z.string(),
  updated_at: z.string(),
  category_id: z.string().nullable().optional(),
  category_name: z.string().nullable().optional(),
  category_slug: z.string().nullable().optional(),
  article_url: z.string(),
  rag_image_context: z.string().nullable().optional(),
  rag_images: z.array(suporteRagArticleImageSchema)
});
var suporteRagArticlesExportResponseSchema = z.object({
  articles: z.array(suporteRagArticleExportItemSchema)
});
var suporteRagArticleSyncedResponseSchema = z.object({
  ok: z.literal(true),
  id: z.string(),
  lastRagSyncedAt: z.string()
});
var suporteStripeWebhookReceivedResponseSchema = z.object({
  received: z.literal(true)
});
var suporteStripeWebhookDuplicateResponseSchema = z.object({
  received: z.literal(true),
  duplicate: z.literal(true)
});

// src/rag/index.ts
var rag_exports = {};
__export(rag_exports, {
  ragApiErrorSchema: () => ragApiErrorSchema,
  ragApiErrorWithHintSchema: () => ragApiErrorWithHintSchema,
  ragApiErrorWithIdSchema: () => ragApiErrorWithIdSchema,
  ragDeleteUploadResponseSchema: () => ragDeleteUploadResponseSchema,
  ragFileUploadRowSchema: () => ragFileUploadRowSchema,
  ragFileUploadsListResponseSchema: () => ragFileUploadsListResponseSchema,
  ragLoginRequestSchema: () => ragLoginRequestSchema,
  ragLoginResponseSchema: () => ragLoginResponseSchema,
  ragLogoutResponseSchema: () => ragLogoutResponseSchema,
  ragOkResponseSchema: () => ragOkResponseSchema,
  ragSchemaMissingResponseSchema: () => ragSchemaMissingResponseSchema,
  ragSupportArticlesSyncFailureSchema: () => ragSupportArticlesSyncFailureSchema,
  ragSupportArticlesSyncOptionsSchema: () => ragSupportArticlesSyncOptionsSchema,
  ragSupportArticlesSyncResponseSchema: () => ragSupportArticlesSyncResponseSchema,
  ragSupportArticlesSyncSummarySchema: () => ragSupportArticlesSyncSummarySchema,
  ragSyncedArticleRowSchema: () => ragSyncedArticleRowSchema,
  ragSyncedArticlesListResponseSchema: () => ragSyncedArticlesListResponseSchema,
  ragUploadIngestResponseSchema: () => ragUploadIngestResponseSchema
});
var ragApiErrorSchema = z.object({
  error: z.string()
});
var ragApiErrorWithHintSchema = z.object({
  error: z.string(),
  hint: z.string().optional()
});
var ragApiErrorWithIdSchema = z.object({
  error: z.string(),
  id: z.string()
});
var ragSchemaMissingResponseSchema = z.object({
  error: z.string(),
  hint: z.string()
});
var ragLoginRequestSchema = z.object({
  token: z.string().min(1)
});
var ragOkResponseSchema = z.object({
  ok: z.literal(true)
});
var ragLoginResponseSchema = ragOkResponseSchema;
var ragLogoutResponseSchema = ragOkResponseSchema;
var ragFileUploadRowSchema = z.object({
  id: z.string(),
  created_at: z.string(),
  filename: z.string(),
  storage_path: z.string(),
  content_type: z.string().nullable(),
  status: z.string(),
  error_message: z.string().nullable(),
  chunk_count: z.number()
});
var ragFileUploadsListResponseSchema = z.object({
  uploads: z.array(ragFileUploadRowSchema)
});
var ragUploadIngestResponseSchema = z.object({
  ok: z.literal(true),
  id: z.string(),
  chunk_count: z.number()
});
var ragDeleteUploadResponseSchema = ragOkResponseSchema;
var ragSyncedArticleRowSchema = z.object({
  source_id: z.string(),
  article_slug: z.string(),
  article_url: z.string(),
  article_updated_at: z.string(),
  chunk_count: z.number(),
  status: z.string(),
  last_error: z.string().nullable(),
  last_synced_at: z.string()
});
var ragSyncedArticlesListResponseSchema = z.object({
  articles: z.array(ragSyncedArticleRowSchema)
});
var ragSupportArticlesSyncFailureSchema = z.object({
  article_id: z.string(),
  slug: z.string(),
  error: z.string()
});
var ragSupportArticlesSyncSummarySchema = z.object({
  total: z.number(),
  inserted: z.number(),
  updated: z.number(),
  unchanged: z.number(),
  removed: z.number(),
  synced_at: z.string(),
  article_id: z.string().optional(),
  failures: z.array(ragSupportArticlesSyncFailureSchema)
});
var ragSupportArticlesSyncResponseSchema = z.object({
  ok: z.boolean(),
  summary: ragSupportArticlesSyncSummarySchema
});
var ragSupportArticlesSyncOptionsSchema = z.object({
  articleId: z.string().optional(),
  force: z.boolean().optional()
});

// src/automacoes/index.ts
var automacoes_exports = {};
__export(automacoes_exports, {
  TEMPORAL_TRIGGER_EVENTS: () => TEMPORAL_TRIGGER_EVENTS,
  adicionarInteresseConfigSchema: () => adicionarInteresseConfigSchema,
  adicionarInteresseTipoSchema: () => adicionarInteresseTipoSchema,
  adicionarTagConfigSchema: () => adicionarTagConfigSchema,
  agendamentoModoSchema: () => agendamentoModoSchema,
  aguardarConfigSchema: () => aguardarConfigSchema,
  aguardarDataConfigSchema: () => aguardarDataConfigSchema,
  aguardarDataModoSchema: () => aguardarDataModoSchema,
  alterarQualificacaoConfigSchema: () => alterarQualificacaoConfigSchema,
  atribuirAgenteIaConfigSchema: () => atribuirAgenteIaConfigSchema,
  atribuirLeadCorretorConfigSchema: () => atribuirLeadCorretorConfigSchema,
  atualizarCampoContatoConfigSchema: () => atualizarCampoContatoConfigSchema,
  automacaoExecucaoSchema: () => automacaoExecucaoSchema,
  automacaoFormSchema: () => automacaoFormSchema,
  automacaoOpcoesAvancadasSchema: () => automacaoOpcoesAvancadasSchema,
  automacaoSchema: () => automacaoSchema,
  automacaoStatusSchema: () => automacaoStatusSchema,
  automacaoStepSchema: () => automacaoStepSchema,
  automacaoTriggerSchema: () => automacaoTriggerSchema,
  buildExecucaoDedupWhere: () => buildExecucaoDedupWhere,
  contatoCampoSchema: () => contatoCampoSchema,
  createAutomacaoRequestSchema: () => createAutomacaoRequestSchema,
  criarAtividadeConfigSchema: () => criarAtividadeConfigSchema,
  criarContatoSeAusenteConfigSchema: () => criarContatoSeAusenteConfigSchema,
  criarLeadConfigSchema: () => criarLeadConfigSchema,
  criarNegocioFunilConfigSchema: () => criarNegocioFunilConfigSchema,
  describeMatchDispatchLimits: () => describeMatchDispatchLimits,
  describeTemporalDedupRule: () => describeTemporalDedupRule,
  destinatarioConfigSchema: () => destinatarioConfigSchema,
  destinatarioTipoSchema: () => destinatarioTipoSchema,
  deveDispararAgendamentoProgramado: () => deveDispararAgendamentoProgramado,
  dispararTesteEntidadeTipoSchema: () => dispararTesteEntidadeTipoSchema,
  dispararTesteRequestSchema: () => dispararTesteRequestSchema,
  encerrarAutomacaoConfigSchema: () => encerrarAutomacaoConfigSchema,
  enviarEmailConfigSchema: () => enviarEmailConfigSchema,
  enviarWhatsappConfigSchema: () => enviarWhatsappConfigSchema,
  etiquetaConversaConfigSchema: () => etiquetaConversaConfigSchema,
  execucaoListStatsSchema: () => execucaoListStatsSchema,
  execucaoPassoSchema: () => execucaoPassoSchema,
  execucaoPassoStatusSchema: () => execucaoPassoStatusSchema,
  execucaoPeriodoSchema: () => execucaoPeriodoSchema,
  execucaoStatusSchema: () => execucaoStatusSchema,
  fecharConversaConfigSchema: () => fecharConversaConfigSchema,
  getAutomacaoResponseSchema: () => getAutomacaoResponseSchema,
  getExecucaoResponseSchema: () => getExecucaoResponseSchema,
  getExecutarUmaVezPorRegistroUiHelp: () => getExecutarUmaVezPorRegistroUiHelp,
  horarioComercialModoSchema: () => horarioComercialModoSchema,
  listAutomacoesQuerySchema: () => listAutomacoesQuerySchema,
  listAutomacoesResponseSchema: () => listAutomacoesResponseSchema,
  listExecucoesQuerySchema: () => listExecucoesQuerySchema,
  listExecucoesResponseSchema: () => listExecucoesResponseSchema,
  marcarLeadPendenteConfigSchema: () => marcarLeadPendenteConfigSchema,
  marcarLeadPerdidoConfigSchema: () => marcarLeadPerdidoConfigSchema,
  marcarLeadQualificadoConfigSchema: () => marcarLeadQualificadoConfigSchema,
  marcarNegocioGanhoConfigSchema: () => marcarNegocioGanhoConfigSchema,
  marcarNegocioPerdidoConfigSchema: () => marcarNegocioPerdidoConfigSchema,
  moverEtapaConfigSchema: () => moverEtapaConfigSchema,
  notificarCorretorConfigSchema: () => notificarCorretorConfigSchema,
  pausarAgenteConfigSchema: () => pausarAgenteConfigSchema,
  pausarNegocioConfigSchema: () => pausarNegocioConfigSchema,
  pularProximoCondicaoSchema: () => pularProximoCondicaoSchema,
  pularProximoSeConfigSchema: () => pularProximoSeConfigSchema,
  redistribuirLeadConfigSchema: () => redistribuirLeadConfigSchema,
  redistribuirLeadModoSchema: () => redistribuirLeadModoSchema,
  removerSegmentoConfigSchema: () => removerSegmentoConfigSchema,
  resolveAutomacaoDedupPolicy: () => resolveAutomacaoDedupPolicy,
  retomarAgenteConfigSchema: () => retomarAgenteConfigSchema,
  retomarNegocioConfigSchema: () => retomarNegocioConfigSchema,
  rodadaIdAgendamento: () => rodadaIdAgendamento,
  startOfUtcDay: () => startOfUtcDay,
  startOfUtcYear: () => startOfUtcYear,
  stepTypeSchema: () => stepTypeSchema,
  transferirConversaConfigSchema: () => transferirConversaConfigSchema,
  triggerCategorySchema: () => triggerCategorySchema,
  triggerConfigSchema: () => triggerConfigSchema,
  triggerDurationUnidadeSchema: () => triggerDurationUnidadeSchema,
  triggerEventSchema: () => triggerEventSchema,
  updateAutomacaoRequestSchema: () => updateAutomacaoRequestSchema,
  zonedParts: () => zonedParts
});

// src/automacoes/dedup.ts
var TEMPORAL_TRIGGER_EVENTS = /* @__PURE__ */ new Set([
  "contato_aniversario",
  "lead_sem_atendimento",
  "etapa_estagnada",
  "tarefa_vencida",
  "chave_expirando",
  "chave_expirada",
  "proposta_expirando",
  "proposta_expirada",
  "conversa_sem_resposta",
  "sla_sem_resposta_humana",
  "janela_24h_expirando",
  "negocio_pausado",
  "negocio_sem_responsavel",
  "lead_frio",
  "qualificacao_baixa",
  "agendamento_programado"
]);
var MS_HORA = 60 * 60 * 1e3;
var MS_DIA = 24 * MS_HORA;
function duracaoMs(quantidade, unidade) {
  const q = Math.max(1, quantidade);
  switch (unidade) {
    case "minutos":
      return q * 60 * 1e3;
    case "horas":
      return q * MS_HORA;
    case "dias":
    default:
      return q * MS_DIA;
  }
}
function startOfUtcDay(date) {
  return new Date(
    Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())
  );
}
function startOfUtcYear(date) {
  return new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
}
function formatDuracaoLabel(quantidade, unidade) {
  if (unidade === "minutos") {
    return quantidade === 1 ? "1 minuto" : `${quantidade} minutos`;
  }
  if (unidade === "horas") {
    return quantidade === 1 ? "1 hora" : `${quantidade} horas`;
  }
  return quantidade === 1 ? "1 dia" : `${quantidade} dias`;
}
function describeTemporalDedupRule(evento, triggerConfig) {
  switch (evento) {
    case "contato_aniversario":
      return "no m\xE1ximo 1\xD7 por ano civil por contato";
    case "lead_sem_atendimento":
      return "no m\xE1ximo 1\xD7 a cada 24 horas por lead enquanto continuar sem atendimento";
    case "tarefa_vencida":
      return "no m\xE1ximo 1\xD7 a cada 24 horas por neg\xF3cio enquanto a tarefa estiver vencida";
    case "etapa_estagnada": {
      const q = triggerConfig.quantidade ?? 7;
      const u = triggerConfig.unidade ?? "dias";
      return `no m\xE1ximo 1\xD7 a cada ${formatDuracaoLabel(q, u)} por neg\xF3cio enquanto estiver estagnado`;
    }
    case "chave_expirando":
      return "no m\xE1ximo 1\xD7 por dia por contato enquanto a chave estiver expirando";
    case "chave_expirada":
      return "no m\xE1ximo 1\xD7 por dia por contato enquanto a chave estiver expirada";
    case "proposta_expirando":
      return "no m\xE1ximo 1\xD7 por dia por neg\xF3cio enquanto a proposta estiver expirando";
    case "proposta_expirada":
      return "no m\xE1ximo 1\xD7 por dia por neg\xF3cio enquanto a proposta estiver expirada";
    case "conversa_sem_resposta":
      return "no m\xE1ximo 1\xD7 a cada 24 horas por conversa enquanto continuar sem resposta";
    case "sla_sem_resposta_humana":
      return "no m\xE1ximo 1\xD7 a cada 24 horas por conversa enquanto o SLA humano continuar estourado";
    case "janela_24h_expirando":
      return "no m\xE1ximo 1\xD7 por janela de 24h por conversa (lembrete antes da expira\xE7\xE3o)";
    case "negocio_pausado":
      return "no m\xE1ximo 1\xD7 a cada intervalo configurado por neg\xF3cio pausado";
    case "negocio_sem_responsavel":
      return "no m\xE1ximo 1\xD7 a cada 24 horas por neg\xF3cio sem respons\xE1vel";
    case "lead_frio":
      return "no m\xE1ximo 1\xD7 a cada intervalo configurado por lead frio";
    case "qualificacao_baixa":
      return "no m\xE1ximo 1\xD7 a cada intervalo configurado por neg\xF3cio com baixa qualifica\xE7\xE3o";
    case "agendamento_programado":
      return "1\xD7 por rodada (data/hora ou dia+hora) por contato do segmento";
    default:
      return "intervalo autom\xE1tico definido pelo sistema";
  }
}
function getExecutarUmaVezPorRegistroUiHelp(params) {
  if (TEMPORAL_TRIGGER_EVENTS.has(params.evento)) {
    const regra = describeTemporalDedupRule(
      params.evento,
      params.triggerConfig
    );
    return {
      isTemporal: true,
      subtitle: `Gatilho temporal: ${regra}. Esta op\xE7\xE3o n\xE3o se aplica.`,
      tooltipTitle: "Gatilho temporal \u2014 regra autom\xE1tica",
      tooltipBody: `Automa\xE7\xF5es com gatilho temporal s\xE3o verificadas periodicamente (cron) e n\xE3o usam a op\xE7\xE3o "Executar uma vez por registro".

Regra deste gatilho: ${regra}.`
    };
  }
  if (params.evento === "match_criado") {
    const limites = describeMatchDispatchLimits(params.triggerConfig);
    if (limites) {
      return {
        isTemporal: false,
        subtitle: `Match: ${limites}. Esta op\xE7\xE3o \xE9 ignorada enquanto esses limites estiverem configurados.`,
        tooltipTitle: "Limites de disparo de match",
        tooltipBody: `Para o gatilho "Novo match", o motor usa max. de disparos e intervalo em dias configurados no gatilho (${limites}), em vez de "Executar uma vez por registro".`
      };
    }
  }
  return {
    isTemporal: false,
    subtitle: "Evita reexecu\xE7\xE3o para o mesmo contato, lead ou neg\xF3cio.",
    tooltipTitle: "Executar uma vez por registro",
    tooltipBody: "Ativa: a automa\xE7\xE3o roda apenas uma vez por registro (contato, lead ou neg\xF3cio), mesmo que o gatilho dispare novamente.\n\nDesativada: cada novo evento gera uma nova execu\xE7\xE3o."
  };
}
function describeMatchDispatchLimits(triggerConfig) {
  const partes = [];
  if (typeof triggerConfig.maxDisparos === "number" && triggerConfig.maxDisparos > 0) {
    partes.push(
      `m\xE1ximo ${triggerConfig.maxDisparos} disparo${triggerConfig.maxDisparos === 1 ? "" : "s"} por contato`
    );
  }
  if (typeof triggerConfig.intervaloDias === "number" && triggerConfig.intervaloDias > 0) {
    partes.push(
      `intervalo m\xEDnimo de ${triggerConfig.intervaloDias} dia${triggerConfig.intervaloDias === 1 ? "" : "s"}`
    );
  }
  return partes.length > 0 ? partes.join("; ") : null;
}
function resolveAutomacaoDedupPolicy(params) {
  const now = params.now ?? /* @__PURE__ */ new Date();
  if (!TEMPORAL_TRIGGER_EVENTS.has(params.evento)) {
    if (params.executarUmaVezPorRegistro) {
      return { mode: "lifetime", reason: "executarUmaVezPorRegistro" };
    }
    return { mode: "none" };
  }
  switch (params.evento) {
    case "contato_aniversario":
      return {
        mode: "since",
        since: startOfUtcYear(now),
        reason: "aniversario_por_ano"
      };
    case "lead_sem_atendimento":
    case "tarefa_vencida":
    case "conversa_sem_resposta":
    case "sla_sem_resposta_humana":
      return {
        mode: "since",
        since: new Date(now.getTime() - MS_DIA),
        reason: "lembrete_diario"
      };
    case "janela_24h_expirando":
      return {
        mode: "since",
        since: new Date(now.getTime() - MS_DIA),
        reason: "janela_24h"
      };
    case "etapa_estagnada":
      return {
        mode: "since",
        since: new Date(
          now.getTime() - duracaoMs(
            params.triggerConfig.quantidade ?? 7,
            params.triggerConfig.unidade ?? "dias"
          )
        ),
        reason: "intervalo_estagnacao"
      };
    case "chave_expirando":
    case "chave_expirada":
    case "proposta_expirando":
    case "proposta_expirada":
      return {
        mode: "since",
        since: startOfUtcDay(now),
        reason: "lembrete_dia"
      };
    case "negocio_pausado":
    case "lead_frio":
    case "qualificacao_baixa":
      return {
        mode: "since",
        since: new Date(
          now.getTime() - duracaoMs(
            params.triggerConfig.quantidade ?? 7,
            params.triggerConfig.unidade ?? "dias"
          )
        ),
        reason: "intervalo_temporal"
      };
    case "negocio_sem_responsavel":
      return {
        mode: "since",
        since: new Date(now.getTime() - MS_DIA),
        reason: "lembrete_diario"
      };
    case "agendamento_programado": {
      const modo = params.triggerConfig.agendamentoModo;
      if (modo === "unico") {
        return { mode: "lifetime", reason: "agendamento_unico" };
      }
      return {
        mode: "since",
        since: startOfUtcDay(now),
        reason: "agendamento_rodada"
      };
    }
    default:
      return { mode: "none" };
  }
}
function buildExecucaoDedupWhere(params) {
  const base = {
    automacaoId: params.automacaoId,
    entidadeTipo: params.entidadeTipo,
    entidadeId: params.entidadeId
  };
  if (params.policy.mode === "since") {
    return { ...base, createdAt: { gte: params.policy.since } };
  }
  return base;
}

// src/automacoes/agendamento.ts
var DEFAULT_FUSO = "America/Sao_Paulo";
function zonedParts(date, timeZone) {
  const fmt = new Intl.DateTimeFormat("en-US", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    weekday: "short"
  });
  const parts = fmt.formatToParts(date);
  const get = (type) => parts.find((p) => p.type === type)?.value ?? "0";
  const weekdayMap = {
    Sun: 0,
    Mon: 1,
    Tue: 2,
    Wed: 3,
    Thu: 4,
    Fri: 5,
    Sat: 6
  };
  const weekdayStr = get("weekday");
  return {
    year: Number(get("year")),
    month: Number(get("month")),
    day: Number(get("day")),
    hour: Number(get("hour")) % 24,
    minute: Number(get("minute")),
    weekday: weekdayMap[weekdayStr] ?? 0
  };
}
function parseHora(hora) {
  const m = /^(\d{1,2}):(\d{2})$/.exec(hora.trim());
  if (!m) return null;
  const hour = Number(m[1]);
  const minute = Number(m[2]);
  if (hour < 0 || hour > 23 || minute < 0 || minute > 59) return null;
  return { hour, minute };
}
function deveDispararAgendamentoProgramado(config, now = /* @__PURE__ */ new Date(), toleranciaMs = 2 * 60 * 1e3) {
  const modo = config.agendamentoModo ?? "unico";
  const fuso = config.fuso?.trim() || DEFAULT_FUSO;
  if (modo === "unico") {
    if (!config.dataHora?.trim()) return false;
    const alvo = new Date(config.dataHora);
    if (Number.isNaN(alvo.getTime())) return false;
    const diff = now.getTime() - alvo.getTime();
    return diff >= 0 && diff < toleranciaMs;
  }
  const parsed = parseHora(config.hora ?? "");
  if (!parsed) return false;
  const z61 = zonedParts(now, fuso);
  if (z61.hour !== parsed.hour || z61.minute !== parsed.minute) return false;
  if (modo === "diario") return true;
  const dias = Array.isArray(config.diasSemana) ? config.diasSemana : [];
  return dias.includes(z61.weekday);
}
function rodadaIdAgendamento(config, now = /* @__PURE__ */ new Date()) {
  const modo = config.agendamentoModo ?? "unico";
  const fuso = config.fuso?.trim() || DEFAULT_FUSO;
  if (modo === "unico" && config.dataHora) {
    const d = new Date(config.dataHora);
    if (!Number.isNaN(d.getTime())) return d.toISOString().slice(0, 16);
  }
  const z61 = zonedParts(now, fuso);
  const hora = config.hora?.trim() || `${String(z61.hour).padStart(2, "0")}:${String(z61.minute).padStart(2, "0")}`;
  const ymd = `${z61.year}-${String(z61.month).padStart(2, "0")}-${String(z61.day).padStart(2, "0")}`;
  return `${ymd}T${hora}`;
}

// src/automacoes/index.ts
var triggerCategorySchema = z.enum([
  "contato",
  "lead",
  "oportunidade",
  "tarefas",
  "imoveis",
  /** Match perfil de interesse × imóvel. */
  "matches",
  "chaves",
  "propostas",
  "conversas",
  /** Disparo por data/hora ou recorrência (cron). */
  "agendamento"
]);
var triggerEventSchema = z.enum([
  "contato_criado",
  "tag_adicionada",
  "tag_removida",
  "contato_aniversario",
  "lead_captado",
  "lead_qualificado",
  "lead_perdido",
  "lead_sem_atendimento",
  /** Lead criado com telefone/contato já existente (`duplicado=true`). */
  "lead_duplicado",
  /** Lead sem origem preenchida no momento da captura. */
  "lead_sem_origem",
  /** Lead/contato sem atividade (mensagem/tarefa) há X tempo — cron. */
  "lead_frio",
  "oportunidade_criada",
  "etapa_alterada",
  "oportunidade_ganho",
  "oportunidade_perdido",
  "tarefa_criada",
  "tarefa_concluida",
  "tarefa_vencida",
  "imovel_status_alterado",
  /**
   * Novo match entre perfil de interesse do contato e um imóvel.
   * Config: scoreMinimo, maxDisparos, intervaloDias.
   */
  "match_criado",
  "etapa_estagnada",
  /** Negócio com status Pausado há X tempo — cron. */
  "negocio_pausado",
  /** Negócio sem responsável atribuído — cron / criação. */
  "negocio_sem_responsavel",
  /** Qualificação (estrelas) baixa há X dias — cron. */
  "qualificacao_baixa",
  "chave_retirada",
  "chave_expirando",
  "chave_expirada",
  "chave_devolvida",
  "proposta_criada",
  "proposta_aceita",
  "proposta_recusada",
  "proposta_expirando",
  "proposta_expirada",
  // Conversas (WhatsApp + agentes)
  "conversa_iniciada",
  "conversa_finalizada",
  "conversa_arquivada",
  "conversa_etiqueta_adicionada",
  "conversa_etiqueta_removida",
  "mensagem_recebida",
  "primeira_mensagem_contato",
  "conversa_sem_resposta",
  "sla_sem_resposta_humana",
  "janela_24h_expirando",
  "conversa_reaberta",
  "humano_assumiu",
  "conversa_transferida",
  /** Humano devolveu a conversa ao agente de IA. */
  "agente_transferiu",
  /** Agente de IA transferiu / escalou para atendimento humano. */
  "agente_transferiu_humano",
  "agente_respondeu",
  "primeira_resposta_ia",
  "imovel_compartilhado_conversa",
  "empreendimento_compartilhado_conversa",
  "visita_agendada_chat",
  "visita_realizada_chat",
  "visita_no_show_chat",
  /** Contato enviou mídia (imagem/áudio/vídeo/documento). */
  "mensagem_midia_recebida",
  /** Contato pediu opt-out (ex.: "parar", "stop"). */
  "opt_out_recebido",
  /**
   * Mensagem inbound recebida fora do horário comercial do dashboard.
   * Útil para auto-resposta + tarefa para o próximo expediente.
   */
  "mensagem_fora_horario",
  /**
   * Disparo programado (one-shot ou recorrente diário/semanal).
   * Público-alvo: segmento em `config.segmentoId`.
   */
  "agendamento_programado"
]);
var agendamentoModoSchema = z.enum(["unico", "diario", "semanal"]);
var triggerDurationUnidadeSchema = z.enum(["minutos", "horas", "dias"]);
var triggerConfigSchema = z.object({
  quantidade: z.number().optional(),
  unidade: triggerDurationUnidadeSchema.optional(),
  funilId: z.string().optional(),
  funilNome: z.string().optional(),
  funilIds: z.array(z.number().int()).optional(),
  funilNomes: z.array(z.string()).optional(),
  etapaId: z.string().optional(),
  etapaNome: z.string().optional(),
  etapaDestinoId: z.string().optional(),
  etapaDestinoNome: z.string().optional(),
  segmentoId: z.string().optional(),
  segmentoNome: z.string().optional(),
  tipoTarefa: z.string().optional(),
  acaoValue: z.string().optional(),
  acaoLabel: z.string().optional(),
  statusDestino: z.array(z.string()).optional(),
  diasAntes: z.number().int().min(0).optional(),
  responsavelIds: z.array(z.number().int()).optional(),
  responsavelNomes: z.array(z.string()).optional(),
  finalidades: z.array(z.string()).optional(),
  imovelIds: z.array(z.number().int()).optional(),
  imovelNomes: z.array(z.string()).optional(),
  empreendimentoIds: z.array(z.number().int()).optional(),
  empreendimentoNomes: z.array(z.string()).optional(),
  /** Etiqueta de conversa (ConversationLabel.id como string). */
  labelId: z.string().optional(),
  labelNome: z.string().optional(),
  /** Canal / instância (ChannelInstance.id). */
  channelInstanceId: z.number().int().optional(),
  channelInstanceNome: z.string().optional(),
  /**
   * Motivo da transferência IA→humano (`agente_transferiu_humano`).
   * Ex.: sem_rag | keyword | confianca | resposta_escalar
   */
  motivoTransferencia: z.string().optional(),
  motivosTransferencia: z.array(z.string()).optional(),
  /**
   * Qualificação máxima (estrelas) para `qualificacao_baixa`.
   * Dispara quando `oportunidade.qualificacao <= qualificacaoMax`.
   */
  qualificacaoMax: z.number().int().min(0).max(5).optional(),
  /**
   * Score mínimo de relevância (0–100) para `match_criado`.
   * Dispara quando `payload.scoreRelevancia >= scoreMinimo`.
   */
  scoreMinimo: z.number().min(0).max(100).optional(),
  /**
   * Máximo de disparos automáticos por contato nesta automação (`match_criado`).
   */
  maxDisparos: z.number().int().min(1).max(50).optional(),
  /**
   * Intervalo mínimo em dias entre disparos ao mesmo contato (`match_criado`).
   */
  intervaloDias: z.number().int().min(0).max(365).optional(),
  /** Palavras-chave de opt-out (default: parar, stop, sair). */
  optOutKeywords: z.array(z.string()).optional(),
  /**
   * Modo do gatilho `agendamento_programado`.
   * - unico: dispara uma vez em `dataHora`
   * - diario: todo dia em `hora` (HH:mm)
   * - semanal: nos `diasSemana` (0=dom…6=sáb) em `hora`
   */
  agendamentoModo: agendamentoModoSchema.optional(),
  /** ISO datetime para modo `unico`. */
  dataHora: z.string().optional(),
  /** Horário local HH:mm para diario/semanal. */
  hora: z.string().optional(),
  /** Dias da semana (0–6) para modo semanal. */
  diasSemana: z.array(z.number().int().min(0).max(6)).optional(),
  /** IANA timezone (default America/Sao_Paulo). */
  fuso: z.string().optional()
}).passthrough().default({});
var automacaoTriggerSchema = z.object({
  categoria: triggerCategorySchema,
  evento: triggerEventSchema,
  config: triggerConfigSchema
});
var stepTypeSchema = z.enum([
  "criar_atividade",
  "aguardar",
  "aguardar_data",
  "enviar_whatsapp",
  "enviar_email",
  "mover_etapa",
  "adicionar_tag",
  "remover_segmento",
  "notificar_corretor",
  "marcar_lead_qualificado",
  "marcar_lead_perdido",
  "marcar_lead_pendente",
  "criar_negocio_funil",
  "atribuir_lead_corretor",
  "redistribuir_lead",
  "marcar_negocio_ganho",
  "marcar_negocio_perdido",
  "alterar_qualificacao",
  "adicionar_interesse",
  "pausar_negocio",
  "retomar_negocio",
  "atualizar_campo_contato",
  "encerrar_automacao",
  "pular_proximo_se",
  // Conversas / CRM / agentes
  "criar_lead",
  "atribuir_agente_ia",
  "adicionar_etiqueta_conversa",
  "remover_etiqueta_conversa",
  "fechar_conversa",
  "transferir_conversa",
  "criar_contato_se_ausente",
  "pausar_agente",
  "retomar_agente"
]);
var baseStepSchema = z.object({
  id: z.string(),
  tipo: stepTypeSchema,
  label: z.string().optional()
});
var criarAtividadeConfigSchema = z.object({
  titulo: z.string().min(1),
  tipo: z.enum(["ligacao", "visita", "reuniao", "tarefa", "email"]),
  prazoDias: z.number().int().min(0).default(1),
  descricao: z.string().optional()
});
var aguardarConfigSchema = z.object({
  quantidade: z.number().int().min(1),
  unidade: z.enum(["minutos", "horas", "dias"])
});
var destinatarioTipoSchema = z.enum([
  "contato",
  "responsavel",
  "membro",
  "fixo"
]);
var destinatarioConfigSchema = z.object({
  destinatarioTipo: destinatarioTipoSchema.default("contato"),
  membroId: z.number().int().optional(),
  membroNome: z.string().optional(),
  telefoneFixo: z.string().optional(),
  emailFixo: z.string().optional()
});
var enviarWhatsappConfigSchema = destinatarioConfigSchema.extend({
  templateId: z.string().min(1),
  templateNome: z.string().optional(),
  whatsappInstanceId: z.number().int().optional(),
  whatsappInstanceNome: z.string().optional()
});
var enviarEmailConfigSchema = destinatarioConfigSchema.extend({
  templateId: z.string().min(1),
  templateNome: z.string().optional(),
  assunto: z.string().optional()
});
var moverEtapaConfigSchema = z.object({
  funilId: z.string().min(1),
  funilNome: z.string().optional(),
  etapaId: z.string().min(1),
  etapaNome: z.string().optional()
});
var adicionarTagConfigSchema = z.object({
  segmentoId: z.string().min(1),
  segmentoNome: z.string().optional()
});
var notificarCorretorConfigSchema = z.object({
  mensagem: z.string().min(1),
  canal: z.enum(["app", "email", "whatsapp"]).default("app")
});
var marcarLeadQualificadoConfigSchema = z.object({
  comentario: z.string().optional()
});
var marcarLeadPerdidoConfigSchema = z.object({
  motivoPerdaId: z.number().int().optional(),
  motivoPerdaNome: z.string().optional(),
  comentarioPerda: z.string().optional()
});
var marcarLeadPendenteConfigSchema = z.object({
  nota: z.string().optional()
});
var criarNegocioFunilConfigSchema = z.object({
  funilId: z.string().min(1),
  funilNome: z.string().optional(),
  etapaId: z.string().min(1),
  etapaNome: z.string().optional(),
  titulo: z.string().optional()
});
var atribuirLeadCorretorConfigSchema = z.object({
  corretorId: z.number().int(),
  corretorNome: z.string().optional()
});
var redistribuirLeadModoSchema = z.enum(["fila", "manual"]);
var redistribuirLeadConfigSchema = z.object({
  modo: redistribuirLeadModoSchema.optional(),
  corretorId: z.number().int().optional(),
  corretorNome: z.string().optional()
});
var marcarNegocioGanhoConfigSchema = z.object({
  comentario: z.string().optional()
});
var marcarNegocioPerdidoConfigSchema = z.object({
  motivoPerdaId: z.number().int().optional(),
  motivoPerdaNome: z.string().optional(),
  comentarioPerda: z.string().optional()
});
var alterarQualificacaoConfigSchema = z.object({
  qualificacao: z.number().int().min(0).max(5)
});
var adicionarInteresseTipoSchema = z.enum(["imovel", "empreendimento"]);
var adicionarInteresseConfigSchema = z.object({
  tipo: adicionarInteresseTipoSchema,
  imovelId: z.number().int().optional(),
  imovelNome: z.string().optional(),
  empreendimentoId: z.number().int().optional(),
  empreendimentoNome: z.string().optional()
});
var pausarNegocioConfigSchema = z.object({});
var retomarNegocioConfigSchema = z.object({});
var removerSegmentoConfigSchema = z.object({
  segmentoId: z.string().min(1),
  segmentoNome: z.string().optional()
});
var contatoCampoSchema = z.enum(["observacao", "nota"]);
var atualizarCampoContatoConfigSchema = z.object({
  campo: contatoCampoSchema,
  valor: z.string().min(1)
});
var encerrarAutomacaoConfigSchema = z.object({
  motivo: z.string().optional()
});
var pularProximoCondicaoSchema = z.enum([
  "respondeu_whatsapp",
  "abriu_email",
  "ja_qualificado",
  "tem_lead",
  "tem_etiqueta",
  "ia_ativa",
  "horario_comercial",
  /**
   * Verdadeira quando NÃO houve mensagem (inbound nem outbound) na conversa
   * no período configurado — base da cadência “próximo toque só se sem resposta”.
   */
  "sem_mensagem",
  /** Contato pertence ao segmento/tag informado. */
  "tem_segmento",
  /** Negócio saiu da etapa de origem do gatilho (contexto da execução). */
  "mudou_etapa",
  /** Negócio está Ganho. */
  "negocio_ganho",
  /** Negócio está Perdido. */
  "negocio_perdido"
]);
var horarioComercialModoSchema = z.enum(["dentro", "fora"]);
var pularProximoSeConfigSchema = z.object({
  condicao: pularProximoCondicaoSchema,
  /** Usado quando `condicao === 'tem_etiqueta'` (ConversationLabel.id). */
  labelId: z.string().optional(),
  labelNome: z.string().optional(),
  /** Usado quando `condicao === 'tem_segmento'` (Segmento.id). */
  segmentoId: z.string().optional(),
  segmentoNome: z.string().optional(),
  /**
   * Janela para `sem_mensagem` (default: desde o início da execução).
   * Se omitido, usa `iniciadoEm` da execução.
   */
  janelaQuantidade: z.number().int().min(1).optional(),
  janelaUnidade: z.enum(["minutos", "horas", "dias"]).optional(),
  /**
   * Usado quando `condicao === 'horario_comercial'`.
   * `dentro` = condição verdadeira dentro do expediente; `fora` = fora.
   * Sem override de janela, reutiliza `dashboard.horariosComerciais`.
   */
  horarioComercialModo: horarioComercialModoSchema.optional(),
  horarioDiasSemana: z.array(z.number().int().min(0).max(6)).optional(),
  horarioHoraInicio: z.string().optional(),
  horarioHoraFim: z.string().optional(),
  horarioFuso: z.string().optional()
});
var criarLeadConfigSchema = z.object({
  finalidade: z.string().optional(),
  origem: z.string().optional()
});
var atribuirAgenteIaConfigSchema = z.object({
  /** Canal onde a conversa deve existir / ser criada (obrigatório se entidade ≠ conversa). */
  channelInstanceId: z.number().int().optional(),
  channelInstanceNome: z.string().optional()
});
var etiquetaConversaConfigSchema = z.object({
  labelId: z.string().min(1),
  labelNome: z.string().optional()
});
var fecharConversaConfigSchema = z.object({});
var transferirConversaConfigSchema = z.object({
  responsavelId: z.number().int(),
  responsavelNome: z.string().optional()
});
var criarContatoSeAusenteConfigSchema = z.object({
  nome: z.string().optional()
});
var pausarAgenteConfigSchema = z.object({});
var retomarAgenteConfigSchema = z.object({});
var aguardarDataModoSchema = z.enum(["dataHora", "diasRelativos"]);
var aguardarDataConfigSchema = z.object({
  modo: aguardarDataModoSchema.default("diasRelativos"),
  dataHora: z.string().optional(),
  diasRelativos: z.number().int().min(0).optional()
});
var automacaoStepSchema = z.discriminatedUnion("tipo", [
  baseStepSchema.extend({
    tipo: z.literal("criar_atividade"),
    config: criarAtividadeConfigSchema
  }),
  baseStepSchema.extend({
    tipo: z.literal("aguardar"),
    config: aguardarConfigSchema
  }),
  baseStepSchema.extend({
    tipo: z.literal("aguardar_data"),
    config: aguardarDataConfigSchema
  }),
  baseStepSchema.extend({
    tipo: z.literal("enviar_whatsapp"),
    config: enviarWhatsappConfigSchema
  }),
  baseStepSchema.extend({
    tipo: z.literal("enviar_email"),
    config: enviarEmailConfigSchema
  }),
  baseStepSchema.extend({
    tipo: z.literal("mover_etapa"),
    config: moverEtapaConfigSchema
  }),
  baseStepSchema.extend({
    tipo: z.literal("adicionar_tag"),
    config: adicionarTagConfigSchema
  }),
  baseStepSchema.extend({
    tipo: z.literal("remover_segmento"),
    config: removerSegmentoConfigSchema
  }),
  baseStepSchema.extend({
    tipo: z.literal("notificar_corretor"),
    config: notificarCorretorConfigSchema
  }),
  baseStepSchema.extend({
    tipo: z.literal("marcar_lead_qualificado"),
    config: marcarLeadQualificadoConfigSchema
  }),
  baseStepSchema.extend({
    tipo: z.literal("marcar_lead_perdido"),
    config: marcarLeadPerdidoConfigSchema
  }),
  baseStepSchema.extend({
    tipo: z.literal("marcar_lead_pendente"),
    config: marcarLeadPendenteConfigSchema
  }),
  baseStepSchema.extend({
    tipo: z.literal("criar_negocio_funil"),
    config: criarNegocioFunilConfigSchema
  }),
  baseStepSchema.extend({
    tipo: z.literal("atribuir_lead_corretor"),
    config: atribuirLeadCorretorConfigSchema
  }),
  baseStepSchema.extend({
    tipo: z.literal("redistribuir_lead"),
    config: redistribuirLeadConfigSchema
  }),
  baseStepSchema.extend({
    tipo: z.literal("marcar_negocio_ganho"),
    config: marcarNegocioGanhoConfigSchema
  }),
  baseStepSchema.extend({
    tipo: z.literal("marcar_negocio_perdido"),
    config: marcarNegocioPerdidoConfigSchema
  }),
  baseStepSchema.extend({
    tipo: z.literal("alterar_qualificacao"),
    config: alterarQualificacaoConfigSchema
  }),
  baseStepSchema.extend({
    tipo: z.literal("adicionar_interesse"),
    config: adicionarInteresseConfigSchema
  }),
  baseStepSchema.extend({
    tipo: z.literal("pausar_negocio"),
    config: pausarNegocioConfigSchema
  }),
  baseStepSchema.extend({
    tipo: z.literal("retomar_negocio"),
    config: retomarNegocioConfigSchema
  }),
  baseStepSchema.extend({
    tipo: z.literal("atualizar_campo_contato"),
    config: atualizarCampoContatoConfigSchema
  }),
  baseStepSchema.extend({
    tipo: z.literal("encerrar_automacao"),
    config: encerrarAutomacaoConfigSchema
  }),
  baseStepSchema.extend({
    tipo: z.literal("pular_proximo_se"),
    config: pularProximoSeConfigSchema
  }),
  baseStepSchema.extend({
    tipo: z.literal("criar_lead"),
    config: criarLeadConfigSchema
  }),
  baseStepSchema.extend({
    tipo: z.literal("atribuir_agente_ia"),
    config: atribuirAgenteIaConfigSchema
  }),
  baseStepSchema.extend({
    tipo: z.literal("adicionar_etiqueta_conversa"),
    config: etiquetaConversaConfigSchema
  }),
  baseStepSchema.extend({
    tipo: z.literal("remover_etiqueta_conversa"),
    config: etiquetaConversaConfigSchema
  }),
  baseStepSchema.extend({
    tipo: z.literal("fechar_conversa"),
    config: fecharConversaConfigSchema
  }),
  baseStepSchema.extend({
    tipo: z.literal("transferir_conversa"),
    config: transferirConversaConfigSchema
  }),
  baseStepSchema.extend({
    tipo: z.literal("criar_contato_se_ausente"),
    config: criarContatoSeAusenteConfigSchema
  }),
  baseStepSchema.extend({
    tipo: z.literal("pausar_agente"),
    config: pausarAgenteConfigSchema
  }),
  baseStepSchema.extend({
    tipo: z.literal("retomar_agente"),
    config: retomarAgenteConfigSchema
  })
]);
var automacaoStatusSchema = z.enum(["ativa", "pausada", "rascunho"]);
var automacaoOpcoesAvancadasSchema = z.object({
  executarUmaVezPorRegistro: z.boolean().default(true),
  cancelarAoResponderWhatsapp: z.boolean().default(false),
  /** Cancela se o negócio mudar de etapa (oportunidade). */
  cancelarAoMudarEtapa: z.boolean().default(false),
  /** Cancela se o negócio for marcado como ganho. */
  cancelarAoGanho: z.boolean().default(false),
  /** Cancela se o negócio/lead for marcado como perdido. */
  cancelarAoPerdido: z.boolean().default(false),
  /** Cancela se o contato pedir opt-out (keyword). */
  cancelarAoOptOut: z.boolean().default(false),
  /**
   * Cancela se o contato entrar no segmento “não contatar”
   * (`segmentoNaoContatarId`) ou se a opção estiver ligada e o contato
   * receber qualquer tag cujo nome contenha “não contatar” / “nao contatar”.
   */
  cancelarAoSegmentoNaoContatar: z.boolean().default(false),
  segmentoNaoContatarId: z.string().optional(),
  segmentoNaoContatarNome: z.string().optional(),
  respeitarHorarioComercial: z.boolean().default(true),
  /**
   * Após N toques de comunicação (`enviar_whatsapp` / `enviar_email`)
   * sem resposta, o processor encerra a execução com erro informativo
   * e permite que o próximo passo pós-cadência (ex.: notificar gestor)
   * seja modelado via `pular_proximo_se` + `encerrar` — ou use o preset.
   * Reservado para telemetria / UI; a cadência em si é composta por passos.
   */
  maxTentativasSemResposta: z.number().int().min(1).max(20).optional(),
  /**
   * ISO datetime: a automação só dispara a partir deste instante
   * (“começar a valer a partir de…”). Aplicável a qualquer gatilho.
   */
  ativaAPartirDe: z.string().optional()
});
var automacaoSchema = z.object({
  id: z.string(),
  nome: z.string().min(1),
  status: automacaoStatusSchema,
  trigger: automacaoTriggerSchema,
  passos: z.array(automacaoStepSchema),
  opcoes: automacaoOpcoesAvancadasSchema.default({
    executarUmaVezPorRegistro: true,
    cancelarAoResponderWhatsapp: false,
    cancelarAoMudarEtapa: false,
    cancelarAoGanho: false,
    cancelarAoPerdido: false,
    cancelarAoOptOut: false,
    cancelarAoSegmentoNaoContatar: false,
    respeitarHorarioComercial: true
  }),
  createdAt: z.string(),
  updatedAt: z.string(),
  ultimaExecucaoEm: z.string().nullable().optional(),
  totalExecucoes: z.number().int().default(0)
});
var automacaoPayloadSchema = z.object({
  nome: z.string().min(1, "Nome \xE9 obrigat\xF3rio"),
  status: automacaoStatusSchema,
  trigger: automacaoTriggerSchema,
  passos: z.array(automacaoStepSchema),
  opcoes: automacaoOpcoesAvancadasSchema
});
function refineAutomacaoTriggerRules(data, ctx) {
  if (!data.trigger) return;
  if (data.trigger.evento === "etapa_alterada") {
    const funilId = data.trigger.config.funilId;
    if (typeof funilId !== "string" || !funilId.trim()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Selecione o funil do gatilho.",
        path: ["trigger", "config", "funilId"]
      });
    }
    const etapaDestinoId = data.trigger.config.etapaDestinoId;
    if (typeof etapaDestinoId !== "string" || !etapaDestinoId.trim()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Selecione a etapa destino do gatilho.",
        path: ["trigger", "config", "etapaDestinoId"]
      });
    }
  }
  if (data.trigger.evento === "tag_adicionada" || data.trigger.evento === "tag_removida" || data.trigger.evento === "agendamento_programado") {
    const segmentoId = data.trigger.config.segmentoId;
    if (typeof segmentoId !== "string" || !segmentoId.trim()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Selecione o segmento do gatilho.",
        path: ["trigger", "config", "segmentoId"]
      });
    }
  }
  if (data.trigger.evento === "agendamento_programado") {
    const modo = data.trigger.config.agendamentoModo ?? "unico";
    if (modo === "unico") {
      const dataHora = data.trigger.config.dataHora;
      if (typeof dataHora !== "string" || !dataHora.trim()) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Informe a data e hora do agendamento.",
          path: ["trigger", "config", "dataHora"]
        });
      }
    } else {
      const hora = data.trigger.config.hora;
      if (typeof hora !== "string" || !/^\d{2}:\d{2}$/.test(hora.trim())) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Informe o hor\xE1rio no formato HH:mm.",
          path: ["trigger", "config", "hora"]
        });
      }
      if (modo === "semanal") {
        const dias = data.trigger.config.diasSemana;
        if (!Array.isArray(dias) || dias.length === 0) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Selecione pelo menos um dia da semana.",
            path: ["trigger", "config", "diasSemana"]
          });
        }
      }
    }
  }
  if (data.trigger.evento === "conversa_etiqueta_adicionada" || data.trigger.evento === "conversa_etiqueta_removida") {
    const labelId = data.trigger.config.labelId;
    if (typeof labelId !== "string" || !labelId.trim()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Selecione a etiqueta do gatilho.",
        path: ["trigger", "config", "labelId"]
      });
    }
  }
  if (data.trigger.evento === "oportunidade_ganho" || data.trigger.evento === "oportunidade_perdido") {
    const funilIds = data.trigger.config.funilIds;
    if (!Array.isArray(funilIds) || funilIds.length === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Selecione pelo menos um funil.",
        path: ["trigger", "config", "funilIds"]
      });
    }
  }
}
function refineAutomacaoPassosRules(data, ctx) {
  if (data.status !== "ativa" && data.status !== "pausada") return;
  if (data.passos === void 0) return;
  if (data.passos.length === 0) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: "Adicione pelo menos uma a\xE7\xE3o antes de ativar a automa\xE7\xE3o.",
      path: ["passos"]
    });
  }
}
var automacaoFormSchema = automacaoPayloadSchema.superRefine(refineAutomacaoTriggerRules).superRefine(refineAutomacaoPassosRules);
var execucaoStatusSchema = z.enum([
  "em_andamento",
  "concluida",
  "falhou",
  "cancelada"
]);
var execucaoPassoStatusSchema = z.enum([
  "pendente",
  "em_andamento",
  "concluido",
  "falhou",
  "ignorado"
]);
var execucaoPassoSchema = z.object({
  id: z.string(),
  passoId: z.string(),
  tipo: stepTypeSchema,
  label: z.string(),
  status: execucaoPassoStatusSchema,
  iniciadoEm: z.string().nullable(),
  concluidoEm: z.string().nullable(),
  erro: z.string().nullable().optional()
});
var automacaoExecucaoSchema = z.object({
  id: z.string(),
  automacaoId: z.string(),
  automacaoNome: z.string(),
  status: execucaoStatusSchema,
  entidadeTipo: z.enum([
    "contato",
    "lead",
    "oportunidade",
    "negocio",
    "imovel",
    "conversa"
  ]),
  entidadeId: z.string(),
  entidadeNome: z.string(),
  iniciadoEm: z.string(),
  concluidoEm: z.string().nullable(),
  passos: z.array(execucaoPassoSchema)
});
var createAutomacaoRequestSchema = automacaoFormSchema;
var updateAutomacaoRequestSchema = automacaoPayloadSchema.partial().superRefine(refineAutomacaoTriggerRules).superRefine(refineAutomacaoPassosRules);
var listAutomacoesQuerySchema = z.object({
  search: z.string().optional(),
  status: automacaoStatusSchema.optional()
});
var execucaoPeriodoSchema = z.enum(["7d", "30d", "90d", "todos"]);
var listExecucoesQuerySchema = z.object({
  automacaoId: z.string().optional(),
  status: execucaoStatusSchema.optional(),
  periodo: execucaoPeriodoSchema.optional()
});
var listAutomacoesResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(automacaoSchema),
  message: z.string().optional(),
  total: z.number()
});
var getAutomacaoResponseSchema = dataResponse(automacaoSchema);
var execucaoListStatsSchema = z.object({
  total: z.number(),
  concluidas: z.number(),
  emAndamento: z.number(),
  falhas: z.number(),
  canceladas: z.number()
});
var listExecucoesResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(automacaoExecucaoSchema),
  message: z.string().optional(),
  total: z.number(),
  stats: execucaoListStatsSchema
});
var getExecucaoResponseSchema = dataResponse(automacaoExecucaoSchema);
var dispararTesteEntidadeTipoSchema = z.enum([
  "contato",
  "lead",
  "oportunidade",
  "imovel",
  "conversa"
]);
var dispararTesteRequestSchema = z.object({
  entidadeTipo: dispararTesteEntidadeTipoSchema.optional(),
  entidadeId: z.string().optional(),
  entidadeNome: z.string().optional(),
  payload: z.record(z.string(), z.unknown()).optional()
});

export { accessUrlDataSchema, admin_exports as admin, ai_agents_exports as aiAgents, anexoItemSchema, apiErrorResponseSchema, api_keys_exports as apiKeys, apiSuccess, audit_logs_exports as auditLogs, autentique_exports as autentique, auth_exports as auth, automacoes_exports as automacoes, booleanLike, builder_exports as builder, campanhas_exports as campanhas, campos_customizados_exports as camposCustomizados, cidadeRefSchema, comodidadeTipoParamSchema, companyTypeEnum, contatos_exports as contatos, contratacao_exports as contratacao, conversas_exports as conversas, createAnexoMetadataSchema, dashboard_exports as dashboard, dashboardIdParamSchema, data_exports as data, dataCatalogItemSchema, data_comodidades_exports as dataComodidades, dataResponse, distribuicao_leads_exports as distribuicaoLeads, documentos_digitais_exports as documentosDigitais, editorJsContentSchema, email_config_exports as emailConfig, email_templates_exports as emailTemplates, empreendimentos_exports as empreendimentos, enderecoSchema, fakeCallRequestSchema, financeiro_exports as financeiro, formaPagamentoEnum, generateAnexoUploadUrlSchema, idLabelSchema, idParamSchema, imoveis_exports as imoveis, imoveis_campanhas_exports as imoveisCampanhas, incorporadoras_exports as incorporadoras, integracoes_exports as integracoes, lead_checkin_exports as leadCheckin, leads_exports as leads, listResponse, mediaItemSchema, meilisearch_exports as meilisearch, messageResponseSchema, motivos_perda_exports as motivosPerda, notifications_exports as notifications, nullableString, oportunidades_exports as oportunidades, paginated, paginationMetaSchema, perfis_interesse_exports as perfisInteresse, personTypeEnum, planos_exports as planos, portal_exports as portal, presignedUploadDataSchema, presignedUrlRequestSchema, presignedUrlResponseSchema, propostaParamsSchema, propostas_exports as propostas, public_api_exports as publicApi, pulse_carteira_exports as pulseCarteira, push_exports as push, rag_exports as rag, registro_chaves_exports as registroChaves, relatorios_exports as relatorios, reportResponse, responsaveis_exports as responsaveis, segmentos_exports as segmentos, site_exports as site, siteParamsSchema, structuredErrorResponseSchema, successResponseSchema, suporte_exports as suporte, tarefas_exports as tarefas, tipoConteudoUploadEnum, updateAnexoMetadataSchema, upload_exports as upload, uploadFolderEnum, uploadUrlDataSchema, userMiniSchema, usuarios_exports as usuarios, validationErrorResponseSchema, valueLabelSchema, webhooks_exports as webhooks, whatsapp_instances_exports as whatsappInstances, whatsapp_templates_exports as whatsappTemplates, workspace_exports as workspace };
//# sourceMappingURL=index.mjs.map
//# sourceMappingURL=index.mjs.map